webpackJsonp([3],{

/***/ "/B3z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/uab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return m; });
/**
 * Created by wzf on 2018/4/23.
 */
var m = {};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "03R4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this,
            _ref;

        var checkStart = function checkStart(rule, value, callback) {
            if (value === '') {
                callback(new Error('請選擇開始日期'));
            } else {
                if (_this.jobOrderForm.endDate != "") {
                    var oldStartDate = new Date(value).getTime() / 1000;
                    var oldEndDate = new Date(_this.jobOrderForm.endDate).getTime() / 1000;
                    if (oldStartDate > oldEndDate) {
                        callback(new Error('開始日期不能大於結束日期'));
                    }
                }
            }
            callback();
        };
        var checkEnd = function checkEnd(rule, value, callback) {
            if (value === '') {
                callback(new Error('請選擇結束日期'));
            } else {
                if (_this.jobOrderForm.startDate != "") {
                    var oldStartDate = new Date(_this.jobOrderForm.startDate).getTime() / 1000;
                    var oldEndDate = new Date(value).getTime() / 1000;
                    if (oldEndDate < oldStartDate) {
                        callback(new Error('結束日期不能小於開始日期'));
                    }
                }
            }
            callback();
        };
        return _ref = {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            jobOrderForm: {
                id: '',
                jobNo: '',
                startDate: '',
                endDate: '',
                jobTime: '',
                volume: '',
                custId: '',
                custNo: '',
                service: 'OB',
                origin: '',
                dest: '',
                contactP: '',
                contactT: '',
                estQty1: '',
                estQty2: '',
                realQty1: '',
                realQty2: '',
                cashOrder: '',
                jobDetail: '',
                status: 0,
                custName: '',
                ver: 1,
                createBy: '',
                createTime: '',
                supervisor: '',
                printCode: '',
                jobId: ''
            },
            remark: '',
            custOptions: [],
            remarkOption: [{
                value: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊',
                label: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊'
            }, {
                value: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊',
                label: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊'
            }, {
                value: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※',
                label: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※'
            }],
            serviceOption: [{
                value: 'OB',
                label: 'OB 出口(Outbound)'
            }, {
                value: 'RL',
                label: 'RL 搬屋/搬運'
            }, {
                value: 'ORL',
                label: 'ORL 搬寫字樓'
            }, {
                value: 'STG',
                label: 'STG 存倉'
            }, {
                value: 'IB',
                label: 'IB 入口'
            }, {
                value: 'SELL',
                label: 'SELL 賣盒'
            }, {
                value: 'MAIL',
                label: 'MAIL 寄件'
            }, {
                value: 'OBOX',
                label: ' 送盒(OBOX)'
            }, {
                value: 'IBOX',
                label: '收盒(IBOX)'
            }, {
                value: 'OTHER',
                label: '其它(OTHER)'
            }],
            jobRules: {
                startDate: [{ required: true, message: '開始日期不能為空', trigger: 'change' }, { validator: checkStart, trigger: 'change' }],
                endDate: [{ required: true, message: '結束日期不能為空', trigger: 'change' }, { validator: checkEnd, trigger: 'change' }],
                custNo: [{ required: true, message: '客戶不能為空', trigger: 'change' }],
                service: [{ required: true, message: '服務類別不能為空', trigger: 'change' }],
                origin: [{ required: false, message: '起點不能為空', trigger: 'change' }, { min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' }],
                dest: [{ min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' }],
                contactP: [{ min: 1, max: 20, message: '長度在1到20個字符', trigger: 'change' }],
                contactT: [{ min: 1, max: 30, message: '長度在1到30個字符', trigger: 'change' }],
                estQty1: [{ required: true, message: '預計箱數量不能為空', trigger: 'change' }, { required: true, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                realQty1: [{ required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                estQty2: [{ required: true, message: '預計板數量不能為空', trigger: 'change' }, { required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                realQty2: [{ required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                jobDetail: [{ required: true, message: '工作內容不能為空', trigger: 'change' }, { min: 1, max: 2000, message: '長度在1到2000個字符', trigger: 'change' }]
            },
            acctId: '',
            jobForm: {
                service: ''
            }
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'jobRules', {
            service: [{ required: true, message: '服務類別不能為空', trigger: 'change' }]
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogJobName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogDiscJobVisible', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'Addloading', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'remarkList', []), _ref;
    },

    methods: {
        getRemarkList: function getRemarkList() {
            var _this2 = this;

            /*查詢常用列表*/
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["s" /* getAllRemarkList */])(2).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    _this2.remarkList = res.data;
                }
            });
        },
        addRemark: function addRemark() {
            var str = document.getElementById('textareaAddId').value;
            /*if(str.indexOf('＊')!=-1 || str.indexOf('※')!=-1){*/
            document.getElementById('textareaAddId').value = document.getElementById('textareaAddId').value + "\n" + this.remark;
            /*}else{
                document.getElementById('textareaAddId').value = document.getElementById('textareaAddId').value + "\n\n\n\n" +this.remark;
            }
            this.remark='＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊';*/
        },
        getIssueDate: function getIssueDate(value) {
            if (value != '' || value != 0) {
                var d = new Date(value);
                var m = d.getMonth() + 1;
                return d.getFullYear() + '-' + m + '-' + d.getDate() + " " + d.getHours() + ":" + d.getMinutes();
            }
        },
        custChange: function custChange(ev) {
            if (ev != "") {
                this.jobOrderForm.custNo = ev.code;
                this.jobOrderForm.custId = ev.id;
                this.jobOrderForm.origin = ev.address;
                this.jobOrderForm.custName = ev.name;
                this.jobOrderForm.contactP = ev.sales;
                this.jobOrderForm.contactT = ev.phone;
            } else {
                this.resetForm("jobOrderForm");
                this.jobOrderForm.custNo = "";
                this.jobOrderForm.custId = "";
                this.jobOrderForm.origin = "";
                this.jobOrderForm.custName = "";
                this.jobOrderForm.contactP = "";
                this.jobOrderForm.contactT = "";
            }
            /* if(ev!="") {
                 this.jobOrderForm.custNo=ev.code;
                 this.jobOrderForm.custId = ev.id;
                 this.jobOrderForm.origin = ev.address;
             }else{
                 this.resetForm("jobOrderForm");
                 this.jobOrderForm.custNo="";
                 this.jobOrderForm.custId = "";
                 this.jobOrderForm.origin = "";
             }*/
        },
        getTimes: function getTimes(ev) {
            this.jobOrderForm.endDate = ev;
        },
        itemRemoteMethod: function itemRemoteMethod(query) {
            var _this3 = this;

            if (query != "") {
                var params = { custNo: query, groupId: null };
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data2 = data.data,
                        res = _data$data2 === undefined ? {} : _data$data2;

                    _this3.custOptions = res.data;
                });
            }
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        validateChange: function validateChange(ev) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,1}$/;
                if (!re.test(ev)) {
                    this.$message.error("請輸入正確的格式，數字只有1位小數");
                    return false;
                }
            }
        },
        jobSave: function jobSave() {
            var _this4 = this;

            this.$refs.jobOrderForm.validate(function (valid) {
                if (valid) {
                    var params1 = { jobNo: _this4.jobOrderForm.jobNo.trim(), service: _this4.jobOrderForm.service, id: _this4.jobOrderForm.id };
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["P" /* getJobNo */])(params1).then(function (data) {
                        var _data$data3 = data.data,
                            res = _data$data3 === undefined ? {} : _data$data3;

                        if (res.data != "") {
                            return _this4.$message.error(_this4.jobOrderForm.jobNo + "工作單號服務類別 " + _this4.jobForm.service + " 已存在，請重新選擇！");
                        } else {
                            if (_this4.jobOrderForm.startDate == '') {
                                _this4.jobOrderForm.startDate = 0;
                            }
                            if (_this4.jobOrderForm.endDate == '') {
                                _this4.jobOrderForm.endDate = 0;
                            }
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.jobOrderForm);
                            params.createTime = Math.round(new Date(params.createTime).getTime() / 1000);
                            params.startDate = Math.round(new Date(params.startDate).getTime() / 1000);
                            params.endDate = Math.round(new Date(params.endDate).getTime() / 1000);
                            params.status = 0;
                            params.jobDetail = document.getElementById('textareaAddId').value;
                            //params.service=this.jobOrderForm.service.join(",");
                            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_69" /* updateJobOrder */])(params).then(function (data) {
                                var _data$data4 = data.data,
                                    errcode = _data$data4.errcode,
                                    errmsg = _data$data4.errmsg;

                                if (errcode == 200) {
                                    _this4.$message.success("修改成功");
                                    _this4.resetForm("jobOrderForm");
                                    _this4.acctId = '';
                                    _this4.$router.push({
                                        name: '工作單',
                                        params: { str: new Date().getTime() }
                                    });
                                    _this4.$store.commit("closeTab", 'jobEdit');
                                } else {
                                    _this4.$message.error("修改失败！");
                                }
                            });
                        }
                    });
                }
            });
        },
        jobSaveItemLoad: function jobSaveItemLoad() {
            this.jobForm.service = "";
            this.dialogJobName = '複製新增工作單';
            this.dialogDiscJobVisible = true;
        },
        jobSaveItem: function jobSaveItem() {
            var _this5 = this;

            this.$refs.jobForm.validate(function (valid) {
                if (valid) {
                    var params1 = { jobNo: _this5.jobOrderForm.jobNo.trim(), service: _this5.jobForm.service, id: '' };
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["P" /* getJobNo */])(params1).then(function (data) {
                        var _data$data5 = data.data,
                            res = _data$data5 === undefined ? {} : _data$data5;

                        if (res.data != "") {
                            return _this5.$message.error(_this5.jobOrderForm.jobNo + "工作單號服務類別 " + _this5.jobForm.service + " 已存在，請重新選擇！");
                        } else {
                            if (_this5.jobOrderForm.startDate == '') {
                                _this5.jobOrderForm.startDate = 0;
                            }
                            if (_this5.jobOrderForm.endDate == '') {
                                _this5.jobOrderForm.endDate = 0;
                            }
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.jobOrderForm);
                            params.createTime = Math.round(new Date(params.createTime).getTime() / 1000);
                            params.startDate = Math.round(new Date(params.startDate).getTime() / 1000);
                            params.endDate = Math.round(new Date(params.endDate).getTime() / 1000);
                            params.jobNo = _this5.jobOrderForm.jobNo.trim();
                            params.service = _this5.jobForm.service;
                            params.status = 0;
                            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_45" /* insertJobOrder */])(params).then(function (data) {
                                var _data$data6 = data.data,
                                    errcode = _data$data6.errcode,
                                    errmsg = _data$data6.errmsg;

                                if (errcode == 200) {
                                    _this5.$message.success("複製新增成功!");
                                    _this5.dialogDiscJobVisible = false;
                                    _this5.resetForm("jobOrderForm");
                                    _this5.resetForm("jobForm");
                                    _this5.$router.push({
                                        name: '工作單',
                                        params: { str: new Date().getTime() }
                                    });
                                    _this5.$store.commit("closeTab", 'jobEdit');
                                } else {
                                    _this5.dialogDiscJobVisible = false;
                                    _this5.$message.error("複製新增失败！");
                                }
                            });
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.acctId == '';
            this.$router.push({
                name: '工作單',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "jobEdit");
        },
        getJobParams: function getJobParams() {
            /*  if (this.acctId == '') {
                  this.acctId = this.$route.params.jobId;
                  if (this.acctId != '' || this.acctId != undefined) {
                      this.queryOneAcctRec(this.acctId);
                  }
              }
              if (this.acctId != this.$route.params.jobId && this.$route.params.jobId != undefined) {*/
            this.acctId = this.$route.params.jobId;
            this.queryOneAcctRec(this.acctId);
            //}
        },
        queryOneAcctRec: function queryOneAcctRec(acctId) {
            var _this6 = this;

            if (acctId != undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["S" /* getJobRecord */])(acctId).then(function (data) {
                    var item = data.data;
                    if (item.data[0] != null) {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.jobOrderForm, item.data[0]);

                        var params = { custNo: item.data[0].custNo, groupId: null };
                        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                            var _data$data7 = data.data,
                                res = _data$data7 === undefined ? {} : _data$data7;

                            _this6.custOptions = res.data;
                        });

                        //let typeS=item.data[0].service.split(",")
                        _this6.jobOrderForm.service = item.data[0].service;
                        _this6.jobOrderForm.estQty1 = parseInt(item.data[0].estQty1);
                        _this6.jobOrderForm.estQty2 = parseInt(item.data[0].estQty2);

                        if (item.data[0].realQty1 != null && item.data[0].realQty1 != 0) {
                            _this6.jobOrderForm.realQty1 = parseInt(item.data[0].realQty1);
                        } else {
                            _this6.jobOrderForm.realQty1 = "";
                        }
                        if (item.data[0].realQty2 != null && item.data[0].realQty2 != 0) {
                            _this6.jobOrderForm.realQty2 = parseInt(item.data[0].realQty2);
                        } else {
                            _this6.jobOrderForm.realQty2 = "";
                        }
                        if (item.data[0].startDate == 0) {
                            _this6.jobOrderForm.startDate = "";
                        } else {
                            _this6.jobOrderForm.startDate = new Date(item.data[0].startDate * 1000);
                        }
                        if (item.data[0].createTime == 0) {
                            _this6.jobOrderForm.createTime = "";
                        } else {
                            _this6.jobOrderForm.createTime = new Date(item.data[0].createTime * 1000);
                        }
                        if (item.data[0].endDate == 0) {
                            _this6.jobOrderForm.endDate = "";
                        } else {
                            _this6.jobOrderForm.endDate = new Date(item.data[0].endDate * 1000);
                        }
                    }
                });
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getJobParams();
        this.getRemarkList();
    },

    computed: {}
});

/***/ }),

/***/ "0FSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[_c('el-input',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow},on:{"blur":function($event){return _vm.selSCode()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[(_vm.form.codeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])]:[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.codeShow,"fetch-suggestions":_vm.querySearch,"trigger-on-focus":false},on:{"input":function($event){return _vm.addList(0,0,'cCode')},"select":_vm.handleSelect},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',[_c('template',{slot:"label"},[_vm._v("\n                                    總體積"),(_vm.form.unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.form.unitVolume==='1'?'箱':_vm.form.unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.totalVolume))])],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"單 價 :"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_c('el-input',{staticStyle:{"width":"80px"},attrs:{"size":"medium"},on:{"input":function($event){return _vm.$forceUpdate()},"blur":function($event){return _vm.handlePrice(_vm.form.price)}},model:{value:(_vm.form.price),callback:function ($$v) {_vm.$set(_vm.form, "price", $$v)},expression:"form.price"}})],1),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("體積單位 :")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"80px"},attrs:{"size":"medium","placeholder":"","disabled":_vm.oldUnitVolume!=null},on:{"change":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.form.unitVolume),callback:function ($$v) {_vm.$set(_vm.form, "unitVolume", $$v)},expression:"form.unitVolume"}},[_c('el-option',{attrs:{"label":"箱","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"立方尺","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"立方米","value":"3"}})],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"20px","font-size":"13px !important"}},[_vm._v("上一次單價 : "+_vm._s(_vm.form.prePrice)),_c('br'),_vm._v("入庫單號 : "+_vm._s(_vm.form.storInCode)),_c('br'),_vm._v("入庫時間 : "+_vm._s(_vm.form.storInTime))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"總價格(HKD) :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.formatCurrency(_vm.form.totalPrice))+" ")]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"20px","font-size":"13px !important","position":"relative","top":"-10px"}},[_vm._v("\n                                    出倉金額(HKD) : "+_vm._s(_vm.formatCurrency(_vm.form.outTotalAmount))),_c('br'),_vm._v("\n                                    剩餘金額(HKD) : "+_vm._s(_vm.formatCurrency(_vm.form.remainingAmount))+"\n                                ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_c('el-form',[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._l((_vm.addWarehousingList),function(items,i){return [_c('thead',{key:i},[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"colspan":"7"}},[_c('el-date-picker',{staticStyle:{"width":"40%"},attrs:{"format":"yyyy年MM月dd日 HH:mm","type":"datetime","size":"large"},model:{value:(items.createDate),callback:function ($$v) {_vm.$set(items, "createDate", $$v)},expression:"items.createDate"}})],1),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v("第"+_vm._s(items.second)+"次")]),_vm._v(" "),(items.storInItem.length === 0 || items.state === 0)?[_c('el-button',{attrs:{"icon":"el-icon-delete","type":"danger","circle":""},on:{"click":function($event){return _vm.delAddWarehousingList(items,i)}}},[_vm._v("刪除")])]:_vm._e()],2)]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"8%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("位置")]),_vm._v(" "),_c('th',{attrs:{"width":"7%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"14%"}},[_vm._v("\n                                    剩餘體積"),(_vm.form.unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.form.unitVolume==='1'?'箱':_vm.form.unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("出倉體積")]),_vm._v(" "),_c('th',{attrs:{"width":"7%"}},[_vm._v("出入倉紀錄")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_vm._v("剩餘件數")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("出倉件數")])])]),_vm._v(" "),_vm._l((items.storInItem),function(item1,index){return _c('tr',{key:index},[_c('td',{staticClass:"number",attrs:{"width":"8%"}},[(item1.state ===1)?[_c('span',[_vm._v(_vm._s(item1.boxNo))])]:[_c('el-input',{attrs:{"disabled":item1.boxNoShow,"size":"medium","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"change":function($event){return _vm.addList(i,index,'boxNo')}},model:{value:(item1.boxNo),callback:function ($$v) {_vm.$set(item1, "boxNo", $$v)},expression:"item1.boxNo"}})]],2),_vm._v(" "),_c('td',{staticClass:"actions",attrs:{"width":"9%"}},[(item1.state ===1)?[_c('span',[_vm._v(_vm._s(item1.value))])]:[_c('el-select',{style:(items.addStorIn==false?'float: left;':''),attrs:{"size":"medium","disabled":item1.locationIdShows,"default-first-option":"","clearable":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethod,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelectState($event,i,index)},"focus":function($event){return _vm.isNullOptions4()}},model:{value:(item1.value),callback:function ($$v) {_vm.$set(item1, "value", $$v)},expression:"item1.value"}},_vm._l((_vm.options4),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2),_vm._v(" "),_c('td',{attrs:{"width":"7%"}},[(item1.state ===1)?[_c('span',[_vm._v(_vm._s(item1.unit))])]:[_c('el-select',{attrs:{"size":"medium","placeholder":"請輸入","disabled":item1.unitShow},on:{"change":function($event){return _vm.addList(i,index,'unit')}},model:{value:(item1.unit),callback:function ($$v) {_vm.$set(item1, "unit", $$v)},expression:"item1.unit"}},_vm._l((_vm.company),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[(item1.state ===1)?[_c('span',[_vm._v(_vm._s(item1.item))])]:[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"disabled":item1.itemShows,"size":"medium","fetch-suggestions":_vm.querySearchRemark,"placeholder":"請輸入內容"},on:{"input":function($event){return _vm.addList(i,index,'item')},"select":function($event){return _vm.addList(i,index,'item')}},model:{value:(item1.item),callback:function ($$v) {_vm.$set(item1, "item", $$v)},expression:"item1.item"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"14%"}},[(item1.state ===1)?[_vm._v("\n                                        "+_vm._s(item1.remainingVolume)+" \n                                    ")]:[_c('el-input',{attrs:{"size":"medium","disabled":item1.ckgShow},on:{"blur":function($event){return _vm.handleBlurVolume(item1, i)}},model:{value:(item1.remainingVolume),callback:function ($$v) {_vm.$set(item1, "remainingVolume", $$v)},expression:"item1.remainingVolume"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_vm._v("\n                                    "+_vm._s(!item1.deliverVolume ? '' : item1.deliverVolume)+"\n                                ")]),_vm._v(" "),_c('th',{attrs:{"width":"8%"}},[_c('el-button',{attrs:{"size":"mini","type":"success","circle":""},on:{"click":function($event){return _vm.handleOpenRecord(item1)}}},[_vm._v("查看")])],1),_vm._v(" "),_c('td',{attrs:{"width":"7%"}},[(item1.state ===1)?[_vm._v("\n                                        "+_vm._s(item1.remainingQuantity)+"\n                                    ")]:[_c('el-input',{attrs:{"size":"medium","disabled":item1.ckgShow,"maxlength":"3","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"input":function($event){return _vm.addList(i,index,'remainingQuantity')}},model:{value:(item1.remainingQuantity),callback:function ($$v) {_vm.$set(item1, "remainingQuantity", $$v)},expression:"item1.remainingQuantity"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[_vm._v("\n                                    "+_vm._s(!item1.deliverGodown ? '' : item1.deliverGodown)+"\n                                    "),(item1.state === 0)?[_c('el-button',{attrs:{"type":"danger","size":"mini","circle":""},on:{"click":function($event){return _vm.delStorInItem(i,index)}}},[_vm._v("刪除")])]:_vm._e()],2)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('br')])])]})],2),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v("保存")]),_vm._v(" "),(_vm.$store.getters.customerInSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 取消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerInSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],1)])],1)])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"","visible":_vm.dialogVisible,"width":"70%","center":"","close-on-click-modal":false,"show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.recordList}},[_c('el-table-column',{attrs:{"prop":"oldVolume","label":"原體積","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateVolume","label":"編輯體積","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oldQuantity","label":"原件數","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"編輯件數","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(Math.abs(Number(scope.row.totalQuantity)-Number(scope.row.oldQuantity)))+" \n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalVolume","label":"總體積","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalQuantity","label":"總件數","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createDate","label":"時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm.formatDate(scope.row.createDate))+" \n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","label":"備注","width":"100"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"30px","display":"flex","justify-content":"center"}},[_c('el-button',{attrs:{"size":"medium"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("關閉")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1RGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            volumeDisabled: false,
            dialogVisible: false,
            dialogForm: {},
            curIndex: null,
            options4: [],
            options: [],
            list: [],
            tableloading: false,
            show: true,
            add: false,
            addStorOn: false,
            cId: 0,
            storDateId: 0, //當前已出倉的日期表id
            storOnCustomerList: [],
            customerCode: {},
            storOnList: [],
            addStorOnList: [],
            codeList: [],
            codeInList: [], //入庫單號
            addstorOnList: [],
            rkCont: true, //入庫和客戶資訊
            addStorOnMap: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
            createDate: "", //時間
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            form: {
                id: null,
                sCode: null,
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false
            },
            searchStorOn: '',
            searchName: '',
            searchSalesId: '',
            custSalesList: []
        };
    },
    mounted: function mounted() {},

    methods: {
        handleAll: function handleAll(val) {
            if (val == 1) {
                this.dialogForm.volume = this.dialogForm.remainingVolume;
                this.volumeDisabled = true;
                var sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100);
                this.dialogForm.amount = sum / 100;
            }
            if (val == 0) {
                this.dialogForm.volume = null;
                this.volumeDisabled = false;
                this.dialogForm.amount = null;
            }
            if (val == 4) {
                this.volumeDisabled = false;
            }
            this.$forceUpdate();
        },
        formatCurrency: function formatCurrency(amount) {
            var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (!amount) return;
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: decimalPlaces
            });
            return '' + formatter.format(amount);
        },
        handleBlurVolume: function handleBlurVolume() {
            var value = Number(this.dialogForm.volume);
            var regex = /^(0|[1-9][0-9]*)$/;
            var message = '請輸入大於0等于0的整數';
            if (this.dialogForm.unitVolume == '3') {
                regex = /^(([1-9][0-9]{0,2}(,\\d{3})*)|0)(\.\d{1,2})?$/;
                message = '请输入大于等于零最多两位小数的数字';
            } else {
                regex = /^(0|[1-9][0-9]*)$/;
                message = '請輸入大於0等于0的整數';
            }
            if (!regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: '請輸入大於0等于0的整數' });
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
                this.$forceUpdate();
                return;
            }
            if (value > Number(this.dialogForm.remainingVolume)) {
                this.$message({ type: 'warning', message: '出倉體積不能大於剩餘體積' });
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
                this.$forceUpdate();
                return;
            }

            var sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100);
            this.dialogForm.amount = sum / 100;
            this.$forceUpdate();
        },
        printing: function printing(item) {
            /*打印*/
            if (item !== null) {
                var url = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL + "/getPrintingList?custId=" + item.cid + "&storOnDateId=" + item.storDateId + "&token=" + this.$store.getters.staff.token;
                window.location.href = url;
            }
        },
        storOn: function storOn(stor) {
            var _this = this;

            /*確定真的出倉了*/
            var params = { storOnItemList: stor.storOnItem };
            this.$confirm('確定是否出倉? ', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_29" /* getStorOnOkList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode === 200) {
                        _this.$message({
                            message: '出倉成功',
                            type: 'success'
                        });
                        _this.cancelAdd();
                        _this.getStorOnList();
                    }
                });
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            this.$router.push({
                name: '出倉',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", 'addStockout');
        },
        getCodeList: function getCodeList() {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_24" /* getStorOnCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    _this2.codeList = res.data;
                }
            });
        },
        remoteMethod: function remoteMethod(query) {
            var _this3 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.options4 = _this3.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodIn: function remoteMethodIn(query) {
            var _this4 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this4.loading = false;
                    _this4.options = _this4.codeInList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        handleCurrentChange: function handleCurrentChange() {
            /*分頁*/
            this.getStorOnList();
        },
        selSotrOn: function selSotrOn(id) {
            var _this5 = this;

            /*查詢出倉詳情*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerOnSte", false);
            this.add = true;
            this.show = false;
            this.rkCont = false;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_25" /* getStorOnItemStorinIdBy */])(id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    var storDateId = null;
                    res.data.forEach(function (item, i) {
                        //重新處理下資料
                        if (i === 0) {
                            _this5.createDate = new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm");
                        }
                        _this5.storDateId = item.storDateId;
                        var itemList = {};
                        var floor = void 0;_this5.cId = item.cId;
                        floor = item.name;
                        if (new Date(new Date(item.createDate * 1000)).toDateString() !== new Date().toDateString()) {
                            //是否是當天時間 不是當天的時間不能修改
                            itemList = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId, volume: item.volume, amount: item.amount, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume, unitVolume: item.unitVolume, unitPrice: item.unitPrice, quantity: item.quantity, checked: false };
                        } else {
                            itemList = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId, volume: item.volume, amount: item.amount, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume, unitVolume: item.unitVolume, unitPrice: item.unitPrice, quantity: item.quantity, checked: false };
                        }
                        if (!sotrOnMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { id: item.id, state: item.state, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                            sotrOnMap.set(item.storDateId, storIdItemList);
                        } else {
                            sotrOnMap.get(item.storDateId).storOnItem.push(itemList);
                        }
                        // sotrOnMap.set(item.id,itemList)
                    });
                    _this5.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    //console.log( this.storOnList);
                    _this5.selCustimerId(_this5.storDateId); //查詢客戶id
                    _this5.form.codeShow = true;
                    _this5.form.sCodeShow = true;
                    _this5.form.nameShow = true;
                    _this5.form.phoneShow = true;
                    _this5.form.addressShow = true;
                    _this5.form.salesShow = true;
                }
            });

            //				getPrintingListByStorDateId(32).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //				});
            //
            //                getPrintingList({custId:30,storOnDateId:32}).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //                })
        },
        selCustimerId: function selCustimerId(id) {
            var _this6 = this;

            /*查詢客戶ID*/
            //console.log("id",id)
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_27" /* getStorOnListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;
                //console.log(res);

                if (res.errcode === 200) {
                    var _res$data$customer = res.data.customer,
                        _id = _res$data$customer.id,
                        code = _res$data$customer.code,
                        name = _res$data$customer.name,
                        phone = _res$data$customer.phone,
                        address = _res$data$customer.address,
                        sales = _res$data$customer.sales,
                        createDate = _res$data$customer.createDate;

                    _this6.form.id = _id;
                    _this6.form.code = code;
                    _this6.form.name = name;
                    _this6.form.address = address;
                    _this6.form.phone = phone;
                    _this6.form.sales = sales;
                    _this6.form.createDate = new Date(createDate * 1000).Format("yyyy-MM-dd hh:mm");
                    _this6.form.sCode = res.data.scode;
                }
            });
        },
        getStorOnList: function getStorOnList() {
            var _this7 = this;

            /*查詢入庫*/
            this.getCodeList();
            this.tableloading = true;
            this.rkCont = true;
            var params = { page: this.pager.page, size: this.pager.size, storOn: this.searchStorOn, custName: this.searchName, salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_26" /* getStorOnList */])(params).then(function (data) {
                var _data$data5 = data.data,
                    res = _data$data5 === undefined ? {} : _data$data5;
                //console.log("res",res)

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this7.storOnCustomerList = items;
                    _this7.storOnCustomerList.forEach(function (a, b) {
                        a.storInDate = new Date(a.onDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this7.$set(_this7.storOnCustomerList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this7.pager.total = total;
                    _this7.pager.page = page;
                    _this7.pager.size = size;
                    _this7.tableloading = false;
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.getInCodeList();
        },
        cancelAdd: function cancelAdd() {
            this.add = false;
            this.show = true;
            this.addStorOn = false;
            this.nullList();
        },
        handleSelect: function handleSelect(cid) {
            var _this8 = this;

            /*選擇出倉后*/
            var str = [];
            if (cid === null || cid === undefined) {
                this.addStorOn = true;
                cid = this.cId;
            } else {
                str = cid.split(',');
                cid = str[0];
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* getCustomerById */])(cid).then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                if (res.errcode === 200) {
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this8.form.id = id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = sales;
                    var codeId = _this8.form.sCode.split(',');
                    if (codeId[1] !== undefined) {
                        //確定codeID中是否有值
                        code = codeId[1];
                    } else {
                        code = _this8.form.sCode;
                    }
                    var params = { page: _this8.pager.page, size: _this8.pager.size, id: id, code: code };
                    //console.log("2",params);
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_60" /* selStorInItemCustomerId */])(params).then(function (data) {
                        var _data$data7 = data.data,
                            res = _data$data7 === undefined ? {} : _data$data7;

                        if (res.errcode === 200) {
                            var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                            res.data.data.forEach(function (item, i) {
                                //重新處理下資料
                                var floor = void 0;
                                if (item.floor === 0) {
                                    floor = "GF " + item.name;
                                } else {
                                    floor = item.floor + "F " + item.name;
                                }
                                var itemList = { state: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, storDateId: _this8.storDateId, volume: item.volume, amount: item.amount, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume, unitVolume: item.unitVolume, unitPrice: item.unitPrice, quantity: item.quantity, checked: false };
                                if (i === 0) {
                                    //添加
                                    var storIdItemList = { id: item.id, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                                    sotrOnMap.set(i, storIdItemList);
                                } else {
                                    sotrOnMap.get(0).storOnItem.push(itemList);
                                }
                            });
                            if (_this8.addStorOn === true) {
                                _this8.addStorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            } else {
                                _this8.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            }
                        }
                    });
                }
            });
        },
        selCutomerCode: function selCutomerCode() {
            var _this9 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    _this9.customerCode = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this9.customerCode.forEach(function (a, b) {
                        _this9.$set(_this9.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this9.list = list.map(function (item) {
                        return { value: item.id, label: item.code };
                    });
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this10 = this;

            /*出倉*/
            var addstorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.addStorOnMap.values()));
            if (addstorOnList.length == 0) {
                return this.$alert("請選擇出倉記錄", '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            }
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return this.$alert("工作單號不能為空", '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            }
            var codeId = this.form.sCode.split(',');
            var code = "";
            if (this.rkCont === true) {
                this.codeList.forEach(function (item) {
                    if (item.code === codeId[1]) {
                        _this10.addStorOn = true;
                    }
                });
            }
            if (codeId[1] !== undefined) {
                //確定codeID中是否有值
                code = codeId[1];
            } else {
                code = this.form.sCode;
            }
            var params = {
                code: code,
                addStorOn: this.addStorOn,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storOnItemList: addstorOnList
            };
            //console.log("params",params);
            var str = this.isStringNull();
            if (str !== "") {
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                this.$confirm('確定是否出倉? ', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_52" /* insertStorOn */])(params).then(function (data) {
                        var _data$data9 = data.data,
                            res = _data$data9 === undefined ? {} : _data$data9;

                        if (res.errcode === 200) {
                            _this10.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            _this10.cancelAdd();
                            //this.getStorOnList();
                            _this10.addStorOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                            _this10.$router.push({
                                name: '出倉',
                                params: { str: new Date().getTime() }
                            });
                            _this10.$store.commit("closeTab", 'addStockout');
                        } else {
                            _this10.$message.error(res.errmsg);
                        }
                    });
                }).catch(function () {
                    _this10.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        },
        checkedOne: function checkedOne(index, item) {
            var list = {};
            if (this.addStorOn === false) {
                list = this.storOnList[0].storOnItem[index];
            } else {
                list = this.addStorOnList[0].storOnItem[index];
            }
            var storOn = { storInItemId: list.id, state: 1, unit: list.unit, id: list.id, boxNo: list.boxNo, item: list.item, qty: list.qty, locationId: list.locationId, value: list.value, storDateId: list.storDateId, volume: list.volume, amount: list.amount, remainingQuantity: list.remainingQuantity, remainingVolume: list.remainingVolume, unitVolume: list.unitVolume, unitPrice: list.unitPrice, quantity: list.quantity, checked: false };
            if (!this.addStorOnMap.has(list.id)) {
                if (this.addStorOnList.length !== 0) {
                    this.addStorOnList[0].storOnItem[index].state = 1;
                }
                this.addStorOnMap.set(list.id, storOn);
            } else {
                this.addStorOnList[0].storOnItem[index].state = 0;
                this.addStorOnMap.delete(list.id);
            }
        },

        // changeOne(val, row, index) {
        //     row.state = 1
        //     row.quantity = row.remainingQuantity
        //     let list = {}
        //     if(this.addStorOn===false){
        //         list = this.storOnList[0].storOnItem[index];
        //     }else{
        //         list = this.addStorOnList[0].storOnItem[index];
        //     }
        //     let storOn = {storInItemId:list.id,state:1,unit:list.unit,id:list.id,boxNo:list.boxNo,item:list.item,qty:list.qty,locationId:list.locationId,value:list.value,storDateId:list.storDateId,volume:list.volume,amount:list.amount,remainingQuantity:list.remainingQuantity,remainingVolume:list.remainingVolume,unitVolume:list.unitVolume,unitPrice:list.unitPrice,quantity:list.quantity,checked:true};
        //     if(val){
        //         row.remark = '出整' + list.unit + '，共' + this.dialogForm.quantity +'件' 
        //         if(!this.addStorOnMap.has(list.id)){
        //             if(this.addStorOnList.length !== 0){
        //                 this.addStorOnList[0].storOnItem[index].state = 1;
        //             }
        //             this.addStorOnMap.set(list.id,storOn)
        //         }else{
        //             this.addStorOnList[0].storOnItem[index].state =1;
        //         }
        //     }else{
        //         if(this.addStorOnMap.has(list.id)){
        //             if(this.addStorOnList.length !== 0){
        //                 this.addStorOnList[0].storOnItem[index].state = 0;
        //             }
        //             row.state = 0
        //             row.remark = ''
        //             this.addStorOnMap.delete(list.id)
        //         }
        //     }
        //     this.$forceUpdate()
        // },
        handleStor: function handleStor(index) {
            this.curIndex = index;
            if (this.addStorOn === false) {
                this.dialogForm = this.storOnList[0].storOnItem[index];
            } else {
                this.dialogForm = this.addStorOnList[0].storOnItem[index];
            }
            if (!this.dialogForm.checked) {
                this.dialogForm.quantity = 1;
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
            }
            console.log(this.dialogForm);
            this.dialogVisible = true;
        },
        handleItem: function handleItem() {
            var id = this.dialogForm.id;
            var unit = this.dialogForm.unitVolume == '1' ? '箱' : this.dialogForm.unitVolume == '2' ? 'cu.ft' : this.dialogForm.unitVolume == '3' ? 'm³' : '';
            if (this.dialogForm.state == 1 || this.dialogForm.state == 4) {
                this.dialogForm.checked = true;
                if (this.dialogForm.quantity == this.dialogForm.remainingQuantity) this.dialogForm.state = 1;
                if (this.dialogForm.state == 1) {
                    this.dialogForm.quantity = this.dialogForm.remainingQuantity;
                    this.dialogForm.remark = '\u51FA\u6574' + this.dialogForm.unit + '\uFF0C\u5171' + this.dialogForm.quantity + '\u4EF6' + (this.dialogForm.volume ? '，體積' + this.dialogForm.volume + unit : '');
                }
                if (this.dialogForm.state == 4) {
                    this.dialogForm.remark = '\u51FA\u90E8\u5206\uFF0C' + this.dialogForm.quantity + '\u4EF6' + (this.dialogForm.volume ? '，體積' + this.dialogForm.volume + unit : '');
                }
                if (!this.addStorOnMap.has(id)) {
                    if (this.addStorOnList.length !== 0) {
                        this.addStorOnList[0].storOnItem[this.curIndex].state = this.dialogForm.state;
                    }
                    this.addStorOnMap.set(id, this.dialogForm);
                } else {
                    this.addStorOnMap.set(id, this.dialogForm);
                }
            } else {
                this.dialogForm.state = 0;
                this.dialogForm.remark = '';
                this.dialogForm.checked = false;
                if (this.addStorOnMap.has(id)) {
                    if (this.addStorOnList.length !== 0) {
                        this.addStorOnList[0].storOnItem[this.curIndex].state = 0;
                    }
                    this.addStorOnMap.delete(id);
                }
            }
            this.dialogVisible = false;
        },
        nullList: function nullList() {
            /*清空*/
            this.storOnList = [];
            this.storDateId = 0;
            this.isNullOptions();
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null
            };
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        isStringNull: function isStringNull() {
            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "出庫單不能為空";
            }if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }if (this.form.name === null || this.form.name === "") {
                return "姓名不能為空";
            }if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            return str;
        },
        test: function test() {
            this.show = true;
            this.add = false;
        },
        getInCodeList: function getInCodeList() {
            var _this11 = this;

            /*查詢入庫單號*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_20" /* getStorInCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data10 = data.data,
                    res = _data$data10 === undefined ? {} : _data$data10;
                //console.log("11",res);

                if (res.errcode === 200) {
                    _this11.codeInList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this11.codeInList.forEach(function (a, b) {
                        _this11.$set(_this11.codeInList[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this11.codeInList = list.map(function (item) {
                        return { value: item.id + "," + item.code, label: item.code };
                    });
                } else {
                    _this11.$message.error(res.errmsg);
                }
            });
        },
        isNullOptions: function isNullOptions() {
            this.options = [];
        }
    },
    activated: function activated() {
        var _this12 = this;

        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data11 = data.data,
                res = _data$data11 === undefined ? {} : _data$data11;

            _this12.custSalesList = res.data;
        });
        /*進入載入*/
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.selCutomerCode();
        this.storInAdd();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ADD_STOR_ON");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("EDIT_STOR_ON");
        }
    },
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "1VJQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return m; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _m;

/**
 * Created by wzf on 2018/4/23.
 */
var m = (_m = {
    b_newrole: '新增角色',
    t_deleterole: '刪除角色',
    t_updaterole: '編輯角色',
    m_newsucs: '新增成功',
    m_deletesuc: '刪除成功',
    m_info: '信息提示',
    m_accountnumber: '請輸入賬號',
    m_length220: '長度在 2 到 20 個字符',
    m_deleterole: '此操作將永久刪除該角色, 是否繼續?',
    m_jurisdiction: '請至少選擇壹種權限',
    m_updatesucs: '修改成功',
    t_confirm: '確認',
    t_cancel: '取消',
    t_search: '搜索條件',
    t_custcode: '客戶編號',
    t_groupname: '組名',
    t_customergroupname: '客戶組名',
    b_breakrelation: '解除關系',
    b_newmembergrp: '新增客戶組成員',
    m_groupnameinput: '請輸入客戶組名',
    m_customerinput: '請輸入客戶',
    m_deleteconfirmnexus: '此操作將解除與客戶組的關系, 是否繼續?',
    m_removesuc: '關系解除成功',
    t_memberdata: '成員資料',
    m_newmembersuc: '添加成員成功',
    t_memebername: '成員名字',
    b_query: '查詢',
    b_opt: '操作',
    b_edit: '編輯',
    t_nodata: '暫無數據',
    t_customergroup: '客戶組管理',
    t_newcustomergroup: '新增客戶組',
    t_updatecustomergroup: '編輯客戶組',
    t_deletecustomergroup: '刪除客戶組',
    t_customergroupsee: '客戶組詳情',
    t_newproductcode: '新增客戶產品編碼',
    t_updateproductcode: '編輯客戶產品編碼',
    t_deletecustproductc: '刪除客戶產品編碼',
    b_cancel: '取消',
    b_save: '保存'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_newsucs', '新增成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_updatesucs', '修改成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deleteconfirm', '此操作將永久刪除該資料, 是否繼續？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deletesuc', '刪除成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_customer', '客戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 's_login', '用戶名/別名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_login', '用戶名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enable', '啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_stop', '停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newTask', '新增任務'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_salesName', '銷售員'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_taskDate', '任務時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_booking', '搬遷預訂'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_site', '現場調查'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_delete', '刪除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_selectthefile', '選擇檔案'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enclosureadmin', '附件管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_uploadfile', '上傳文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_uploadfileMaxFiftyMb', '上傳文件不能超過50MB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_uploadsuccess', '上傳成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_filename', '文件名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_filenameremark', '文件備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_uploadby', '上傳人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_uploadtime', '上傳時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_remarks', '備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_file', '文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_download', '下載'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_delete', '刪除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_task', '任務資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_export', "導出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastweek', '最近壹周'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastmonth', '最近壹個月'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastthreemonth', '最近三個月'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_accounting', '會計'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_cust', '客戶報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storIn', '入倉報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storOn', '出倉報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storInOn', '出入倉紀錄表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_existing', '貨倉現存報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_jobNo', '工作單號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_date', '日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_startdate', '開始日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enddate', '結束日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_quarterDate', '季度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_monthDate', '月份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_yearDate', '年份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_date', '請選擇季度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_monthDate', '請選擇月份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_yearDate', '請選擇年份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_customer', '請選擇客戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newFeedBack', '新增回料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newRolling', '新增出倉'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_numbernot0', '數量不能少於0!'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_addgoodsadjustment', '新增貨品調整'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_editgoodsadjustment', '修改貨品調整'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_qtysk', '數量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_prodcode', '產品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_nodata', '暫無數據'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_new', '新增'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_untreated', '該產品已存在，還未處理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_repeatedselection', '重復選擇產品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_productchoice', '請選擇產品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_number', '請輸入數量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_remarks', '請輸入備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_newgoodssuc', '新增貨品成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_lengthmin100', '長度不超過100位'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_producttype', '請選擇產品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_import', '導入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_delete', '刪除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deleteconfirm', '此操作將永久刪除該資料, 是否繼續？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deletesuc', '刪除成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_Importconfirm', '妳確定要入倉嗎？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_outconfirm', '妳確定要出倉嗎？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_Importsucs', '導入成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_ExportFormat', '導出格式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_place', '地點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseSalesName', '請選擇銷售員'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleasePlace', '請選擇地點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseStartdate', '請選擇開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseEnddate', '請選擇結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_calendarStartdate', '開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_calendarEnddate', '結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_startmaxenddate', '開始時間不能大於結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_endminstartdate', '結束時間不能小於開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_downloadPDF', 'PDF下载'), _m);

/***/ }),

/***/ "1Xoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"rollingForm",staticClass:"demo-form-inline",staticStyle:{"width":"1500px"},attrs:{"inline":true,"model":_vm.rollingForm,"rules":_vm.rollingRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"feedDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},model:{value:(_vm.rollingForm.feedDate),callback:function ($$v) {_vm.$set(_vm.rollingForm, "feedDate", $$v)},expression:"rollingForm.feedDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"車號：","prop":"carNumber"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateCarNumber(_vm.rollingForm.carNumber)}},model:{value:(_vm.rollingForm.carNumber),callback:function ($$v) {_vm.$set(_vm.rollingForm, "carNumber", $$v)},expression:"rollingForm.carNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"扎車(坑紙)","prop":"oneCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"坑紙","clearable":""},on:{"change":function($event){return _vm.validatePitPaperTitle(_vm.rollingForm.oneCar)}},model:{value:(_vm.rollingForm.oneCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "oneCar", $$v)},expression:"rollingForm.oneCar"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"扎車(地膠)","prop":"twoCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"地膠","clearable":""},on:{"change":function($event){return _vm.validateTwoCarTitle(_vm.rollingForm.twoCar)}},model:{value:(_vm.rollingForm.twoCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "twoCar", $$v)},expression:"rollingForm.twoCar"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"扎車(縐紋紙)","prop":"threeCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"縐紋紙","clearable":""},on:{"change":function($event){return _vm.validateThreeTitle(_vm.rollingForm.threeCar)}},model:{value:(_vm.rollingForm.threeCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "threeCar", $$v)},expression:"rollingForm.threeCar"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.poiItemList),function(poiItem){return _c('div',[(poiItem.index!=1)?_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticStyle:{"margin-left":"100px","border":"1px dashed #000","width":"73%","margin-bottom":"3px"}})]):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"坑紙","prop":"pitPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatePitPaper(poiItem)}},model:{value:(poiItem.pitPaper),callback:function ($$v) {_vm.$set(poiItem, "pitPaper", $$v)},expression:"poiItem.pitPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"報紙","prop":"newsPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatenewsPaper(poiItem)}},model:{value:(poiItem.newsPaper),callback:function ($$v) {_vm.$set(poiItem, "newsPaper", $$v)},expression:"poiItem.newsPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"卜卜膠","prop":"buBu"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatebuBu(poiItem)}},model:{value:(poiItem.buBu),callback:function ($$v) {_vm.$set(poiItem, "buBu", $$v)},expression:"poiItem.buBu"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"拷貝紙","prop":"copyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatecopyPaper(poiItem)}},model:{value:(poiItem.copyPaper),callback:function ($$v) {_vm.$set(poiItem, "copyPaper", $$v)},expression:"poiItem.copyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"毡","prop":"mat"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatemat(poiItem)}},model:{value:(poiItem.mat),callback:function ($$v) {_vm.$set(poiItem, "mat", $$v)},expression:"poiItem.mat"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"保鮮紙","prop":"tinFoil"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetinFoil(poiItem)}},model:{value:(poiItem.tinFoil),callback:function ($$v) {_vm.$set(poiItem, "tinFoil", $$v)},expression:"poiItem.tinFoil"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"高木箱","prop":"azusa"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateazusa(poiItem)}},model:{value:(poiItem.azusa),callback:function ($$v) {_vm.$set(poiItem, "azusa", $$v)},expression:"poiItem.azusa"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"矮木箱","prop":"shortWood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateshortWood(poiItem)}},model:{value:(poiItem.shortWood),callback:function ($$v) {_vm.$set(poiItem, "shortWood", $$v)},expression:"poiItem.shortWood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"鐵車","prop":"ironCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateironCar(poiItem)}},model:{value:(poiItem.ironCar),callback:function ($$v) {_vm.$set(poiItem, "ironCar", $$v)},expression:"poiItem.ironCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"車仔","prop":"chelsea"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatechelsea(poiItem)}},model:{value:(poiItem.chelsea),callback:function ($$v) {_vm.$set(poiItem, "chelsea", $$v)},expression:"poiItem.chelsea"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"軟紙","prop":"softPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatesoftPaper(poiItem)}},model:{value:(poiItem.softPaper),callback:function ($$v) {_vm.$set(poiItem, "softPaper", $$v)},expression:"poiItem.softPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"爛紙","prop":"lousyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatelousyPaper(poiItem)}},model:{value:(poiItem.lousyPaper),callback:function ($$v) {_vm.$set(poiItem, "lousyPaper", $$v)},expression:"poiItem.lousyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"防潮珠","prop":"moistureproof"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatemoistureproof(poiItem)}},model:{value:(poiItem.moistureproof),callback:function ($$v) {_vm.$set(poiItem, "moistureproof", $$v)},expression:"poiItem.moistureproof"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電批","prop":"electric"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateelectric(poiItem)}},model:{value:(poiItem.electric),callback:function ($$v) {_vm.$set(poiItem, "electric", $$v)},expression:"poiItem.electric"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"叉","prop":"fork"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatefork(poiItem)}},model:{value:(poiItem.fork),callback:function ($$v) {_vm.$set(poiItem, "fork", $$v)},expression:"poiItem.fork"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"散箱","prop":"bulktank"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatebulktank(poiItem)}},model:{value:(poiItem.bulktank),callback:function ($$v) {_vm.$set(poiItem, "bulktank", $$v)},expression:"poiItem.bulktank"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地膠","prop":"toGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetoGlue(poiItem)}},model:{value:(poiItem.toGlue),callback:function ($$v) {_vm.$set(poiItem, "toGlue", $$v)},expression:"poiItem.toGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙","prop":"gummedPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validategummedPaper},model:{value:(poiItem.gummedPaper),callback:function ($$v) {_vm.$set(poiItem, "gummedPaper", $$v)},expression:"poiItem.gummedPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"铁笼","prop":"cage"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatecage(poiItem)}},model:{value:(poiItem.cage),callback:function ($$v) {_vm.$set(poiItem, "cage", $$v)},expression:"poiItem.cage"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"夾板(長)","prop":"plywood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateplywood(poiItem)}},model:{value:(poiItem.plywood),callback:function ($$v) {_vm.$set(poiItem, "plywood", $$v)},expression:"poiItem.plywood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙卡板","prop":"paperCardBoard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatepaperCardBoard(poiItem)}},model:{value:(poiItem.paperCardBoard),callback:function ($$v) {_vm.$set(poiItem, "paperCardBoard", $$v)},expression:"poiItem.paperCardBoard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"開木箱工具","prop":"tool"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetool(poiItem)}},model:{value:(poiItem.tool),callback:function ($$v) {_vm.$set(poiItem, "tool", $$v)},expression:"poiItem.tool"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠(110cm)","prop":"glue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateglue(poiItem)}},model:{value:(poiItem.glue),callback:function ($$v) {_vm.$set(poiItem, "glue", $$v)},expression:"poiItem.glue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"Plasma","prop":"plasma"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateplasma(poiItem)}},model:{value:(poiItem.plasma),callback:function ($$v) {_vm.$set(poiItem, "plasma", $$v)},expression:"poiItem.plasma"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"縐紋紙","prop":"crepePaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatecrepePaper(poiItem)}},model:{value:(poiItem.crepePaper),callback:function ($$v) {_vm.$set(poiItem, "crepePaper", $$v)},expression:"poiItem.crepePaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"平衣","prop":"flatClothing"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateflatClothing(poiItem)}},model:{value:(poiItem.flatClothing),callback:function ($$v) {_vm.$set(poiItem, "flatClothing", $$v)},expression:"poiItem.flatClothing"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"冰箱","prop":"refrigerator"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validaterefrigerator(poiItem)}},model:{value:(poiItem.refrigerator),callback:function ($$v) {_vm.$set(poiItem, "refrigerator", $$v)},expression:"poiItem.refrigerator"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"黑色橡筋","prop":"elastic"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateelastic(poiItem)}},model:{value:(poiItem.elastic),callback:function ($$v) {_vm.$set(poiItem, "elastic", $$v)},expression:"poiItem.elastic"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙板","prop":"cardboard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatecardboard(poiItem)}},model:{value:(poiItem.cardboard),callback:function ($$v) {_vm.$set(poiItem, "cardboard", $$v)},expression:"poiItem.cardboard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("塊")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"企身","prop":"stiff"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatestiff(poiItem)}},model:{value:(poiItem.stiff),callback:function ($$v) {_vm.$set(poiItem, "stiff", $$v)},expression:"poiItem.stiff"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(長)","prop":"lengthFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatelengthFloor(poiItem)}},model:{value:(poiItem.lengthFloor),callback:function ($$v) {_vm.$set(poiItem, "lengthFloor", $$v)},expression:"poiItem.lengthFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(短)","prop":"shortFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateshortFloor(poiItem)}},model:{value:(poiItem.shortFloor),callback:function ($$v) {_vm.$set(poiItem, "shortFloor", $$v)},expression:"poiItem.shortFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"吊繩","prop":"theWire"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetheWire(poiItem)}},model:{value:(poiItem.theWire),callback:function ($$v) {_vm.$set(poiItem, "theWire", $$v)},expression:"poiItem.theWire"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"滑潤","prop":"smooth"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatesmooth(poiItem)}},model:{value:(poiItem.smooth),callback:function ($$v) {_vm.$set(poiItem, "smooth", $$v)},expression:"poiItem.smooth"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"膠(120cm)","prop":"oneGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoneGlue(poiItem)}},model:{value:(poiItem.oneGlue),callback:function ($$v) {_vm.$set(poiItem, "oneGlue", $$v)},expression:"poiItem.oneGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"積車","prop":"productCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateproductCar(poiItem)}},model:{value:(poiItem.productCar),callback:function ($$v) {_vm.$set(poiItem, "productCar", $$v)},expression:"poiItem.productCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"搬花網","prop":"wireMesh"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatewireMesh(poiItem)}},model:{value:(poiItem.wireMesh),callback:function ($$v) {_vm.$set(poiItem, "wireMesh", $$v)},expression:"poiItem.wireMesh"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙冚","prop":"tape"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetape(poiItem)}},model:{value:(poiItem.tape),callback:function ($$v) {_vm.$set(poiItem, "tape", $$v)},expression:"poiItem.tape"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(新)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(舊)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"梳化套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"床褥套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"白水松："}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新大","prop":"big"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatebig(poiItem)}},model:{value:(poiItem.big),callback:function ($$v) {_vm.$set(poiItem, "big", $$v)},expression:"poiItem.big"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊大","prop":"oldBig"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoldbig(poiItem)}},model:{value:(poiItem.oldBig),callback:function ($$v) {_vm.$set(poiItem, "oldBig", $$v)},expression:"poiItem.oldBig"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3座位","prop":"threeSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatethreeSeats(poiItem)}},model:{value:(poiItem.threeSeats),callback:function ($$v) {_vm.$set(poiItem, "threeSeats", $$v)},expression:"poiItem.threeSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"6呎","prop":"sixRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatesixRuler(poiItem)}},model:{value:(poiItem.sixRuler),callback:function ($$v) {_vm.$set(poiItem, "sixRuler", $$v)},expression:"poiItem.sixRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"1吋","prop":"oneSmall"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoneSmall(poiItem)}},model:{value:(poiItem.oneSmall),callback:function ($$v) {_vm.$set(poiItem, "oneSmall", $$v)},expression:"poiItem.oneSmall"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新中","prop":"inthe"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateinthe(poiItem)}},model:{value:(poiItem.inthe),callback:function ($$v) {_vm.$set(poiItem, "inthe", $$v)},expression:"poiItem.inthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊中","prop":"oldInthe"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoldinthe(poiItem)}},model:{value:(poiItem.oldInthe),callback:function ($$v) {_vm.$set(poiItem, "oldInthe", $$v)},expression:"poiItem.oldInthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"2座位","prop":"twoSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatetwoSeats(poiItem)}},model:{value:(poiItem.twoSeats),callback:function ($$v) {_vm.$set(poiItem, "twoSeats", $$v)},expression:"poiItem.twoSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"5呎","prop":"fiveRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatefiveRuler(poiItem)}},model:{value:(poiItem.fiveRuler),callback:function ($$v) {_vm.$set(poiItem, "fiveRuler", $$v)},expression:"poiItem.fiveRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"半吋","prop":"small"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatesmall(poiItem)}},model:{value:(poiItem.small),callback:function ($$v) {_vm.$set(poiItem, "small", $$v)},expression:"poiItem.small"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新細","prop":"fine"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatefine(poiItem)}},model:{value:(poiItem.fine),callback:function ($$v) {_vm.$set(poiItem, "fine", $$v)},expression:"poiItem.fine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊細","prop":"oldFine"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoldfine(poiItem)}},model:{value:(poiItem.oldFine),callback:function ($$v) {_vm.$set(poiItem, "oldFine", $$v)},expression:"poiItem.oldFine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"1座位","prop":"oneSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validateoneSeats(poiItem)}},model:{value:(poiItem.oneSeats),callback:function ($$v) {_vm.$set(poiItem, "oneSeats", $$v)},expression:"poiItem.oneSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"4呎","prop":"fourRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatefourRuler(poiItem)}},model:{value:(poiItem.fourRuler),callback:function ($$v) {_vm.$set(poiItem, "fourRuler", $$v)},expression:"poiItem.fourRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3呎","prop":"threeRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":function($event){return _vm.validatethreeRuler(poiItem)}},model:{value:(poiItem.threeRuler),callback:function ($$v) {_vm.$set(poiItem, "threeRuler", $$v)},expression:"poiItem.threeRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":" "}},[_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.removeRollItem(poiItem.index)}}},[_c('i',{staticClass:"fa fa-trash"})])],1)],1)],1)],1)}),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"其他：","prop":"oneOther"}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.oneOther),callback:function ($$v) {_vm.$set(_vm.rollingForm, "oneOther", $$v)},expression:"rollingForm.oneOther"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"送盒："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.sendBox),callback:function ($$v) {_vm.$set(_vm.rollingForm, "sendBox", $$v)},expression:"rollingForm.sendBox"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"內部備註："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.internal),callback:function ($$v) {_vm.$set(_vm.rollingForm, "internal", $$v)},expression:"rollingForm.internal"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"40px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"45px","margin-top":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.createPoiItem()}}},[_vm._v("添加單")]),_vm._v(" "),_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(this.loadingSave),expression:"this.loadingSave"}],staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.feedBackSave}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1YtF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2FFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this,
            _ref;

        var validateFile = function validateFile(rule, value, callback) {
            if (value == "") {
                document.getElementById("file_name").innerHTML = _this.$t('m.t_selectthefile');
                callback(new Error(' '));
            }
            callback();
        };
        return _ref = {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            Calendar: [],
            taskForm: {
                id: '',
                taskDate: '',
                remark: '',
                calendarDate: '',
                startDate: '',
                endDate: '',
                place: '',
                salesId: ''
            },
            addDate: '', //添加行程时间
            fileList: [], //文件list
            fileName: [], //文件名称list
            taskRules: {
                salesId: [{ required: true, message: this.$t('m.m_pleaseSalesName'), trigger: 'change' }],
                place: [{ required: true, message: this.$t('m.m_pleasePlace'), trigger: 'change' }],
                startDate: [{ required: true, message: this.$t('m.m_pleaseStartdate'), trigger: 'change' }],
                endDate: [{ required: true, message: this.$t('m.m_pleaseEnddate'), trigger: 'change' }],
                remark: [{ required: true, message: this.$t('m.m_remarks'), trigger: 'change' }]
            },
            salesOptions: [],
            calendarEvents: [],
            dialogFormVisible: false,
            optTitle: '新增日歷',

            loading: false,
            value: new Date(),
            optValue: 0
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fileList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'addEidtloading', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogFileListVisible', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogFileVisible', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogFileListName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogFileName', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'datalist', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'msglist', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'forid', -1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fileListPager', {
            page: 0,
            size: 10,
            total: 0
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tableloading', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fileId', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'oldFileId', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'custFile', {
            file: "",
            comment: ""
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'custFileRules', {
            file: [{ required: true, validator: validateFile, trigger: 'change' }],
            comment: [{ required: false, message: this.$t('m.m_remarks'), trigger: 'change' }]
        }), _ref;
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.loading = true;
        this.getStaffAllList();
        this.getTaskCalendarLists();

        // console.log(this.Calendar);
        // $('#calendar').prepend('<div style="height: 2.1em;line-height:2.1em">'+
        //           '<input type="radio" name="data_type" value="0" onclick="onDataTypeclick(this)" checked><span>開始時間</span>'+
        //           '<input type="radio" name="data_type"value="1" onclick="onDataTypeclick(this)"><span>結束時間</span></div>'); 
    },

    methods: {
        getStaffAllList: function getStaffAllList() {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_13" /* getStaffAllList */])().then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                _this2.salesOptions = res.data;
            });
            //this.Calendar[0].calendarDate
            //datalist

            //console.log(this.datalist);
        },
        getSalseVal: function getSalseVal(val) {
            var obj = this.salesOptions.find(function (v) {
                return v.id == val;
            });
            if (obj == undefined) {
                return "";
            } else {
                return obj.name;
            }
        },
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {
            this.getCustFileList();
        },
        appGetImgeUrl: function appGetImgeUrl(fileUrl) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_40" /* imageUrl */])(fileUrl);
        },
        getImageUrl: function getImageUrl(index, row) {
            var fileUrl = row.relativePath;

            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_40" /* imageUrl */])(fileUrl);
        },
        openFile: function openFile(index, row) {
            var fileUrl = row.relativePath;
            window.open(Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_40" /* imageUrl */])(fileUrl));
        },
        pictureImg: function pictureImg(index, row) {
            var url = row.fileUrl;
            var suffixName = url.substr(url.lastIndexOf(".")).toLowerCase(); //获得文件后缀名
            var strFilter = ".jpeg|.gif|.jpg|.png|.bmp|.pic|";
            if (strFilter.indexOf(suffixName) > -1) {
                return true;
            } else {
                return false;
            }
        },

        //手机端上传文件
        appFileUp: function appFileUp(value) {
            this.returnId = value;
            console.log(value);
            this.custFileAdd();
        },
        handleChangeImg: function handleChangeImg($event) {
            if ($event.currentTarget.className == 'taskImg') {
                $event.currentTarget.className = 'taskImg open';
            } else {
                $event.currentTarget.className = 'taskImg';
            }
        },
        fileListEdit: function fileListEdit(value) {
            console.log(value);
            this.dialogFileListName = this.$t('m.t_enclosureadmin');
            this.dialogFileListVisible = true;
            this.returnId = value;
            this.getCustFileList();
        },
        getCustFileList: function getCustFileList() {
            var _this3 = this;

            if (this.returnId != "" || this.returnId != undefined) {
                var params = {
                    page: this.fileListPager.page,
                    size: this.fileListPager.size,
                    taskId: this.returnId,
                    typeId: 2
                };
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["z" /* getCustFileList */])(params).then(function (data) {
                    var _data$data2 = data.data,
                        res = _data$data2 === undefined ? {} : _data$data2;

                    if (res.errcode == 200) {
                        var _res$data = res.data,
                            size = _res$data.size,
                            page = _res$data.page,
                            total = _res$data.total,
                            _res$data$data = _res$data.data,
                            items = _res$data$data === undefined ? [] : _res$data$data;

                        _this3.fileList = items;
                        console.log(_this3.fileList);
                        _this3.fileListPager.total = total;
                        _this3.fileListPager.page = page;
                        _this3.fileListPager.size = size;
                        _this3.tableloading = false;
                    } else {
                        _this3.$message.error(res.errmsg);
                    }
                });
            }
        },
        custFileAdd: function custFileAdd() {
            this.dialogFileName = this.$t('m.b_uploadfile');
            this.dialogFileVisible = true;
            this.clearFile();
            //重置file
            var file = document.getElementById('file');
            if (file != null || file != undefined) {
                file.value = "";
            }
            var fileValue = document.getElementById("file_name");
            if (fileValue != null || fileValue != undefined) {
                fileValue.innerHTML = "";
            }
            this.resetForm("custFile");
        },
        getFile: function getFile(event) {
            if (event.target.files[0] != undefined && event.target.files[0] != null) {
                //this.uploadFile.file = event.target.files[0];
                var upFile = event.target.files;
                console.log(upFile);
                for (var i = 0; i < upFile.length; i++) {
                    this.fileList.push(upFile[i]);
                    this.fileName.push(upFile[i].name);
                }
            }

            // if(event.target.files[0]!=undefined&&event.target.files[0]!=null) {
            //     this.custFile.file = event.target.files[0];
            //     document.getElementById("file_name").innerHTML = this.custFile.file.name;
            // }
        },
        clearFile: function clearFile() {
            this.fileList = [];
            this.fileName = [];
        },
        custFileSave: function custFileSave() {
            // this.$refs.custFile.validate((valid) => {
            //     if (valid) {
            // let fileSize=this.custFile.file.size/1024;
            // if (fileSize>50000){
            //     this.$message.warning(this.$t('m.b_uploadfileMaxFiftyMb'));
            //     return;
            // }
            // console.log(this.fileList);
            //阻止元素发生默认的行为
            event.preventDefault();
            for (var i = 0; i < this.fileList.length; i++) {
                var token = JSON.parse(window.sessionStorage.getItem("staff")).token;
                var paramData = new FormData(); //创建form对象
                paramData.append("file", this.fileList[i]); //this.custFile.file);//通过append向form对象添加数据
                //paramData.append("comment",this.custFile.comment);//通过append向form对象添加数据
                paramData.append("typeId", 2); //通过append向form对象添加数据
                paramData.append("taskId", this.returnId); //通过append向form对象添加数据*/
                var config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': token
                    }
                };
                this.$http.post(__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL + '/fileUpload/upload', paramData, config).then(function (res) {
                    var item = res.data;
                    if (item.errcode === 200) {
                        this.$message.success(this.$t('m.m_uploadsuccess'));
                        this.getCustFileList();
                        this.resetForm("custFile");
                        this.dialogFileVisible = false;
                        this.clearFile();
                        if (this.$store.getters.ismobilePhone) {
                            this.getTaskCalendarLists();
                            //手机端刷新行程列表
                        }

                        //重置file
                        var file = document.getElementById('file');
                        file.value = '';
                        document.getElementById("file_name").innerHTML = "";
                    }
                });
            }
            // }
            //            });
        },
        deleteCustFile: function deleteCustFile(index, row) {
            var _this4 = this;

            this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.b_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["f" /* deleteCustFile */])(row.id).then(function (data) {
                    var _data$data3 = data.data,
                        errcode = _data$data3.errcode,
                        errmsg = _data$data3.errmsg;

                    if (errcode == 200) {
                        _this4.$message.success(_this4.$t('m.m_deletesuc'));
                        _this4.getCustFileList();
                        if (_this4.$store.getters.ismobilePhone) {
                            _this4.getTaskCalendarLists();
                            //手机端刷新行程列表
                        }
                    } else {
                        _this4.$message.error(errmsg);
                    }
                });
            });
        },
        fileDownload: function fileDownload(index, row) {
            window.location.href = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL + '/fileDownload?id=' + row.id;
        },
        getTaskCalendarLists: function getTaskCalendarLists() {
            var _this5 = this;

            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_33" /* getTaskCalendarList */])().then(function (result) {
                var _result$data = result.data,
                    res = _result$data === undefined ? {} : _result$data;

                _this5.Calendar = res.data;
                for (var i = 0; i < _this5.Calendar.length; i++) {
                    var cdata = _this5.Calendar[i].calendarDate;
                    // console.log(this.Calendar[i].id);
                    var cdbool = false;
                    for (var j = 0; j < _this5.datalist.length; j++) {
                        if (cdata == _this5.datalist[j]) {
                            cdbool = true;
                        }
                    }
                    if (!cdbool) _this5.datalist.push(cdata);
                }
                if (_this5.addDate != null) {
                    _this5.queryTask(_this5.addDate, 0); //刷新添加行程
                }
                // console.log(this.datalist);
            });
        },
        ToDate: function ToDate(tim) {
            //時間处理
            var d = new Date(tim);
            d.setHours(0, 0, 0, 0);
            return tim = d.setHours(0, 0, 0, 0);
        },

        // 返回 类似 2016-01-02 格式的字符串
        formatDate: function formatDate(year, month, day) {
            var y = year;
            var m = month;
            if (m < 10) m = '0' + m;
            var d = day;
            if (d < 10) d = '0' + d;
            return y + '-' + m + '-' + d;
        },
        queryTask: function queryTask(date, state) {
            var _this6 = this;

            if (state == 0) {
                this.msglist = new Array();
                this.addDate = date;
                this.forid = -1;
            }
            this.forid++;
            if (this.forid < this.Calendar.length) {
                var s = this.Calendar[this.forid].calendarDate;

                if (s == date) {
                    var params = {
                        page: 0, //this.fileListPager.page,
                        size: 10, // this.fileListPager.size,
                        taskId: this.Calendar[this.forid].id, //this.returnId,
                        typeId: 2
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["z" /* getCustFileList */])(params).then(function (data) {
                        var _data$data4 = data.data,
                            res = _data$data4 === undefined ? {} : _data$data4;

                        if (res.errcode == 200) {
                            var _res$data2 = res.data,
                                size = _res$data2.size,
                                page = _res$data2.page,
                                total = _res$data2.total,
                                _res$data2$data = _res$data2.data,
                                items = _res$data2$data === undefined ? [] : _res$data2$data;
                            // this.fileList=items;

                            _this6.msglist.push({ "taskMsg": _this6.Calendar[_this6.forid], "imgFile": items });
                            // console.log(this.msglist);
                            _this6.queryTask(date, 1);
                        } else {
                            _this6.$message.error(res.errmsg);
                        }
                    });
                } else {
                    this.queryTask(date, 1);
                }
            }
            // for(var i=0;i<this.Calendar.length;i++)
            // {
            // 		   var s=this.Calendar[i].calendarDate;
            // 		   if(s==date)
            // 		   {
            // 		    this.msglist.push(this.Calendar[i]);
            // 		  }
            // }
            // this.$router.go(0);
            // console.log(this.Calendar);
        },

        //app版本获取附件所有
        // appGetCustFileList(valueid,date)
        // {
        // 	    var params = {
        // 	        page: 0,//this.fileListPager.page,
        // 	        size:10,// this.fileListPager.size,
        // 	        taskId:valueid, //this.returnId,
        // 	        typeId: 2,
        // 	    };
        // 	    getCustFileList(params).then(data => {
        // 	        let {data:res={}}=data;
        // 	        if(res.errcode==200){
        // 	            let {size,page,total,data:items=[]}=res.data;
        // 	            this.fileList=items;


        // 	        }else {
        // 	            this.$message.error(res.errmsg);
        // 	        }
        // 	    });

        // },

        // 新增
        handleAddClick: function handleAddClick(date) {
            // console.log('====='+date)
            // console.log(this.dataBgState)
            // console.log(this.Calendar);
            // if(this.Calendar[20].hasOwnProperty("calendarDate"))
            // console.log('calendarDatek不为空')
            // else
            //  console.log('calendarDatek为空')
            // console.log(this.Calendar[0].calendarDate.slice(0,4));
            //  console.log(this.Calendar[0].calendarDate.split('-').slice(1)[0]);
            //  console.log(this.Calendar[0].calendarDate.split('-').slice(2).join('-').slice(0,2));


            //------添加日歷事情


            this.resetForm("taskForm");
            this.dialogFormVisible = true;
            this.optTitle = '新增日歷';
            this.taskForm.id = '';
            var newTime = new Date();
            if (newTime.getHours() <= 23) {
                newTime.setHours(newTime.getHours() + 1);
            }
            if (newTime.getMinutes() > 0 && newTime.getMinutes() < 15) {
                newTime.setMinutes(0);
            } else if (newTime.getMinutes() >= 15 && newTime.getMinutes() < 30) {
                newTime.setMinutes(15);
            } else if (newTime.getMinutes() >= 30 && newTime.getMinutes() < 45) {
                newTime.setMinutes(30);
            } else if (newTime.getMinutes() >= 45 && newTime.getMinutes() < 60) {
                newTime.setMinutes(45);
            } else {
                newTime.setMinutes(60);
            }
            var endTime = new Date();
            if (endTime.getHours() <= 22) {
                endTime.setHours(endTime.getHours() + 2);
            }
            if (endTime.getMinutes() > 0 && endTime.getMinutes() < 15) {
                endTime.setMinutes(0);
            } else if (endTime.getMinutes() >= 15 && endTime.getMinutes() < 30) {
                endTime.setMinutes(15);
            } else if (endTime.getMinutes() >= 30 && endTime.getMinutes() < 45) {
                endTime.setMinutes(30);
            } else if (endTime.getMinutes() >= 45 && endTime.getMinutes() < 60) {
                endTime.setMinutes(45);
            } else {
                endTime.setMinutes(60);
            }

            var startStr = "";
            var startMinStr = "";
            if (newTime.getHours() < 10) {
                startStr = '0' + newTime.getHours();
            } else {
                startStr = newTime.getHours();
            }
            if (newTime.getMinutes() < 10) {
                startMinStr = '0' + newTime.getMinutes();
            } else {
                startMinStr = newTime.getMinutes();
            }

            var endStr = "";
            var endMinStr = "";
            if (endTime.getHours() < 10) {
                endStr = '0' + endTime.getHours();
            } else {
                endStr = endTime.getHours();
            }
            if (endTime.getMinutes() < 10) {
                endMinStr = '0' + endTime.getMinutes();
            } else {
                endMinStr = endTime.getMinutes();
            }
            this.taskForm.startDate = startStr + ":" + startMinStr;
            this.taskForm.endDate = endStr + ":" + endMinStr;
            this.taskForm.calendarDate = date;
        },
        handleEventClick: function handleEventClick(info) {
            var _this7 = this;

            this.getStaffAllList();
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_32" /* getTaskCalendarById */])(info).then(function (result) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this7.taskForm, result.data.data);
            });
            this.optTitle = '修改日歷';
            this.dialogFormVisible = true;
        },

        // 保存事件
        saveEvent: function saveEvent() {
            var _this8 = this;

            this.$refs.taskForm.validate(function (valid) {
                if (valid) {

                    if (_this8.taskForm.startDate == '') {
                        _this8.taskForm.startDate = 0;
                    }
                    if (_this8.taskForm.endDate == '') {
                        _this8.taskForm.endDate = 0;
                    }
                    if (_this8.taskForm.endDate != '' && _this8.taskForm.startDate != '') {
                        var oldStartDate = _this8.taskForm.startDate.split(":");
                        var oldEndDate = _this8.taskForm.endDate.split(":");

                        if (oldStartDate[0] > oldEndDate[0] && oldStartDate[1] > oldEndDate[1]) {
                            return _this8.$message.error(_this8.$t('m.m_startmaxenddate'));
                        }
                        if (oldEndDate[0] < oldStartDate[0] && oldEndDate[1] < oldStartDate[1]) {
                            return _this8.$message.error(_this8.$t('m.m_endminstartdate'));
                        }
                    }

                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.taskForm);

                    if (_this8.taskForm.id === undefined || _this8.taskForm.id === '') {
                        // 新增
                        params.taskDate = Math.round(new Date(params.calendarDate).getTime() / 1000);
                        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_54" /* insertTaskCalendar */])(params).then(function (data) {
                            var _data$data5 = data.data,
                                res = _data$data5 === undefined ? {} : _data$data5;

                            if (res.errcode == 200) {
                                _this8.$message.success("新增成功！！");
                                _this8.resetForm("taskForm");
                                _this8.taskForm.startDate = "";
                                _this8.taskForm.endDate = "";
                                _this8.getTaskCalendarLists();
                            } else {
                                _this8.$message.error(res.errmsg);
                            }
                        });
                    } else {
                        //修改
                        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_82" /* updateTaskCalendar */])(params).then(function (data) {
                            var _data$data6 = data.data,
                                res = _data$data6 === undefined ? {} : _data$data6;

                            if (res.errcode == 200) {
                                _this8.$message.success("修改成功");
                                _this8.resetForm("taskForm");
                                _this8.taskForm.startDate = "";
                                _this8.taskForm.endDate = "";
                                _this8.getTaskCalendarLists();
                            } else {
                                _this8.$message.error(res.errmsg);
                            }
                        });
                    }
                    _this8.dialogFormVisible = false;
                }
            });
        },

        // 删除事件
        delEvent: function delEvent(id) {
            var _this9 = this;

            this.$confirm('你確定要删除任务日歷嗎?', this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["r" /* deleteTaskCalendarById */])(id).then(function (data) {
                    var _data$data7 = data.data,
                        res = _data$data7 === undefined ? {} : _data$data7;

                    if (res.errcode == 200) {
                        _this9.$message.success('刪除成功');
                        _this9.dialogFormVisible = false;
                        _this9.resetForm("taskForm");
                        _this9.getTaskCalendarLists();
                    } else {
                        _this9.$message.error("刪除失败！");
                    }
                });
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },

    computed: {
        staff: function staff() {
            return this.$store.getters.staff;
        },
        custTaskAdd: function custTaskAdd() {
            return this.$store.getters.hasPermission("TASK_ADD");
        },
        custTaskEditAll: function custTaskEditAll() {
            return this.$store.getters.hasPermission("TASK_EDIT_ALL");
        },
        custTaskEdit: function custTaskEdit() {
            return this.$store.getters.hasPermission("TASK_EDIT");
        },
        custTaskDelete: function custTaskDelete() {
            return this.$store.getters.hasPermission("TASK_DELETE");
        },
        canFile: function canFile() {
            return this.$store.getters.hasPermission("TASK_FILE");
        },
        canFileAdd: function canFileAdd() {
            return this.$store.getters.hasPermission("TASK_FILE_ADD");
        },
        canFileDow: function canFileDow() {
            return this.$store.getters.hasPermission("TASK_FILE_DOW");
        },
        canFileDel: function canFileDel() {
            return this.$store.getters.hasPermission("TASK_FILE_DEL");
        }
    }
});

/***/ }),

/***/ "2KmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.customerAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),(!_vm.$store.getters.ismobilePhone)?_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCustomerList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"客戶編號/姓名/電話","clearable":""},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"銷售員"},model:{value:(_vm.searchSalesId),callback:function ($$v) {_vm.searchSalesId=$$v},expression:"searchSalesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getCustomerList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{staticStyle:{"width":"110%"}},[_c('div',{staticClass:"banckFont",on:{"click":_vm.homeClick}},[_vm._v("客戶列表")]),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",staticStyle:{"margin":"12px 0 12px 0"},attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCustomerList.apply(null, arguments)}}},[_c('el-input',{staticStyle:{"width":"110px"},attrs:{"placeholder":"編號/姓名/電話"},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"90px"},attrs:{"filterable":"","clearable":"","placeholder":"銷售員"},model:{value:(_vm.searchSalesId),callback:function ($$v) {_vm.searchSalesId=$$v},expression:"searchSalesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getCustomerList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.ismobilePhone)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.customerTableloading),expression:"customerTableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'rgba(39,116,244,0.1)',color:'#333333'},"border":"","data":_vm.customerList},on:{"row-click":_vm.selDetails}},[_c('el-table-column',{attrs:{"prop":"code","label":"客戶編號","width":"110%"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"操作","width":"100%","align":"center"}},[_c('span',{staticStyle:{"color":"#4B78FF"},on:{"click":function($event){return _vm.selDetails(_vm.scope.row)}}},[_vm._v("查看")])])],1):_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.customerTableloading),expression:"customerTableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"border":"","data":_vm.customerList}},[_c('el-table-column',{attrs:{"prop":"code","label":"客戶編號","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"電話","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales","label":"銷售員","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"操作","width":"100%","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" 操作\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.customerEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯\n                                ")]):_vm._e(),_vm._v(" "),(_vm.canDetail)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.selDetails(scope.row)}}},[_c('i',{staticClass:"fa fa-search-plus"}),_vm._v(" 詳情\n                                ")]):_vm._e(),_vm._v(" "),(_vm.canDel)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleDelete(scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" 刪除\n                                ")]):_vm._e()],1)],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[(!_vm.$store.getters.ismobilePhone)?_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}}):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('el-pagination',{attrs:{"small":"","layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}}):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogDiscEditVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"customerForm",attrs:{"model":_vm.customerForm,"label-width":"130px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"客戶編號:","prop":"code"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text","placeholder":"請輸入客戶編號"},on:{"change":function($event){return _vm.itemChange(_vm.customerForm.code)}},model:{value:(_vm.customerForm.code),callback:function ($$v) {_vm.$set(_vm.customerForm, "code", $$v)},expression:"customerForm.code"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"姓名:","prop":"name"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"auto-complete":"off","placeholder":"請輸入姓名"},model:{value:(_vm.customerForm.name),callback:function ($$v) {_vm.$set(_vm.customerForm, "name", $$v)},expression:"customerForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"電話:","prop":"phone"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"auto-complete":"off","placeholder":"請輸入電話"},model:{value:(_vm.customerForm.phone),callback:function ($$v) {_vm.$set(_vm.customerForm, "phone", $$v)},expression:"customerForm.phone"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"地址:","prop":"address"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"textarea","autosize":{ minRows: 4, maxRows:18},"placeholder":"請輸入地址"},model:{value:(_vm.customerForm.address),callback:function ($$v) {_vm.$set(_vm.customerForm, "address", $$v)},expression:"customerForm.address"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"銷售員：","prop":"salesId"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"filterable":"","placeholder":""},model:{value:(_vm.customerForm.salesId),callback:function ($$v) {_vm.$set(_vm.customerForm, "salesId", $$v)},expression:"customerForm.salesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check"},on:{"click":_vm.customerSave}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-delete"},on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v("取 消")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2TEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[(_vm.custGroupAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.addCustGroup}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.t_newcustomergroup')))]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCustGroupPageList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_search')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.t_groupname'),"clearable":""},model:{value:(_vm.serchGroupName),callback:function ($$v) {_vm.serchGroupName=$$v},expression:"serchGroupName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.t_custcode'),"clearable":""},model:{value:(_vm.serchCustNo),callback:function ($$v) {_vm.serchCustNo=$$v},expression:"serchCustNo"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getCustGroupPageList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.custGroupList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"groupName","align":"left","label":_vm.$t('m.t_groupname')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.custGroupNameEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.custGroupEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.t_updatecustomergroup')))]):_vm._e(),_vm._v(" "),(_vm.custGroupDelete)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.deleteCustEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "+_vm._s(_vm.$t('m.t_deletecustomergroup')))]):_vm._e(),_vm._v(" "),(_vm.custGroupInfromation)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.itemEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" "+_vm._s(_vm.$t('m.t_customergroupsee')))]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custGroupPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogAddName,"visible":_vm.dialogDiscAddVisible,"width":"450px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogDiscAddVisible=$event}}},[_c('el-form',{ref:"custGroupForm",attrs:{"model":_vm.custGroupForm,"rules":_vm.custGroupRules,"label-width":"130px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_customergroupname')+'：',"prop":"groupName"}},[_c('el-input',{staticStyle:{"width":"180px"},attrs:{"auto-complete":"off"},model:{value:(_vm.custGroupForm.groupName),callback:function ($$v) {_vm.$set(_vm.custGroupForm, "groupName", $$v)},expression:"custGroupForm.groupName"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscAddVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.Addloading},on:{"click":_vm.custGroupSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogEditName,"visible":_vm.dialogDiscEditVisible,"width":"450px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"custForm",attrs:{"model":_vm.custForm,"rules":_vm.custRules,"label-width":"130px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_customer')+'：',"prop":"custNo"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"default-first-option":"","placeholder":"","filterable":"","remote":"","remote-method":_vm.itemRemoteMethod},model:{value:(_vm.custForm.custNo),callback:function ($$v) {_vm.$set(_vm.custForm, "custNo", $$v)},expression:"custForm.custNo"}},_vm._l((_vm.custOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.code,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.code))]),_vm._v(" \n                                "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.Addloading},on:{"click":_vm.custMgtSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogItemVisible,"width":"80%"},on:{"update:visible":function($event){_vm.dialogItemVisible=$event}}},[_c('div',[_c('div',{staticStyle:{"float":"right"}},[(_vm.custGroupAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.AddCustEdit}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.b_newmembergrp')))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.custGroupItemList,"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"groupName","align":"left","label":_vm.$t('m.t_groupname')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custNo","align":"left","width":"110","label":_vm.$t('m.t_custcode')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","align":"left","label":_vm.$t('m.t_memebername')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"110","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.custGroupNameEdit)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.deleteCustGroupId(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$t('m.b_breakrelation')))]):_vm._e()]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.groupPager.page,"page-size":_vm.groupPager.size,"total":_vm.groupPager.total},on:{"current-change":_vm.handleItemChange,"update:currentPage":function($event){return _vm.$set(_vm.groupPager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.groupPager, "page", $event)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"50px"}}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogItemVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3R8H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGODQ1MTU3MUFDQzkxMUU4QjYzOUEyMDZGOTE1OTNCMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGODQ1MTU3MkFDQzkxMUU4QjYzOUEyMDZGOTE1OTNCMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkY4NDUxNTZGQUNDOTExRThCNjM5QTIwNkY5MTU5M0IzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkY4NDUxNTcwQUNDOTExRThCNjM5QTIwNkY5MTU5M0IzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+/DV9gAAAADFJREFUeNpi/P//PwMWABJkRBdkwqEQmcap+D8+PhMehRjiTAQUomhgIkIhXANAgAEAcFwN/+hTDIcAAAAASUVORK5CYII="

/***/ }),

/***/ "3e/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateStockIn_vue__ = __webpack_require__("KrLK");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f02a101e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateStockIn_vue__ = __webpack_require__("0FSI");
function injectStyle (ssrContext) {
  __webpack_require__("mlcl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateStockIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f02a101e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateStockIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "44TC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pickerOptions3: {
                shortcuts: [{
                    text: this.$t("m.t_lastweek"),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t("m.t_lastmonth"),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t("m.t_lastthreemonth"),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            pickerOptions2: {
                shortcuts: [{
                    text: this.$t('m.t_lastweek'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('m.t_lastmonth'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('m.t_lastthreemonth'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            staffOptions: [],
            dataTypeArrar: [],
            groupOption: [],
            custOptions: [],
            disabled: false,
            reportForm: {
                monthDate: '',
                salesDate: '',
                yearDate: '',
                type: 0,
                custId: '',
                exportFormat: 0,
                jobNo: ''
            },
            itemStatusOption: [],
            rulesReport: {
                salesDate: [{ required: true, message: this.$t('m.m_date'), trigger: 'change' }],
                monthDate: [{ required: true, message: this.$t('m.m_monthDate'), trigger: 'change' }],
                yearDate: [{ required: true, message: this.$t('m.m_yearDate'), trigger: 'change' }]
                /* custNo: [
                     {required: true, message: this.$t('m.m_customer'), trigger: 'change' }
                 ],*/
            },
            statusOptions: [{
                value: 0,
                label: this.$t('m.t_monthDate')
            }, {
                value: 1,
                label: this.$t('m.t_quarterDate')
            }, {
                value: 2,
                label: this.$t('m.t_yearDate')
            }],
            formatOptions: [{
                value: 0,
                label: 'xlsx'
            }, {
                value: 1,
                label: 'xls'
            }, {
                value: 2,
                label: 'csv'
            }]
        };
    },

    watch: {
        valDataType: function valDataType(val, oldVal) {
            this.reportForm.monthDate = "";
            this.reportForm.salesDate = "";
            this.reportForm.type = 0;
            this.reportForm.yearDate = "";
            this.reportForm.custId = "";
            this.reportForm.jobNo = "";
            this.loadingStatus = false;
        }
    },
    methods: {
        downloadFile: function downloadFile(url, name, callback) {
            var this_ = this;
            var loading = __WEBPACK_IMPORTED_MODULE_2_element_ui__["Loading"].service({
                fullscreen: true,
                text: ''
            });
            fetch(url).then(function (response) {
                return response.blob();
            }).then(function (blob) {
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                var suffix = this_.reportForm.exportFormat === 0 ? '.xlsx' : this_.reportForm.exportFormat === 1 ? '.xls' : '.csv';
                link.download = name + suffix; // 设置下载的文件名
                link.click();
                URL.revokeObjectURL(link.href);
                callback(null, 'Download complete');
                loading.close();
            }).catch(function (error) {
                callback(error, null);
                loading.close();
            });
        },
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    var dataType = _this.reportForm.dataType;
                    switch (dataType) {
                        case 1:case 2:case 3:case 4:case 6:
                            var name = dataType === 1 ? 'task-list_' : dataType === 2 ? 'cust-list_' : dataType === 3 ? 'stockin-list_' : dataType === 4 ? 'stockout-list_' : 'stockinout-list_';
                            if (_this.reportForm.type == 0) {
                                if (_this.reportForm.monthDate != null && _this.reportForm.monthDate != "") {
                                    var str = _this.reportForm.monthDate.replace('-', '').substring(2);
                                    name += str;
                                    var startTime = Math.round(new Date(_this.reportForm.monthDate).getTime() / 1000);
                                    // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime +"&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                    _this.downloadFile(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime + "&type=" + _this.reportForm.type + '&custId=' + _this.reportForm.custId + "&exportFormat=" + _this.reportForm.exportFormat + "&token=" + _this.$store.getters.staff.token, name, function (error, message) {
                                        if (error) {
                                            console.error('Download failed:', error);
                                        } else {
                                            console.log(message);
                                        }
                                    });
                                }
                            } else if (_this.reportForm.type == 1) {
                                if (_this.reportForm.salesDate != null && _this.reportForm.salesDate != "") {
                                    var _str = _this.reportForm.salesDate[0].replaceAll('-', '').substring(2) + '_' + _this.reportForm.salesDate[1].replaceAll('-', '').substring(2);
                                    name += _str;
                                    var _startTime = Math.round(new Date(_this.reportForm.salesDate[0]).getTime() / 1000);
                                    var endTime = Math.round(new Date(_this.reportForm.salesDate[1]).getTime() / 1000);
                                    // window.location.href=axios.defaults.baseURL+'/viewReport/report/?dataType='+dataType+'&startTime='+startTime+"&endTime="+endTime+'&type='+this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                    _this.downloadFile(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + _startTime + "&endTime=" + endTime + '&type=' + _this.reportForm.type + '&custId=' + _this.reportForm.custId + "&exportFormat=" + _this.reportForm.exportFormat + "&token=" + _this.$store.getters.staff.token, name, function (error, message) {
                                        if (error) {
                                            console.error('Download failed:', error);
                                        } else {
                                            console.log(message);
                                        }
                                    });
                                }
                            } else {
                                if (_this.reportForm.yearDate != null && _this.reportForm.yearDate != "") {
                                    var _str2 = _this.reportForm.yearDate.substring(2);
                                    name += _str2;
                                    var _startTime2 = Math.round(new Date(_this.reportForm.yearDate).getTime() / 1000);
                                    // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + startTime + "&type=" + this.reportForm.type+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                                    _this.downloadFile(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + '&startTime=' + _startTime2 + "&type=" + _this.reportForm.type + '&custId=' + _this.reportForm.custId + "&exportFormat=" + _this.reportForm.exportFormat + "&token=" + _this.$store.getters.staff.token, name, function (error, message) {
                                        if (error) {
                                            console.error('Download failed:', error);
                                        } else {
                                            console.log(message);
                                        }
                                    });
                                }
                            }
                            break;
                        case 5:
                            // window.location.href = axios.defaults.baseURL + '/viewReport/report/?dataType=' + dataType+ "&type=5" +"&jobNo=" + this.reportForm.jobNo+'&custId='+this.reportForm.custId+"&exportFormat="+this.reportForm.exportFormat+"&token="+ this.$store.getters.staff.token;;
                            _this.downloadFile(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + '/viewReport/report/?dataType=' + dataType + "&type=5" + "&jobNo=" + _this.reportForm.jobNo + '&custId=' + _this.reportForm.custId + "&exportFormat=" + _this.reportForm.exportFormat + "&token=" + _this.$store.getters.staff.token, 'existing-list', function (error, message) {
                                if (error) {
                                    console.error('Download failed:', error);
                                } else {
                                    console.log(message);
                                }
                            });
                            break;
                        /* case 2:
                             window.location.href=axios.defaults.baseURL+'/viewReport/report/?dataType='+dataType+'&startTime='+startTime+"&endTime="+endTime+'&type='+this.reportForm.type+'&custId='+this.reportForm.custId;
                             break;*/
                    }
                }
            });
        },
        itemRemoteMethod: function itemRemoteMethod(query) {
            var _this2 = this;

            if (query != "") {
                var params = { custNo: query, groupId: null };
                Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    _this2.custOptions = res.data;
                });
            }
        },

        /* getItsGroupByCatCode(){
             return getGroupByCatCode("ITS").then(res=>{
                 if(res.errcode==200){
                     let {data:status=[]}=res;
                     for(let i=0;i<status.length;i++){
                         this.itemStatusOption.push(status[i]);
                     }
                 }else{
                     this.$message.error(data.errmsg);
                 }
             }).catch((error)=>{
                 console.log("getUnGroupByCatCode Error");
             })
           },*/
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    mounted: function mounted() {
        /* this.getItsGroupByCatCode();
         getStaffAll().then(data=>{
             this.staffOptions=data.data;
         });
         getCustGroupAll().then(data=>{
             this.groupOption=data.data==null?[]:data.data;
         });*/
    },

    computed: {
        canTask: function canTask() {
            return this.$store.getters.hasPermission("TASK_LIST_EXECL");
        },
        canCust: function canCust() {
            return this.$store.getters.hasPermission("CUST_LIST_EXECL");
        },
        canStorIn: function canStorIn() {
            return this.$store.getters.hasPermission("STOR_IN_EXECL");
        },
        canStorOn: function canStorOn() {
            return this.$store.getters.hasPermission("STOR_ON_EXECL");
        },
        canExisting: function canExisting() {
            return this.$store.getters.hasPermission("STOR_EXISTING_EXECL");
        },
        valDataType: function valDataType() {
            return this.reportForm.dataType;
        },
        canType1: function canType1() {
            var val = false;
            for (var i = 0; i < this.dataTypeArrar.length; i++) {
                if (this.dataTypeArrar[i].type == 1 && this.dataTypeArrar[i].view) {
                    val = true;
                }
            }
            return val;
        }
    },
    activated: function activated() {
        this.dataTypeArrar = [{
            value: 1,
            label: this.$t("m.menu_task"),
            type: 1,
            view: this.canTask
        }, {
            value: 2,
            label: this.$t("m.menu_cust"),
            type: 1,
            view: this.canCust
        }, {
            value: 3,
            label: this.$t("m.menu_storIn"),
            type: 1,
            view: this.canStorIn
        }, {
            value: 4,
            label: this.$t("m.menu_storOn"),
            type: 1,
            view: this.canStorOn
        }, {
            value: 6,
            label: this.$t("m.menu_storInOn"),
            type: 1,
            view: this.canStorOn
        }, {
            value: 5,
            label: this.$t("m.menu_existing"),
            type: 1,
            view: this.canExisting
        }];
    }
});

/***/ }),

/***/ "4AcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"feedForm",staticClass:"demo-form-inline",staticStyle:{"width":"1500px"},attrs:{"inline":true,"model":_vm.feedForm,"rules":_vm.feedRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{staticStyle:{"margin-left":"25px"},attrs:{"label":"日期：","prop":"feedDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},model:{value:(_vm.feedForm.feedDate),callback:function ($$v) {_vm.$set(_vm.feedForm, "feedDate", $$v)},expression:"feedForm.feedDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"車號：","prop":"carNumber"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},model:{value:(_vm.feedForm.carNumber),callback:function ($$v) {_vm.$set(_vm.feedForm, "carNumber", $$v)},expression:"feedForm.carNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"扎車","prop":"title"}},[_c('el-input',{staticStyle:{"width":"500px"},attrs:{"placeholder":"半卷坑紙 + 1地膠 + 2縐紋紙","clearable":""},model:{value:(_vm.feedForm.title),callback:function ($$v) {_vm.$set(_vm.feedForm, "title", $$v)},expression:"feedForm.title"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"坑紙","prop":"pitPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.pitPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "pitPaper", $$v)},expression:"feedForm.pitPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"報紙","prop":"newsPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.newsPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "newsPaper", $$v)},expression:"feedForm.newsPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"卜卜膠","prop":"buBu"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.buBu),callback:function ($$v) {_vm.$set(_vm.feedForm, "buBu", $$v)},expression:"feedForm.buBu"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"拷貝紙","prop":"copyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.copyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "copyPaper", $$v)},expression:"feedForm.copyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"毡","prop":"mat"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.mat),callback:function ($$v) {_vm.$set(_vm.feedForm, "mat", $$v)},expression:"feedForm.mat"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"保鮮紙","prop":"tinFoil"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.tinFoil),callback:function ($$v) {_vm.$set(_vm.feedForm, "tinFoil", $$v)},expression:"feedForm.tinFoil"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"高木箱","prop":"azusa"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.azusa),callback:function ($$v) {_vm.$set(_vm.feedForm, "azusa", $$v)},expression:"feedForm.azusa"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"矮木箱","prop":"shortWood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.shortWood),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortWood", $$v)},expression:"feedForm.shortWood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"鐵車","prop":"IronCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.IronCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "IronCar", $$v)},expression:"feedForm.IronCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"車仔","prop":"chelsea"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.chelsea),callback:function ($$v) {_vm.$set(_vm.feedForm, "chelsea", $$v)},expression:"feedForm.chelsea"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"軟紙","prop":"softPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.softPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "softPaper", $$v)},expression:"feedForm.softPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"爛紙","prop":"lousyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.lousyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "lousyPaper", $$v)},expression:"feedForm.lousyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"防潮珠","prop":"moistureproof"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.moistureproof),callback:function ($$v) {_vm.$set(_vm.feedForm, "moistureproof", $$v)},expression:"feedForm.moistureproof"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電批","prop":"electric"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.electric),callback:function ($$v) {_vm.$set(_vm.feedForm, "electric", $$v)},expression:"feedForm.electric"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"叉","prop":"fork"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.fork),callback:function ($$v) {_vm.$set(_vm.feedForm, "fork", $$v)},expression:"feedForm.fork"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"150px","label":"紙盒(新/舊)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地膠","prop":"toGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.toGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "toGlue", $$v)},expression:"feedForm.toGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙","prop":"gummedPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.gummedPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "gummedPaper", $$v)},expression:"feedForm.gummedPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"铁笼","prop":"cage"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.cage),callback:function ($$v) {_vm.$set(_vm.feedForm, "cage", $$v)},expression:"feedForm.cage"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"夾板(長)","prop":"plywood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.plywood),callback:function ($$v) {_vm.$set(_vm.feedForm, "plywood", $$v)},expression:"feedForm.plywood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"大","prop":"big"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.big),callback:function ($$v) {_vm.$set(_vm.feedForm, "big", $$v)},expression:"feedForm.big"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"中","prop":"inthe"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.inthe),callback:function ($$v) {_vm.$set(_vm.feedForm, "inthe", $$v)},expression:"feedForm.inthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"細","prop":"fine"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.fine),callback:function ($$v) {_vm.$set(_vm.feedForm, "fine", $$v)},expression:"feedForm.fine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"Plasma","prop":"plasma"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.plasma),callback:function ($$v) {_vm.$set(_vm.feedForm, "plasma", $$v)},expression:"feedForm.plasma"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"縐紋紙","prop":"crepePaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.crepePaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "crepePaper", $$v)},expression:"feedForm.crepePaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"平衣","prop":"flatClothing"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.flatClothing),callback:function ($$v) {_vm.$set(_vm.feedForm, "flatClothing", $$v)},expression:"feedForm.flatClothing"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"冰箱","prop":"refrigerator"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.refrigerator),callback:function ($$v) {_vm.$set(_vm.feedForm, "refrigerator", $$v)},expression:"feedForm.refrigerator"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"黑色橡筋","prop":"elastic"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.elastic),callback:function ($$v) {_vm.$set(_vm.feedForm, "elastic", $$v)},expression:"feedForm.elastic"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙板","prop":"cardboard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.cardboard),callback:function ($$v) {_vm.$set(_vm.feedForm, "cardboard", $$v)},expression:"feedForm.cardboard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("塊")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"企身","prop":"stiff"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.stiff),callback:function ($$v) {_vm.$set(_vm.feedForm, "stiff", $$v)},expression:"feedForm.stiff"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"梳化套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"床褥套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"白水松："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"散箱","prop":"bulktank"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.bulktank),callback:function ($$v) {_vm.$set(_vm.feedForm, "bulktank", $$v)},expression:"feedForm.bulktank"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙卡板","prop":"paperCardBoard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.paperCardBoard),callback:function ($$v) {_vm.$set(_vm.feedForm, "paperCardBoard", $$v)},expression:"feedForm.paperCardBoard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3座位","prop":"threeSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.threeSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeSeats", $$v)},expression:"feedForm.threeSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"6呎","prop":"sixRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.sixRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "sixRuler", $$v)},expression:"feedForm.sixRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"1吋","prop":"oneSmall"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.oneSmall),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSmall", $$v)},expression:"feedForm.oneSmall"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"開木箱工具","prop":"tool"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.tool),callback:function ($$v) {_vm.$set(_vm.feedForm, "tool", $$v)},expression:"feedForm.tool"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠(110cm)","prop":"glue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.glue),callback:function ($$v) {_vm.$set(_vm.feedForm, "glue", $$v)},expression:"feedForm.glue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"2座位","prop":"twoSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.twoSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "twoSeats", $$v)},expression:"feedForm.twoSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"5呎","prop":"fiveRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.fiveRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fiveRuler", $$v)},expression:"feedForm.fiveRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"半吋","prop":"small"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.small),callback:function ($$v) {_vm.$set(_vm.feedForm, "small", $$v)},expression:"feedForm.small"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(長)","prop":"lengthFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.lengthFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "lengthFloor", $$v)},expression:"feedForm.lengthFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(短)","prop":"shortFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.shortFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortFloor", $$v)},expression:"feedForm.shortFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"1座位","prop":"oneSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.oneSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSeats", $$v)},expression:"feedForm.oneSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"4呎","prop":"fourRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.fourRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fourRuler", $$v)},expression:"feedForm.fourRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"吊繩","prop":"theWire"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.theWire),callback:function ($$v) {_vm.$set(_vm.feedForm, "theWire", $$v)},expression:"feedForm.theWire"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"滑潤","prop":"smooth"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.smooth),callback:function ($$v) {_vm.$set(_vm.feedForm, "smooth", $$v)},expression:"feedForm.smooth"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠(120cm)","prop":"oneGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.oneGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneGlue", $$v)},expression:"feedForm.oneGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3呎","prop":"threeRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.threeRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeRuler", $$v)},expression:"feedForm.threeRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"搬花網","prop":"wireMesh"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.wireMesh),callback:function ($$v) {_vm.$set(_vm.feedForm, "wireMesh", $$v)},expression:"feedForm.wireMesh"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"積車","prop":"productCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.productCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "productCar", $$v)},expression:"feedForm.productCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙冚","prop":"tape"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":""},on:{"change":_vm.validateChange},model:{value:(_vm.feedForm.tape),callback:function ($$v) {_vm.$set(_vm.feedForm, "tape", $$v)},expression:"feedForm.tape"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"其他：","prop":"other"}},[_c('el-input',{staticStyle:{"width":"1200px"},attrs:{"placeholder":"","clearable":""},model:{value:(_vm.feedForm.other),callback:function ($$v) {_vm.$set(_vm.feedForm, "other", $$v)},expression:"feedForm.other"}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.feedBackSave}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4XP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateFeedBack_vue__ = __webpack_require__("HPlT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d9e0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateFeedBack_vue__ = __webpack_require__("T7El");
function injectStyle (ssrContext) {
  __webpack_require__("KDGA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateFeedBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d9e0ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateFeedBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4kQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            feedForm: {
                feedDate: "",
                carNumber: '',
                title: '',
                pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '',
                copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                IronCar: '',
                toGlue: '',
                softPaper: '',
                lousyPaper: '',
                moistureproof: '',
                electric: '',
                gummedPaper: '',
                big: '',
                inthe: '',
                fine: '',
                plasma: '',
                crepePaper: '',
                flatClothing: '',
                refrigerator: '',
                elastic: '',
                cardboard: '',
                stiff: '',
                bulktank: '',
                paperCardBoard: '',
                threeSeats: '',
                twoSeats: '',
                oneSeats: '',
                threeRuler: '',
                fourRuler: '',
                fiveRuler: '',
                sixRuler: '',
                oneSmall: '',
                small: '',
                tool: '',
                glue: '',
                cage: '',
                theWire: '',
                plywood: '',
                oneGlue: '',
                wireMesh: '',
                productCar: '',
                tape: '',
                other: '',

                fork: '', //叉
                shortFloor: '', //短木板
                lengthFloor: '',
                chelsea: '', //車仔
                smooth: '' //滑潤
            },
            feedRules: {
                feedDate: [{ required: true, message: '日期不能為空', trigger: 'change' }],
                carNumber: [{ required: true, message: '車號不能為空', trigger: 'change' }],
                title: [{ required: true, message: '不能為空', trigger: 'change' }]
            }
        };
    },

    methods: {
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        validateChange: function validateChange(ev) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,1}$/;
                if (!re.test(ev)) {
                    this.$message.error("請輸入正確的格式，數字只有1位小數");
                    return false;
                }
            }
        },

        /*  validateChangeList(ev){
              if(ev!=null && ev!=''){
                  var str = ev.split("/");
                  console.log(str[0]+"==="+str[1]);
                  var re=/^[0-9]\d*\.{0,1}\d{0,1}$/;
                  if(!re.test(str[0]) && !re.test(str[1])){
                      this.$message.error("請輸入正確的格式，數字只有1位小數");
                      return false;
                  }
              }
          },*/
        feedBackSave: function feedBackSave() {
            var _this = this;

            this.$refs.feedForm.validate(function (valid) {
                if (valid) {
                    if (_this.feedForm.feedDate == '') {
                        _this.feedForm.feedDate = 0;
                    }
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.feedForm);
                    params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                    params.status = 0;
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_43" /* insertFeedBack */])(params).then(function (data) {
                        var _data$data = data.data,
                            errcode = _data$data.errcode,
                            errmsg = _data$data.errmsg;

                        if (errcode == 200) {
                            _this.$message.success("保存成功");
                            _this.resetForm("feedForm");
                            _this.$router.push({
                                name: '回料紙',
                                params: { str: new Date().getTime() }
                            });
                            _this.$store.commit("closeTab", 'feedAdd');
                        } else {
                            _this.$message.error("保存失败");
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                name: '回料紙',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "feedAdd");
        }
    },
    mounted: function mounted() {},
    activated: function activated() {},

    computed: {}
});

/***/ }),

/***/ "55r/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5CEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rolling_vue__ = __webpack_require__("vd4L");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e722aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rolling_vue__ = __webpack_require__("1Xoy");
function injectStyle (ssrContext) {
  __webpack_require__("1YtF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rolling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17e722aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rolling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5Qma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[(_vm.form.sCodeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sCode))])]:[_c('el-select',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow,"filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethodIn,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelect($event)},"focus":function($event){return _vm.isNullOptions()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),(_vm.canAdd)?[(!_vm.rkCont)?[_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleSelect()}}},[_vm._v("新 建")])],1)]:_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_vm._l((_vm.addStorOnList),function(stor,index){return [(_vm.addStorOn)?_c('table',{key:index,staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_vm._v("可出倉")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',[_vm._v("出倉")])])]),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',{key:index,class:storOn.state === 1?'stateShow':'',attrs:{"id":storOn.id}},[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('label',{staticClass:"my_protocol"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.checkedOne(index)}}}),_c('span')])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('br')])])],2):_vm._e()]}),_vm._v(" "),_vm._l((_vm.storOnList),function(stor,index){return [_c('table',{key:index,staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[(!_vm.rkCont)?[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(stor.createDate))]),_vm._v(" "),_c('span',{staticStyle:{"padding-right":"215px"}},[_vm._v("已出倉")])]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_c('el-button',{on:{"click":function($event){return _vm.printing(stor.storOnItem[0])}}},[_vm._v("打印")]),_vm._v(" "),(stor.state === 1)?[_c('el-button',{on:{"click":function($event){return _vm.storOn(stor)}}},[_vm._v("確定出倉")])]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                體積"),(_vm.storOnList[0].storOnItem[0].unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.storOnList[0].storOnItem[0].unitVolume==='1'?'箱':_vm.storOnList[0].storOnItem[0].unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("件數")]),_vm._v(" "),(_vm.rkCont)?[_c('th',[_vm._v("操作")])]:_vm._e(),_vm._v(" "),(_vm.rkCont)?[_c('th',{attrs:{"width":"18%"}},[_vm._v("備注")])]:_vm._e()],2)],2),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',{key:index},[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.remainingVolume))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.remainingQuantity))]),_vm._v(" "),(_vm.rkCont)?[_c('td',{staticClass:"actions"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.handleStor(index)}}},[_vm._v("\n                                        出倉\n                                    ")])],1)]:_vm._e(),_vm._v(" "),(_vm.rkCont)?[_c('td',{staticClass:"actions",attrs:{"width":"18%"}},[_vm._v(_vm._s(storOn.remark))])]:_vm._e()],2)}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}})])],2)]}),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[(_vm.canEdit)?[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v(" 保 存")])]:_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 取 消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],2)],2)])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"出倉","visible":_vm.dialogVisible,"width":"500px","close-on-click-modal":false,"show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{attrs:{"model":_vm.dialogForm,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"編號"}},[_c('span',[_vm._v(_vm._s(_vm.dialogForm.boxNo))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物品"}},[_c('span',[_vm._v(_vm._s(_vm.dialogForm.item))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":'出整' + _vm.dialogForm.unit}},[_c('el-checkbox',{attrs:{"true-label":1,"false-label":0},on:{"change":_vm.handleAll},model:{value:(_vm.dialogForm.state),callback:function ($$v) {_vm.$set(_vm.dialogForm, "state", $$v)},expression:"dialogForm.state"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"出部分"}},[_c('el-checkbox',{staticStyle:{"margin-right":"10px"},attrs:{"true-label":4,"false-label":0},on:{"change":_vm.handleAll},model:{value:(_vm.dialogForm.state),callback:function ($$v) {_vm.$set(_vm.dialogForm, "state", $$v)},expression:"dialogForm.state"}}),_vm._v(" "),_c('el-input-number',{attrs:{"size":"small","min":1,"max":_vm.dialogForm.remainingQuantity,"label":""},model:{value:(_vm.dialogForm.quantity),callback:function ($$v) {_vm.$set(_vm.dialogForm, "quantity", $$v)},expression:"dialogForm.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('template',{slot:"label"},[_vm._v("\n                    出倉體積\n                ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"160px"},attrs:{"size":"small","disabled":!this.dialogForm.remainingVolume || _vm.volumeDisabled},on:{"blur":_vm.handleBlurVolume,"input":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.dialogForm.volume),callback:function ($$v) {_vm.$set(_vm.dialogForm, "volume", $$v)},expression:"dialogForm.volume"}}),(_vm.dialogForm.unitVolume)?_c('span',[_vm._v(" "+_vm._s(_vm.dialogForm.unitVolume==='1'?'箱':_vm.dialogForm.unitVolume==='2'?'cu.ft':'m³'))]):_vm._e()],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"出倉金額"}},[_vm._v("\n                "+_vm._s(_vm.formatCurrency(_vm.dialogForm.amount))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.handleItem}},[_vm._v("確定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "66ga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedBackList_vue__ = __webpack_require__("67vk");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e2ec6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedBackList_vue__ = __webpack_require__("w99b");
function injectStyle (ssrContext) {
  __webpack_require__("wV9u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedBackList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6e2ec6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedBackList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "67vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查詢條件
            serchCarNumber: "",
            serchStatus: '',
            getFeedDate: '',
            selectionItems: [],
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            custTaskList: [],
            dialogName: '',
            tableloading: false
        };
    },

    methods: {
        pdfDownload: function pdfDownload(value) {
            var url = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + "/excel/feedStock?feedId=" + value.id + "&token=" + this.$store.getters.staff.token;
            window.location.href = url;
        },
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {},
        custTaskPageChange: function custTaskPageChange(val) {
            this.getFeedBackList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        getFeedBackList: function getFeedBackList() {
            var _this = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, carNumber: this.serchCarNumber.trim(), feedDate: this.getFeedDate, status: this.serchStatus };
            if (params.feedDate != null && params.feedDate != '') {
                params.feedDate = parseInt(new Date(params.feedDate).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["G" /* getFeedBackList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this.custTaskList = items;
                    _this.pager.total = total;
                    _this.pager.page = page;
                    _this.pager.size = size;
                    _this.tableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        feedBackEdit: function feedBackEdit(row) {
            this.$router.push({
                name: '編輯回料纸',
                params: {
                    feedId: row.id
                }
            });
            var path = "/feedEdit/" + row.id;
            this.$router.push(path);
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getFeedBackList();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("FEED_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("FEED_EDIT");
        },
        canPdf: function canPdf() {
            return this.$store.getters.hasPermission("FEED_PDF");
        }
    }
});

/***/ }),

/***/ "6gl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            titleTxt: ["PALLET#", "DIMENSION(CM)", "CBM", "PKGS."],
            acctId: '',
            acctItemId: '',
            jobJsonList: [],
            jobPalletList: [],
            jobJsonList2: [], //变为2维数组
            jobJsonNumList: [], //数字数组

            jobPalletNumList: [], //版号数组
            jobTrcount: 0,
            jobForm: {
                id: '',
                jobId: ''
            },
            forNum: 0,
            dateMap: {},
            /*printName:'',
            printDate:new Date(),*/
            jobOrderForms: {
                jobNo: '',
                printName: '',
                printDate: '',
                startDate: ''
            },
            dialogFileVisible: false,
            dialogFileName: '',
            addEidtloading: false,
            boxFile: {
                box: '',
                pallet: '',
                jobId: '',
                boxOldId: '',
                palletOldId: ''
            },
            boxFileRules: {
                pallet: [{ required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入數字！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }]
            }
        };
    },

    methods: {
        getIssueDate: function getIssueDate(value) {
            if (value != '' || value != 0) {
                var d = new Date(value);
                var m = d.getMonth() + 1;
                return d.getFullYear() + '-' + m + '-' + d.getDate();
            }
        },
        boxClick: function boxClick(item) {
            this.boxFile.box = item.index;
            this.boxFile.pallet = item.pallet;
            this.boxFile.boxOldId = item.boxOldId;
            this.boxFile.palletOldId = item.palletOldId;
            this.boxFile.jobId = this.acctId;
            this.dialogFileVisible = true;
            this.addEidtloading = false;
            this.dialogFileName = "編輯卡板箱號";
        },
        boxSave: function boxSave() {
            var _this = this;

            this.$refs.boxFile.validate(function (valid) {
                if (valid) {
                    /*  this.$confirm("你確定要編輯箱號為" + this.boxFile.box + "的卡板號嗎？", this.$t('m.m_info'), {
                          cancelButtonText: this.$t('m.b_cancel'),
                          confirmButtonText: this.$t('m.t_confirm'),
                          type: 'warning'
                      }).then(() => {*/
                    _this.addEidtloading = true;
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this.boxFile);
                    Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_71" /* updateJobPalletPrint */])(params).then(function (data) {
                        var _data$data = data.data,
                            errcode = _data$data.errcode,
                            errmsg = _data$data.errmsg;

                        if (errcode == 200) {
                            _this.$message.success("編輯成功！");
                            _this.dialogFileVisible = false;
                            _this.addEidtloading = false;
                            _this.queryOneAcctRec(_this.acctId, _this.acctItemId);
                        } else {
                            _this.$message.error("編輯失敗！");
                        }
                    });
                    /*})*/
                }
            });
        },
        jobPallSave: function jobPallSave() {
            var _this2 = this;

            this.jobForm.jobId = this.acctId;
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.jobForm);
            params.printName = this.jobOrderForms.printName;
            params.printDate = Math.round(new Date(this.jobOrderForms.printDate).getTime() / 1000);
            var idList = [];
            var palletList = [];
            var pkgSList = [];
            var cbmList = [];
            var cmLongList = [];
            var cmWideList = [];
            var cmHighList = [];

            this.jobPalletList.forEach(function (v, i) {
                return idList[i] = v.id;
            });
            this.jobPalletList.forEach(function (v, i) {
                return palletList[i] = v.pallet;
            });
            this.jobPalletList.forEach(function (v, i) {
                return pkgSList[i] = v.pkgS;
            });
            this.jobPalletList.forEach(function (v, i) {
                return cbmList[i] = v.cbm;
            });
            this.jobPalletList.forEach(function (v, i) {
                return cmLongList[i] = v.cmLong;
            });
            this.jobPalletList.forEach(function (v, i) {
                return cmWideList[i] = v.cmWide;
            });
            this.jobPalletList.forEach(function (v, i) {
                return cmHighList[i] = v.cmHigh;
            });

            params.idList = idList;
            params.palletList = palletList;
            params.pkgSList = pkgSList;
            params.cbmList = cbmList;
            params.cmLongList = cmLongList;
            params.cmWideList = cmWideList;
            params.cmHighList = cmHighList;
            Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_70" /* updateJobPallet */])(params).then(function (data) {
                var _data$data2 = data.data,
                    errcode = _data$data2.errcode,
                    errmsg = _data$data2.errmsg;

                if (errcode == 200) {
                    _this2.$message.success("修改成功");
                    _this2.resetForm("jobForm");
                    _this2.acctId = '';
                    _this2.acctItemId = '';
                    _this2.jobJsonList = [];
                    _this2.jobJsonNumList = [], //数字数组
                    _this2.jobPalletNumList = [], //版号数组
                    _this2.jobTrcount = 0;
                    _this2.$router.push({
                        name: '工作單',
                        params: { str: new Date().getTime() }
                    });
                    _this2.$store.commit("closeTab", 'jobPrint');
                } else {
                    _this2.$message.error("修改失败！");
                }
            });
        },
        goBack: function goBack() {
            this.acctId = '';
            this.acctItemId = '';
            this.jobJsonList = [];
            this.jobJsonNumList = [], //数字数组
            this.jobPalletNumList = [], //版号数
            this.jobTrcount = 0;
            this.$router.push({
                name: '工作單',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "jobPrint");
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        getJobParams: function getJobParams() {
            if (this.acctId == '') {
                this.acctId = this.$route.params.jobId;
                this.acctItemId = this.$route.params.id;
                if (this.acctId != '' || this.acctId != undefined) {
                    this.queryOneAcctRec(this.acctId, this.acctItemId);
                }
            }
            if (this.acctId != this.$route.params.jobId && this.$route.params.jobId != undefined) {
                this.acctId = this.$route.params.jobId;
                this.acctItemId = this.$route.params.id;
                this.queryOneAcctRec(this.acctId, this.acctItemId);
            }
        },
        queryOneAcctRec: function queryOneAcctRec(acctId, acctItemId) {
            var _this3 = this;

            Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["S" /* getJobRecord */])(acctItemId).then(function (data) {
                var item = data.data;
                if (item.data[0] != null) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this3.jobOrderForms, item.data[0]);
                    if (item.data[0].printDate == 0 || item.data[0].printDate == null) {
                        _this3.jobOrderForms.printDate = new Date();
                    } else {
                        _this3.jobOrderForms.printDate = new Date(item.data[0].printDate * 1000);
                    }
                    if (item.data[0].startDate == 0 || item.data[0].startDate == null) {
                        _this3.jobOrderForms.startDate = new Date();
                    } else {
                        _this3.jobOrderForms.startDate = new Date(item.data[0].startDate * 1000);
                    }
                }
            });
            //this.jobOrderForms.printDate=new Date();
            this.jobPalletList = [];
            var params = { jobId: acctId };
            Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["R" /* getJobPalletList */])(params).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                _this3.jobPalletList = res.data;
            });
            this.jobTrcount = 0;
            this.jobJsonList = [];
            this.jobJsonNumList = [], //数字数组
            this.jobPalletNumList = [], //版号数组

            Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["O" /* getJobJsonList */])(params).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;

                _this3.jobJsonList = res.data;
                if (_this3.jobJsonList.length > 0) {
                    _this3.jobTrcount = _this3.jobJsonList[0].number;
                    /*	this.jobTrcount=Math.ceil(this.jobJsonList.length/10);//这个是多少行
                                    const iconsArr = []; // 声明数组
                                    this.jobJsonList.forEach((item, index) => {
                                    const page = Math.floor(index / 10); // 计算该元素为第几个素组内
                                    if (!iconsArr[page]) { // 判断是否存在
                                      iconsArr[page] = [];
                                    }
                                    iconsArr[page].push(item);
                                  });
                    	this.jobJsonList2=iconsArr;*/

                    for (var i = 0; i < _this3.jobTrcount * 10; i++) {
                        _this3.jobJsonNumList.push(i + 1);
                    }
                    var iconsArr = []; // 声明数组
                    _this3.jobJsonNumList.forEach(function (item, index) {
                        var page = Math.floor(index / 10); // 计算该元素为第几个素组内
                        if (!iconsArr[page]) {
                            // 判断是否存在
                            iconsArr[page] = [];
                        }
                        iconsArr[page].push(item);
                    });
                    _this3.jobJsonList2 = iconsArr;

                    var iconsArr1 = []; // 声明数组
                    _this3.jobPalletNumList = [];
                    _this3.jobJsonNumList.forEach(function (item, index) {
                        var page = Math.floor(index / 10); // 计算该元素为第几个素组内
                        if (!iconsArr1[page]) {
                            // 判断是否存在
                            iconsArr1[page] = [];
                        }
                        var boxN = 0;
                        var boxId = 0;
                        var palletId = 0;
                        for (var j = 0; j < _this3.jobJsonList.length; j++) {
                            if (item == _this3.jobJsonList[j].box) {
                                boxN = _this3.jobJsonList[j].pallet;
                                boxId = _this3.jobJsonList[j].boxOldId;
                                palletId = _this3.jobJsonList[j].palletOldId;
                                break;
                            }
                        }

                        if (boxN != 0) {
                            _this3.boxName = {
                                index: item,
                                pallet: boxN,
                                boxOldId: boxId,
                                palletOldId: palletId
                            }, iconsArr1[page].push(_this3.boxName);
                        } else {
                            _this3.boxName = {
                                index: item,
                                pallet: "",
                                boxOldId: "",
                                palletOldId: ""
                            }, iconsArr1[page].push(_this3.boxName);
                        }
                    });
                    _this3.jobPalletNumList = iconsArr1;
                }
            });
        }
    },
    activated: function activated() {
        this.getJobParams();
    }
});

/***/ }),

/***/ "8KJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        var validateFile = function validateFile(rule, value, callback) {
            if (value == "") {
                document.getElementById("file_name").innerHTML = _this.$t('m.t_selectthefile');
                callback(new Error(' '));
            }
            callback();
        };
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查询條件
            serchItemName: "",
            itemStorList: [],
            itemOptions: [],
            custNo: '',
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            tableloading: false,
            dialogCodeName: '',
            dialogCodeVisible: false,
            addEidtloading: false,
            itemForm: {
                id: '',
                itemName: '',
                qty: '',
                oldQty: 0,
                remark: '',
                adjQty: ''
            },
            itemRules: {
                itemName: [{ required: true, message: "請輸入產品", trigger: 'change' }],
                qty: [{ required: true, message: "請輸入調整數量", trigger: 'change' }, { required: true, validator: function validator(rule, value, callback) {
                        var reg = /^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正確的格式，且只有兩位小數'));
                            }
                        }
                        callback();
                    }, trigger: 'blur' }],
                adjQty: [{ required: true, message: "請輸入調整數量", trigger: 'change' }, { required: true, validator: function validator(rule, value, callback) {
                        var reg = /^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正確的格式，且只有兩位小數'));
                            }
                        }
                        callback();
                    }, trigger: 'blur' }],
                remark: [{ required: true, message: "請輸入原因", trigger: 'change' }]
            },

            diaItemsName: '',
            dialogItemVisible: false,
            itemLogList: [],
            selectionItems: [],

            showInfoTitle: '',
            divShowInfo: false,
            storInfoList: [],
            storloading: false
        };
    },

    methods: (_methods = {
        calculateQty: function calculateQty(value) {
            var reg = /^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    return;
                } else {
                    this.itemForm.adjQty = Number(this.itemForm.oldQty + parseFloat(value)).toFixed(2);
                }
            }
        },
        calculateAdjQty: function calculateAdjQty(value) {
            var reg = /^[-]?[0-9]\d*\.{0,1}\d{0,2}$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    return;
                } else {
                    if (this.itemForm.oldQty < parseFloat(value)) {
                        this.itemForm.qty = Number(parseFloat(value) - this.itemForm.oldQty).toFixed(2);
                    } else {
                        this.itemForm.qty = Number((this.itemForm.oldQty - parseFloat(value)) * -1).toFixed(2);
                    }
                }
            }
        },
        validateItemName: function validateItemName(itemName) {
            var _this2 = this;

            var params = { itemName: itemName };
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["M" /* getItemRecord */])(params).then(function (data) {
                var item = data.data.data;
                if (item != null && item != "") {
                    _this2.itemForm.itemName = "";
                    return _this2.$message.error("該產品名已經存在！");
                }
            });
        },
        showInfo: function showInfo(row) {
            var _this3 = this;

            this.showInfoTitle = "详情";
            this.divShowInfo = true;
            this.storloading = true;
            var params = null;
            if (row.remark == null) {
                params = { name: "" };
            } else {
                params = { name: row.remark };
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_7" /* getRollingItemRecordByNo */])(params).then(function (data) {
                _this3.storInfoList = data.data.data;
                _this3.storloading = false;
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },

        //日志记录
        updateLog: function updateLog(id) {
            var _this4 = this;

            this.tableloading = true;
            this.dialogItemVisible = true;
            this.diaItemsName = "修改日誌";
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_17" /* getStockAdjId */])(id).then(function (data) {
                _this4.itemLogList = data.data.data;
                _this4.tableloading = false;
            });
        },
        validateNum: function validateNum(num) {
            if (num != '' && num != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(num)) {
                    this.itemForm.Qty = "";
                    return this.$message.error("請輸入正確的格式，且只有兩位小數");
                }
            }
        },
        itemListSave: function itemListSave() {
            var _this5 = this;

            this.$refs.itemForm.validate(function (valid) {
                if (valid) {
                    _this5.addEidtloading = true;
                    if (_this5.itemForm.id != '') {
                        var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this5.itemForm);
                        return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_68" /* updateItemStock */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                _this5.$message.success("修改货品成功!");
                                _this5.dialogCodeVisible = false;
                                _this5.addEidtloading = false;
                                _this5.itemClean();
                                _this5.getItemStorList();
                            } else {
                                _this5.addEidtloading = false;
                                _this5.$message.error(res.errmsg);
                            }
                        }).catch(function (error) {
                            console.log("updateSave Error");
                        });
                    } else {
                        var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this5.itemForm);
                        return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* addItems */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                _this5.$message.success(_this5.$t('m.m_newgoodssuc'));
                                _this5.dialogCodeVisible = false;
                                _this5.addEidtloading = false;
                                _this5.itemClean();
                                _this5.getItemStorList();
                            } else {
                                _this5.addEidtloading = false;
                                _this5.$message.error(res.errmsg);
                            }
                        }).catch(function (error) {
                            console.log("updateSave Error");
                        });
                    }
                }
            });
        },
        itemListAdd: function itemListAdd() {
            this.itemClean();
            this.dialogCodeName = "添加產品";
            this.dialogCodeVisible = true;
        },
        itemClean: function itemClean() {
            this.itemForm.id = "";
            this.itemForm.qty = "";
            this.itemForm.remark = "";
            this.itemForm.adjQty = "";
            this.itemForm.itemName = "";
            this.itemForm.oldQty = 0;
        },

        //编辑
        itemEdit: function itemEdit(row) {
            //this.resetForm("itemForm");
            this.dialogCodeName = "修改產品倉存";
            this.dialogCodeVisible = true;
            this.getItemNameById(row.itemName);
        },
        getItemNameById: function getItemNameById(itemName) {
            var _this6 = this;

            var params = { itemName: itemName };
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["M" /* getItemRecord */])(params).then(function (data) {
                var item = data.data.data;
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this6.itemForm, item);
                _this6.itemForm.qty = "";
                _this6.itemForm.adjQty = "";
                _this6.itemForm.remark = "";
            });
        },

        //隐藏事件
        updateStatus: function updateStatus(id) {
            var _this7 = this;

            this.$confirm('你確定要隱藏該產品嗎?', this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["j" /* deleteItemById */])(id).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode == 200) {
                        _this7.$message.success('隱藏成功');
                        _this7.getItemStorList();
                    } else {
                        _this7.$message.error("隱藏失败！");
                    }
                });
            });
        },
        itemOptionChange: function itemOptionChange() {
            this.getItemStorList();
        },
        getItemOptions: function getItemOptions(itemCode) {
            var _this8 = this;

            if (itemCode != "") {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["K" /* getItemAll */])(itemCode).then(function (data) {
                    _this8.itemOptions = data.data.data;
                });
            }
        },
        itemPageChange: function itemPageChange(val) {
            this.getItemStorList();
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'handleSelectionChange', function handleSelectionChange(val) {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'getItemStorList', function getItemStorList() {
        var _this9 = this;

        this.tableloading = true;
        var params = { itemName: this.serchItemName };
        return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["N" /* getItemStorListAll */])(params).then(function (data) {
            _this9.itemStorList = data.data.data;

            _this9.tableloading = false;
        });
        /* var params={page:this.pager.page,size:this.pager.size,itemName:this.serchItemName};
        return getItemStorList(params).then(data=>{
            let {data:res={}}=data;
            if(res.errcode==200){
                let {size,page,total,data:items=[]}=res.data;
                this.itemStorList=items;
                this.pager.total=total;
                this.pager.page=page;
                this.pager.size=size;
                this.tableloading=false;
            }else{
                this.$message.error(res.errmsg);
            }
        });*/
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'resetForm', function resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields();
        }
    }), _methods),
    mounted: function mounted() {},
    activated: function activated() {
        this.addEidtloading = false;
        this.getItemStorList();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ITEM_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("ITEM_EDIT");
        },
        canDetails: function canDetails() {
            return this.$store.getters.hasPermission("ITEM_DETAILS");
        },
        candHide: function candHide() {
            return this.$store.getters.hasPermission("ITEM_HIDE");
        },
        candLOG: function candLOG() {
            return this.$store.getters.hasPermission("ITEM_LOG");
        }
    }
});

/***/ }),

/***/ "8KPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[(_vm.EDIT_LOCATION)?[_c('div',{staticClass:"right"},[(_vm.$store.getters.sta)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.locationAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")]):_vm._e()],1)]:_vm._e()],2),_vm._v(" "),(_vm.loadingimg)?_c('div',{staticStyle:{"position":"absolute","left":"50%","top":"34%"}},[_c('img',{attrs:{"src":__webpack_require__("JV7o")}})]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('div',{staticClass:"ind_main"},[_c('div',{staticClass:"ind_cont"},[(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"tabs"},_vm._l((_vm.locationList),function(flo){return _c('div',{staticClass:"tab-item",class:{'active':flo.floor == _vm.num},attrs:{"id":'tab'+flo.floor}},[_c('div',{staticClass:"ind_txt"},[_c('div',{staticClass:"fl"},[_vm._v("\n\t\t\t\t\t\t\t\t\t當前"),_c('span',{staticStyle:{"color":"#285EFF"}},[_vm._v(_vm._s(_vm.presentnum)+"/F")]),_c('span',{staticStyle:{"color":"#333333"}},[_vm._v("樓層共"+_vm._s(flo.floorcount)+"個位置，剩餘"+_vm._s(flo.floorcount-flo.usecount)+"個 ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#FF394D"}},[_vm._v("( "+_vm._s(_vm.useflocountSum)+"/"+_vm._s(_vm.floorcountSum)+" ) 空置率："+_vm._s(((_vm.floorcountSum - _vm.useflocountSum)/_vm.floorcountSum*100).toFixed(2))+"%")])]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"tab_box"},[_c('table',{staticClass:"tab1",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((4),function(n){return _c('tr',{staticClass:"xuline",staticStyle:{"width":"24%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'cur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).state == 1&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td')]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount <=1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0 )?[_c('td',{staticClass:"cur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name))]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount > 1&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0 )?[_c('td',{staticClass:"curTwo",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zVBY")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 0 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"curThree",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t  "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t  ")])])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==1)?[_c('td',{staticClass:"curFive",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t  "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t  ")])])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td',{staticClass:"curfour"})]:_vm._e()]})],2)}),0),_vm._v(" "),_c('table',{staticClass:"tab2",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((10),function(n){return (n>4)?_c('tr',{staticClass:"xuline",staticStyle:{"width":"16%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'cur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td',{staticClass:"curfour"})]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 && flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount <= 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"cur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 && flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount > 1&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"curTwo",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t    ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zVBY")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 0&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"curThree",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==1)?[_c('td',{staticClass:"curFive",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t  "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t  ")])])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td',{staticClass:"curfour"})]:_vm._e()]})],2):_vm._e()}),0),_vm._v(" "),_c('table',{staticClass:"tab3",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((16),function(n){return (n>10)?_c('tr',{staticClass:"xuline",staticStyle:{"width":"16%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'cur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t\t\t\t\t   ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td',{staticClass:"curfour"})]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 && flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount <= 1&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"cur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 && flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).isCount > 1&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"curTwo",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zVBY")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 0&&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==0)?[_c('td',{staticClass:"curThree",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t   "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t   ")])])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).state == 1 &&flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).type ==1)?[_c('td',{staticClass:"curFive",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).whetherPublic,flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)}}},[_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t  "+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t  ")])])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td',{staticClass:"curfour"})]:_vm._e()]})],2):_vm._e()}),0)]),_vm._v(" "),(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"tongji"},[_c('div',{staticClass:"fl_1"},[_c('span',{staticStyle:{"color":"#C0C0C0"}},[_vm._v(_vm._s(flo.aInfoa))]),_vm._v("/"+_vm._s(flo.aInfob))]),_vm._v(" "),_c('div',{staticClass:"fl_2"},[_c('span',{staticStyle:{"color":"#C0C0C0"}},[_vm._v(_vm._s(flo.bInfoa))]),_vm._v("/"+_vm._s(flo.bInfob))]),_vm._v(" "),_c('div',{staticClass:"fl_3"},[_c('span',{staticStyle:{"color":"#C0C0C0"}},[_vm._v(_vm._s(flo.cInfoa))]),_vm._v("/"+_vm._s(flo.cInfob))])]):_vm._e()])}),0):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"table_qh",attrs:{"id":"table_qh"}},[_c('ul',[_vm._l((_vm.locationList),function(flo,index){return [(flo.floor == 0)?_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v("G/F")]):(flo.floor!=0&&flo.floor!=3)?_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v(_vm._s(flo.floor)+"/F")]):_vm._e()]})],2)]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"banckFont"},[_vm._v("倉庫一覽")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',[_c('div',{staticStyle:{"margin":"12px 0 12px 0","color":"#333333","font-size":"14px"}},[_vm._v("當前"+_vm._s(_vm.presentnum)+"/F"),_c('span',{staticStyle:{"color":"#333333"}},[_vm._v("樓層共"+_vm._s(_vm.locationList[_vm.num].floorcount)+"個位置，剩餘"+_vm._s(_vm.locationList[_vm.num].floorcount-_vm.locationList[_vm.num].usecount)+"個 ")])]),_vm._v(" "),_c('div',{staticClass:"mob_tongjiLeft"},[_c('span',{staticClass:"font1"},[_vm._v("Left")]),_c('br'),_c('span',{staticClass:"font2"},[_c('span',{staticStyle:{"color":"#999999"}},[_vm._v(_vm._s(_vm.locationList[_vm.num].aInfoa))]),_vm._v("/"+_vm._s(_vm.locationList[_vm.num].aInfob))])]),_vm._v(" "),_c('div',{staticClass:"mob_tongjiMiddle"},[_c('span',{staticClass:"font1"},[_vm._v("Middle")]),_c('br'),_c('span',{staticClass:"font2"},[_c('span',{staticStyle:{"color":"#999999"}},[_vm._v(_vm._s(_vm.locationList[_vm.num].bInfoa))]),_vm._v("/"+_vm._s(_vm.locationList[_vm.num].bInfob))])]),_vm._v(" "),_c('div',{staticClass:"mob_tongjiRight"},[_c('span',{staticClass:"font1"},[_vm._v("Right")]),_c('br'),_c('span',{staticClass:"font2"},[_c('span',{staticStyle:{"color":"#999999"}},[_vm._v(_vm._s(_vm.locationList[_vm.num].cInfoa))]),_vm._v("/"+_vm._s(_vm.locationList[_vm.num].cInfob))])]),_vm._v(" "),_c('div',{staticClass:"table_qh",attrs:{"id":"table_qh"}},[_c('ul',[_vm._l((_vm.locationList),function(flo,index){return [(flo.floor == 0)?_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v("G/F")]):(flo.floor!=0&&flo.floor!=3)?_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v(_vm._s(flo.floor)+"/F")]):_vm._e()]})],2)])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogDiscEditVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"locationForm",attrs:{"model":_vm.locationForm,"rules":_vm.locationRules,"label-width":"130px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"貨架名:","prop":"name"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text"},on:{"blur":function($event){return _vm.itemChange(_vm.locationForm.name)}},model:{value:(_vm.locationForm.name),callback:function ($$v) {_vm.$set(_vm.locationForm, "name", $$v)},expression:"locationForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"樓層:","prop":"floor"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"span":24,"placeholder":"請選擇"},model:{value:(_vm.locationForm.floor),callback:function ($$v) {_vm.$set(_vm.locationForm, "floor", $$v)},expression:"locationForm.floor"}},_vm._l((_vm.floorSelect),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"X軸:","prop":"x"}},[_c('el-input-number',{staticStyle:{"width":"200px"},attrs:{"controls-position":"right","min":1,"max":16},on:{"input":_vm.a},model:{value:(_vm.locationForm.x),callback:function ($$v) {_vm.$set(_vm.locationForm, "x", $$v)},expression:"locationForm.x"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"Y軸:","prop":"y"}},[_c('el-input-number',{staticStyle:{"width":"200px"},attrs:{"controls-position":"right","min":1,"max":30},on:{"input":_vm.b},model:{value:(_vm.locationForm.y),callback:function ($$v) {_vm.$set(_vm.locationForm, "y", $$v)},expression:"locationForm.y"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer","id":"operation"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.locationSave}},[_vm._v("確認")]),_vm._v(" "),(_vm.locationForm.id != '' && _vm.locationForm.state == 0)?[_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"primaryTwo"},on:{"click":function($event){return _vm.locationDel(_vm.locationForm.id)}}},[_vm._v("刪除")])]:_vm._e()],2)],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.tkshow},on:{"update:visible":function($event){_vm.tkshow=$event}}},[_c('span',[_vm._v("貨架編號："+_vm._s(_vm.shelfName))]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_c('div',{staticClass:"listSelect"},[_c('el-select',{attrs:{"placeholder":"請選擇","clearable":""},on:{"change":_vm.selectChangedType},model:{value:(_vm.selectTypeValue),callback:function ($$v) {_vm.selectTypeValue=$$v},expression:"selectTypeValue"}},_vm._l((_vm.TypeList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"請選擇","clearable":""},on:{"change":_vm.selectChanged},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}},_vm._l((_vm.orderTypeList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_vm._l((_vm.locationNames),function(lnames,i){return [_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',{staticStyle:{"background-color":"#6A8FFF","color":"#FFFFFF"}},[_c('th',{staticStyle:{"text-align":"left"},attrs:{"colspan":"4"}},[_vm._v(_vm._s(lnames)+" \n                            "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.selDetails(_vm.locationCust[i])}}},[_vm._v("客戶詳情")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("單："+_vm._s(i+1))])],1)]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("訂單號")]),_vm._v(" "),_c('th',[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30%"}},[_vm._v("創建時間")])])]),_vm._v(" "),_vm._l((_vm.locationListB),function(item1,index){return (_vm.locationListB.length != 0)?_c('tr',[(item1.cCode == lnames.substr(0,lnames.indexOf('(')))?[_c('td',{staticClass:"actions"},[_vm._v("\n                                    "+_vm._s(item1.sCode)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n                                    "+_vm._s(item1.unit)+"("+_vm._s(item1.boxNo)+")\n                                ")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n                                    "+_vm._s(item1.item)+"\n                                ")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n                                    "+_vm._s(item1.createDate)+"\n                                ")])]:_vm._e()],2):_vm._e()}),_vm._v(" "),(_vm.locationListB.length == 0)?_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v("暫無數據")])]):_vm._e()],2)]})],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fr"},[_c('div',{staticClass:"kx"},[_c('span',[_vm._v("空閒 ")])]),_vm._v(" "),_c('div',{staticClass:"wl"},[_c('span',[_vm._v("物料 ")])]),_vm._v(" "),_c('div',{staticClass:"yd"},[_c('span',[_vm._v("一單")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})]),_vm._v(" "),_c('div',{staticClass:"ed"},[_c('span',[_vm._v("多單")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("zVBY")}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Ofm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPrinting_vue__ = __webpack_require__("6gl7");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f48c0a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPrinting_vue__ = __webpack_require__("jXLy");
function injectStyle (ssrContext) {
  __webpack_require__("NwjW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPrinting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f48c0a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPrinting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8PTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"}),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getItemStorList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_search')}},[_c('el-select',{staticStyle:{"width":"150px"},attrs:{"default-first-option":"","filterable":"","remote":"","clearable":"","remote-method":_vm.getItemOptions,"placeholder":""},on:{"change":_vm.itemOptionChange},model:{value:(_vm.serchItemName),callback:function ($$v) {_vm.serchItemName=$$v},expression:"serchItemName"}},_vm._l((_vm.itemOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.itemName,"value":item.itemName}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.itemName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getItemStorList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-left":"370px"}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.itemListAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增產品")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",staticStyle:{"width":"800px"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.itemStorList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"itemName","align":"left","label":"產品名稱"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stockAvail","align":"left","width":"110","label":"總數量"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stockOnhold","align":"left","width":"110","label":"已用數量"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storCode","label":"可用數量","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(scope.row.stockAvail-scope.row.stockOnhold)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.itemEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(_vm.canDetails)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.showInfo(scope.row)}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("詳情")]):_vm._e(),_vm._v(" "),(_vm.candHide)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.updateStatus(scope.row.id)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("隱藏")]):_vm._e(),_vm._v(" "),(_vm.candLOG)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.updateLog(scope.row.id)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("修改日誌")]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogCodeName,"visible":_vm.dialogCodeVisible,"width":"450px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogCodeVisible=$event}}},[_c('el-form',{ref:"itemForm",attrs:{"model":_vm.itemForm,"rules":_vm.itemRules,"label-width":"160px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.b_prodcode')+'：',"prop":"itemName"}},[(this.itemForm.id!='')?_c('span',[_vm._v(_vm._s(_vm.itemForm.itemName))]):_c('span',[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},on:{"change":function($event){return _vm.validateItemName(_vm.itemForm.itemName)}},model:{value:(_vm.itemForm.itemName),callback:function ($$v) {_vm.$set(_vm.itemForm, "itemName", $$v)},expression:"itemForm.itemName"}})],1)])],1)],1),_vm._v(" "),(this.itemForm.id!='')?_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"貨存數量：","prop":"oldQty"}},[_vm._v("\n                        "+_vm._s(_vm.itemForm.oldQty)+"\n                    ")])],1)],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"調整數量：","prop":"qty"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},on:{"change":function($event){return _vm.calculateQty(_vm.itemForm.qty)}},model:{value:(_vm.itemForm.qty),callback:function ($$v) {_vm.$set(_vm.itemForm, "qty", $$v)},expression:"itemForm.qty"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"調整后數量：","prop":"adjQty"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},on:{"change":function($event){return _vm.calculateAdjQty(_vm.itemForm.adjQty)}},model:{value:(_vm.itemForm.adjQty),callback:function ($$v) {_vm.$set(_vm.itemForm, "adjQty", $$v)},expression:"itemForm.adjQty"}})],1)],1)],1),_vm._v(" "),(this.itemForm.id!='')?_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"原因：","prop":"remark"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"textarea","autosize":{minRows: 4,maxRows: 10},"placeholder":""},model:{value:(_vm.itemForm.remark),callback:function ($$v) {_vm.$set(_vm.itemForm, "remark", $$v)},expression:"itemForm.remark"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogCodeVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.itemListSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.diaItemsName,"visible":_vm.dialogItemVisible,"width":"60%"},on:{"update:visible":function($event){_vm.dialogItemVisible=$event}}},[_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.itemLogList,"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"itemName","align":"left","width":"100","label":"產品名稱"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stockAvail","align":"right","width":"100","label":"初始數量"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qty","align":"right","width":"100","label":"數量"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stockAvail","align":"right","width":"100","label":"修改後數量"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(scope.row.stockAvail+scope.row.qty)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","align":"left","label":"原因"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createBy","align":"left","width":"90","label":"創建人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createDate","align":"left","width":"160","label":"創建時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.createDate!=0)?[_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.createDate*1000,'%Y-%m-%d %H:%M:%s'))+"\n                        ")]:_vm._e()]}}])})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"height":"50px"}}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogItemVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.showInfoTitle,"visible":_vm.divShowInfo,"width":"30%"},on:{"update:visible":function($event){_vm.divShowInfo=$event}}},[_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.storloading),expression:"storloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.storInfoList,"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"carNumber","align":"left","label":"車號"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qty","align":"right","label":"數量"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.itemName=='PIT_PAPER')?[_vm._v("\n                            "+_vm._s(scope.row.qty+parseFloat(scope.row.oneCar))+"\n                        ")]:(scope.row.itemName=='TOGLUE')?[_vm._v("\n                            "+_vm._s(scope.row.qty+parseFloat(scope.row.twoCar))+"\n                        ")]:(scope.row.itemName=='CREPE_PAPER')?[_vm._v("\n                            "+_vm._s(scope.row.qty+parseFloat(scope.row.threeCar))+"\n                        ")]:[_vm._v("\n                            "+_vm._s(scope.row.qty)+"\n                        ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"feedDate","align":"left","width":"110","label":_vm.$t('m.t_date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.feedDate!=0)?[_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.feedDate*1000,'%Y-%m-%d'))+"\n                        ")]:_vm._e()]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.divShowInfo = false}}},[_vm._v("關閉")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Y1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warehousing_vue__ = __webpack_require__("RirL");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7284d09a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warehousing_vue__ = __webpack_require__("sMeZ");
function injectStyle (ssrContext) {
  __webpack_require__("sYFo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warehousing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7284d09a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warehousing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8pc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__ = __webpack_require__("ohnS");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d5c772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__ = __webpack_require__("YcAl");
function injectStyle (ssrContext) {
  __webpack_require__("pIGA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Role_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24d5c772_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Role_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8s4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElButton',

  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean
  },

  computed: {
    _elFormItemSize: function _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});

/***/ }),

/***/ "9kf3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',[_c('el-form',{ref:"reportForm",attrs:{"model":_vm.reportForm,"rules":_vm.rulesReport,"label-width":"150px","size":"small"}},[(_vm.canType1)?_c('el-form-item',{attrs:{"label":_vm.$t('m.m_accounting')+'：'}},[_vm._l((_vm.dataTypeArrar),function(item,index){return (item.view&&item.type==1)?[_c('el-radio-group',{model:{value:(_vm.reportForm.dataType),callback:function ($$v) {_vm.$set(_vm.reportForm, "dataType", $$v)},expression:"reportForm.dataType"}},[_c('el-radio',{staticStyle:{"width":"150px"},attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])],1)]:_vm._e()})],2):_vm._e(),_vm._v(" "),(this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==5||this.reportForm.dataType==6)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_customer')+'：',"prop":"custId"}},[_c('el-select',{staticStyle:{"width":"250px"},attrs:{"default-first-option":"","placeholder":"","filterable":"","remote":"","remote-method":_vm.itemRemoteMethod,"clearable":""},on:{"clear":function($event){_vm.reportForm.custId = ''}},model:{value:(_vm.reportForm.custId),callback:function ($$v) {_vm.$set(_vm.reportForm, "custId", $$v)},expression:"reportForm.custId"}},_vm._l((_vm.custOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.code,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.code))]),_vm._v(" \n                            "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)],1):_vm._e(),_vm._v(" "),(this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_date')+'：'}},[_c('el-select',{staticStyle:{"width":"250px"},attrs:{"filterable":"","remote":"","placeholder":this.$t('m.t_date')},model:{value:(_vm.reportForm.type),callback:function ($$v) {_vm.$set(_vm.reportForm, "type", $$v)},expression:"reportForm.type"}},_vm._l((_vm.statusOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),((this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6) && this.reportForm.type==0)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_monthDate')+'：',"prop":"monthDate"}},[_c('el-date-picker',{staticStyle:{"width":"250px","margin-top":"-8px"},attrs:{"value-format":"yyyy-MM","type":"month","placeholder":""},model:{value:(_vm.reportForm.monthDate),callback:function ($$v) {_vm.$set(_vm.reportForm, "monthDate", $$v)},expression:"reportForm.monthDate"}})],1):_vm._e(),_vm._v(" "),((this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6)&& this.reportForm.type==1)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_quarterDate')+'：',"prop":"salesDate"}},[_c('el-date-picker',{staticStyle:{"width":"250px"},attrs:{"value-format":"yyyy-MM-dd","type":"daterange","align":"right","unlink-panels":"","range-separator":"~","start-placeholder":_vm.$t('m.t_startdate'),"end-placeholder":_vm.$t('m.t_enddate'),"picker-options":_vm.pickerOptions2},model:{value:(_vm.reportForm.salesDate),callback:function ($$v) {_vm.$set(_vm.reportForm, "salesDate", $$v)},expression:"reportForm.salesDate"}})],1):_vm._e(),_vm._v(" "),((this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==6) && this.reportForm.type==2)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_yearDate')+'：',"prop":"yearDate"}},[_c('el-date-picker',{staticStyle:{"width":"250px","margin-top":"-8px"},attrs:{"value-format":"yyyy","type":"year","placeholder":""},model:{value:(_vm.reportForm.yearDate),callback:function ($$v) {_vm.$set(_vm.reportForm, "yearDate", $$v)},expression:"reportForm.yearDate"}})],1):_vm._e(),_vm._v(" "),(this.reportForm.dataType==5)?_c('el-form-item',{attrs:{"label":_vm.$t('m.menu_jobNo')+'：'}},[_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":""},model:{value:(_vm.reportForm.jobNo),callback:function ($$v) {_vm.$set(_vm.reportForm, "jobNo", $$v)},expression:"reportForm.jobNo"}})],1):_vm._e(),_vm._v(" "),(this.reportForm.dataType==1 ||this.reportForm.dataType==2 ||this.reportForm.dataType==3 ||this.reportForm.dataType==4||this.reportForm.dataType==5||this.reportForm.dataType==6)?_c('el-form-item',{attrs:{"label":_vm.$t('m.t_ExportFormat')+'：'}},[_c('el-select',{staticStyle:{"width":"250px"},attrs:{"filterable":"","remote":"","placeholder":this.$t('m.t_ExportFormat')},model:{value:(_vm.reportForm.exportFormat),callback:function ($$v) {_vm.$set(_vm.reportForm, "exportFormat", $$v)},expression:"reportForm.exportFormat"}},_vm._l((_vm.formatOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(this.reportForm.dataType>0)?_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","disabled":_vm.loadingStatus},on:{"click":function($event){return _vm.submitForm('reportForm')}}},[_vm._v(_vm._s(_vm.$t('m.t_export')))])],1):_vm._e()],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9qvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        var checkStart = function checkStart(rule, value, callback) {
            if (value === '') {
                callback(new Error('請選擇開始日期'));
            } else {
                if (_this.jobOrderForm.endDate != "") {
                    var oldStartDate = new Date(value).getTime() / 1000;
                    var oldEndDate = new Date(_this.jobOrderForm.endDate).getTime() / 1000;
                    if (oldStartDate > oldEndDate) {
                        callback(new Error('開始日期不能大於結束日期'));
                    }
                }
            }
            callback();
        };
        var checkEnd = function checkEnd(rule, value, callback) {
            if (value === '') {
                callback(new Error('請選擇結束日期'));
            } else {
                if (_this.jobOrderForm.startDate != "") {
                    var oldStartDate = new Date(_this.jobOrderForm.startDate).getTime() / 1000;
                    var oldEndDate = new Date(value).getTime() / 1000;
                    if (oldEndDate < oldStartDate) {
                        callback(new Error('結束日期不能小於開始日期'));
                    }
                }
            }
            callback();
        };
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            jobOrderForm: {
                startDate: '',
                endDate: '',
                jobTime: '',
                volume: '',
                custId: '',
                custNo: '',
                service: '',
                origin: '',
                dest: '',
                contactP: '',
                contactT: '',
                estQty1: '',
                estQty2: '',
                realQty1: '',
                realQty2: '',
                cashOrder: '',
                jobDetail: '',
                custName: '',
                jobNo: '',
                supervisor: '',
                printCode: ''
            },
            custOptions: [],
            remark: '',
            remarkOption: [{
                value: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊',
                label: '＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊'
            }, {
                value: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊',
                label: '＊ 搬 運 時 請 留 意 單 位 內 地 板 及 牆 身 , 用 物 料 保 護 以 免 刮 花 ＊'
            }, {
                value: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※',
                label: '※易碎物品或不可壓的物品要用“易碎”貼紙標識, 並小心包裝及搬運※'
            }],
            serviceOption: [{
                value: 'OB',
                label: 'OB 出口(Outbound)'
            }, {
                value: 'RL',
                label: 'RL 搬屋/搬運'
            }, {
                value: 'ORL',
                label: 'ORL 搬寫字樓'
            }, {
                value: 'STG',
                label: 'STG 存倉'
            }, {
                value: 'IB',
                label: 'IB 入口'
            }, {
                value: 'SELL',
                label: 'SELL 賣盒'
            }, {
                value: 'MAIL',
                label: 'MAIL 寄件'
            }, {
                value: 'OBOX',
                label: ' 送盒(OBOX)'
            }, {
                value: 'IBOX',
                label: '收盒(IBOX)'
            }, {
                value: 'OTHER',
                label: '其它(OTHER)'
            }],
            jobRules: {
                jobNo: [{ required: true, message: '工作單號不能為空', trigger: 'change' }, { min: 1, max: 8, message: '長度在 1 到 8 個字符', trigger: 'change' }],
                startDate: [{ required: true, message: '開始日期不能為空', trigger: 'change' }, { validator: checkStart, trigger: 'change' }],
                endDate: [{ required: true, message: '結束日期不能為空', trigger: 'change' }, { validator: checkEnd, trigger: 'change' }],
                custNo: [{ required: true, message: '客戶不能為空', trigger: 'change' }],
                service: [{ required: true, message: '服務類別不能為空', trigger: 'change' }],
                origin: [{ required: false, message: '起點不能為空', trigger: 'change' }, { min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' }],
                dest: [{ min: 1, max: 2000, message: '長度在 1 到 2000 個字符', trigger: 'change' }],
                contactP: [{ min: 1, max: 20, message: '長度在1到20個字符', trigger: 'change' }],
                contactT: [{ min: 1, max: 20, message: '長度在1到20個字符', trigger: 'change' }],
                estQty1: [{ required: true, message: '預計紙箱數量不能為空', trigger: 'change' }, { min: 1, max: 11, message: '長度在 1 到 11 個字符', trigger: 'change' }, { required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                realQty1: [{ min: 1, max: 11, message: '長度在 1 到 11 個字符', trigger: 'change' }, { required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                estQty2: [{ required: true, message: '預計板數數量不能為空', trigger: 'change' }, { min: 1, max: 11, message: '長度在 1 到 11 個字符', trigger: 'change' }, { required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                realQty2: [{ min: 1, max: 11, message: '長度在 1 到 11 個字符', trigger: 'change' }, { required: false, validator: function validator(rule, value, callback) {
                        var reg = /^[0-9]+$/;
                        if (value != "" && value != null) {
                            if (!reg.test(value)) {
                                callback(new Error('請輸入正數！'));
                            }
                        }
                        callback();
                    }, trigger: 'blur'
                }],
                jobDetail: [{ required: true, message: '工作內容不能為空', trigger: 'change' }, { min: 1, max: 2000, message: '長度在1到2000個字符', trigger: 'change' }]
            },
            remarkList: []
        };
    },

    methods: {
        getRemarkList: function getRemarkList() {
            var _this2 = this;

            /*查詢常用列表*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["s" /* getAllRemarkList */])(2).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    _this2.remarkList = res.data;
                }
            });
        },
        addRemark: function addRemark() {
            var str = document.getElementById('textareaid').value;
            //if(str.indexOf('＊')!=-1 || str.indexOf('※')!=-1){
            document.getElementById('textareaid').value = document.getElementById('textareaid').value + "\n" + this.remark;
            /*}else{
                            document.getElementById('textareaid').value = document.getElementById('textareaid').value + "\n\n\n\n" +this.remark;
            }
            this.remark='＊ 易 碎 或 不 可 壓 的 紙 箱 , 請 小 心 包 裝 及 搬 運 ＊';*/
        },
        custChange: function custChange(ev) {
            if (ev != "") {
                this.jobOrderForm.custNo = ev.code;
                this.jobOrderForm.custId = ev.id;
                this.jobOrderForm.origin = ev.address;
                this.jobOrderForm.custName = ev.name;
                this.jobOrderForm.contactP = ev.sales;
                this.jobOrderForm.contactT = ev.phone;
            } else {
                this.resetForm("jobOrderForm");
                this.jobOrderForm.custNo = "";
                this.jobOrderForm.custId = "";
                this.jobOrderForm.origin = "";
                this.jobOrderForm.custName = "";
                this.jobOrderForm.contactP = "";
                this.jobOrderForm.contactT = "";
            }
        },
        getTimes: function getTimes(ev) {
            this.jobOrderForm.endDate = ev;
        },
        itemRemoteMethod: function itemRemoteMethod(query) {
            var _this3 = this;

            if (query != "") {
                var params = { custNo: query, groupId: null };
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data2 = data.data,
                        res = _data$data2 === undefined ? {} : _data$data2;

                    _this3.custOptions = res.data;
                });
            }
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        validateChange: function validateChange(ev) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,1}$/;
                if (!re.test(ev)) {
                    this.$message.error("請輸入正確的格式，數字只有1位小數");
                    return false;
                }
            }
        },
        jobSave: function jobSave() {
            var _this4 = this;

            this.$refs.jobOrderForm.validate(function (valid) {
                if (valid) {
                    var params1 = { jobNo: _this4.jobOrderForm.jobNo.trim(), service: _this4.jobOrderForm.service, id: '' };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["P" /* getJobNo */])(params1).then(function (data) {
                        var _data$data3 = data.data,
                            res = _data$data3 === undefined ? {} : _data$data3;

                        if (res.data != "") {
                            return _this4.$message.error(_this4.jobOrderForm.jobNo + " 工作單號" + _this4.jobOrderForm.service + "已存在，請重新選擇！");
                        } else {
                            if (_this4.jobOrderForm.startDate == '') {
                                _this4.jobOrderForm.startDate = 0;
                            }
                            if (_this4.jobOrderForm.endDate == '') {
                                _this4.jobOrderForm.endDate = 0;
                            }
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.jobOrderForm);
                            params.startDate = Math.round(new Date(params.startDate).getTime() / 1000);
                            params.endDate = Math.round(new Date(params.endDate).getTime() / 1000);
                            params.jobNo = _this4.jobOrderForm.jobNo.trim();
                            params.status = 0;
                            params.jobDetail = document.getElementById('textareaid').value;
                            //params.service=this.jobOrderForm.service.join(",");
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_45" /* insertJobOrder */])(params).then(function (data) {
                                var _data$data4 = data.data,
                                    errcode = _data$data4.errcode,
                                    errmsg = _data$data4.errmsg;

                                if (errcode == 200) {
                                    _this4.$message.success("新增成功");
                                    _this4.resetForm("jobOrderForm");
                                    _this4.$router.push({
                                        name: '工作單',
                                        params: { str: new Date().getTime() }
                                    });
                                    _this4.$store.commit("closeTab", 'jobAdd');
                                } else {
                                    _this4.$message.error("新增失败！");
                                }
                            });
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.resetForm("jobOrderForm");
            this.$router.push({
                name: '工作單',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "jobAdd");
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getRemarkList();
    },

    computed: {}
});

/***/ }),

/***/ "A+ON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Remark_vue__ = __webpack_require__("HknD");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de43dd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Remark_vue__ = __webpack_require__("cjmy");
function injectStyle (ssrContext) {
  __webpack_require__("ybj/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4de43dd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Remark_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de43dd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Remark_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AT53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"el-button",class:[
    _vm.type ? 'el-button--' + _vm.type : '',
    _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round,
      'is-circle': _vm.circle
    }
  ],attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._v(" "),(_vm.icon && !_vm.loading)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AwDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"loginForm",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.loginForm,"rules":_vm.rules,"label-position":"left","label-width":"0px","id":"login_from"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"right1"},[_c('div',{staticClass:"right_box"},[_c('div',{staticStyle:{"width":"68%","margin-left":"15%","margin-top":"10%"},attrs:{"id":"loginDiv"}},[_c('h3',{staticClass:"title"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":__webpack_require__("P7rK")}})]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"name"}},[_c('el-input',{attrs:{"type":"text","id":"loginName","auto-complete":"off","placeholder":"帳號"},model:{value:(_vm.loginForm.name),callback:function ($$v) {_vm.$set(_vm.loginForm, "name", $$v)},expression:"loginForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","autocomplete":"new-password","id":"password","auto-complete":"off","placeholder":"密碼"},model:{value:(_vm.loginForm.password),callback:function ($$v) {_vm.$set(_vm.loginForm, "password", $$v)},expression:"loginForm.password"}})],1),_vm._v(" "),_c('el-checkbox',{staticClass:"remember",model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("記住用戶名")]),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"100%"}},[_c('el-button',{staticStyle:{"width":"100%","background-color":"#4B78FF"},attrs:{"type":"primary","loading":_vm.logining},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleSubmit.apply(null, arguments)}}},[_vm._v("登入")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BKd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',[_c('div',{staticClass:"xinz"},[[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/addStockout'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")]):_vm._e()],1)],1)]],2),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getStorOnList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"出倉單"},model:{value:(_vm.searchStorOn),callback:function ($$v) {_vm.searchStorOn=$$v},expression:"searchStorOn"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":"客戶/電話"},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"銷售員"},model:{value:(_vm.searchSalesId),callback:function ($$v) {_vm.searchSalesId=$$v},expression:"searchSalesId"}},_vm._l((_vm.custSalesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getStorOnList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"ind_main ind_main2"},[_c('div',{staticClass:"ind_cont2"},[[_c('el-table',{staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.storOnCustomerList,"empty-text":"无数据","stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"scode","align":"left","label":"出倉單"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","align":"left","label":"客戶"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(scope.row.customer.code)+","+_vm._s(scope.row.customer.name)+"\n\t\t\t\t\t\t\t\t\t\t")]}}],null,false,1455876062)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer.phone","align":"left","label":"電話"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer.sales","align":"left","label":"銷售員"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storInDate","align":"left","label":"時間"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","width":"100","align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.canEdit)?_c('el-button',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.updateSelSotrOut(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯\n\t\t\t\t\t\t                ")]):_vm._e()]}}],null,false,2637740007)})],1)],_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.add)?_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[(_vm.form.sCodeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sCode))])]:[_c('el-select',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow,"filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethodIn,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelect($event)},"focus":function($event){return _vm.isNullOptions()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),(_vm.canAdd)?[(!_vm.rkCont)?[_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleSelect()}}},[_vm._v("新 建")])],1)]:_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_vm._l((_vm.addStorOnList),function(stor,index){return [(_vm.addStorOn)?_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"6"}},[_vm._v("可出倉")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("數量")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',[_vm._v("出倉")])])]),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',{class:storOn.state === 1?'stateShow':'',attrs:{"id":storOn.id}},[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.qty))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('label',{staticClass:"my_protocol"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.checkedOne(index)}}}),_c('span')])])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('br')])])],2):_vm._e()]}),_vm._v(" "),_vm._l((_vm.storOnList),function(stor,index){return [_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[(!_vm.rkCont)?[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(stor.createDate))]),_vm._v(" "),_c('span',{staticStyle:{"padding-right":"215px"}},[_vm._v("已出倉")])]),_vm._v(" "),_c('th',{attrs:{"colspan":"1"}},[_c('el-button',{on:{"click":function($event){return _vm.printing(stor.storOnItem[0])}}},[_vm._v("打印")]),_vm._v(" "),(stor.state === 1)?[_c('el-button',{on:{"click":function($event){return _vm.storOn(stor)}}},[_vm._v("確定出倉")])]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("數量")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),(_vm.rkCont)?[_c('th',[_vm._v("出倉")])]:_vm._e()],2)],2),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.qty))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),(_vm.rkCont)?[_c('td',{staticClass:"actions"},[_c('label',{staticClass:"my_protocol"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.checkedOne(index)}}}),_c('span')])])]:_vm._e()],2)}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"6"}})])],2)]}),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[(_vm.canEdit)?[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v(" 保 存")])]:_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.cancelAdd}},[_vm._v(" 取 消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],2)],2)])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Baxo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BdBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddJobOrder_vue__ = __webpack_require__("9qvi");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5541a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddJobOrder_vue__ = __webpack_require__("dQMV");
function injectStyle (ssrContext) {
  __webpack_require__("H09n")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddJobOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e5541a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddJobOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CO2H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CqVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("vaGB");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068fe518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("ZqOZ");
function injectStyle (ssrContext) {
  __webpack_require__("gdsr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_068fe518_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D9yh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAABLUlEQVQoU3XQvUsCcRjA8e9zZQoiCEEQTQ0RNQVC3RkVNPSCd2Z/QDQHQVO0REiDNPcPCEEuTXJGk3AteTg0NLQGLUHQUkGC9ntCoxKlZ3t4PjxvQk/oTC5JrLUHUpfQv+ouS3ei82uTmEgZNAaMgRaoXeYFtO1+sdreOkIJuMaSLZRFjDkHqfL6ti33wXsHq+PugxRQPSGsHP10UjszBVYZ+IDmhqjj7gKnqBxK6Bf6bkivjKDRW9BB0dTqKENDeZRpCf0Fnd0cxmoWEYkDxxiNY1HC4H6vYXsHQE5C31HHWwIC4BmlCOYGkTOpVZL9eM6dwOIOJMonO1jm6V/cmZRKRUgkBiQIGmpnsj04kwXrAuGx90AggfLQXvHvz2lvGWW8D6tpYRoVqVdfvgDm0nbViRz5RAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "EMXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_vue__ = __webpack_require__("8s4O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e11e4b64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_button_vue__ = __webpack_require__("ApwA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e11e4b64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fy7F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G3uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    inject: ['reload'],
    methods: {
        getSearchList: function getSearchList() {
            var _this = this;

            this.tableloading = true;
            var keywords = this.$store.getters.keywords;
            if (keywords == '' || keywords == null) {
                keywords = "";
            }
            var params = { page: this.pager.page, size: this.pager.size, scode: keywords };
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_12" /* getSearchList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    _this.customerList = res.data.data;
                    _this.pager.total = res.data.total;
                    _this.pager.page = res.data.page;
                    _this.pager.size = res.data.size;
                    _this.tableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        selDetails: function selDetails(row) {
            //查看客戶詳情資訊
            this.$store.commit("setSearchSte", true);
            this.$router.push({
                name: '客戶詳情',
                params: {
                    id: row.id
                }
            });
        },
        selSotrIn: function selSotrIn(id) {
            //查看入倉詳情資訊
            this.$store.commit("setSearchSte", true);
            this.$store.commit("setWarehouseSta", true);
            this.$router.push({
                name: '入倉',
                params: {
                    id: id,
                    typeId: 2
                }
            });
        },
        selSotrOn: function selSotrOn(id) {
            //查看出倉詳情資訊
            this.$store.commit("setSearchSte", true);
            this.$store.commit("setStoronSta", true);
            this.$router.push({
                name: '出倉',
                params: {
                    id: id,
                    typeId: 2
                }
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.getSearchList();
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        customerAdd: function customerAdd(index, row) {
            this.dialogName = "新增客戶資訊", this.dialogDiscEditVisible = true;
            this.resetForm("customerForm");
        },
        customerSave: function customerSave() {
            var _this2 = this;

            this.$refs.customerForm.validate(function (valid) {
                if (valid) {
                    if (_this2.customerForm.id == "") {
                        //新增
                        _this2.addEidtloading = true;
                        //var  params=Object.assign({},this.customerForm);
                        var params = { code: _this2.customerForm.code, name: _this2.customerForm.name, phone: _this2.customerForm.phone, address: _this2.customerForm.address, sales: _this2.customerForm.sales };
                        Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_42" /* insertCustomer */])(params).then(function (data) {
                            _this2.addEidtloading = false;
                            //let {errcode,errmsg}=data;
                            var _data$data2 = data.data,
                                res = _data$data2 === undefined ? {} : _data$data2;

                            if (res.errcode == 200) {
                                _this2.$message.success("新增成功！！");
                                _this2.getCustomerList();
                                _this2.resetForm("customerForm");
                                _this2.dialogDiscEditVisible = false;
                            } else {
                                _this2.$message.error(res.errmsg);
                            }
                        }, function (err) {
                            _this2.addEidtloading = false;
                        });
                    } else {
                        //編輯
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.bankForm);
                        updateBank(params).then(function (data) {
                            _this2.addEidtloading = false;
                            var errcode = data.errcode,
                                errmsg = data.errmsg;

                            if (errcode == 200) {
                                _this2.$message.success(_this2.$t('m.amendSuccess'));
                                _this2.getCustomerList();
                                //                                    this.resetForm("bankForm");
                                _this2.dialogDiscEditVisible = false;
                            } else {
                                _this2.$message.error(data.errmsg);
                            }
                        }, function (err) {
                            _this2.addEidtloading = false;
                        });
                    }
                }
            });
        },


        //清除表單內容
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    data: function data() {
        var _this3 = this;

        var validateNumber = function validateNumber(rule, value, callback) {
            var reg = /^[1-15]\d*$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    callback(new Error(_this3.$t('m.canOnlyEnterPositiveNumber')));
                }
            }
            callback();
        };

        //驗證客戶編號是否重複
        var validateCustomerCode = function validateCustomerCode(rule, value, callback) {
            var params = { code: _this3.customerForm.code };
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_38" /* getValidateCustomerCode */])(params).then(function (data) {
                var item = data.data.data;
                if (item) {
                    callback(new Error('客戶編號重複！'));
                } else {
                    callback();
                }
            });
            callback();
        };
        return {
            //查詢準則

            searchBankName: "",
            customerList: [],
            selectionItems: [],
            tableloading: false,
            addEidtloading: false,
            dialogDiscEditVisible: false,
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            dialogName: '',
            customerForm: {
                id: "",
                sales: "",
                code: "",
                name: "",
                phone: "",
                address: ''
            },
            //新增客戶資訊表單驗證
            customerRules: {
                code: [{ required: true, message: '請輸入客戶編號', trigger: 'blur' }, { validator: validateCustomerCode, trigger: 'blur' }],
                name: [{ required: true, message: '請輸入客戶名', trigger: 'blur' }],
                phone: [{ required: true, message: '請輸入手機號', trigger: 'blur' }],
                address: [{ required: true, message: '請輸入位址', trigger: 'blur' }],
                sales: [{ required: true, message: '請輸入銷售員', trigger: 'blur' }]
            }
        };
    },


    //        mounted() {
    //
    //        },
    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("BANK_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("BANK_EDIT");
        },
        canDel: function canDel() {
            return this.$store.getters.hasPermission("BANK_DEL");
        }
    },
    activated: function activated() {
        //this.reload();
        this.getSearchList();
    },

    watch: {
        '$route': 'getSearchList'
    }

});

/***/ }),

/***/ "G7FF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("SHlf");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e0c39f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("o18F");
function injectStyle (ssrContext) {
  __webpack_require__("pdO/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e0c39f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e0c39f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GIqa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gdxj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            options4: [],
            options: [],
            list: [],
            tableloading: false,
            show: true,
            add: false,
            addStorOn: false,
            cId: 0,
            storDateId: 0, //當前已出倉的日期表id
            storOnCustomerList: [],
            customerCode: {},
            storOnList: [],
            addStorOnList: [],
            codeList: [],
            codeInList: [], //入庫單號
            addstorOnList: [],
            rkCont: true, //入庫和客戶資訊
            addStorOnMap: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
            createDate: "", //時間
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            form: {
                id: null,
                sCode: null,
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false
            },
            searchStorOn: '',
            searchName: '',
            searchSalesId: '',
            custSalesList: []
        };
    },
    mounted: function mounted() {},

    methods: {
        updateSelSotrOut: function updateSelSotrOut(row) {
            this.$router.push({
                name: '編輯出倉',
                params: {
                    id: row.id,
                    typeId: 1,
                    custId: 0
                }
            });
            var path = "/updatesStockout/" + row.id + "/" + 1 + "/" + 0;
            this.$router.push(path);
        },
        printing: function printing(item) {
            /*打印*/
            if (item !== null) {
                var url = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL + "/getPrintingList?custId=" + item.cid + "&storOnDateId=" + item.storDateId + "&token=" + this.$store.getters.staff.token;
                window.location.href = url;
            }
        },
        storOn: function storOn(stor) {
            var _this = this;

            /*確定真的出倉了*/
            var params = { storOnItemList: stor.storOnItem };
            this.$confirm('確定是否出倉? ', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_29" /* getStorOnOkList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode === 200) {
                        _this.$message({
                            message: '出倉成功',
                            type: 'success'
                        });
                        _this.cancelAdd();
                        _this.getStorOnList();
                    }
                });
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            this.$router.go(-1);
        },
        getCodeList: function getCodeList() {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_24" /* getStorOnCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    _this2.codeList = res.data;
                }
            });
        },
        remoteMethod: function remoteMethod(query) {
            var _this3 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.options4 = _this3.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodIn: function remoteMethodIn(query) {
            var _this4 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this4.loading = false;
                    _this4.options = _this4.codeInList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        handleCurrentChange: function handleCurrentChange() {
            /*分頁*/
            this.getStorOnList();
        },
        selSotrOn: function selSotrOn(id) {
            var _this5 = this;

            /*查詢出倉詳情*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerOnSte", false);
            this.add = true;
            this.show = false;
            this.rkCont = false;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_25" /* getStorOnItemStorinIdBy */])(id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    var storDateId = null;
                    res.data.forEach(function (item, i) {
                        //重新處理下資料
                        if (i === 0) {
                            _this5.createDate = new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm");
                        }
                        _this5.storDateId = item.storDateId;
                        var itemList = {};
                        var floor = void 0;_this5.cId = item.cId;
                        floor = item.name;
                        if (new Date(new Date(item.createDate * 1000)).toDateString() !== new Date().toDateString()) {
                            //是否是當天時間 不是當天的時間不能修改
                            itemList = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId };
                        } else {
                            itemList = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId };
                        }
                        if (!sotrOnMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { id: item.id, state: item.state, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                            sotrOnMap.set(item.storDateId, storIdItemList);
                        } else {
                            sotrOnMap.get(item.storDateId).storOnItem.push(itemList);
                        }
                        // sotrOnMap.set(item.id,itemList)
                    });
                    _this5.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    //console.log( this.storOnList);
                    _this5.selCustimerId(_this5.storDateId); //查詢客戶id
                    _this5.form.codeShow = true;
                    _this5.form.sCodeShow = true;
                    _this5.form.nameShow = true;
                    _this5.form.phoneShow = true;
                    _this5.form.addressShow = true;
                    _this5.form.salesShow = true;
                }
            });

            //				getPrintingListByStorDateId(32).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //				});
            //
            //                getPrintingList({custId:30,storOnDateId:32}).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //                })
        },
        selCustimerId: function selCustimerId(id) {
            var _this6 = this;

            /*查詢客戶ID*/
            //console.log("id",id)
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_27" /* getStorOnListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;
                //console.log(res);

                if (res.errcode === 200) {
                    var _res$data$customer = res.data.customer,
                        _id = _res$data$customer.id,
                        code = _res$data$customer.code,
                        name = _res$data$customer.name,
                        phone = _res$data$customer.phone,
                        address = _res$data$customer.address,
                        sales = _res$data$customer.sales,
                        createDate = _res$data$customer.createDate;

                    _this6.form.id = _id;
                    _this6.form.code = code;
                    _this6.form.name = name;
                    _this6.form.address = address;
                    _this6.form.phone = phone;
                    _this6.form.sales = sales;
                    _this6.form.createDate = new Date(createDate * 1000).Format("yyyy-MM-dd hh:mm");
                    _this6.form.sCode = res.data.scode;
                }
            });
        },
        getStorOnList: function getStorOnList() {
            var _this7 = this;

            /*查詢入庫*/
            this.getCodeList();
            this.tableloading = true;
            this.rkCont = true;
            var params = { page: this.pager.page, size: this.pager.size, storOn: this.searchStorOn.trim(), custName: this.searchName.trim(), salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_26" /* getStorOnList */])(params).then(function (data) {
                var _data$data5 = data.data,
                    res = _data$data5 === undefined ? {} : _data$data5;
                //console.log("res",res)

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this7.storOnCustomerList = items;
                    _this7.storOnCustomerList.forEach(function (a, b) {
                        a.storInDate = new Date(a.onDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this7.$set(_this7.storOnCustomerList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this7.pager.total = total;
                    _this7.pager.page = page;
                    _this7.pager.size = size;
                    _this7.tableloading = false;
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.getInCodeList();
        },
        cancelAdd: function cancelAdd() {
            this.add = false;
            this.show = true;
            this.addStorOn = false;
            this.nullList();
        },
        handleSelect: function handleSelect(cid) {
            var _this8 = this;

            /*選擇出倉后*/
            var str = [];
            if (cid === null || cid === undefined) {
                this.addStorOn = true;
                cid = this.cId;
            } else {
                str = cid.split(',');
                cid = str[0];
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* getCustomerById */])(cid).then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                if (res.errcode === 200) {
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this8.form.id = id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = sales;
                    var codeId = _this8.form.sCode.split(',');
                    if (codeId[1] !== undefined) {
                        //確定codeID中是否有值
                        code = codeId[1];
                    } else {
                        code = _this8.form.sCode;
                    }
                    var params = { page: _this8.pager.page, size: _this8.pager.size, id: id, code: code };
                    //console.log("2",params);
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_60" /* selStorInItemCustomerId */])(params).then(function (data) {
                        var _data$data7 = data.data,
                            res = _data$data7 === undefined ? {} : _data$data7;

                        if (res.errcode === 200) {
                            var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                            res.data.data.forEach(function (item, i) {
                                //重新處理下資料
                                var floor = void 0;
                                if (item.floor === 0) {
                                    floor = "GF " + item.name;
                                } else {
                                    floor = item.floor + "F " + item.name;
                                }
                                var itemList = { state: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, storDateId: _this8.storDateId };
                                if (i === 0) {
                                    //添加
                                    var storIdItemList = { id: item.id, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                                    sotrOnMap.set(i, storIdItemList);
                                } else {
                                    sotrOnMap.get(0).storOnItem.push(itemList);
                                }
                            });
                            if (_this8.addStorOn === true) {
                                _this8.addStorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            } else {
                                _this8.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            }
                        }
                    });
                }
            });
        },
        selCutomerCode: function selCutomerCode() {
            var _this9 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    _this9.customerCode = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this9.customerCode.forEach(function (a, b) {
                        _this9.$set(_this9.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this9.list = list.map(function (item) {
                        return { value: item.id, label: item.code };
                    });
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this10 = this;

            /*出倉*/
            var addstorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.addStorOnMap.values()));
            var codeId = this.form.sCode.split(',');
            var code = "";
            if (this.rkCont === true) {
                this.codeList.forEach(function (item) {
                    if (item.code === codeId[1]) {
                        _this10.addStorOn = true;
                    }
                });
            }
            if (codeId[1] !== undefined) {
                //確定codeID中是否有值
                code = codeId[1];
            } else {
                code = this.form.sCode;
            }
            var params = {
                code: code,
                addStorOn: this.addStorOn,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storOnItemList: addstorOnList
            };
            //console.log("params",params);
            var str = this.isStringNull();
            if (str !== "") {
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                this.$confirm('確定是否出倉? ', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_52" /* insertStorOn */])(params).then(function (data) {
                        var _data$data9 = data.data,
                            res = _data$data9 === undefined ? {} : _data$data9;

                        if (res.errcode === 200) {
                            _this10.$message({
                                message: '出倉成功',
                                type: 'success'
                            });
                            _this10.cancelAdd();
                            _this10.getStorOnList();
                            _this10.addStorOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                        } else {
                            _this10.$message.error(res.errmsg);
                        }
                    });
                }).catch(function () {
                    _this10.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        },
        checkedOne: function checkedOne(index) {
            var list = {};
            if (this.addStorOn === false) {
                list = this.storOnList[0].storOnItem[index];
            } else {
                list = this.addStorOnList[0].storOnItem[index];
            }
            var storOn = { storInItemId: list.id, state: 1, unit: list.unit, id: list.id, boxNo: list.boxNo, item: list.item, qty: list.qty, locationId: list.locationId, value: list.value, storDateId: list.storDateId };
            if (!this.addStorOnMap.has(list.id)) {
                if (this.addStorOnList.length !== 0) {
                    this.addStorOnList[0].storOnItem[index].state = 1;
                }
                this.addStorOnMap.set(list.id, storOn);
            } else {
                this.addStorOnList[0].storOnItem[index].state = 0;
                this.addStorOnMap.delete(list.id);
            }
        },
        nullList: function nullList() {
            /*清空*/
            this.storOnList = [];
            this.storDateId = 0;
            this.isNullOptions();
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null
            };
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        isStringNull: function isStringNull() {
            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "出庫單不能為空";
            }if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }if (this.form.name === null || this.form.name === "") {
                return "姓名不能為空";
            }if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            return str;
        },
        test: function test() {
            this.show = true;
            this.add = false;
        },
        getInCodeList: function getInCodeList() {
            var _this11 = this;

            /*查詢入庫單號*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_20" /* getStorInCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data10 = data.data,
                    res = _data$data10 === undefined ? {} : _data$data10;
                //console.log("11",res);

                if (res.errcode === 200) {
                    _this11.codeInList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this11.codeInList.forEach(function (a, b) {
                        _this11.$set(_this11.codeInList[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this11.codeInList = list.map(function (item) {
                        return { value: item.id + "," + item.code, label: item.code };
                    });
                } else {
                    _this11.$message.error(res.errmsg);
                }
            });
        },
        isNullOptions: function isNullOptions() {
            this.options = [];
        }
    },
    activated: function activated() {
        var _this12 = this;

        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data11 = data.data,
                res = _data$data11 === undefined ? {} : _data$data11;

            _this12.custSalesList = res.data;
        });
        /*進入載入*/
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getStorOnList();
        this.selCutomerCode();

        //首页查詢功能
        if (this.$store.getters.storonSta == true) {
            this.selSotrOn(this.$route.params.id);
            this.$store.commit("setSearchSte", true);
        }

        //客戶详情編輯
        if (this.$store.getters.customerOnSte == true) {
            //                this.$store.commit("setSearchSte",true);
            this.selSotrOn(this.$route.params.id);
        }
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ADD_STOR_ON");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("EDIT_STOR_ON");
        }
    },
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "H09n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HPlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            disabledNum: false,
            feedForm: {
                id: '',
                feedDate: '',
                carNumber: '',
                pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '',
                copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '',
                softPaper: '',
                lousyPaper: '', //烂纸
                moistureproof: '',
                electric: '',
                gummedPaper: '',
                big: '',
                inthe: '',
                fine: '',
                oldBig: '',
                oldInthe: '',
                oldFine: '',
                plasma: '',
                crepePaper: '',
                flatClothing: '', //平衣
                refrigerator: '',
                elastic: '', //黑色橡筋
                cardboard: '',
                stiff: '',
                bulktank: '',
                paperCardBoard: '',
                threeSeats: '',
                twoSeats: '',
                oneSeats: '',
                threeRuler: '',
                fourRuler: '',
                fiveRuler: '',
                sixRuler: '',
                oneSmall: '',
                small: '',
                tool: '',
                glue: '',
                toCounter: '',
                cage: '', //铁笼
                theWire: '',
                plywood: '',
                oneGlue: '',
                wireMesh: '',
                productCar: '',
                tape: '',
                other: '',
                status: '',
                oneCar: '',
                twoCar: '',
                threeCar: '',
                smooth: '',
                lengthFloor: '',
                shortFloor: '',
                fork: '',
                chelsea: '',
                sendBox: '',
                oneOther: '',
                internal: ''
            },
            acctId: '',
            feedRules: {
                feedDate: [{ required: true, message: '日期不能為空', trigger: 'change' }],
                carNumber: [{ required: true, message: '車號不能為空', trigger: 'change' }]
                /*  oneCar:[
                      {required: true, message: '扎車坑紙不能為空', trigger: 'change' },
                  ],
                  twoCar:[
                      {required: true, message: '扎車地膠不能為空', trigger: 'change' },
                  ],
                  threeCar:[
                      {required: true, message: '扎車縐紋紙不能為空', trigger: 'change' },
                  ],*/
            },
            rollingId: 0,
            loadingSave: false,
            feedOldForm: {
                oldfork: '',
                oldchelsea: '',
                oldpitPaper: '', //坑紙
                oldnewsPaper: '', //报纸
                oldbuBu: '',
                oldcopyPaper: '',
                oldmat: '', //毡
                oldtinFoil: '', //保鲜纸
                oldazusa: '',
                oldshortWood: '', //矮木
                oldironCar: '',
                oldtoGlue: '',
                oldsoftPaper: '',
                oldlousyPaper: '', //烂纸
                oldmoistureproof: '',
                oldelectric: '',
                oldgummedPaper: '',
                agedbig: '',
                agedinthe: '',
                agedfine: '',
                oldoldBig: '',
                oldoldInthe: '',
                oldoldFine: '',
                oldplasma: '',
                oldcrepePaper: '',
                oldflatClothing: '', //平衣
                oldrefrigerator: '',
                oldelastic: '', //黑色橡筋
                oldcardboard: '',
                oldstiff: '',
                oldbulktank: '',
                oldpaperCardBoard: '',
                oldthreeSeats: '',
                oldtwoSeats: '',
                oldoneSeats: '',
                oldthreeRuler: '',
                oldfourRuler: '',
                oldfiveRuler: '',
                oldsixRuler: '',
                oldoneSmall: '',
                oldsmall: '',
                oldtool: '',
                oldglue: '',
                oldtoCounter: '',
                oldcage: '', //铁笼
                oldtheWire: '',
                oldplywood: '',
                oldoneGlue: '',
                oldwireMesh: '',
                oldproductCar: '',
                oldtape: '',
                oldother: '',
                oldstatus: '',
                oldoneCar: '',
                oldtwoCar: '',
                oldthreeCar: '',
                oldsmooth: '',
                oldlengthFloor: '',
                oldshortFloor: ''
            },
            paramsFeedId: '',
            updateFeedId: 0
        };
    },

    methods: {
        initalFeeding: function initalFeeding() {
            this.disabledNum = false;
            this.feedForm = {
                id: '',
                feedDate: '',
                carNumber: '',
                pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '',
                copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '',
                softPaper: '',
                lousyPaper: '', //烂纸
                moistureproof: '',
                electric: '',
                gummedPaper: '',
                big: '',
                inthe: '',
                fine: '',
                oldBig: '',
                oldInthe: '',
                oldFine: '',
                plasma: '',
                crepePaper: '',
                flatClothing: '', //平衣
                refrigerator: '',
                elastic: '', //黑色橡筋
                cardboard: '',
                stiff: '',
                bulktank: '',
                paperCardBoard: '',
                threeSeats: '',
                twoSeats: '',
                oneSeats: '',
                threeRuler: '',
                fourRuler: '',
                fiveRuler: '',
                sixRuler: '',
                oneSmall: '',
                small: '',
                tool: '',
                glue: '',
                toCounter: '',
                cage: '', //铁笼
                theWire: '',
                plywood: '',
                oneGlue: '',
                wireMesh: '',
                productCar: '',
                tape: '',
                other: '',
                status: '',
                oneCar: '',
                twoCar: '',
                threeCar: '',
                smooth: '',
                lengthFloor: '',
                shortFloor: '',
                fork: '',
                chelsea: '',
                sendBox: '',
                oneOther: '',
                internal: ''
            }, this.acctId = '';
            this.rollingId = 0;
        },
        updateFeedSave: function updateFeedSave() {
            var _this = this;

            if (this.feedForm.feedDate == '') {
                this.feedForm.feedDate = 0;
            }
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.feedForm);
            params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
            params.rollingId = this.rollingId;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_66" /* updateFeedSave */])(params).then(function (data) {
                var _data$data = data.data,
                    errcode = _data$data.errcode,
                    errmsg = _data$data.errmsg;

                if (errcode == 200) {
                    _this.$message.success("保存成功");
                    _this.resetForm("feedForm");
                    _this.acctId = '';
                    _this.rollingId = 0;
                    _this.updateFeedId = 0;
                    _this.initalFeeding();
                    _this.$router.push({
                        name: '物料出入倉',
                        params: { str: new Date().getTime() }
                    });
                    _this.$store.commit("closeTab", 'feedEdit');
                } else {
                    _this.$message.error("保存失败");
                }
            });
        },
        validateChange: function validateChange(ev, bigvalue, oneCar) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(ev)) {
                    if (oneCar == "pitPaper") {
                        this.feedForm.pitPaper = ""; //坑紙
                    }if (oneCar == "newsPaper") {
                        this.feedForm.newsPaper = ""; //报纸
                    }if (oneCar == "buBu") {
                        this.feedForm.buBu = "";
                    }if (oneCar == "copyPaper") {
                        this.feedForm.copyPaper = "";
                    }if (oneCar == "mat") {
                        this.feedForm.mat = ""; //毡
                    }if (oneCar == "tinFoil") {
                        this.feedForm.tinFoil = ""; //保鲜纸
                    }if (oneCar == "azusa") {
                        this.feedForm.azusa = "";
                    }if (oneCar == "shortWood") {
                        this.feedForm.shortWood = ""; //矮木
                    }if (oneCar == "ironCar") {
                        this.feedForm.ironCar = "";
                    }if (oneCar == "toGlue") {
                        this.feedForm.toGlue = "";
                    }if (oneCar == "softPaper") {
                        this.feedForm.softPaper = "";
                    }if (oneCar == "lousyPaper") {
                        this.feedForm.lousyPaper = ""; //烂纸
                    }if (oneCar == "moistureproof") {
                        this.feedForm.moistureproof = "";
                    }if (oneCar == "electric") {
                        this.feedForm.electric = "";
                    }if (oneCar == "gummedPaper") {
                        this.feedForm.gummedPaper = "";
                    }if (oneCar == "big") {
                        this.feedForm.big = "";
                    }if (oneCar == "inthe") {
                        this.feedForm.inthe = "";
                    }if (oneCar == "fine") {
                        this.feedForm.fine = "";
                    }if (oneCar == "oldBig") {
                        this.feedForm.oldBig = "";
                    }if (oneCar == "oldInthe") {
                        this.feedForm.oldInthe = "";
                    }if (oneCar == "oldFine") {
                        this.feedForm.oldFine = "";
                    }if (oneCar == "plasma") {
                        this.feedForm.plasma = "";
                    }if (oneCar == "crepePaper") {
                        this.feedForm.crepePaper = "";
                    }if (oneCar == "flatClothing") {
                        this.feedForm.flatClothing = ""; //平衣
                    }if (oneCar == "refrigerator") {
                        this.feedForm.refrigerator = "";
                    }if (oneCar == "elastic") {
                        this.feedForm.elastic = ""; //黑色橡筋
                    }if (oneCar == "cardboard") {
                        this.feedForm.cardboard = "";
                    }if (oneCar == "stiff") {
                        this.feedForm.stiff = "";
                    }if (oneCar == "bulktank") {
                        this.feedForm.bulktank = "";
                    }if (oneCar == "paperCardBoard") {
                        this.feedForm.paperCardBoard = "";
                    }if (oneCar == "threeSeats") {
                        this.feedForm.threeSeats = "";
                    }if (oneCar == "twoSeats") {
                        this.feedForm.twoSeats = "";
                    }if (oneCar == "oneSeats") {
                        this.feedForm.oneSeats = "";
                    }if (oneCar == "threeRuler") {
                        this.feedForm.threeRuler = "";
                    }if (oneCar == "fourRuler") {
                        this.feedForm.fourRuler = "";
                    }if (oneCar == "fiveRuler") {
                        this.feedForm.fiveRuler = "";
                    }if (oneCar == "sixRuler") {
                        this.feedForm.sixRuler = "";
                    }if (oneCar == "oneSmall") {
                        this.feedForm.oneSmall = "";
                    }if (oneCar == "small") {
                        this.feedForm.small = "";
                    }if (oneCar == "tool") {
                        this.feedForm.tool = "";
                    }if (oneCar == "glue") {
                        this.feedForm.glue = "";
                    }if (oneCar == "toCounter") {
                        this.feedForm.toCounter = "";
                    }if (oneCar == "cage") {
                        this.feedForm.cage = ""; //铁笼
                    }if (oneCar == "theWire") {
                        this.feedForm.theWire = "";
                    }if (oneCar == "plywood") {
                        this.feedForm.plywood = "";
                    }if (oneCar == "oneGlue") {
                        this.feedForm.oneGlue = "";
                    }if (oneCar == "wireMesh") {
                        this.feedForm.wireMesh = "";
                    }if (oneCar == "productCar") {
                        this.feedForm.productCar = "";
                    }if (oneCar == "tape") {
                        this.feedForm.tape = "";
                    }if (oneCar == "oneCar") {
                        this.feedForm.oneCar = "";
                    }if (oneCar == "twoCar") {
                        this.feedForm.twoCar = "";
                    }if (oneCar == "threeCar") {
                        this.feedForm.threeCar = "";
                    }if (oneCar == "smooth") {
                        this.feedForm.smooth = "";
                    }if (oneCar == "lengthFloor") {
                        this.feedForm.lengthFloor = "";
                    }if (oneCar == "shortFloor") {
                        this.feedForm.shortFloor = "";
                    }if (oneCar == "fork") {
                        this.feedForm.fork = "";
                    }if (oneCar == "chelsea") {
                        this.feedForm.chelsea = "";
                    }
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (parseFloat(ev) > parseFloat(bigvalue)) {
                        if (oneCar == "pitPaper") {
                            this.feedForm.pitPaper = ""; //坑紙
                        }if (oneCar == "newsPaper") {
                            this.feedForm.newsPaper = ""; //报纸
                        }if (oneCar == "buBu") {
                            this.feedForm.buBu = "";
                        }if (oneCar == "copyPaper") {
                            this.feedForm.copyPaper = "";
                        }if (oneCar == "mat") {
                            this.feedForm.mat = ""; //毡
                        }if (oneCar == "tinFoil") {
                            this.feedForm.tinFoil = ""; //保鲜纸
                        }if (oneCar == "azusa") {
                            this.feedForm.azusa = "";
                        }if (oneCar == "shortWood") {
                            this.feedForm.shortWood = ""; //矮木
                        }if (oneCar == "ironCar") {
                            this.feedForm.ironCar = "";
                        }if (oneCar == "toGlue") {
                            this.feedForm.toGlue = "";
                        }if (oneCar == "softPaper") {
                            this.feedForm.softPaper = "";
                        }if (oneCar == "lousyPaper") {
                            this.feedForm.lousyPaper = ""; //烂纸
                        }if (oneCar == "moistureproof") {
                            this.feedForm.moistureproof = "";
                        }if (oneCar == "electric") {
                            this.feedForm.electric = "";
                        }if (oneCar == "gummedPaper") {
                            this.feedForm.gummedPaper = "";
                        }if (oneCar == "big") {
                            this.feedForm.big = "";
                        }if (oneCar == "inthe") {
                            this.feedForm.inthe = "";
                        }if (oneCar == "fine") {
                            this.feedForm.fine = "";
                        }if (oneCar == "oldBig") {
                            this.feedForm.oldBig = "";
                        }if (oneCar == "oldInthe") {
                            this.feedForm.oldInthe = "";
                        }if (oneCar == "oldFine") {
                            this.feedForm.oldFine = "";
                        }if (oneCar == "plasma") {
                            this.feedForm.plasma = "";
                        }if (oneCar == "crepePaper") {
                            this.feedForm.crepePaper = "";
                        }if (oneCar == "flatClothing") {
                            this.feedForm.flatClothing = ""; //平衣
                        }if (oneCar == "refrigerator") {
                            this.feedForm.refrigerator = "";
                        }if (oneCar == "elastic") {
                            this.feedForm.elastic = ""; //黑色橡筋
                        }if (oneCar == "cardboard") {
                            this.feedForm.cardboard = "";
                        }if (oneCar == "stiff") {
                            this.feedForm.stiff = "";
                        }if (oneCar == "bulktank") {
                            this.feedForm.bulktank = "";
                        }if (oneCar == "paperCardBoard") {
                            this.feedForm.paperCardBoard = "";
                        }if (oneCar == "threeSeats") {
                            this.feedForm.threeSeats = "";
                        }if (oneCar == "twoSeats") {
                            this.feedForm.twoSeats = "";
                        }if (oneCar == "oneSeats") {
                            this.feedForm.oneSeats = "";
                        }if (oneCar == "threeRuler") {
                            this.feedForm.threeRuler = "";
                        }if (oneCar == "fourRuler") {
                            this.feedForm.fourRuler = "";
                        }if (oneCar == "fiveRuler") {
                            this.feedForm.fiveRuler = "";
                        }if (oneCar == "sixRuler") {
                            this.feedForm.sixRuler = "";
                        }if (oneCar == "oneSmall") {
                            this.feedForm.oneSmall = "";
                        }if (oneCar == "small") {
                            this.feedForm.small = "";
                        }if (oneCar == "tool") {
                            this.feedForm.tool = "";
                        }if (oneCar == "glue") {
                            this.feedForm.glue = "";
                        }if (oneCar == "toCounter") {
                            this.feedForm.toCounter = "";
                        }if (oneCar == "cage") {
                            this.feedForm.cage = ""; //铁笼
                        }if (oneCar == "theWire") {
                            this.feedForm.theWire = "";
                        }if (oneCar == "plywood") {
                            this.feedForm.plywood = "";
                        }if (oneCar == "oneGlue") {
                            this.feedForm.oneGlue = "";
                        }if (oneCar == "wireMesh") {
                            this.feedForm.wireMesh = "";
                        }if (oneCar == "productCar") {
                            this.feedForm.productCar = "";
                        }if (oneCar == "tape") {
                            this.feedForm.tape = "";
                        }if (oneCar == "oneCar") {
                            this.feedForm.oneCar = "";
                        }if (oneCar == "twoCar") {
                            this.feedForm.twoCar = "";
                        }if (oneCar == "threeCar") {
                            this.feedForm.threeCar = "";
                        }if (oneCar == "smooth") {
                            this.feedForm.smooth = "";
                        }if (oneCar == "lengthFloor") {
                            this.feedForm.lengthFloor = "";
                        }if (oneCar == "shortFloor") {
                            this.feedForm.shortFloor = "";
                        }if (oneCar == "fork") {
                            this.feedForm.fork = "";
                        }if (oneCar == "chelsea") {
                            this.feedForm.chelsea = "";
                        }
                        return this.$message.error("入倉數量不能大於出倉數量");
                    }
                }
            }
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        feedSave: function feedSave(ev) {
            var _this2 = this;

            if (ev == 1) {
                this.$confirm(this.$t('m.m_Importconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(function () {
                    _this2.feedBackSave(ev);
                });
            } else {
                this.feedBackSave(ev);
            }
        },
        feedBackSave: function feedBackSave(ev) {
            var _this3 = this;

            this.$refs.feedForm.validate(function (valid) {
                if (valid) {
                    _this3.loadingSave = true;
                    if (_this3.feedForm.feedDate == '') {
                        _this3.feedForm.feedDate = 0;
                    }
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.feedForm);
                    params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                    params.rollingId = _this3.rollingId;
                    params.status = ev;
                    /* if (this.feedForm.id=='' || this.feedForm.id==null) {
                         insertFeedBack(params).then(data => {
                             let {errcode, errmsg} = data.data;
                             if (errcode == 200) {
                                 this.$message.success("保存成功");
                                 this.resetForm("feedForm");
                                 this.$router.push({
                                     name: '物料出入倉',
                                     params: {str: new Date().getTime()}
                                 })
                                 this.$store.commit("closeTab", 'feedEdit');
                             } else {
                                 this.$message.error("保存失败");
                             }
                         },);
                     } else {*/
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_65" /* updateFeedDate */])(params).then(function (data) {
                        var _data$data2 = data.data,
                            errcode = _data$data2.errcode,
                            errmsg = _data$data2.errmsg;

                        if (errcode == 200) {
                            if (ev == 1) {
                                _this3.$message.success("入倉成功");
                            } else {
                                _this3.$message.success("保存成功");
                            }
                            _this3.loadingSave = false;
                            _this3.resetForm("feedForm");
                            _this3.acctId = '';
                            _this3.rollingId = 0;
                            _this3.updateFeedId = 0;
                            _this3.initalFeeding();
                            _this3.$router.push({
                                name: '物料出入倉',
                                params: { str: new Date().getTime() }
                            });
                            _this3.$store.commit("closeTab", 'feedEdit');
                        } else {
                            _this3.$message.error("保存失败");
                            _this3.loadingSave = false;
                        }
                    });
                    //}
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                name: '物料出入倉',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "feedEdit");
            this.initalFeeding();
            this.updateFeedId = 0;
        },
        getFeedParams: function getFeedParams() {
            this.disabledNum = false;
            this.initalFeeding();
            if (this.acctId == '') {
                this.acctId = this.$route.params.feedId;
                if (this.acctId != '' && this.acctId != null && this.acctId != undefined) {
                    this.queryOneAcctRec(this.acctId);
                }
            }
            if (this.acctId != this.$route.params.feedId && this.$route.params.feedId != undefined) {
                this.acctId = this.$route.params.feedId;
                this.queryOneAcctRec(this.acctId);
            }

            if (this.rollingId == 0) {
                this.rollingId = this.$route.params.rollId;
                if (this.rollingId != '' && this.rollingId != null && this.rollingId != undefined) {
                    this.paramsFeedId = this.rollingId;
                    this.queryOneRollList(this.rollingId);
                }
            }
            if (this.rollingId != this.$route.params.rollId && this.$route.params.rollId != undefined) {
                this.rollingId = this.$route.params.rollId;
                this.paramsFeedId = this.rollingId;
                this.queryOneRollList(this.rollingId);
            }
        },
        queryOneRollList: function queryOneRollList(acctId) {
            var _this4 = this;

            if (acctId != undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_8" /* getRollingListById */])(acctId).then(function (data) {
                    var item = data.data;
                    if (item != null) {
                        if (_this4.disabledNum != true) {
                            if (item.data.feedDate == null || item.data.feedDate == '' || item.data.feedDate == 0) {
                                _this4.feedForm.feedDate = "";
                            } else {
                                _this4.feedForm.feedDate = new Date(item.data.feedDate * 1000);
                            }
                            _this4.feedForm.carNumber = item.data.carNumber;
                            _this4.feedOldForm.oldoneCar = item.data.oneCar == 0 ? '' : item.data.oneCar;
                            _this4.feedOldForm.oldtwoCar = item.data.twoCar == 0 ? '' : item.data.twoCar;
                            _this4.feedOldForm.oldthreeCar = item.data.threeCar == 0 ? '' : item.data.threeCar;
                        }

                        if (_this4.acctId == '' || _this4.acctId == null) {
                            _this4.feedForm.sendBox = item.data.sendBox;
                            _this4.feedForm.oneOther = item.data.oneOther;
                            _this4.feedForm.internal = item.data.internal;
                        }
                        if (_this4.disabledNum != true) {
                            if (item.data.rollingItem != null) {
                                var tempList = item.data.rollingItem;
                                for (var i = 0; i < tempList.length; i++) {
                                    var poiItem = tempList[i];
                                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.feedOldForm);
                                    if (poiItem.pitPaper == 0) {
                                        _this4.feedOldForm.oldpitPaper = ''; //坑紙
                                    } else {
                                        if (item.data.oneCar == 0) {
                                            _this4.feedOldForm.oldpitPaper = parseFloat(poiItem.pitPaper); //坑紙
                                        } else {
                                            _this4.feedOldForm.oldpitPaper = parseFloat(poiItem.pitPaper) + parseFloat(item.data.oneCar); //坑紙
                                        }
                                    }
                                    if (poiItem.toGlue == 0) {
                                        _this4.feedOldForm.oldtoGlue = ''; //地膠
                                    } else {
                                        if (item.data.twoCar == 0) {
                                            _this4.feedOldForm.oldtoGlue = parseFloat(poiItem.toGlue); //地膠
                                        } else {
                                            _this4.feedOldForm.oldtoGlue = parseFloat(poiItem.toGlue) + parseFloat(item.data.twoCar); //地膠
                                        }
                                    }
                                    if (poiItem.crepePaper == 0) {
                                        _this4.feedOldForm.oldcrepePaper = ''; //縐紋紙
                                    } else {
                                        if (item.data.threeCar == 0) {
                                            _this4.feedOldForm.oldcrepePaper = parseFloat(poiItem.crepePaper); //縐紋紙
                                        } else {
                                            _this4.feedOldForm.oldcrepePaper = parseFloat(poiItem.crepePaper) + parseFloat(item.data.threeCar); //縐紋紙
                                        }
                                    }
                                    _this4.feedOldForm.oldnewsPaper = poiItem.newsPaper == 0 ? '' : poiItem.newsPaper; //报纸
                                    _this4.feedOldForm.oldbuBu = poiItem.buBu == 0 ? '' : poiItem.buBu;
                                    _this4.feedOldForm.oldcopyPaper = poiItem.copyPaper == 0 ? '' : poiItem.copyPaper;
                                    _this4.feedOldForm.oldmat = poiItem.mat == 0 ? '' : poiItem.mat; //毡
                                    _this4.feedOldForm.oldtinFoil = poiItem.tinFoil == 0 ? '' : poiItem.tinFoil; //保鲜纸
                                    _this4.feedOldForm.oldazusa = poiItem.azusa == 0 ? '' : poiItem.azusa;
                                    _this4.feedOldForm.oldshortWood = poiItem.shortWood == 0 ? '' : poiItem.shortWood; //矮木
                                    _this4.feedOldForm.oldironCar = poiItem.ironCar == 0 ? '' : poiItem.ironCar;
                                    _this4.feedOldForm.oldsoftPaper = poiItem.softPaper == 0 ? '' : poiItem.softPaper;
                                    _this4.feedOldForm.oldlousyPaper = poiItem.lousyPaper == 0 ? '' : poiItem.lousyPaper; //烂纸
                                    _this4.feedOldForm.oldmoistureproof = poiItem.moistureproof == 0 ? '' : poiItem.moistureproof;
                                    _this4.feedOldForm.oldelectric = poiItem.electric == 0 ? '' : poiItem.electric;
                                    _this4.feedOldForm.oldgummedPaper = poiItem.gummedPaper == 0 ? '' : poiItem.gummedPaper;
                                    _this4.feedOldForm.agedbig = poiItem.big == 0 ? '' : poiItem.big;
                                    _this4.feedOldForm.agedinthe = poiItem.inthe == 0 ? '' : poiItem.inthe;
                                    _this4.feedOldForm.agedfine = poiItem.fine == 0 ? '' : poiItem.fine;
                                    _this4.feedOldForm.oldoldBig = poiItem.oldBig == 0 ? '' : poiItem.oldBig;
                                    _this4.feedOldForm.oldoldInthe = poiItem.oldInthe == 0 ? '' : poiItem.oldInthe;
                                    _this4.feedOldForm.oldoldFine = poiItem.oldFine == 0 ? '' : poiItem.oldFine;
                                    _this4.feedOldForm.oldplasma = poiItem.plasma == 0 ? '' : poiItem.plasma;
                                    _this4.feedOldForm.oldflatClothing = poiItem.flatClothing == 0 ? '' : poiItem.flatClothing; //平衣
                                    _this4.feedOldForm.oldrefrigerator = poiItem.refrigerator == 0 ? '' : poiItem.refrigerator;
                                    _this4.feedOldForm.oldelastic = poiItem.elastic == 0 ? '' : poiItem.elastic; //黑色橡筋
                                    _this4.feedOldForm.oldcardboard = poiItem.cardboard == 0 ? '' : poiItem.cardboard;
                                    _this4.feedOldForm.oldstiff = poiItem.stiff == 0 ? '' : poiItem.stiff;
                                    _this4.feedOldForm.oldbulktank = poiItem.bulktank == 0 ? '' : poiItem.bulktank;
                                    _this4.feedOldForm.oldpaperCardBoard = poiItem.paperCardBoard == 0 ? '' : poiItem.paperCardBoard;
                                    _this4.feedOldForm.oldthreeSeats = poiItem.threeSeats == 0 ? '' : poiItem.threeSeats;
                                    _this4.feedOldForm.oldtwoSeats = poiItem.twoSeats == 0 ? '' : poiItem.twoSeats;
                                    _this4.feedOldForm.oldoneSeats = poiItem.oneSeats == 0 ? '' : poiItem.oneSeats;
                                    _this4.feedOldForm.oldthreeRuler = poiItem.threeRuler == 0 ? '' : poiItem.threeRuler;
                                    _this4.feedOldForm.oldfourRuler = poiItem.fourRuler == 0 ? '' : poiItem.fourRuler;
                                    _this4.feedOldForm.oldfiveRuler = poiItem.fiveRuler == 0 ? '' : poiItem.fiveRuler;
                                    _this4.feedOldForm.oldsixRuler = poiItem.sixRuler == 0 ? '' : poiItem.sixRuler;
                                    _this4.feedOldForm.oldoneSmall = poiItem.oneSmall == 0 ? '' : poiItem.oneSmall;
                                    _this4.feedOldForm.oldsmall = poiItem.small == 0 ? '' : poiItem.small;
                                    _this4.feedOldForm.oldtool = poiItem.tool == 0 ? '' : poiItem.tool;
                                    _this4.feedOldForm.oldglue = poiItem.glue == 0 ? '' : poiItem.glue;
                                    _this4.feedOldForm.oldtoCounter = poiItem.toCounter == 0 ? '' : poiItem.toCounter;
                                    _this4.feedOldForm.oldcage = poiItem.cage == 0 ? '' : poiItem.cage; //铁笼
                                    _this4.feedOldForm.oldtheWire = poiItem.theWire == 0 ? '' : poiItem.theWire;
                                    _this4.feedOldForm.oldplywood = poiItem.plywood == 0 ? '' : poiItem.plywood;
                                    _this4.feedOldForm.oldoneGlue = poiItem.oneGlue == 0 ? '' : poiItem.oneGlue;
                                    _this4.feedOldForm.oldwireMesh = poiItem.wireMesh == 0 ? '' : poiItem.wireMesh;
                                    _this4.feedOldForm.oldproductCar = poiItem.productCar == 0 ? '' : poiItem.productCar;
                                    _this4.feedOldForm.oldtape = poiItem.tape == 0 ? '' : poiItem.tape;
                                    _this4.feedOldForm.oldother = poiItem.other == 0 ? '' : poiItem.other;
                                    _this4.feedOldForm.oldstatus = poiItem.status == 0 ? '' : poiItem.status;
                                    _this4.feedOldForm.oldsmooth = poiItem.smooth == 0 ? '' : poiItem.smooth;
                                    _this4.feedOldForm.oldlengthFloor = poiItem.lengthFloor == 0 ? '' : poiItem.lengthFloor;
                                    _this4.feedOldForm.oldshortFloor = poiItem.shortFloor == 0 ? '' : poiItem.shortFloor;
                                    _this4.feedOldForm.oldfork = poiItem.fork == 0 ? '' : poiItem.fork;
                                    _this4.feedOldForm.oldchelsea = poiItem.chelsea == 0 ? '' : poiItem.chelsea;
                                }
                            }
                        }
                    }
                });
            }
        },
        queryOneAcctRec: function queryOneAcctRec(acctId) {
            var _this5 = this;

            if (acctId != undefined) {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["H" /* getFeedById */])(acctId).then(function (data) {
                    var item = data.data;
                    if (item != null) {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this5.feedForm, item.data);
                        if (item.data.feedDate == null || item.data.feedDate == '' || item.data.feedDate == 0) {
                            _this5.feedForm.feedDate = "";
                        } else {
                            _this5.feedForm.feedDate = new Date(item.data.feedDate * 1000);
                        }
                        if (item.data.status == 1) {
                            _this5.disabledNum = true;
                        }
                    }
                });
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        var outId = this.$route.params.rollId;
        if (outId != '' && outId != null && outId != undefined) {
            if (outId != this.paramsFeedId && this.updateFeedId == 0) {
                this.disabledNum = false;
                this.getFeedParams();
            } else if (outId == this.paramsFeedId && this.updateFeedId == 0) {
                this.disabledNum = false;
                this.getFeedParams();
            }
        }
        this.updateFeedId = 1;
    },

    computed: {
        canImport: function canImport() {
            return this.$store.getters.hasPermission("ROLL_IMPORT");
        }
    }
});

/***/ }),

/***/ "HkCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__("Hyt6");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adba85b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__("2KmG");
function injectStyle (ssrContext) {
  __webpack_require__("/B3z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-adba85b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adba85b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HknD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        var orderingValid = function orderingValid(rule, value, callback) {
            var reg = /^[1-9]\d*$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    callback(new Error(_this.$t('m.m_notpitnumber')));
                }
            }
            if (value > 999999999) {
                callback(new Error(_this.$t('m.m_oversize')));
            }
            callback();
        };
        return {
            sysName: 'ROYAL',
            collapsed: false,
            logBg: true,
            dialogTableVisible: false,
            dialogFormVisible: false,
            dialogName: "",
            staffTableloading: false,
            staffSaveloading: false,
            searchName: '',
            searchType: '',
            staffs: [],
            dataTypeOptions: [{
                id: 1,
                value: this.$t('m.menu_salesslip')
            }, {
                id: 2,
                value: this.$t('m.menu_returngoods')
            }],
            homeForm: {
                id: '',
                content: '',
                ordering: '',
                typeId: ''
            },
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            /* homeRules: {*/
            //                    content: [
            //                        {required: true, message: '內容不能為空', trigger: 'blur' },
            //                        { min: 1, max: 200, message:'內容不能超過200', trigger: 'blur' }
            //                    ],
            //                    ordering: [
            //                        {required: true, message:'排序不能為空', trigger: 'blur' },
            //                        { validator: orderingValid,trigger: 'blur' }
            /*     typeId: [
                     {required: true, message:'請選擇類別', trigger: 'blur' },
                 ]
            },*/
            roles: [],
            remarkList: [],

            dialogTypeName: "",
            dialogTypeVisible: false,
            typeForm: {
                typeName: ''
            }
        };
    },

    methods: {
        handleTypeAdd: function handleTypeAdd(ev) {
            this.dialogTypeVisible = true;
            this.dialogTypeName = '新增類別';
            this.typeForm = {
                typeName: ''
            }, this.resetForm("typeForm");
        },
        getRemarkList: function getRemarkList() {
            var _this2 = this;

            /*查詢常用列表*/
            var params = { typeName: '' };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["u" /* getAllTypeList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    _this2.remarkList = res.data;
                }
                _this2.searchType = "";
            });
        },
        handleSelectionChange: function handleSelectionChange() {},
        requestRemarkList: function requestRemarkList() {
            var _this3 = this;

            this.staffTableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, content: this.searchName.trim(), typeId: this.searchType };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_3" /* getRemarkList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        staffs = _res$data$data === undefined ? [] : _res$data$data;

                    _this3.staffs = staffs;
                    _this3.pager.total = total;
                    _this3.pager.page = page;
                    _this3.pager.size = size;
                    _this3.staffTableloading = false;
                } else {
                    _this3.$message.error(data.errmsg);
                }
            });
        },
        handleAdd: function handleAdd(ev) {
            this.dialogFormVisible = true;
            this.dialogName = '新增';
            this.homeForm = {
                id: '',
                content: '',
                ordering: '',
                typeId: ''
            }, this.resetForm("homeForm");
        },
        handleEdit: function handleEdit(index, row) {
            this.dialogFormVisible = true;
            this.dialogName = '編輯';
            /*console.log(row.id);*/
            this.requestRemarkById(row.id);
            this.resetForm("homeForm");
        },
        handleDelete: function handleDelete(index, row) {
            this.requestDeleteRemark(row.id);
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.requestRemarkList();
        },
        isTypeNull: function isTypeNull() {
            /*是否为空*/
            if (this.typeForm.typeName === "" || this.typeForm.typeName === null) {
                return "請輸入類別";
            }
            return "";
        },
        handleTypeSave: function handleTypeSave() {
            var _this4 = this;

            this.$refs.typeForm.validate(function (valid) {
                var str = _this4.isTypeNull();
                if (str !== "") {
                    _this4.dialogVisible = true;
                    _this4.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                } else {
                    var params = { typeName: _this4.typeForm.typeName };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["u" /* getAllTypeList */])(params).then(function (data) {
                        var _data$data3 = data.data,
                            res = _data$data3 === undefined ? {} : _data$data3;

                        if (res.data != "") {
                            _this4.$message.error('該類別也存在，請重新輸入！');
                        } else {
                            if (valid) {
                                var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.typeForm);
                                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_47" /* insertRemark */])(params).then(function (data) {
                                    var _data$data4 = data.data,
                                        res = _data$data4 === undefined ? {} : _data$data4;

                                    if (res.errcode == 200) {
                                        _this4.$message.success('添加成功！');
                                        _this4.resetForm("homeForm");
                                        _this4.dialogTypeVisible = false;
                                        _this4.getRemarkList();
                                    } else {
                                        _this4.$message.error(res.errmsg);
                                    }
                                }).catch(function (error) {
                                    _this4.$message.error('添加失敗！');
                                });
                            }
                        }
                    });
                }
            });
        },
        handleSave: function handleSave() {
            var _this5 = this;

            this.$refs.homeForm.validate(function (valid) {
                var str = _this5.isNull();
                if (str !== "") {
                    _this5.dialogVisible = true;
                    _this5.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                } else {
                    if (valid) {
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this5.homeForm);
                        params.typeName = '';
                        if (params.id === '') {
                            delete params.id;
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_47" /* insertRemark */])(params).then(function (data) {
                                var _data$data5 = data.data,
                                    res = _data$data5 === undefined ? {} : _data$data5;

                                if (res.errcode == 200) {
                                    _this5.$message.success('添加成功！');
                                    _this5.resetForm("homeForm");
                                    _this5.dialogFormVisible = false;
                                    _this5.requestRemarkList();
                                } else {
                                    _this5.$message.error(res.errmsg);
                                }
                            }).catch(function (error) {
                                _this5.$message.error('添加失敗！');
                            });
                        } else {
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_74" /* updateRemark */])(params).then(function (data) {
                                _this5.staffSaveloading = false;
                                var _data$data6 = data.data,
                                    res = _data$data6 === undefined ? {} : _data$data6;

                                if (res.errcode == 200) {
                                    _this5.$message.success('修改成功');
                                    _this5.requestRemarkList();
                                    _this5.resetForm("homeForm");
                                    _this5.dialogFormVisible = false;
                                } else {
                                    _this5.$message.error(res.errmsg);
                                }
                            });
                        }
                    }
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        isNull: function isNull() {
            /*是否为空*/
            if (this.homeForm.typeId === "" || this.homeForm.typeId === null) {
                return "請選擇類別";
            }
            if (this.homeForm.content === "" || this.homeForm.content === null) {
                return "請輸入備註內容";
            }
            return "";
        },
        requestDeleteRemark: function requestDeleteRemark(ids) {
            var _this6 = this;

            this.$confirm('確定刪除此數據嗎?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["l" /* deleteRemarkById */])(ids).then(function (data) {
                    var _data$data7 = data.data,
                        res = _data$data7 === undefined ? {} : _data$data7;

                    if (res.errcode == 200) {
                        _this6.$message.success('刪除成功!');
                        _this6.requestRemarkList();
                    } else {
                        _this6.$message.error(res.errmsg);
                    }
                });
            }).catch(function () {
                _this6.$message({
                    type: 'info',
                    message: '刪除失敗'
                });
            });
        },
        requestRemarkById: function requestRemarkById(id) {
            var _this7 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_2" /* getRemarkById */])(id).then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this7.homeForm, res.data);
            });
        }
    },
    mounted: function mounted() {},

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("REMARK_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("REMARK_EDIT");
        },
        canDelete: function canDelete() {
            return this.$store.getters.hasPermission("REMARK_DELETE");
        }
    },
    activated: function activated() {
        this.requestRemarkList(); //初始化備註管理資料
        this.getRemarkList(); //常用列表
    }
});

/***/ }),

/***/ "Hyt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        remoteMethodSales: function remoteMethodSales(query) {
            var _this = this;

            /*選擇銷售員*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this.loading = false;
                    _this.salesList = _this.saList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.salesList = [];
            }
        },
        homeClick: function homeClick() {
            // console.log("etetert");
            this.$router.push({
                name: '倉庫一覽'
            });
        },
        clickLoad: function clickLoad() {
            /*點擊銷售員框時載入*/
            //this.saList =[];
            this.salesList = this.saList;
        },
        getCustomerList: function getCustomerList() {
            var _this2 = this;

            this.customerTableloading = true;
            var params = {
                page: this.pager.page,
                size: this.pager.size,
                name: this.searchName.trim(),
                salesId: this.searchSalesId
            };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["F" /* getCustomerList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this2.customerList = items;
                    _this2.isDate();
                    _this2.pager.total = total;
                    _this2.pager.page = page;
                    _this2.pager.size = size;
                    _this2.customerTableloading = false;
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        isDate: function isDate() {
            /*處理日期*/
            this.customerList.forEach(function (a, i) {
                a.createDate = new Date(a.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"); //new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
            });
        },
        querySearch: function querySearch(queryString, cb) {
            /*載入數據*/
            var restaurants = this.customerCode;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (restaurant) {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        itemChange: function itemChange(value) {
            var _this3 = this;

            this.customerForm.code = value.toUpperCase();
            if (this.customerForm.id == "") {
                var params = { code: this.customerForm.code };
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_38" /* getValidateCustomerCode */])(params).then(function (data) {
                    var item = data.data.data;
                    if (item) {
                        _this3.$alert("客戶編號重複！", '提示', {
                            confirmButtonText: '確定',
                            callback: function callback(action) {
                                _this3.customerForm.code = "";
                            }
                        });
                    }
                });
            } else if (this.customerForm.id != "") {
                if (this.isCFcode != this.customerForm.code) {
                    var params = { code: this.customerForm.code };
                    return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_38" /* getValidateCustomerCode */])(params).then(function (data) {
                        var item = data.data.data;
                        if (item) {
                            _this3.$alert("客戶編號重複！", '提示', {
                                confirmButtonText: '確定',
                                callback: function callback(action) {
                                    _this3.customerForm.code = "";
                                }
                            });
                        }
                    });
                }
            }
        },
        letSalesList: function letSalesList() {
            var _this4 = this;

            /*查詢銷售員LIST*/
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_11" /* getSalesList */])().then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;
                //console.log(res)

                if (res.errcode === 200) {
                    var salesOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                    res.data.forEach(function (item, i) {
                        salesOnMap.set(i, { id: item.id, value: item.name });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(salesOnMap.values()));
                    _this4.saList = list.map(function (item) {
                        return { value: item.value, label: item.value };
                    });
                }
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.getCustomerList();
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        customerAdd: function customerAdd(index, row) {
            this.dialogName = "新增客戶資訊", this.customerForm.id = "";
            this.resetForm("customerForm");

            this.dialogDiscEditVisible = true;
        },
        customerEdit: function customerEdit(row) {
            this.dialogName = "編輯客戶資訊", this.dialogDiscEditVisible = true;
            this.resetForm("customerForm");
            this.customerById(row.id);
        },
        handleDelete: function handleDelete(row) {
            var _this5 = this;

            this.$confirm('妳確定要刪除客戶：' + row.code + "嗎?", this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_83" /* validateCustomerById */])(row.id).then(function (data) {
                    var item = data.data;
                    if (item.errcode == 200) {
                        if (item.data > 0) {
                            _this5.$message.warning("客戶有倉存信息，不能刪除！");
                        } else {
                            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["g" /* deleteCustomerById */])(row.id).then(function (data) {
                                var _data$data3 = data.data,
                                    res = _data$data3 === undefined ? {} : _data$data3;

                                if (res.errcode == 200) {
                                    _this5.$message.success('刪除成功');
                                    _this5.getCustomerList();
                                } else {
                                    _this5.$message.error(res.errmsg);
                                }
                            });
                        }
                    } else {
                        _this5.$message.error(item.errmsg);
                    }
                });
            });
        },
        getSalseVal: function getSalseVal(val) {
            var obj = this.salesList.find(function (v) {
                return v.id == val;
            });
            if (obj == undefined) {
                return "";
            } else {
                return obj.name;
            }
        },
        customerById: function customerById(id) {
            var _this6 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["D" /* getCustomerById */])(id).then(function (data) {
                var item = data.data;
                if (item.errcode == 200) {
                    _this6.isCFcode = item.data[0].code;
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.customerForm, item.data[0]);
                } else {
                    _this6.$message.error(item.errmsg);
                }
            });
        },
        selDetails: function selDetails(row) {
            //查看客戶詳情資訊
            this.$store.commit("setSearchSte", false);
            this.$router.push({
                name: '客戶詳情',
                params: {
                    id: row.id
                }
            });
        },
        customerSave: function customerSave() {
            var _this7 = this;

            /*this.$refs.customerForm.validate((valid) => {*/
            var str = this.isNull();
            if (str !== "") {
                this.dialogVisible = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                if (this.customerForm.id == "") {
                    //新增
                    this.addEidtloading = true;
                    //var  params=Object.assign({},this.customerForm);
                    var params = {
                        code: this.customerForm.code,
                        name: this.customerForm.name,
                        phone: this.customerForm.phone,
                        address: this.customerForm.address,
                        sales: this.customerForm.sales,
                        salesId: this.customerForm.salesId
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_42" /* insertCustomer */])(params).then(function (data) {
                        _this7.addEidtloading = false;
                        var _data$data4 = data.data,
                            res = _data$data4 === undefined ? {} : _data$data4;

                        if (res.errcode == 200) {
                            _this7.$message.success("新增成功！！");
                            _this7.getCustomerList();
                            _this7.resetForm("customerForm");
                            _this7.dialogDiscEditVisible = false;
                        } else {
                            _this7.$message.error(res.errmsg);
                        }
                    }, function (err) {
                        _this7.addEidtloading = false;
                    });
                } else {
                    //編輯
                    var params = {
                        id: this.customerForm.id,
                        code: this.customerForm.code,
                        name: this.customerForm.name,
                        phone: this.customerForm.phone,
                        sales: this.customerForm.sales,
                        address: this.customerForm.address,
                        salesId: this.customerForm.salesId
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_64" /* updateCustomer */])(params).then(function (data) {
                        _this7.addEidtloading = false;
                        var _data$data5 = data.data,
                            res = _data$data5 === undefined ? {} : _data$data5;

                        if (res.errcode == 200) {
                            _this7.$message.success("修改成功");
                            _this7.getCustomerList();
                            _this7.resetForm("customerForm");
                            _this7.dialogDiscEditVisible = false;
                        } else {
                            _this7.$message.error(res.errmsg);
                        }
                    }, function (err) {
                        _this7.addEidtloading = false;
                    });
                }
            }
        },


        //清除表單內容
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        isNull: function isNull() {
            /*是否为空*/
            if (this.customerForm.code === "" || this.customerForm.code === null) {
                return "客戶編號不能為空";
            } else if (this.customerForm.code.length > 20) {
                return "客戶編號不能大於20位";
            }
            if (this.customerForm.name === "" || this.customerForm.name === null) {
                return "姓名不能為空";
            } else if (this.customerForm.name.length > 50) {
                return "姓名不能大於50位";
            }
            if (this.customerForm.phone === "" || this.customerForm.phone === null) {
                return "電話不能為空";
            } else if (this.customerForm.phone.length > 30) {
                return "電話不能大於30位";
            }
            if (this.customerForm.address === "" || this.customerForm.address === null) {
                return "地址不能為空";
            } else if (this.customerForm.address.length > 255) {
                return "地址長度不能大於255位";
            }
            if (this.customerForm.salesId === "" || this.customerForm.salesId === null) {
                return "銷售員不能為空";
            }
            return "";
        }
    },
    data: function data() {
        var _this8 = this;

        var validateNumber = function validateNumber(rule, value, callback) {
            var reg = /^[1-15]\d*$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    callback(new Error(_this8.$t('m.canOnlyEnterPositiveNumber')));
                }
            }
            callback();
        };

        //驗證客戶編號是否重複
        //            var validateCustomerCode=(rule, value, callback) => {
        //                var params={code:this.customerForm.code};
        //                return getValidateCustomerCode(params).then(data=>{
        //                    if(this.customerForm.id == '') {
        //                        let item = data.data.data;
        //                        if (item) {
        //                            callback(new Error('客戶編號重複！'));
        //                        } else {
        //                            callback();
        //                        }
        //                    }
        //                });
        //                callback();
        //            };
        return {
            //查詢準則
            searchBankName: "",
            customerList: [],
            salesList: [], //銷售員LIST
            saList: [], //銷售員LIST
            selectionItems: [],
            tableloading: false,
            addEidtloading: false,
            dialogDiscEditVisible: false,
            customerTableloading: false,
            isCFcode: "",
            pager: {
                page: 0,
                size: 15,
                total: 0
            },
            dialogName: '',
            searchName: '',
            searchSalesId: '',
            customerForm: {
                id: "",
                sales: "",
                salesId: "",
                code: "",
                name: "",
                phone: "",
                address: ''
            }
            //新增客戶資訊表單驗證
            //                customerRules: {
            //                    code: [
            //                        {required: true, message: '請輸入客戶編號', trigger: 'blur' },
            //                        {max:30,message:"客戶編號最多只能30位元",trigger:'blur'},
            //                        { validator: validateCustomerCode,trigger: 'blur' }
            //                    ],
            //                    name:[
            //                        {required: true, message: '請輸入客戶名', trigger: 'blur' },
            //                        {max:30,message:"客戶名最多只能20位元",trigger:'change'},
            //                    ],
            //                    phone:[
            //                        {required: true, message: '請輸入手機號', trigger: 'blur' },
            //                        {max:16,message:"手機號最多只能16位",trigger:'blur'}
            //                    ],
            //                    address:[
            //                        {required: true, message: '請輸入位址', trigger: 'blur' }
            //                    ],
            //                    sales:[
            //                        {required: true, message: '請選擇銷售員', trigger: 'blur' }
            //                    ]
            //                }
        };
    },


    //        mounted() {
    //
    //        },
    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("CUST_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("CUST_EDIT");
        },
        canDel: function canDel() {
            return this.$store.getters.hasPermission("CUST_DEL");
        },
        canDetail: function canDetail() {
            return this.$store.getters.hasPermission("CUST_DETAILS");
        }
    },
    activated: function activated() {
        var _this9 = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data6 = data.data,
                res = _data$data6 === undefined ? {} : _data$data6;

            _this9.salesList = res.data;
        });
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getCustomerList();
    }
});

/***/ }),

/***/ "J2a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查詢條件
            serchSalesId: "",
            getTaskDate: '',
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            calenTaskList: [],
            salesList: [],
            tableloading: false
        };
    },

    methods: {
        goBack: function goBack() {
            this.$router.push({
                name: '行事曆',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "calenList");
        },
        custTaskPageChange: function custTaskPageChange(val) {
            this.getCalendarTaskList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        getCalendarTaskList: function getCalendarTaskList() {
            var _this = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, salesId: this.serchSalesId, taskDate: this.getTaskDate };
            if (params.taskDate != null && params.taskDate != '') {
                params.taskDate = parseInt(new Date(params.taskDate).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["w" /* getCalendarTaskList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this.calenTaskList = items;
                    _this.pager.total = total;
                    _this.pager.page = page;
                    _this.pager.size = size;
                    _this.tableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        var _this2 = this;

        this.getCalendarTaskList();
        Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data2 = data.data,
                res = _data$data2 === undefined ? {} : _data$data2;

            _this2.salesList = res.data;
        });
    },

    computed: {}
});

/***/ }),

/***/ "J8pp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JC9h":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.e18672f.jpg";

/***/ }),

/***/ "JNZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//    function boxheight(){ //函數：獲取尺寸
//        //獲取流覽器窗口高度
//        var winHeight=0;
//        if (window.innerHeight)
//            winHeight = window.innerHeight;
//        else if ((document.body) && (document.body.clientHeight))
//            winHeight = document.body.clientHeight;
//        //通過Document對body進行檢測，獲取流覽器視覺化高度
//        if (document.documentElement && document.documentElement.clientHeight)
//            winHeight = document.documentElement.clientHeight;
//        //DIV高度為流覽器窗口高度
//        document.getElementById("table_qh").style.height= winHeight +"px";
//
//    }
//    window.onresize=boxheight; //視窗或框架被調整大小時執行




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    methods: {
        selectChangedType: function selectChangedType(value) {
            var _this = this;

            var params = { whetherPublic: 2, id: this.locationId, type: parseInt(value) };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_73" /* updateLocationWhether */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    _this.$message.success('設置成功');
                    _this.getLocationList();
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        selectChanged: function selectChanged(value) {
            var _this2 = this;

            console.log(value);
            var params = { whetherPublic: parseInt(value), id: this.locationId, type: 2 };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_73" /* updateLocationWhether */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode == 200) {
                    _this2.$message.success('設置成功');
                    _this2.getLocationList();
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        selDetails: function selDetails(custId) {
            //查看客戶詳情資訊
            this.$router.push({
                name: '客戶詳情',
                params: {
                    id: custId
                }
            });
            this.tkshow = false;
            /*  var path="/customer/"+row.custId
              this.$router.push(path);*/
        },
        isAllow: function isAllow() {
            //   let status = 0;
            // if(document.getElementById("box01").checked){
            //       status = 1;
            // }
            //   var params={whetherPublic:status,id:this.locationId};
            //   return updateLocationWhether(params).then(data=>{
            //       let {data:res={}}=data;
            //       if(res.errcode==200){
            //           this.$message.success('設置成功');
            //           this.getLocationList();
            //       }else{
            //           this.$message.error(res.errmsg);
            //       }
            //   });

        },
        a: function a() {
            if (this.thx != this.locationForm.x) {
                this.isx = true;
            } else {
                this.isx = false;
            }
        },
        b: function b() {
            if (this.thy != this.locationForm.y) {
                this.isy = true;
            } else {
                this.isy = false;
            }
        },
        getLocationList: function getLocationList() {
            var _this3 = this;

            //載入頁面
            this.EDIT_LOCATION = this.$store.getters.hasPermission("EDIT_LOCATION"); //查詢是否能修改
            //                document.getElementById("table_qh").offsetHeight = 80;
            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["X" /* getLocationList */])(params).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode == 200) {
                    _this3.locationList = res.data;
                    // 計算所有的倉庫數量和使用數量
                    var allFloorCount = 0;
                    var allUseCount = 0;
                    _this3.locationList.map(function (item) {
                        if (item.floor != 3) {
                            allFloorCount += item.floorcount;
                            allUseCount += item.usecount;
                        }
                    });
                    _this3.floorcountSum = allFloorCount;
                    _this3.useflocountSum = allUseCount;
                    // console.log("111");
                    // console.log(this.locationList);
                    _this3.floCount = data.data;

                    _this3.tableloading = false;
                    _this3.loading = true;
                    _this3.loadingimg = false;
                } else {
                    _this3.$message.error(res.errmsg);
                }
            });
        },
        listCut: function listCut(index) {
            //切換樓層效果
            this.changeRed = index;
            this.num = index;
            if (index == 0) this.presentnum = "G";else this.presentnum = index;
        },
        itemChange: function itemChange(value) {
            this.locationForm.name = value.toUpperCase();
        },
        locationAdd: function locationAdd() {
            this.dialogName = "新增貨架", this.dialogDiscEditVisible = true;
            this.resetForm("locationForm");
            this.locationForm = {
                id: "",
                name: "",
                floor: "",
                side: "",
                x: "",
                y: ""
            };
        },
        cusInventory: function cusInventory(id, status, name) {
            var _this4 = this;

            //客戶庫存
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["T" /* getLocationById */])(id).then(function (data) {
                var item = data.data;
                if (item.errcode == 200) {
                    _this4.selectValue = item.data.whetherPublic + "";
                    _this4.selectTypeValue = item.data.type + "";
                }
            });
            if (status == 0) {
                this.hobbies = false;
            } else {
                this.hobbies = true;
            }
            this.shelfName = name;
            this.locationId = id;
            this.tkshow = true;
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getCusInventory */])(id).then(function (data) {
                _this4.locationNames = [];
                _this4.locationCust = [];
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;

                if (res.errcode == 200) {
                    var obj = res.data;
                    _this4.locationListB = obj;
                    //                        this.locationListB.forEach((a)=>{
                    //
                    //                        });
                    for (var i = 0; i < _this4.locationListB.length; i++) {
                        _this4.locationListB[i].createDate = new Date(_this4.locationListB[i].createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        if (_this4.locationNames.indexOf(_this4.locationListB[i].cCode + '(' + _this4.locationListB[i].name + ')') == -1) {
                            _this4.locationNames.push(_this4.locationListB[i].cCode + '(' + _this4.locationListB[i].name + ')');
                        }
                        if (_this4.locationCust.indexOf(_this4.locationListB[i].custId) == -1) {
                            _this4.locationCust.push(_this4.locationListB[i].custId);
                        }
                    }
                } else {
                    _this4.$message.error(res.errmsg);
                }
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        locationDel: function locationDel(id) {
            var _this5 = this;

            this.$confirm('您確定刪除此資料嗎', '刪除提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["k" /* deleteLocationById */])(id).then(function (data) {
                    var _data$data5 = data.data,
                        res = _data$data5 === undefined ? {} : _data$data5;

                    if (res.errcode == 200) {
                        _this5.$message.success('刪除成功');
                        _this5.getLocationList();
                        _this5.dialogDiscEditVisible = false;
                    } else {
                        _this5.$message.error(res.errmsg);
                    }
                });
            }).catch(function () {
                _this5.$message({
                    type: 'info',
                    message: '已取消刪除'
                });
            });
        },
        locationEdit: function locationEdit(id) {
            if (this.EDIT_LOCATION === true) {
                this.dialogName = "編輯架子", this.dialogDiscEditVisible = true;
                this.resetForm("locationForm");
                this.locationById(id);
            }
        },
        locationById: function locationById(id) {
            var _this6 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["T" /* getLocationById */])(id).then(function (data) {
                var item = data.data;
                if (item.errcode == 200) {
                    _this6.thx = item.data.x;
                    _this6.thy = item.data.y;
                    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this6.locationForm, item.data);
                } else {
                    _this6.$message.error(item.errmsg);
                }
            });
        },
        clickprinting: function clickprinting() {
            console.log("打印報表");
            this.$router.push({
                name: '打印報表'
            });
        },
        locationSave: function locationSave() {
            var _this7 = this;

            this.$refs.locationForm.validate(function (valid) {
                if (valid) {

                    if (parseInt(_this7.locationForm.x) > 0 && parseInt(_this7.locationForm.x) < 5) {
                        _this7.locationForm.side = 1;
                    }
                    if (parseInt(_this7.locationForm.x) > 4 && parseInt(_this7.locationForm.x) < 13) {
                        _this7.locationForm.side = 2;
                    }
                    if (parseInt(_this7.locationForm.x) > 12 && parseInt(_this7.locationForm.x) < 17) {
                        _this7.locationForm.side = 3;
                    }

                    if (_this7.locationForm.id == "") {
                        //新增
                        //驗證位置是否使用
                        var params = { floor: _this7.locationForm.floor, x: _this7.locationForm.x, y: _this7.locationForm.y };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["V" /* getLocationByXY */])(params).then(function (data) {
                            var item = data.data;
                            if (item.data == false) {
                                return _this7.$message.error("該位置已被使用！");
                            } else {
                                _this7.addEidtloading = true;
                                //var  params=Object.assign({},this.locationForm);
                                var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ name: _this7.locationForm.name, side: _this7.locationForm.side, floor: _this7.locationForm.floor, x: _this7.locationForm.x, y: _this7.locationForm.y }, 'side', _this7.locationForm.side);
                                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_46" /* insertLocation */])(params).then(function (data) {
                                    var _data$data6 = data.data,
                                        res = _data$data6 === undefined ? {} : _data$data6;

                                    _this7.addEidtloading = false;
                                    //let {errcode,errmsg}=data;
                                    if (res.errcode == 200) {
                                        _this7.$message.success("新增成功！！");
                                        _this7.getLocationList();
                                        _this7.resetForm("locationForm");
                                        _this7.dialogDiscEditVisible = false;
                                    } else {
                                        _this7.$message.error(res.errmsg);
                                    }
                                }, function (err) {
                                    _this7.addEidtloading = false;
                                });
                            }
                        });
                    } else {
                        //編輯
                        //                            console.log(this.isx);
                        if (_this7.isx == true || _this7.isy == true) {
                            //驗證位置是否使用
                            var params = { floor: _this7.locationForm.floor, x: _this7.locationForm.x, y: _this7.locationForm.y };
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["V" /* getLocationByXY */])(params).then(function (data) {
                                var item = data.data;
                                if (item.data == false) {
                                    return _this7.$message.error("該位置已被使用！");
                                } else {
                                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                                        id: _this7.locationForm.id,
                                        name: _this7.locationForm.name,
                                        side: _this7.locationForm.side,
                                        floor: _this7.locationForm.floor,
                                        x: _this7.locationForm.x,
                                        y: _this7.locationForm.y
                                    }, 'side', _this7.locationForm.side);
                                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_72" /* updateLocation */])(params).then(function (data) {
                                        _this7.addEidtloading = false;
                                        var _data$data7 = data.data,
                                            res = _data$data7 === undefined ? {} : _data$data7;

                                        if (res.errcode == 200) {
                                            _this7.$message.success("修改成功");
                                            _this7.getLocationList();
                                            _this7.resetForm("locationForm");
                                            _this7.dialogDiscEditVisible = false;
                                        } else {
                                            _this7.$message.error(res.errmsg);
                                        }
                                    }, function (err) {
                                        _this7.addEidtloading = false;
                                    });
                                }
                            });
                        } else {
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                                id: _this7.locationForm.id,
                                name: _this7.locationForm.name,
                                side: _this7.locationForm.side,
                                floor: _this7.locationForm.floor,
                                x: _this7.locationForm.x,
                                y: _this7.locationForm.y
                            }, 'side', _this7.locationForm.side);
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_72" /* updateLocation */])(params).then(function (data) {
                                _this7.addEidtloading = false;
                                var _data$data8 = data.data,
                                    res = _data$data8 === undefined ? {} : _data$data8;

                                if (res.errcode == 200) {
                                    _this7.$message.success("修改成功");
                                    _this7.getLocationList();
                                    _this7.resetForm("locationForm");
                                    _this7.dialogDiscEditVisible = false;
                                } else {
                                    _this7.$message.error(res.errmsg);
                                }
                            }, function (err) {
                                _this7.addEidtloading = false;
                            });
                        }
                    }
                }
            });
        },

        //清除表單內容
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    data: function data() {
        var _this8 = this;

        var validateNumber = function validateNumber(rule, value, callback) {
            var reg = /^[1-15]\d*$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    callback(new Error(_this8.$t('m.canOnlyEnterPositiveNumber')));
                }
            }
            callback();
        };
        //驗證客戶編號是否重複
        var validateLocationName = function validateLocationName(rule, value, callback) {
            if (_this8.locationForm.id == '') {
                var params = { name: _this8.locationForm.name };
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_39" /* getValidateLocationName */])(params).then(function (data) {
                    var item = data.data.data;
                    if (item) {
                        callback(new Error('貨架名重複！'));
                    } else {
                        callback();
                    }
                });
            }
            callback();
        };

        return {
            locationNames: [],
            locationCust: [],
            locationId: 0,
            hobbies: false,
            loading: false,
            loadingimg: true,
            custName: '',
            tkshow: false,
            isx: false,
            isy: false,
            thx: 0,
            thy: 0,
            shelfName: '',
            EDIT_LOCATION: false, //是否可以修改
            num: 0,
            presentnum: 'G', //当前楼层
            changeRed: 0,
            hjis: false,
            //查詢準則
            searchBankName: "",
            storList: [],
            locationList: [],
            locationListA: [],
            locationListB: [],
            floCount: [],
            floSideCount: [],
            selectionItems: [],
            tableloading: false,
            addEidtloading: false,
            dialogDiscEditVisible: false,
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            dialogName: '',
            locationForm: {
                id: "",
                name: "",
                floor: "",
                side: "",
                order: ""
            },
            orderTypeList: [{
                value: '0',
                label: '一單'
            }, {
                value: '1',
                label: '多單'
            }],
            selectValue: '0',
            selectTypeValue: '0',
            TypeList: [{
                value: '0',
                label: '正常單'
            }, {
                value: '1',
                label: '物料單'
            }],
            options: [{
                value: '1',
                label: '左'
            }, {
                value: '2',
                label: '中'
            }, {
                value: '3',
                label: '右'
            }],
            floorSelect: [{
                value: '0',
                label: 'G/F'
            }, {
                value: '1',
                label: '1/F'
            }, {
                value: '2',
                label: '2/F'
            }],
            //新增客戶資訊表單驗證
            locationRules: {
                name: [{ required: true, message: '貨架名不能為空', trigger: 'blur' }, { max: 10, message: "貨架名最多只能10位", trigger: 'blur' }, { validator: validateLocationName, trigger: 'blur' }],
                floor: [{ required: true, message: '請選擇樓層', trigger: 'blur' }],
                x: [{ required: true, message: 'x軸不能為空', trigger: 'blur' }],
                y: [{ required: true, message: 'y軸不能為空', trigger: 'blur' }]
            },
            // 所有倉庫數量
            floorcountSum: 0,
            // 倉庫所有使用數量
            useflocountSum: 0
        };
    },
    activated: function activated() {
        //            document.write('屏幕宽度：' + screen.availWidth);
        //            document.write('屏幕高度：' + screen.availHeight);
        if (screen.availWidth == 1024) {
            this.$store.commit("setCollapsed", true);
        }
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getLocationList();
        //            if(this.$store.getters.isLoding == true){
        //                location.reload();
        //            }
    },

    computed: {
        canIS_DIO: function canIS_DIO() {
            return this.$store.getters.hasPermission("IS_DIO");
        }
    }

});

/***/ }),

/***/ "JU1R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Home__ = __webpack_require__("j7e0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Search__ = __webpack_require__("G7FF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Homepage__ = __webpack_require__("KNlE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Warehousing__ = __webpack_require__("8Y1G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_StockOut__ = __webpack_require__("vxvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Staff__ = __webpack_require__("Rxym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Customer__ = __webpack_require__("HkCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Searcha__ = __webpack_require__("Kzek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Remark__ = __webpack_require__("A+ON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Role__ = __webpack_require__("8pc/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_CustomerManagement__ = __webpack_require__("S++V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_TaskList__ = __webpack_require__("CqVz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_ExcelExport__ = __webpack_require__("pM4q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_FeedBackList__ = __webpack_require__("66ga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_StockAdjustMent__ = __webpack_require__("MW5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_FeedBack__ = __webpack_require__("oEYu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_UpdateFeedBack__ = __webpack_require__("4XP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_RollingList__ = __webpack_require__("M7E1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Rolling__ = __webpack_require__("5CEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_UpdateRolling__ = __webpack_require__("uEEz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_TaskCalendar__ = __webpack_require__("h7Tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_CalendarList__ = __webpack_require__("dOt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_JobOrderList__ = __webpack_require__("S2+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_AddJobOrder__ = __webpack_require__("BdBI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_UpdateJobOrder__ = __webpack_require__("TSgG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_AddStockIn__ = __webpack_require__("rUVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_UpdateStockIn__ = __webpack_require__("3e/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_AddStockOut__ = __webpack_require__("aT0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_UpdateStockOut__ = __webpack_require__("Qc+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_JobPrinting__ = __webpack_require__("8Ofm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_ItemStor__ = __webpack_require__("qPEd");








































var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
    return originalPush.call(this, location).catch(function (err) {
        return err;
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["default"],
        hidden: true,
        children: []
    }, {
        path: '/',
        name: '倉庫一覽',
        component: __WEBPACK_IMPORTED_MODULE_3__views_Home__["default"],
        hidden: true,
        children: [{
            path: 'customer/:id',
            name: '客戶詳情',
            component: __WEBPACK_IMPORTED_MODULE_4__views_Search__["default"],
            hidden: true,
            children: []
        }, {
            path: 'stockin/',
            name: '入倉',
            component: __WEBPACK_IMPORTED_MODULE_6__views_Warehousing__["default"],
            hidden: true,
            children: []
        }, {
            path: 'addStockin/',
            name: '新增入倉',
            component: __WEBPACK_IMPORTED_MODULE_28__views_AddStockIn__["default"],
            hidden: true,
            children: []
        }, {
            path: 'updateStockin/:id/:typeId/:custId',
            name: '編輯入倉',
            component: __WEBPACK_IMPORTED_MODULE_29__views_UpdateStockIn__["default"],
            hidden: true,
            children: []
        }, {
            path: 'stockout/',
            name: '出倉',
            component: __WEBPACK_IMPORTED_MODULE_7__views_StockOut__["default"],
            hidden: true,
            children: []
        }, {
            path: 'addStockout/',
            name: '新增出倉',
            component: __WEBPACK_IMPORTED_MODULE_30__views_AddStockOut__["default"],
            hidden: true,
            children: []
        }, {
            path: 'updatesStockout/:id/:typeId/:custId',
            name: '編輯出倉',
            component: __WEBPACK_IMPORTED_MODULE_31__views_UpdateStockOut__["default"],
            hidden: true,
            children: []
        }, {
            path: 'page/',
            name: '倉庫一覽',
            component: __WEBPACK_IMPORTED_MODULE_5__views_Homepage__["default"],
            hidden: true,
            children: []
        }, {
            path: 'staff/',
            name: '員工',
            component: __WEBPACK_IMPORTED_MODULE_8__views_Staff__["default"],
            hidden: true,
            children: []
        }, {
            path: 'customer/',
            name: '客戶',
            component: __WEBPACK_IMPORTED_MODULE_9__views_Customer__["default"],
            hidden: true,
            children: []
        }, {
            path: 'customer/:keywords',
            name: '首頁搜尋網頁面',
            component: __WEBPACK_IMPORTED_MODULE_10__views_Searcha__["default"],
            hidden: true,
            children: []
        }, {
            path: 'remark/',
            name: '常用備註',
            component: __WEBPACK_IMPORTED_MODULE_11__views_Remark__["default"],
            hidden: true,
            children: []
        }, {
            path: 'role/',
            name: '角色',
            component: __WEBPACK_IMPORTED_MODULE_12__views_Role__["default"],
            hidden: true,
            children: []
        }, {
            path: 'custgrp/',
            name: '客戶組',
            component: __WEBPACK_IMPORTED_MODULE_13__views_CustomerManagement__["default"],
            hidden: true,
            children: []
        }, {
            path: 'task/',
            name: '任務列表',
            component: __WEBPACK_IMPORTED_MODULE_14__views_TaskList__["default"],
            hidden: true,
            children: []
        }, {
            path: 'reports/',
            name: '報表',
            component: __WEBPACK_IMPORTED_MODULE_15__views_ExcelExport__["default"],
            hidden: true,
            children: []
        }, {
            path: 'materialin/',
            name: '回料紙',
            component: __WEBPACK_IMPORTED_MODULE_16__views_FeedBackList__["default"],
            hidden: true,
            children: []
        }, {
            path: 'feedAdd',
            name: '新增回料紙',
            component: __WEBPACK_IMPORTED_MODULE_18__views_FeedBack__["default"],
            hidden: true,
            children: []
        }, {
            path: 'feedEdit/:feedId/:rollId',
            name: '編輯回料紙',
            component: __WEBPACK_IMPORTED_MODULE_19__views_UpdateFeedBack__["default"],
            hidden: true,
            children: []
        }, {
            path: 'materialout/',
            name: '物料出入倉',
            component: __WEBPACK_IMPORTED_MODULE_20__views_RollingList__["default"],
            hidden: true,
            children: []
        }, {
            path: 'rollAdd',
            name: '新增出倉紙',
            component: __WEBPACK_IMPORTED_MODULE_21__views_Rolling__["default"],
            hidden: true,
            children: []
        }, {
            path: 'rollEdit/:outId',
            name: '編輯出倉紙',
            component: __WEBPACK_IMPORTED_MODULE_22__views_UpdateRolling__["default"],
            hidden: true,
            keepAlive: true,
            children: []
        }, {
            path: 'stockAdj/',
            name: '貨品調整',
            component: __WEBPACK_IMPORTED_MODULE_17__views_StockAdjustMent__["default"],
            hidden: true,
            children: []
        }, {
            path: 'taskCalendar/',
            name: '行事曆',
            component: __WEBPACK_IMPORTED_MODULE_23__views_TaskCalendar__["default"],
            hidden: true,
            children: []
        }, {
            path: 'calenList/',
            name: '行事曆列表',
            component: __WEBPACK_IMPORTED_MODULE_24__views_CalendarList__["default"],
            hidden: true,
            children: []
        }, {
            path: 'jobOrder/',
            name: '工作單',
            component: __WEBPACK_IMPORTED_MODULE_25__views_JobOrderList__["default"],
            hidden: true,
            children: []
        }, {
            path: 'jobAdd',
            name: '新增工作單',
            component: __WEBPACK_IMPORTED_MODULE_26__views_AddJobOrder__["default"],
            hidden: true,
            children: []
        }, {
            path: 'jobPrint/:id/:jobId',
            name: '卡板箱号管理',
            component: __WEBPACK_IMPORTED_MODULE_32__views_JobPrinting__["default"],
            hidden: true,
            children: []
        }, {
            path: 'jobEdit/:jobId',
            name: '編輯工作單',
            component: __WEBPACK_IMPORTED_MODULE_27__views_UpdateJobOrder__["default"],
            hidden: true,
            children: []
        }, {
            path: 'itemStor/',
            name: '產品倉存',
            component: __WEBPACK_IMPORTED_MODULE_33__views_ItemStor__["default"],
            hidden: true,
            children: []
        }]
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "JV7o":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "KDGA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KNlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("JNZ0");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f38550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("8KPn");
function injectStyle (ssrContext) {
  __webpack_require__("yH7D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7f38550"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7f38550_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KrLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            recordList: [],
            dialogVisible: false,
            options4: [],
            salesList: [], //銷售員LIST
            saList: [], //銷售員LIST
            custSalesList: [], //銷售員LIST
            list: [],
            tableloading: false,
            warehousingList: [],
            storIn: [], //入庫詳細資訊
            customerCode: {},
            remarkList: [], //常用列表
            locationList: {}, //架子表信息
            addNum: false,
            updateStorIn: "",
            codeList: [],
            company: [{ value: '籠', label: '籠' }, { value: '盒', label: '盒' }, { value: '板', label: '板' }, { value: '散件', label: '散件' }], //單位
            storInId: 0,
            typeId: 1,
            custId: 0,
            addWarehousingList: [{ state: 1, second: 1, createDate: null, code: this.RndNum(), addStorIn: true, storInItem: [{ addStorinItem: true, num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', itemShows: true, qtyShow: true, locationIdShows: true }] }],
            show: true, //資訊頁面
            add: false, //添加頁面
            rkCont: null, //入庫和客戶資訊
            submitInfo: true, //是否禁止保存按钮
            code: '',
            pager: {
                page: 0,
                size: 15,
                total: 0
            },
            form: {
                id: null,
                sCode: '',
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false,
                price: null,
                unitVolume: null,
                totalPrice: null,
                totalVolume: null,
                outTotalAmount: null,
                remainingAmount: null
            },
            searchStorIn: '',
            searchName: '',
            searchSalesId: '',
            acctStockId: '',
            oldUnitVolume: null
        };
    },

    methods: {
        formatCurrency: function formatCurrency(amount) {
            var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (!amount) return;
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: decimalPlaces
            });
            return '' + formatter.format(amount);
        },
        formatDate: function formatDate(time) {
            if (!time) return;
            var date = new Date(time * 1000);
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以要加1，并且需要两位数表示
            var day = date.getDate().toString().padStart(2, '0');
            var hours = date.getHours().toString().padStart(2, '0');
            var minutes = date.getMinutes().toString().padStart(2, '0');
            var seconds = date.getSeconds().toString().padStart(2, '0');
            return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
        },
        handleOpenRecord: function handleOpenRecord(item) {
            var _this = this;

            if (!item.id) return;
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_30" /* getStotInOutRecord */])(item.id).then(function (res) {
                if (res) {
                    _this.recordList = res.data.data || [];
                    _this.dialogVisible = true;
                }
            });
        },
        selSCode: function selSCode() {
            var _this2 = this;

            /*查詢入庫單是否重复*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_58" /* selCode */])(this.form.sCode).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    if (res.data !== null) {
                        //数据庫中没有当前入庫單號
                        if (res.data.code !== _this2.updateStorIn) {
                            //当前輸入的帐号是否是修改的帐号
                            _this2.$alert("當前入庫單號:" + _this2.form.sCode + " 已存在!", '提示', {
                                confirmButtonText: '確定',
                                type: 'warning',
                                callback: function callback(action) {
                                    if (_this2.updateStorIn !== "") {
                                        _this2.form.sCode = _this2.updateStorIn;
                                    } else {
                                        _this2.form.sCode = "";
                                    }
                                }
                            });
                        }
                    }
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            if (this.typeId == 2) {
                this.$router.push({
                    name: '客戶詳情',
                    params: {
                        id: this.custId
                    }
                });
                this.$store.commit("closeTab", 'updateStockin');
            } else {
                this.$router.push({
                    name: '入倉',
                    params: { str: new Date().getTime() }
                });
                this.$store.commit("closeTab", 'updateStockin');
            }
        },
        remoteMethod: function remoteMethod(query) {
            var _this3 = this;

            /*選擇位置*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.options4 = _this3.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodSales: function remoteMethodSales(query) {
            var _this4 = this;

            /*選擇銷售員*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this4.loading = false;
                    _this4.saList = _this4.salesList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        clickLoad: function clickLoad() {
            /*点击銷售員框时加载*/
            this.saList = [];
            this.saList = this.salesList;
        },
        handleCurrentChange: function handleCurrentChange() {
            this.getWarehousing();
        },
        isDate: function isDate() {
            /*处理日期*/
            this.addWarehousingList.forEach(function (a, i) {
                if (a.createDate) {
                    a.createDate = Math.round(new Date(a.createDate).getTime() / 1000); //new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
                }
            });
        },
        isStringNull: function isStringNull() {
            var _this5 = this;

            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "工作單號不能為空";
            }
            if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }
            if (this.form.name === null || this.form.name === "") {
                return "物品不能為空";
            }
            if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }
            if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }
            if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }
            if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            try {
                this.addWarehousingList.forEach(function (a, i) {
                    if (a.createDate === null || a.createDate === "") {
                        str = "Job00" + (i + 1) + "的時間不能為空";
                        foreach.break = new Error(str);
                    } else {
                        a.storInItem.forEach(function (item, j) {
                            if (item.item === "") {
                                a.storInItem.splice(j, 1); //刪除當前這條沒有值的資料
                            } else {
                                var num = 0;
                                if (_this5.addShow === true) {
                                    //点击新建后把最前面的变为反的
                                    if (i === 0) {
                                        num = _this5.addWarehousingList.length;
                                    } else {
                                        num = i - 1;
                                    }
                                } else {
                                    num = i + 1;
                                }
                                if (item.unit === null || item.unit === "" || item.unit === undefined) {
                                    str = "第" + num + "次的單位不能為空";
                                    foreach.break = new Error(str);
                                }
                                if (item.boxNo === null || item.boxNo === 0) {
                                    str = "第" + num + "次的編號不能為空";
                                    foreach.break = new Error(str);
                                }
                                if (item.item === null || item.item === "") {
                                    str = "第" + num + "次的名稱不能為空";
                                    foreach.break = new Error(str);
                                }
                                // if(item.qty === null || item.qty === ""){
                                //     str = "第"+ num +"次的數量不能為空";
                                //     foreach.break = new Error(str);
                                // }
                                // if(item.quantity === null || item.quantity === ""){
                                //     str = "第"+ num +"次的件數不能為空";
                                //     foreach.break = new Error(str);
                                // }
                                if ((!item.remainingQuantity || item.remainingQuantity == 0 || item.remainingQuantity == null) && item.state != 1) {
                                    str = "無出倉件數，第" + num + "次的剩餘件數必須大於0";
                                    foreach.break = new Error(str);
                                }
                                if (item.locationId === null || item.locationId === "") {
                                    str = "位置不能為空";
                                    foreach.break = new Error(str);
                                }
                                // item.qty = Number(item.qty);
                                item.qty = 1;
                                item.remainingQuantity = Number(item.remainingQuantity);
                                item.quantity = Number(item.remainingQuantity) + Number(item.deliverGodown || 0);
                                item.remainingVolume = Number(item.remainingVolume);
                                item.volume = Number(item.remainingVolume) + Number(item.deliverVolume || 0);

                                if (!item.addStorinItem && (item.remainingVolume != item.oldRemainingVolume || item.remainingQuantity != item.oldRemainingQuantity)) {
                                    item.updateStorinItem = true;
                                }
                            }
                        });
                    }
                    var nary = _this5.addWarehousingList[i].storInItem.sort(); //查找是否有重复的單位和BOX
                    var obj = {};
                    var obj1 = {};
                    for (var j = 0, l = nary.length; j < l; j++) {
                        if (nary[j].state === 0) {
                            if (obj[nary[j].boxNo + "," + nary[j].unit]) {
                                if (obj1[nary[j].unit]) {
                                    str = "有重複的單位: " + nary[j].unit + " ,和編號: " + nary[j].boxNo;
                                    foreach.break = new Error(str);
                                }
                            } else {
                                obj[nary[j].boxNo + "," + nary[j].unit] = nary[j].boxNo + "," + nary[j].unit;
                                obj1[nary[j].unit] = nary[j].unit;
                            }
                        }
                    }
                });
            } catch (e) {
                return str;
            }
            return str;
        },
        getWarehousing: function getWarehousing() {
            var _this6 = this;

            /*查詢入庫*/
            this.submitInfo = true;
            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, storIn: this.searchStorIn.trim(), custName: this.searchName.trim(), salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_21" /* getStorInList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this6.warehousingList = items;
                    _this6.warehousingList.forEach(function (a, b) {
                        a.storInDate = new Date(a.storInDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this6.$set(_this6.warehousingList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this6.pager.total = total;
                    _this6.pager.page = page;
                    _this6.pager.size = size;
                    _this6.tableloading = false;
                } else {
                    _this6.$message.error(res.errmsg);
                }
            });
        },
        addWarehousing: function addWarehousing() {
            var _this7 = this;

            /*點擊新增後向陣列添加一條資料*/
            this.addShow = true;
            var boxNo = void 0;
            this.addWarehousingList.forEach(function (item, i) {
                //查詢当前BOXNO 最大值 +1
                var index = Number(_this7.addWarehousingList.length - 1);
                var a = Number(_this7.addWarehousingList[index].storInItem.length - 1);
                boxNo = Number(_this7.addWarehousingList[index].storInItem[a].boxNo) + 1;
            });
            this.addWarehousingList.unshift({ state: 0, second: this.addWarehousingList.length + 1, createDate: new Date().Format("yyyy-MM-dd hh:mm:ss"), code: null, addStorIn: true,
                storInItem: [{ state: 0, unitShow: true, num: 1, addStorinItem: true, boxNo: boxNo, item: '', qty: null, locationId: '', value: '', boxNoShow: false, itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, remainingVolume: null, oldRemainingVolume: null, countVolume: null, deliverGodown: null, deliverVolume: null, inItemPrice: 0, remainingQuantity: null, oldRemainingQuantity: null, updateStorinItem: false, quantity: null, quantityShow: true }] });
        },
        querySearch: function querySearch(queryString, cb) {
            /*載入數據*/
            var restaurants = this.customerCode;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (restaurant) {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        handleSelect: function handleSelect(item) {
            var _this8 = this;

            /*選擇客編號後*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* getCustomerById */])(item.id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode === 200) {
                    //console.log("resCUS",res);
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this8.form.id = id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = sales;
                    if (id != undefined) {
                        _this8.getLocationByCusId(id);
                    }
                } else {
                    _this8.$message.error(res.errmsg);
                }
            });
        },
        querySearchRemark: function querySearchRemark(queryString, cb) {
            /*載入常用列表數據*/
            var restaurants = this.remarkList;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        selCustimerId: function selCustimerId(id) {
            var _this9 = this;

            /*查詢客戶ID*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_22" /* getStorInListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;
                //console.log(res)

                if (res.errcode === 200) {
                    var _res$data$customer = res.data.customer,
                        _id = _res$data$customer.id,
                        code = _res$data$customer.code,
                        name = _res$data$customer.name,
                        phone = _res$data$customer.phone,
                        address = _res$data$customer.address;

                    _this9.form.id = _id;
                    _this9.form.code = code;
                    _this9.form.name = name;
                    _this9.form.address = address;
                    _this9.form.phone = phone;
                    _this9.form.sales = res.data.sales;
                    _this9.form.sCode = res.data.scode;
                    _this9.form.price = res.data.price;
                    _this9.form.totalPrice = res.data.totalPrice;
                    _this9.form.totalVolume = res.data.totalVolume;
                    _this9.form.outTotalAmount = res.data.outTotalAmount;
                    _this9.form.remainingAmount = res.data.remainingAmount;
                    _this9.form.unitVolume = res.data.unitVolume;
                    _this9.form.prePrice = res.data.lastPrice;
                    _this9.form.storInCode = res.data.lastCode;
                    _this9.form.storInTime = res.data.lastStorInTime;
                    _this9.oldUnitVolume = _this9.form.unitVolume;
                    if (_id != undefined) {
                        _this9.getLocationByCusId(_id);
                        // getPrePrice({custId: id, code: res.data.scode}).then((result)=>{
                        //     if(result) {
                        //         const { price,code:storInCode,storInTime } = result.data.data
                        //         this.form.prePrice = price
                        //         this.form.storInCode = storInCode
                        //         this.form.storInTime = storInTime
                        //         this.$forceUpdate()
                        //     }
                        // }).catch(()=>{})
                    }
                }
            });
        },
        delAddWarehousingList: function delAddWarehousingList(item, i) {
            var _this10 = this;

            /*删除StorInDate表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this10.addShow === true) {
                    _this10.addWarehousingList.splice(i, 1); //删除数组
                    _this10.addShow = false;
                } else {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["d" /* delStorInDate */])(item.id).then(function (str) {
                        //删除
                        var _str$data = str.data,
                            res = _str$data === undefined ? {} : _str$data;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this10.addWarehousingList.splice(i, 1); //删除数组
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this10.$message({
                            type: 'info',
                            message: mes
                        });
                    });
                }
                //let id = this.addWarehousingList[i].id;
            }).catch(function () {
                _this10.$message({
                    type: 'info',
                    message: '已取消刪除'
                });
            });
        },
        delStorInItem: function delStorInItem(i, index) {
            var _this11 = this;

            /*删除StorInItem表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this11.addWarehousingList[i].storInItem[index].addStorinItem === true) {
                    _this11.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                } else {
                    var id = _this11.addWarehousingList[i].storInItem[index].id;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["e" /* delStorInItem */])(id).then(function (str) {
                        //删除
                        var _str$data2 = str.data,
                            res = _str$data2 === undefined ? {} : _str$data2;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this11.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this11.$message({
                            type: 'info',
                            message: mes
                        });
                    }).catch(function () {
                        _this11.$message({
                            type: 'info',
                            message: '已取消刪除'
                        });
                    });
                }
            });
            //console.log("l",this.addWarehousingList[i].storInItem[index])
        },
        handleSelectState: function handleSelectState(id, i, index) {
            /*選擇位置後 向陣列添加一條新資料*/
            this.addWarehousingList[i].storInItem[index].unitShow = false;
            this.addWarehousingList[i].storInItem[index].locationId = id; //向選擇位置後的資訊添加位置ID
            return;
            if (this.addWarehousingList[i].storInItem[index].num === 1) {
                //
                var box = Number(this.addWarehousingList[i].storInItem[index].boxNo);
                this.addWarehousingList[i].storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, boxNo: box + 1, item: '', qty: null, locationId: '', value: '', itemShows: false, qtyShow: true, locationIdShows: false });
            }
            this.addWarehousingList[i].storInItem[index].num = 0;
            this.addWarehousingList[i].storInItem[index + 1].unit = this.addWarehousingList[i].storInItem[index].unit;
            this.addWarehousingList[i].storInItem[index].locationId = id; //向選擇位置後的資訊添加位置ID
        },
        isNullOptions4: function isNullOptions4() {
            /*点击时清空当前数组*/
            this.options4 = [];
            //this.getLocationByCusId(this.form.id);
        },
        selSotrIn: function selSotrIn(id, typeId, custId) {
            var _this12 = this;

            /*查詢入庫的詳細資訊*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerInSte", false);
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.addShow = false;
            this.rkCont = false; //入庫和客戶資訊
            this.storInId = id;
            this.typeId = typeId;
            this.custId = custId;
            var params = { page: this.pager.page, size: 100, storInId: id };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_59" /* selStorInItem */])(params).then(function (str) {
                //查詢當前入庫單裡有多少資料
                var _str$data3 = str.data,
                    res = _str$data3 === undefined ? {} : _str$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var leagueMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    var cId = void 0;
                    var i = 1;
                    res.data.data.forEach(function (item) {
                        //重新處理下資料
                        _this12.form.createDate = new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        var itemList = {};cId = item.cId;_this12.updateStorIn = item.sCode;
                        var floor = void 0;
                        if (item.floor === 0) {
                            floor = "GF " + item.name;
                        } else {
                            floor = item.floor + "F " + item.name;
                        }
                        if (item.state === 1) {
                            //是否是當天時間 不是當天的時間不能修改
                            itemList = { unitShow: true, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShows: true, qtyShow: true, locationIdShows: true, boxNoShow: true, length: item.length, wide: item.wide, high: item.high, ckgShow: true, volume: item.volume, remainingVolume: item.remainingVolume, oldRemainingVolume: item.remainingVolume, countVolume: item.countVolume, deliverGodown: item.deliverGodown, deliverVolume: item.deliverVolume, inItemPrice: item.inItemPrice, remainingQuantity: item.remainingQuantity, oldRemainingQuantity: item.remainingQuantity, updateStorinItem: false, quantity: item.quantity, quantityShow: true };
                        } else {
                            itemList = { unitShow: false, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShow: false, qtyShow: false, locationIdShow: false, length: item.length, wide: item.wide, high: item.high, ckgShow: false, volume: item.volume, remainingVolume: item.remainingVolume, oldRemainingVolume: item.remainingVolume, countVolume: item.countVolume, deliverGodown: item.deliverGodown, deliverVolume: item.deliverVolume, inItemPrice: item.inItemPrice, remainingQuantity: item.remainingQuantity, oldRemainingQuantity: item.remainingQuantity, updateStorinItem: false, quantity: item.quantity, quantityShow: false };
                        }
                        if (!leagueMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { state: 1, second: i, id: item.storDateId, code: item.sCode, createDate: new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"),
                                addStorIn: false, storInItem: [itemList] };
                            leagueMap.set(item.storDateId, storIdItemList);
                            i++;
                        } else {
                            leagueMap.get(item.storDateId).storInItem.push(itemList);
                        }
                    });
                    _this12.addWarehousingList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(leagueMap.values()));
                    var boxNo = void 0;
                    _this12.addWarehousingList.forEach(function (item, i) {
                        //查詢当前BOX 最大值 +1
                        var index = Number(_this12.addWarehousingList.length - 1);
                        var a = Number(_this12.addWarehousingList[index].storInItem.length - 1);
                        boxNo = Number(_this12.addWarehousingList[index].storInItem.length);
                        item.storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, id: item.id, boxNo: boxNo + 1, item: '', qty: null, locationId: '', value: '',
                            itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, remainingVolume: null, oldRemainingVolume: null, countVolume: null, deliverGodown: null, deliverVolume: null, inItemPrice: 0, remainingQuantity: null, oldRemainingQuantity: null, updateStorinItem: false, quantity: null, quantityShow: true });
                    });
                    _this12.selCustimerId(id); //查詢客戶id
                    _this12.form.codeShow = true;
                    _this12.form.sCodeShow = false;
                    _this12.form.nameShow = true;
                    _this12.form.phoneShow = true;
                    _this12.form.addressShow = true;
                    _this12.form.salesShow = true;
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this13 = this;

            /*保存資料到資料庫*/
            this.submitInfo = false; //禁止保存按钮
            var str = this.isStringNull();
            var params = {
                code: this.form.sCode,
                storInId: this.storInId,
                totalVolume: Number(this.form.totalVolume),
                price: Number(this.form.price),
                totalPrice: this.form.totalPrice,
                unitVolume: this.form.unitVolume,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storInDateList: this.addWarehousingList };
            //console.log("pa",params); WHETHER_PUBLIC 当前架子是否公共使用(0不公用 1公用)
            if (str !== "") {
                this.submitInfo = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error',
                    callback: function callback(action) {
                        var boxNo = void 0;
                        _this13.addWarehousingList.forEach(function (item, i) {
                            //查詢当前BOX 最大值 +1
                            var index = Number(_this13.addWarehousingList.length - 1);
                            var a = Number(_this13.addWarehousingList[index].storInItem.length - 1);
                            boxNo = Number(_this13.addWarehousingList[index].storInItem[a].boxNo) + 1;
                            //console.log(item.storInItem[a]);
                            if (item.storInItem[a].quantity !== null || item.storInItem[a].locationId !== "") {
                                item.storInItem.push({ state: 0, unitShow: true, unit: '', num: 0, addStorinItem: true, id: item.id, boxNo: boxNo + i, item: '', qty: null, locationId: '', value: '',
                                    itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, remainingVolume: null, oldRemainingVolume: null, countVolume: null, deliverGodown: null, deliverVolume: null, inItemPrice: 0, remainingQuantity: null, oldRemainingQuantity: null, updateStorinItem: false, quantity: null, quantityShow: true });
                            }
                        });
                    }
                });
            } else {
                this.isDate();
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_80" /* updateStorIn */])(params).then(function (data) {
                    var _data$data5 = data.data,
                        res = _data$data5 === undefined ? {} : _data$data5;

                    if (res.errcode === 200) {
                        _this13.$message({
                            showClose: true,
                            message: '修改成功！',
                            type: 'success'
                        });
                        _this13.cancelAdd();
                        if (_this13.typeId == 2) {
                            _this13.$router.push({
                                name: '客戶詳情',
                                params: {
                                    id: _this13.custId
                                }
                            });
                            _this13.$store.commit("closeTab", 'updateStockin');
                        } else {
                            _this13.$router.push({
                                name: '入倉',
                                params: { str: new Date().getTime() }
                            });
                            _this13.$store.commit("closeTab", 'updateStockin');
                        }
                    } else {
                        _this13.$message.error(res.errmsg);
                        _this13.submitInfo = true;
                    }
                });
            }
        },
        RndNum: function RndNum() {
            //生成一個15位元數的數字
            var rnd = "";
            for (var i = 0; i < 15; i++) {
                rnd += Math.floor(Math.random() * 10);
            }
            return rnd;
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm");
            this.addWarehousingList[0].createDate = new Date().Format("yyyy-MM-dd hh:mm");
            //console.log(this.addWarehousingList);
        },
        cancelAdd: function cancelAdd() {
            /*顯示入庫資訊 關閉添加入庫資訊*/
            this.add = false;
            this.show = true;
            this.nullList();
            this.list = [];
        },
        addList: function addList(i, index, str) {
            /*修改是否能輸入*/
            if (str === "cCode") {
                this.addWarehousingList[i].storInItem[index].locationIdShows = false;
                return;
            }
            if (str === "unit") {
                this.addWarehousingList[i].storInItem[index].itemShows = false;
                return;
            }
            if (str === "item") {
                this.addWarehousingList[i].storInItem[index].ckgShow = false;
                return;
            }
            if (str === "remainingQuantity") {
                var box = Number(this.addWarehousingList[i].storInItem.length);
                var temp = this.addWarehousingList[i].storInItem[box - 1];
                if (temp.locationId && temp.unit && temp.item && temp.remainingQuantity) {
                    this.addWarehousingList[i].storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, boxNo: box + 1, item: '', qty: null, locationId: '', value: '', itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, volume: null, remainingVolume: null, oldRemainingVolume: null, countVolume: null, deliverGodown: null, deliverVolume: null, inItemPrice: 0, remainingQuantity: null, oldRemainingQuantity: null, updateStorinItem: false, ckgShow: true, quantity: null, quantityShow: true });
                }
            }
        },
        handleBlurVolume: function handleBlurVolume(item, i) {
            var value = item.remainingVolume;
            var regex = /^[1-9]\d*$/;
            var message = '請輸入大於0的整數';
            if (this.form.unitVolume == '3') {
                regex = /(^(\d+)(\.\d{1,2})?$)/;
                message = '请输入非零最多两位小数的数字';
            } else {
                regex = /^[1-9]\d*$/;
                message = '請輸入大於0的整數';
            }
            if (value == 0 || !regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: message });
                item.volume = Number(item.deliverVolume || 0);
                var _a = Math.ceil(Number(this.form.price || 0) * item.volume * 100);
                item.inItemPrice = _a / 100;
                item.remainingVolume = null;

                // 總體積
                var _num = 0;
                this.addWarehousingList[i].storInItem.map(function (v) {
                    var temp = Number(v.remainingVolume || 0) * 100 + Number(v.deliverVolume || 0) * 100;
                    v.volume = temp / 100;
                    _num = Number(v.volume || 0) * 100 + _num;
                });
                this.form.totalVolume = _num / 100;

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                }
                this.$forceUpdate();
                return;
            }

            var a = Number(item.deliverVolume || 0) * 100 + Number(item.remainingVolume || 0) * 100;
            var b = a / 100;
            var sum = Math.ceil(Number(this.form.price || 0) * b * 100);
            item.inItemPrice = sum / 100;

            // 總體積
            var num = 0;
            this.addWarehousingList[i].storInItem.map(function (v) {
                var temp = Number(v.remainingVolume || 0) * 100 + Number(v.deliverVolume || 0) * 100;
                v.volume = temp / 100;
                num = Number(v.volume || 0) * 100 + num;
            });
            this.form.totalVolume = num / 100;

            if (this.form.price) {
                var _amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                this.form.totalPrice = _amount / 100;
            }
            this.$forceUpdate();
        },
        handleArea: function handleArea(field, item, i) {
            var value = item[field];
            var regex = /^[1-9]\d*$/;
            if (value == 0 || !regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: '請輸入大於0的整數' });
                item[field] = null;
                item.volume = null;
                item.countVolume = null;
                item.inItemPrice = 0;
                // 總體積
                var _num2 = 0;
                this.addWarehousingList[i].storInItem.map(function (v) {
                    _num2 = Number(v.volume || 0) * 100 + _num2;
                });
                this.form.totalVolume = (_num2 / 100).toFixed(2);

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                }
                this.$forceUpdate();
                return;
            }
            // volume 統計
            if (item.high && item.wide && item.length) {
                var area = Math.ceil(item.length * item.wide * item.high * 35.314 / 1000000);
                item.countVolume = area;
                item.volume = area;

                var sum = Math.ceil(Number(this.form.price || 0) * item.volume * 100);
                item.inItemPrice = sum / 100;

                item.quantityShow = false;
            }
            // 總體積
            var num = 0;
            this.addWarehousingList[i].storInItem.map(function (v) {
                num = Number(v.volume || 0) * 100 + num;
            });
            this.form.totalVolume = (num / 100).toFixed(2);

            if (this.form.price) {
                var _amount2 = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                this.form.totalPrice = _amount2 / 100;
            }
            this.$forceUpdate();
        },
        handlePrice: function handlePrice(val) {
            var _this14 = this;

            var value = val;
            var regex = /(^(\d+)(\.\d{1,2})?$)/;
            if (!regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: '请输入非零最多两位小数的数字' });
                this.form.price = null;
                this.form.totalPrice = null;
                this.addWarehousingList[0].storInItem.map(function (v) {
                    v.inItemPrice = 0;
                });
                this.$forceUpdate();
                return;
            }

            this.addWarehousingList[0].storInItem.map(function (v) {
                var sum = Math.ceil(Number(_this14.form.price || 0) * Number(v.volume || 0) * 100);
                v.inItemPrice = sum / 100;
            });
            if (this.form.totalVolume) {
                var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume || 0) * 100);
                this.form.totalPrice = amount / 100;
            } else {
                this.form.totalPrice = null;
            }
            this.$forceUpdate();
        },
        handleChangeUnit: function handleChangeUnit(val) {
            var _this15 = this;

            if (val != '3') {
                var num = 0; // 总体积
                this.addWarehousingList[0].storInItem.map(function (v) {
                    v.volume = Math.ceil(Number(v.remainingVolume || 0)) + Number(v.deliverVolume || 0);
                    v.inItemPrice = Number(_this15.form.price || 0) * Number(v.volume || 0);
                    num = Number(v.volume || 0) * 100 + num;
                    num = Number(v.volume || 0) * 100 + num;
                });
                this.form.totalVolume = num / 100;

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                } else {
                    this.form.totalPrice = null;
                }
            }
            $forceUpdate();
        },
        selCutomerCode: function selCutomerCode() {
            var _this16 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                if (res.errcode === 200) {
                    _this16.customerCode = res.data;
                    _this16.customerCode.forEach(function (a, b) {
                        _this16.$set(_this16.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                    });
                }
            });
        },
        letSalesList: function letSalesList() {
            var _this17 = this;

            /*查詢銷售員LIST*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_11" /* getSalesList */])().then(function (data) {
                var _data$data7 = data.data,
                    res = _data$data7 === undefined ? {} : _data$data7;
                //console.log(res)

                if (res.errcode === 200) {
                    _this17.salesList = res.data;
                    _this17.salesList.forEach(function (a, b) {
                        _this17.$set(_this17.salesList[b], 'value', a.name); //向陣列裡添加value欄位
                    });
                }
            });
        },
        selLocationState: function selLocationState() {
            var _this18 = this;

            /*查詢位置資訊*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["U" /* getLocationByState */])(Number(0)).then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    _this18.locationList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this18.locationList.forEach(function (a, b) {
                        if (a.floor === "0") {
                            sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                        } else {
                            sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                        }
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this18.list = list.map(function (item) {
                        return { value: item.id, label: item.location };
                    });
                    //console.log("resL",this.list);
                }
            });
        },
        getLocationByCusId: function getLocationByCusId(id) {
            var _this19 = this;

            /*以客戶ID查詢當前客戶在用的架子*/
            if (this.storInId !== 0) {
                //入庫單ID为空 没有架子
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["v" /* getCIdList */])({ id: this.storInId, cusId: id }).then(function (data) {
                    var _data$data9 = data.data,
                        res = _data$data9 === undefined ? {} : _data$data9;

                    if (res.errcode === 200) {
                        _this19.locationList = res.data;
                        var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                        _this19.locationList.forEach(function (a, b) {
                            if (a.floor === "0") {
                                sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                            } else {
                                sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                            }
                        });
                        var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                        var Tlist = list.map(function (item) {
                            return { value: item.id, label: item.location };
                        });
                        var this_ = _this19;
                        var t1 = setInterval(function () {
                            //定时器 3秒后加载到list
                            for (var i = 0; i < Tlist.length; i++) {
                                this_.list.unshift(Tlist[i]);
                            }
                            clearTimeout(t1);
                        }, 3000);
                    }
                });
            }
        },
        getRemarkList: function getRemarkList() {
            var _this20 = this;

            /*查詢常用列表*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["s" /* getAllRemarkList */])(1).then(function (data) {
                var _data$data10 = data.data,
                    res = _data$data10 === undefined ? {} : _data$data10;

                if (res.errcode === 200) {
                    _this20.remarkList = res.data;
                    _this20.remarkList.forEach(function (a, b) {
                        _this20.$set(_this20.remarkList[b], 'value', a.content); //向陣列裡添加value欄位
                    });
                }
            });
        },
        nullList: function nullList() {
            /*清空*/
            this.addWarehousingList = [{ state: 1, second: 1, createDate: null, code: null, addStorIn: true, storInItem: [{ state: 0, unitShow: true, unit: '', num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', boxNoShow: true, itemShows: true, qtyShow: true, locationIdShows: true, length: null, wide: null, high: null, ckgShow: true, volume: null, remainingVolume: null, oldRemainingVolume: null, countVolume: null, deliverGodown: null, deliverVolume: null, inItemPrice: 0, remainingQuantity: null, oldRemainingQuantity: null, updateStorinItem: false, quantity: null, quantityShow: true }] }];
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null, sCode: ''
            };
            this.updateStorIn = "";
            this.storInId = 0;
            //this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        test: function test() {
            this.show = true;
            this.add = false;
        },
        getStockInParams: function getStockInParams() {
            this.acctStockId = this.$route.params.id;
            this.selSotrIn(this.acctStockId, this.$route.params.typeId, this.$route.params.custId);
        }
    },
    activated: function activated() {
        var _this21 = this;

        /*進入載入*/
        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data11 = data.data,
                res = _data$data11 === undefined ? {} : _data$data11;

            _this21.custSalesList = res.data;
        });
        this.cancelAdd();
        this.selCutomerCode();
        this.letSalesList(); //查詢銷售員
        this.getRemarkList(); //常用列表
        this.getStockInParams();
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
    },

    computed: {},
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "Kzek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Searcha_vue__ = __webpack_require__("G3uj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1883fb4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Searcha_vue__ = __webpack_require__("dHlV");
function injectStyle (ssrContext) {
  __webpack_require__("VTPv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1883fb4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Searcha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1883fb4f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Searcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M7E1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RollingList_vue__ = __webpack_require__("pwaT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e1cfb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RollingList_vue__ = __webpack_require__("TKq3");
function injectStyle (ssrContext) {
  __webpack_require__("Fy7F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RollingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e1cfb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RollingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ffd4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("XAhf");
function injectStyle (ssrContext) {
  __webpack_require__("CO2H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ffd4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MW5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockAdjustMent_vue__ = __webpack_require__("iodp");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf015e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockAdjustMent_vue__ = __webpack_require__("qQOr");
function injectStyle (ssrContext) {
  __webpack_require__("u3G3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockAdjustMent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf015e64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockAdjustMent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MaJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1000px"}},[_c('el-form',{ref:"jobOrderForm",staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.jobOrderForm,"rules":_vm.jobRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":5}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"工作單號：","prop":"jobNo"}},[_vm._v("\n                      "+_vm._s(_vm.jobOrderForm.jobNo)+"\n                    ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"版本：","prop":"ver"}},[_vm._v("\n                       "+_vm._s(_vm.jobOrderForm.ver)+"\n                    ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"製單人：","prop":"createBy"}},[_vm._v("\n                        "+_vm._s(_vm.jobOrderForm.createBy)+"\n                    ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"createTime"}},[_vm._v("\n                      "+_vm._s(_vm.getIssueDate(_vm.jobOrderForm.createTime))+"\n                    ")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"startDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},on:{"change":_vm.getTimes},model:{value:(_vm.jobOrderForm.startDate),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "startDate", $$v)},expression:"jobOrderForm.startDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":0.5}},[_c('div',{staticStyle:{"margin-top":"5px","margin-right":"7px"}},[_vm._v("~")])]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-form-item',{attrs:{"prop":"endDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},model:{value:(_vm.jobOrderForm.endDate),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "endDate", $$v)},expression:"jobOrderForm.endDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"時間：","prop":"jobTime"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.jobTime),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "jobTime", $$v)},expression:"jobOrderForm.jobTime"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"服務類別：","prop":"service"}},[_c('el-select',{staticStyle:{"width":"160px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.service),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "service", $$v)},expression:"jobOrderForm.service"}},_vm._l((_vm.serviceOption),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"客戶：","prop":"custNo"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"default-first-option":"","valueKey":"id","placeholder":"","filterable":"","remote":"","remote-method":_vm.itemRemoteMethod},on:{"change":_vm.custChange},model:{value:(_vm.jobOrderForm.custNo),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "custNo", $$v)},expression:"jobOrderForm.custNo"}},_vm._l((_vm.custOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.code,"value":item}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.code))]),_vm._v(" \n           \t\t\t\t\t                                      "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"姓名："}},[_vm._v("\n           \t\t\t\t\t\t\t\t\t         "+_vm._s(_vm.jobOrderForm.custName)+"\n           \t\t\t\t\t\t\t\t\t      ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"大小容量：","prop":"volume"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.volume),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "volume", $$v)},expression:"jobOrderForm.volume"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"起點：","prop":"origin"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.origin),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "origin", $$v)},expression:"jobOrderForm.origin"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"目的地：","prop":"dest"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.dest),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "dest", $$v)},expression:"jobOrderForm.dest"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"聯絡人：","prop":"contactP"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.contactP),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "contactP", $$v)},expression:"jobOrderForm.contactP"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電話號碼：","prop":"contactT"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.contactT),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "contactT", $$v)},expression:"jobOrderForm.contactT"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"主管：","prop":"supervisor"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.supervisor),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "supervisor", $$v)},expression:"jobOrderForm.supervisor"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"打印代碼：","prop":"printCode"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.printCode),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "printCode", $$v)},expression:"jobOrderForm.printCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"是否收錢：","prop":"cashOrder"}},[_c('el-input',{staticStyle:{"width":"240px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.cashOrder),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "cashOrder", $$v)},expression:"jobOrderForm.cashOrder"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"備註：","prop":"remark"}},[_c('el-select',{staticStyle:{"width":"800px"},attrs:{"label-width":"100px","placeholder":"備註","prop":"remark"},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}},_vm._l((_vm.remarkList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.content,"value":item.content}})}),1)],1),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#b68e38","border-color":"#b68e38"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.addRemark}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 添加")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"工作內容：","prop":"jobDetail"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"id":"textareaAddId","type":"textarea","autosize":{ minRows: 8, maxRows:18},"placeholder":""},model:{value:(_vm.jobOrderForm.jobDetail),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "jobDetail", $$v)},expression:"jobOrderForm.jobDetail"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"預計箱：","prop":"estQty1"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.estQty1),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "estQty1", $$v)},expression:"jobOrderForm.estQty1"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"真實箱：","prop":"realQty1"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.realQty1),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "realQty1", $$v)},expression:"jobOrderForm.realQty1"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"預計板：","prop":"estQty2"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.estQty2),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "estQty2", $$v)},expression:"jobOrderForm.estQty2"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"真實板：","prop":"realQty2"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.realQty2),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "realQty2", $$v)},expression:"jobOrderForm.realQty2"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.jobSave}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("關閉")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin-bottom":"5px","margin-left":"15px","background-color":"#b68e38","border-color":"#b68e38","margin-right":"99px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.jobSaveItemLoad}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 複製新增工作單")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogJobName,"visible":_vm.dialogDiscJobVisible,"width":"360px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogDiscJobVisible=$event}}},[_c('el-form',{ref:"jobForm",attrs:{"model":_vm.jobForm,"rules":_vm.jobRules,"label-width":"100px"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"服務類別：","prop":"service"}},[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"placeholder":""},model:{value:(_vm.jobForm.service),callback:function ($$v) {_vm.$set(_vm.jobForm, "service", $$v)},expression:"jobForm.service"}},_vm._l((_vm.serviceOption),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscJobVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.Addloading},on:{"click":_vm.jobSaveItem}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mx8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#4B78FF"}},[_vm._l((_vm.nodes),function(node,index){return (node.id!=9)?[(!node.hidden&&node.children&&node.children.length>0)?_c('el-submenu',{attrs:{"index":node.path}},[_c('template',{slot:"title"},[_c('i',{class:node.icon}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(node.name))])]),_vm._v(" "),_c('menu-tree',{attrs:{"nodes":node.children}})],2):_vm._e(),_vm._v(" "),(!node.hidden&&node.children&&node.children.length==0&&_vm.$store.getters.ismobilePhone&&(node.name == '客戶' || node.name == '首頁'))?_c('el-menu-item',{staticStyle:{"text-align":"center","padding":"0px"},attrs:{"index":node.path},on:{"click":function($event){return _vm.locationAdd(node.path)}}},[_c('i',{class:node.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(node.name))])]):(!node.hidden&&node.children&&node.children.length==0&&_vm.$store.getters.ismobilePhone==false)?_c('el-menu-item',{staticStyle:{"text-align":"center","padding":"0px"},attrs:{"index":node.path},on:{"click":function($event){return _vm.locationAdd(node.path)}}},[_c('i',{class:node.icon}),_vm._v(" "),_c('span',[_vm._v(_vm._s(node.name))])]):_vm._e()]:_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N0R7":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4T7XTvUvVURgH8M9XDXESwt4Gh9Yg0LmtRdoaGsX+B6OmIIJwMHQQR6cSXCTcxD/AWZsaHRryBYQmDaJHfvFLbnhvSJd7xsPzfM6X55wTfa702W+wQFW9aBNuYAm/sJjk85/kXRNUVbO/iuJ3yiGs4DEmkrztCVTVMNZwkuRVU1hVi7iFT3iYZKErUFU38BFfOk9pkTd4gOdJzq8AVTWCTewmed/tdqrqJR7hWZKfTc3lDKpqHE8xmeRdD+A1vmIryfe/gDbmHXxIMlNV9/CkhbaTfKuqHcwlOeo1g05gtonaFm4mWf8f4G4LHF4XGMM+9nAfyy0wjwNMYyrJ2b/ewU3cxo8kTVPzDhpsFMdJTjsHPNi/cJ2fegFMMXER0O3kCQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_filter__ = __webpack_require__("CjbC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_MenuUtil__ = __webpack_require__("UFO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_resource__ = __webpack_require__("8+8L");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_5_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_filter___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]); // 通过插件的形式挂载
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_resource__["a" /* default */]);

//这里是防止用户手动刷新页面，整个app要重新加载,动态新增的路由，会消失，所以我们重新add一次
var staff = JSON.parse(window.sessionStorage.getItem('staff'));
if (staff) {
  var _router$options$route;

  // console.log("Main refresh menus:",staff.menus);
  var routes = [];
  Object(__WEBPACK_IMPORTED_MODULE_10__utils_MenuUtil__["a" /* default */])(routes, staff.menus);
  __WEBPACK_IMPORTED_MODULE_7__router_router__["a" /* default */].addRoutes(routes);
  (_router$options$route = __WEBPACK_IMPORTED_MODULE_7__router_router__["a" /* default */].options.routes).push.apply(_router$options$route, routes);

  //更新VUX的staff，所有請求都是从vux.staff里取Token
  __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */].commit("updateStaff", staff);
}

//没登录就跳转到登录
__WEBPACK_IMPORTED_MODULE_7__router_router__["a" /* default */].beforeEach(function (to, from, next) {
  //console.log("beforeEach");
  var staff = JSON.parse(window.sessionStorage.getItem('staff'));
  if (!staff && to.path !== '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

var i18n = new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]({
  locale: 'zh-CN', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': __webpack_require__("xZXS"), // 中文语言包
    'en-US': __webpack_require__("/uab"), // 英文语言包
    'zh-TW': __webpack_require__("1VJQ") // 繁体语言包
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_5_vue__["default"]({
  el: '#app',
  i18n: i18n, // 不要忘记
  router: __WEBPACK_IMPORTED_MODULE_7__router_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_MenuUtil__ = __webpack_require__("UFO9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var validateName = function validateName(rule, value, callback) {
            if (value === '') {
                callback(new Error("帳號不能為空"));
            } else {
                callback();
            }
        };
        var validatePwd = function validatePwd(rule, value, callback) {
            if (value === '') {
                callback(new Error("密碼不能為空"));
            } else {
                callback();
            }
        };
        return {
            options: [{
                value: 'zh-CN',
                label: '簡體'
            }, {
                value: 'zh-TW',
                label: '繁體'
            }, {
                value: 'en-US',
                label: 'English'
            }],
            langVal: "zh-CN",
            logining: false,
            loginForm: {
                name: "",
                password: ""
            },

            rules: {
                name: [{ validator: validateName, trigger: 'blur' }],
                password: [{ validator: validatePwd, trigger: 'blur' }]
            },
            checked: false
        };
    },

    methods: {
        handleReset: function handleReset() {
            this.$refs.loginForm.resetFields();
        },
        handleSubmit: function handleSubmit(ev) {
            var _this = this;

            this.$router.options.routes = [];
            this.$refs.loginForm.validate(function (valid) {
                if (valid) {
                    _this.logining = true;
                    var params = { name: _this.loginForm.name, password: _this.loginForm.password };

                    Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_35" /* getToken */])(params).then(function (res) {
                        //判斷核取方塊是否被勾選 勾選則調用配置cookie方法
                        if (_this.checked) {
                            //傳入帳號名，密碼，和保存天數3個參數
                            _this.setCookie(_this.loginForm.name, _this.loginForm.password, 7);
                        } else {
                            _this.clearCookie();
                        }
                        _this.logining = false;

                        var _res$data = res.data,
                            data = _res$data === undefined ? {} : _res$data;
                        //                                console.log(data);

                        if (data.errcode === 200) {
                            var _$router$options$rout;

                            var isandroid = /android/gi.test(navigator.appVersion); // 安卓
                            var isiPhone = /iphone/gi.test(navigator.appVersion); // ios
                            var isiPad = /ipad/gi.test(navigator.appVersion); // ipad
                            if (isandroid || isiPhone || isiPad) {
                                //移动端登陆
                                _this.$store.commit("setIsmobilePhone", true);
                            } else {
                                _this.$store.commit("setIsmobilePhone", false);
                            }

                            var _res$data$data = res.data.data,
                                staff = _res$data$data === undefined ? {} : _res$data$data;

                            window.sessionStorage.setItem("staff", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(staff)); //將使用者存儲在session中
                            var routes = [];
                            Object(__WEBPACK_IMPORTED_MODULE_3__utils_MenuUtil__["a" /* default */])(routes, staff.menus);
                            __WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* default */].addRoutes(routes);
                            (_$router$options$rout = _this.$router.options.routes).push.apply(_$router$options$rout, routes);
                            _this.$store.commit("updateStaff", staff);
                            console.log(staff);
                            _this.$router.push({ path: '/' });
                            _this.$store.commit("clearTabs");
                        } else {
                            _this.$message.error(data.errmsg);
                        }
                    }, function (err) {
                        _this.logining = false;
                    });
                }
            });
        },

        //設置cookie
        setCookie: function setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date(); //獲取時間
            exdate.setTime(exdate.getTime() + 7 * 24 * 60 * 60 * 1000); //保存的天數
            //字串拼接cookie
            window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            //window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
        },

        //讀取cookie
        getCookie: function getCookie() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; '); //這裡顯示的格式需要切割一下自己可輸出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('='); //再次切割
                    //判斷查找相對應的值
                    if (arr2[0] == 'userName') {
                        this.loginForm.name = arr2[1]; //保存到保存資料的地方
                        this.checked = true;
                    } else {
                        this.checked = false;
                    }
                    /*if(arr2[0]=='userPwd'){
                        this.loginForm.password=arr2[1];
                        this.checked=true;
                    }else {
                        this.checked=false;
                    }*/
                }
            }
        },
        getLangCoikieKey: function getLangCoikieKey() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; '); //這裡顯示的格式需要切割一下自己可輸出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('='); //再次切割
                    //判斷查找相對應的值
                    if (arr2[0] == 'langKey') {
                        this.langVal = arr2[1];
                        this.$i18n.locale = arr2[1]; //關鍵語句
                    }
                }
            }
        },

        //清除cookie
        clearCookie: function clearCookie() {
            this.setCookie("", "", -1); //修改2值都為空，天數為負1天就好了
        },
        /**
         * 切換語言
         */
        changeLangEvent: function changeLangEvent(val) {
            this.$i18n.locale = val; //關鍵語句
            var exdate = new Date(); //獲取時間
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 7); //保存的天數
            window.document.cookie = "langKey" + "=" + val + ";path=/;expires=" + exdate.toGMTString();
            this.$refs.loginForm.validate(function (valid) {});
        }
    },
    mounted: function mounted() {
        //獲取cookie 記住用戶名細資訊
        this.getCookie();

        //獲取國際化語言
        this.getLangCoikieKey();

        var tags = document.getElementsByTagName("*"); //獲取HTML的所有標籤
        for (var i in tags) {
            //對標籤進行遍歷
            if (tags[i].nodeType == 1) {
                //判斷節點類型
                if (tags[i].getAttribute("id") == "loginName") //判斷ID判斷控制項
                    {
                        tags[i].focus();
                        break;
                    }
            }
        }
    },

    computed: {
        isShowChromeTip: function isShowChromeTip() {
            var userAgent = navigator.userAgent; //取得流覽器的userAgent字串
            if (userAgent.indexOf("Chrome") > -1) {
                return false;
            }
            return true;
        }
    }
});

/***/ }),

/***/ "NwjW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O+1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',[_c('div',{staticClass:"xinz"},[[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/addStockout'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")]):_vm._e()],1)],1)]],2),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getStorOnList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"出倉單"},model:{value:(_vm.searchStorOn),callback:function ($$v) {_vm.searchStorOn=$$v},expression:"searchStorOn"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":"客戶/電話"},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"銷售員"},model:{value:(_vm.searchSalesId),callback:function ($$v) {_vm.searchSalesId=$$v},expression:"searchSalesId"}},_vm._l((_vm.custSalesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getStorOnList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"ind_main ind_main2"},[_c('div',{staticClass:"ind_cont2"},[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.storOnCustomerList,"border":""}},[_c('el-table-column',{attrs:{"prop":"scode","label":"出倉單","fixed":"","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"客戶"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                    "+_vm._s(scope.row.customer.code)+","+_vm._s(scope.row.customer.name)+"\n                                ")]}}],null,false,3596974070)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer.phone","label":"電話","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer.sales","label":"銷售員","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storInDate","label":"時間","width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"120","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.canEdit)?_c('el-button',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.updateSelSotrOut(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯\n                                    ")]):_vm._e()]}}],null,false,2315119591)})],1)],_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.add)?_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[(_vm.form.sCodeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sCode))])]:[_c('el-select',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow,"filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethodIn,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelect($event)},"focus":function($event){return _vm.isNullOptions()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),(_vm.canAdd)?[(!_vm.rkCont)?[_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleSelect()}}},[_vm._v("新 建")])],1)]:_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_vm._l((_vm.addStorOnList),function(stor,index){return [(_vm.addStorOn)?_c('table',{key:index,staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"7"}},[_vm._v("可出倉")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"25%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                    體積\n                                    "),(_vm.addStorOnList[0].storOnItem[0].unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.addStorOnList[0].storOnItem[0].unitVolume==='1'?'箱':_vm.addStorOnList[0].storOnItem[0].unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("件數")]),_vm._v(" "),_c('th',[_vm._v("操作")]),_vm._v(" "),_c('th',{attrs:{"width":"18%"}},[_vm._v("備注")])])]),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',{key:index,class:storOn.state === 1||storOn.state === 4?'stateShow':'',attrs:{"id":storOn.id}},[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(storOn.remainingVolume))]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v(_vm._s(storOn.remainingQuantity))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.handleStor(index)}}},[_vm._v("\n                                        出倉\n                                    ")])],1),_vm._v(" "),_c('th',{attrs:{"width":"18%"}},[_vm._v(_vm._s(storOn.remark))])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}},[_c('br')])])],2):_vm._e()]}),_vm._v(" "),_vm._l((_vm.storOnList),function(stor,index){return [_c('table',{key:index,staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[(!_vm.rkCont)?[_c('tr',[_c('th',{attrs:{"colspan":"5"}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(stor.createDate))]),_vm._v(" "),(stor.state === 1)?_c('span',{staticStyle:{"padding-right":"215px"}},[_vm._v("待出倉")]):_c('span',{staticStyle:{"padding-right":"215px"}},[_vm._v("已出倉")])]),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_c('el-button',{on:{"click":function($event){return _vm.printing(stor.storOnItem[0])}}},[_vm._v("打印")]),_vm._v(" "),(stor.state === 1)?[_c('el-button',{on:{"click":function($event){return _vm.storOn(stor)}}},[_vm._v("確定出倉")])]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("件數")]),_vm._v(" "),_c('th',{attrs:{"width":"12%"}},[_vm._v("\n                                    出倉體積"),(_vm.storOnList[0].storOnItem[0].unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.storOnList[0].storOnItem[0].unitVolume==='1'?'箱':_vm.storOnList[0].storOnItem[0].unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("出倉金額")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),(_vm.rkCont)?[_c('th',[_vm._v("出倉")])]:_vm._e()],2)],2),_vm._v(" "),_vm._l((stor.storOnItem),function(storOn,index){return _c('tr',{key:index},[_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.unit))]),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v(_vm._s(storOn.boxNo))]),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(storOn.item))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.quantity))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.volume))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(_vm.formatCurrency(storOn.amount)))]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v(_vm._s(storOn.value))]),_vm._v(" "),(_vm.rkCont)?[_c('td',{staticClass:"actions"},[_c('label',{staticClass:"my_protocol"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.checkedOne(index)}}}),_c('span')])])]:_vm._e()],2)}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"6"}})])],2),_vm._v(" "),_c('div',{staticClass:"link-top"})]}),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[(_vm.canEdit)?[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v(" 保 存")])]:_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 取 消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerOnSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],2)],2)])],1):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":"出倉","visible":_vm.dialogVisible,"width":"500px","close-on-click-modal":false,"show-close":false},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{attrs:{"model":_vm.dialogForm,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"編號"}},[_c('span',[_vm._v(_vm._s(_vm.dialogForm.boxNo))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"物品"}},[_c('span',[_vm._v(_vm._s(_vm.dialogForm.item))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":'出整' + _vm.dialogForm.unit}},[_c('el-checkbox',{attrs:{"true-label":1,"false-label":0},on:{"change":_vm.handleAll},model:{value:(_vm.dialogForm.state),callback:function ($$v) {_vm.$set(_vm.dialogForm, "state", $$v)},expression:"dialogForm.state"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"出部分"}},[_c('el-checkbox',{staticStyle:{"margin-right":"10px"},attrs:{"true-label":4,"false-label":0},on:{"change":_vm.handleAll},model:{value:(_vm.dialogForm.state),callback:function ($$v) {_vm.$set(_vm.dialogForm, "state", $$v)},expression:"dialogForm.state"}}),_vm._v(" "),_c('el-input-number',{attrs:{"size":"small","min":1,"max":_vm.dialogForm.remainingQuantity,"label":""},model:{value:(_vm.dialogForm.quantity),callback:function ($$v) {_vm.$set(_vm.dialogForm, "quantity", $$v)},expression:"dialogForm.quantity"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('template',{slot:"label"},[_vm._v("\n                        出倉體積\n                    ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"160px"},attrs:{"size":"small","disabled":!this.dialogForm.remainingVolume || _vm.volumeDisabled},on:{"blur":_vm.handleBlurVolume,"input":function($event){return _vm.$forceUpdate()}},model:{value:(_vm.dialogForm.volume),callback:function ($$v) {_vm.$set(_vm.dialogForm, "volume", $$v)},expression:"dialogForm.volume"}}),(_vm.dialogForm.unitVolume)?_c('span',[_vm._v(" "+_vm._s(_vm.dialogForm.unitVolume==='1'?'箱':_vm.dialogForm.unitVolume==='2'?'cu.ft':'m³'))]):_vm._e()],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"出倉金額"}},[_vm._v("\n                    "+_vm._s(_vm.formatCurrency(_vm.dialogForm.amount))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.handleItem}},[_vm._v("確定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Opzk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AddJobOrder.vue": [
		"BdBI"
	],
	"./AddStockIn.vue": [
		"rUVm"
	],
	"./AddStockOut.vue": [
		"aT0o"
	],
	"./Agent.vue": [
		"IxV+",
		1
	],
	"./CalendarList.vue": [
		"dOt5"
	],
	"./Customer.vue": [
		"HkCU"
	],
	"./CustomerManagement.vue": [
		"S++V"
	],
	"./ExcelExport.vue": [
		"pM4q"
	],
	"./FeedBack.vue": [
		"oEYu"
	],
	"./FeedBackList.vue": [
		"66ga"
	],
	"./Home.vue": [
		"j7e0"
	],
	"./Homepage.vue": [
		"KNlE"
	],
	"./Ip.vue": [
		"LMa3",
		0
	],
	"./ItemStor.vue": [
		"qPEd"
	],
	"./JobOrderList.vue": [
		"S2+J"
	],
	"./JobPrinting.vue": [
		"8Ofm"
	],
	"./Login.vue": [
		"lmfZ"
	],
	"./Remark.vue": [
		"A+ON"
	],
	"./Role.vue": [
		"8pc/"
	],
	"./Rolling.vue": [
		"5CEL"
	],
	"./RollingList.vue": [
		"M7E1"
	],
	"./Search.vue": [
		"G7FF"
	],
	"./Searcha.vue": [
		"Kzek"
	],
	"./Staff.vue": [
		"Rxym"
	],
	"./StockAdjustMent.vue": [
		"MW5r"
	],
	"./StockOut.vue": [
		"vxvQ"
	],
	"./TaskCalendar.vue": [
		"h7Tf"
	],
	"./TaskList.vue": [
		"CqVz"
	],
	"./UpdateFeedBack.vue": [
		"4XP5"
	],
	"./UpdateJobOrder.vue": [
		"TSgG"
	],
	"./UpdateRolling.vue": [
		"uEEz"
	],
	"./UpdateStockIn.vue": [
		"3e/W"
	],
	"./UpdateStockOut.vue": [
		"Qc+m"
	],
	"./Warehousing.vue": [
		"8Y1G"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "P7rK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/home.a7d1a83.png";

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return imageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getPermissionTree; });
/* unused harmony export getMenuTree */
/* unused harmony export getRoleAll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getRoleById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return insertRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return updateRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return deleteRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getAllRoleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addRoleByCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getStffRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getStaffList; });
/* unused harmony export getStaffById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getStaffByLoginName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return insertStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return updateStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return deleteStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getStaffAllList; });
/* unused harmony export getStaffAll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getSalesList; });
/* unused harmony export getStaffByTypeList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return modifyStaffPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return modifyStaffByIdPassword; });
/* unused harmony export getValidateStaffStor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getNodeAll; });
/* unused harmony export getNodeList */
/* unused harmony export getNodeById */
/* unused harmony export insertNode */
/* unused harmony export updateNode */
/* unused harmony export deleteNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getIpList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getIpById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return insertIp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return updateIp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteIp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getUserList; });
/* unused harmony export getUserById */
/* unused harmony export insertUser */
/* unused harmony export updateUser */
/* unused harmony export updateUserStatus */
/* unused harmony export updateUserExpiry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getCustomerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getSearchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCustomerCodeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getValidateCustomerCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getCustomerById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return insertCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return updateCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return validateCustomerById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteCustomerById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getLocationBycusId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getLocationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getLocationById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return insertLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return updateLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteLocationById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getValidateLocationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getLocationByXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getStorInList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getStorInListTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return insertStorIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return updateStorIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return selStorInItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getStorInListId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return selStorInItemCustomerId; });
/* unused harmony export getStorInItemListByCusId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getStorInCodeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return delStorInDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return delStorInItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getCusInventory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getCIdList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getPrePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getStotInOutRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return selCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getLocationByState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return updateLocationWhether; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getStorOnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getStorOnListTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return insertStorOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getStorOnItemStorinIdBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getStorOnListId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getStorOnCodeList; });
/* unused harmony export getPrintingListByStorDateId */
/* unused harmony export getPrintingList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getStorOnOkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getRemarkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getAllRemarkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getRemarkById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return insertRemark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return updateRemark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteRemarkById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getAllTypeList; });
/* unused harmony export getGroupByCatCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getCustGroupMgtList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return insertCustGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return updateCustGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getCustGroupMgtById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCustGroupMgtDetailsList; });
/* unused harmony export queryAllCustByCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return updateCustNoGroupId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return updateCustGroupIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getCustAllCustMgtList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return insertTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return updateTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getTaskById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return deleteTaskById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getCustFileList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteCustFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getCalendarTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getFeedBackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return insertFeedBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getFeedById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return updateFeedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return updateFeedSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getRollingsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return insertRolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getRollingsById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return updateRolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getRollingItemRecordById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getRollingItemRecordByNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getRollingListById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return updateRollSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deleteRollingById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return itemRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getItemAll; });
/* unused harmony export getItemStorList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getItemAllList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getItemStorListAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteItemById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getItemRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return updateItemStock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getStockList; });
/* unused harmony export insertStockAdj */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getStockAdjId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return updateStockAdj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getValidateAdjustmentItemCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addStockAdjustmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return deleteStockAdjustment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getStockAdjustmentImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getTaskCalendarList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return insertTaskCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return updateTaskCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getTaskCalendarById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deleteTaskCalendarById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getJobOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return insertJobOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getJobRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return updateJobOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getJobNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getJobJsonList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getJobPalletList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return updateJobPallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return updateJobPalletPrint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);







__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = getBaseUrl();

function getBaseUrl() {
    var curWwwPath = window.document.location.href;

    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    var host = window.document.location.host;
    var port = window.document.location.port;
    //判断是访问客戶端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9280/v1/admin";
    } else {
        curWwwPath = protocol + "//" + hostname + "/v1/admin";
    }
    // 本地正式服
    // curWwwPath = 'https://w.swlogistics.com.hk/v1/admin'
    // 欧振--
    // curWwwPath = 'http://192.168.50.36:9280/v1/admin'
    return curWwwPath;
}

function getImageUrl() {
    var curWwwPath = window.document.location.href;
    var protocol = window.document.location.protocol;
    var hostname = window.document.location.hostname;
    //判断是访问客戶端还是后台
    if (curWwwPath.indexOf("8090") >= 0) {
        curWwwPath = protocol + "//" + hostname + ":9280/";
    } else {
        curWwwPath = protocol + "//" + hostname + "/";
    }
    return curWwwPath;
}
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 100000;
/*axios.defaults.headers.post['Content-Type']='application/json;charset=UTF-8';*/
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
/*axios.interceptors.request.use(
 config=>{
 if(store.state.staff){
 config.headers["Authorization"] = store.state.staff.token;
 }
 /!*if (config.method === 'post'||config.method==='patch') {
 config.data = qs.stringify(config.data);
 }*!/
 return config;
 },
 error=>{
 console.log("err request");
 return Promise.reject(error);
 }
 );
 var  isOutLogin=0;
 axios.interceptors.response.use(
 response => {
 return response.data;
 },
 error => {
 if (error.response) {
 switch (error.response.status) {
 case 401:
 isOutLogin++;
 if (isOutLogin==1){
 Message.warning("登录超时!");
 }
 window.sessionStorage.clear();
 router.options.routes.splice(2,router.options.routes.length-2);
 router.push({path: '/login'});
 break;
 case 504:
 window.sessionStorage.clear();
 router.options.routes.splice(2,router.options.routes.length-2);
 router.push({path: '/login'});
 break;
 case  200:
 isOutLogin=0;
 break;

 }
 }
 if (error.toString().indexOf('timeout')>=0){
 Message.warning("請求超时！");
 }
 return Promise.reject(error);
 }
 );*/
// axios 配置
// http request 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    //console.log(store.state.staff.token)
    var token = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].state.staff.token;
    if (token && config.url != config.baseUrl) {
        config.headers["Authorization"] = token;
    }

    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

// http response 拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (res) {
    //console.log(res);
    if (res.data.errcode === 401) {
        // 401 清除token信息并跳转到登录页面
        sessionStorage.clear();
        __WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* default */].replace({
            path: '/login'
        });
    }
    return res;
}, function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 401 清除token信息并跳转到登录页面
                sessionStorage.clear();
                __WEBPACK_IMPORTED_MODULE_2__router_router__["a" /* default */].replace({
                    path: '/login'
                });
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

//=======================Token=========================
var getToken = function getToken(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/token", { params: params });
};
var getLogout = function getLogout(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/logout/" + id);
};
var imageUrl = function imageUrl(url) {
    return getImageUrl() + "upload/" + url;
};

//=======================Permission=========================
var getPermissionTree = function getPermissionTree(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/permission-tree", { params: params });
};

var getMenuTree = function getMenuTree(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/menu-tree", { params: params });
};

//=======================Role=========================
var getRoleAll = function getRoleAll(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/roles", { params: params });
};

var getRoleList = function getRoleList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/role", { params: params });
};

var getRoleById = function getRoleById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/role/" + id);
};

var insertRole = function insertRole(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/role", data);
};

var updateRole = function updateRole(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateRole", data);
};

var deleteRole = function deleteRole(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/role/" + id);
};

var getAllRoleList = function getAllRoleList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/roleList", { params: params });
};
var addRoleByCopy = function addRoleByCopy(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/addRoleByCopy/" + id);
};

var getStffRoles = function getStffRoles(roleId) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staffRole/" + roleId);
};
//=======================Staff=========================
var getStaffList = function getStaffList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff", { params: params });
};

var getStaffById = function getStaffById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/" + id);
};

var getStaffByLoginName = function getStaffByLoginName(loginName) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStaffByLoginName/" + loginName);
};

var insertStaff = function insertStaff(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/staff", data);
};

var updateStaff = function updateStaff(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/staff", data);
};

var deleteStaff = function deleteStaff(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/staff/" + id);
};

var getStaffAllList = function getStaffAllList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/all");
};

var getStaffAll = function getStaffAll() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/listAll");
};

var getSalesList = function getSalesList(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/salesList");
};

var getStaffByTypeList = function getStaffByTypeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/staffType", { params: params });
};

var modifyStaffPassword = function modifyStaffPassword(password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/staff/modifyStaffPassword/" + password);
};

var modifyStaffByIdPassword = function modifyStaffByIdPassword(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/staff/modifyStaffByIdPassword", params);
};

var getValidateStaffStor = function getValidateStaffStor(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/staff/stor/" + data.storId + "/" + data.staffId);
};

//=======================Node=========================
var getNodeAll = function getNodeAll(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/nodes", { params: params });
};

var getNodeList = function getNodeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/node", { params: params });
};

var getNodeById = function getNodeById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/node/" + id);
};

var insertNode = function insertNode(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/node", data);
};

var updateNode = function updateNode(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/node", data);
};

var deleteNode = function deleteNode(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/node/" + id);
};

//=======================IP=========================
var getIpList = function getIpList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/ip", { params: params });
};

var getIpById = function getIpById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/ip/" + id);
};

var insertIp = function insertIp(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/ip", data);
};

var updateIp = function updateIp(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/ip", data);
};

var deleteIp = function deleteIp(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/ip/" + id);
};

//=======================User=========================
var getUserList = function getUserList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/user", { params: params });
};

var getUserById = function getUserById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/user/" + id);
};

var insertUser = function insertUser(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/user", data);
};

var updateUser = function updateUser(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/user", data);
};

var updateUserStatus = function updateUserStatus(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/user-status", data);
};

var updateUserExpiry = function updateUserExpiry(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/user-expiry", data);
};

//=======================Customer=========================
var getCustomerList = function getCustomerList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customer", { params: params });
};

var getSearchList = function getSearchList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customerSearch", { params: params });
};

var getCustomerCodeList = function getCustomerCodeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customerCode");
};

var getValidateCustomerCode = function getValidateCustomerCode(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customer/validateCustomerCode", { params: params });
};

var getCustomerById = function getCustomerById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customer/" + id);
};

var insertCustomer = function insertCustomer(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertCustomer", data);
};

var updateCustomer = function updateCustomer(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/customer", data);
};

var validateCustomerById = function validateCustomerById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/validateCustomer/" + id);
};
var deleteCustomerById = function deleteCustomerById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/deleteCustomer/" + id);
};
//=======================Location=========================
var getLocationBycusId = function getLocationBycusId(cusId) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/location/cusId/" + cusId);
};
var getLocationList = function getLocationList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/location", { params: params });
};

var getLocationById = function getLocationById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/location/" + id);
};

var insertLocation = function insertLocation(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/location", data);
};

var updateLocation = function updateLocation(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/location", data);
};

var deleteLocationById = function deleteLocationById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/location/" + id);
};
var getValidateLocationName = function getValidateLocationName(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/customer/validateLocationName", { params: params });
};
var getLocationByXY = function getLocationByXY(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/location/locationByXY", { params: params });
};

//=======================StorIn=========================
var getStorInList = function getStorInList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/storIn", { params: params });
};
var getStorInListTwo = function getStorInListTwo(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/storInTwo", { params: params });
};
var insertStorIn = function insertStorIn(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/addStorIn", params);
};
var updateStorIn = function updateStorIn(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateStorIn", params);
};
var selStorInItem = function selStorInItem(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/selStorInItem", { params: params });
};
var getStorInListId = function getStorInListId(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStorInListId/" + id);
};
var selStorInItemCustomerId = function selStorInItemCustomerId(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/selStorInItemCustomerId/", { params: params });
};
var getStorInItemListByCusId = function getStorInItemListByCusId(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/selStorInItemByCusId/" + id);
};
var getStorInCodeList = function getStorInCodeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStorInCodeList");
};
var delStorInDate = function delStorInDate(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/delStorInDate/" + id);
};
var delStorInItem = function delStorInItem(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/delStorInItem/" + id);
};
var getCusInventory = function getCusInventory(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/cusInventory/" + id);
};
var getCIdList = function getCIdList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getCIdList/", { params: params });
};
var getPrePrice = function getPrePrice(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/selNewPrice", { params: params });
};
var getStotInOutRecord = function getStotInOutRecord(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getRecordList/" + id);
};
var selCode = function selCode(code) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/selCodeList/" + code);
};
//=======================Location=========================
var getLocationByState = function getLocationByState(state) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/location/state/" + state);
};
var updateLocationWhether = function updateLocationWhether(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/updateLocationWhether", { params: params });
};

//=======================StorOn=========================
var getStorOnList = function getStorOnList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/storOn", { params: params });
};
var getStorOnListTwo = function getStorOnListTwo(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/storOnTwo", { params: params });
};
var insertStorOn = function insertStorOn(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/addStorOn", params);
};
var getStorOnItemStorinIdBy = function getStorOnItemStorinIdBy(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStorOnItemStorinIdBy/" + id);
};
var getStorOnListId = function getStorOnListId(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStorOnListId/" + id);
};
var getStorOnCodeList = function getStorOnCodeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getStorOnCodeList");
};
var getPrintingListByStorDateId = function getPrintingListByStorDateId(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getPrintingListByStorDateId/" + id);
};
var getPrintingList = function getPrintingList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getPrintingList/", { params: params });
};
var getStorOnOkList = function getStorOnOkList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/getStorOnList", params);
};
//=======================Remark=========================
var getRemarkList = function getRemarkList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/remarkList", { params: params });
};

var getAllRemarkList = function getAllRemarkList(typeId) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getAllRemarkList/" + typeId);
};

var getRemarkById = function getRemarkById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/remark/" + id);
};

var insertRemark = function insertRemark(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/remark", data);
};

var updateRemark = function updateRemark(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/remark", data);
};

var deleteRemarkById = function deleteRemarkById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/remark/" + id);
};
var getAllTypeList = function getAllTypeList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getAllTypeList", { params: params });
};

//=======================Group=========================
var getGroupByCatCode = function getGroupByCatCode(catCode) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/groupByCatCode/" + catCode);
};

var getCustGroupMgtList = function getCustGroupMgtList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/CustGroupList", { params: params });
};
var insertCustGroup = function insertCustGroup(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/custGroups", data);
};
var updateCustGroup = function updateCustGroup(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/custGroupUpdate", data);
};
var getCustGroupMgtById = function getCustGroupMgtById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/groupMgtId/" + id);
};

var getCustGroupMgtDetailsList = function getCustGroupMgtDetailsList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/custGroupDetailList", { params: params });
};
var queryAllCustByCode = function queryAllCustByCode(custNo) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/custGroup/all/" + custNo);
};
var updateCustNoGroupId = function updateCustNoGroupId(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/cust/groupId", data);
};

var updateCustGroupIds = function updateCustGroupIds(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/custNo/groupId", data);
};
var deleteGroupName = function deleteGroupName(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/cust/deleteGroupId", data);
};
var getCustAllCustMgtList = function getCustAllCustMgtList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/cust/all/custMgt", { params: params });
};

//==================task====================
var getTaskList = function getTaskList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/taskList", { params: params });
};
var insertTask = function insertTask(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertTask", data);
};
var updateTask = function updateTask(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/updateTask", data);
};

var getTaskById = function getTaskById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/taskRecord/" + id);
};
var deleteTaskById = function deleteTaskById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/delete/" + id);
};

var getCustFileList = function getCustFileList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/uploadFile", { params: params });
};
var deleteCustFile = function deleteCustFile(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/fileUpload/" + id);
};

var getCalendarTaskList = function getCalendarTaskList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/calendarList", { params: params });
};
//=======================feedBack=========================
var getFeedBackList = function getFeedBackList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/feedList", { params: params });
};
var insertFeedBack = function insertFeedBack(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertFeedBack", data);
};
var getFeedById = function getFeedById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/feedRecord/" + id);
};
var updateFeedDate = function updateFeedDate(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateFeed", data);
};

var updateFeedSave = function updateFeedSave(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateFeedSave", data);
};
//=======================rolling=========================
var getRollingsList = function getRollingsList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/rollList", { params: params });
};
var insertRolling = function insertRolling(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertRolling", data);
};
var getRollingsById = function getRollingsById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/rollRecord/" + id);
};
var updateRolling = function updateRolling(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateRolling", data);
};
var getRollingItemRecordById = function getRollingItemRecordById(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/rollItemRecord", { params: params });
};
var getRollingItemRecordByNo = function getRollingItemRecordByNo(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getRollItem", { params: params });
};

var getRollingListById = function getRollingListById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/rollRecordList/" + id);
};

var updateRollSave = function updateRollSave(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateRollSave", data);
};
var deleteRollingById = function deleteRollingById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/deleteRoll/" + id);
};
//=======================item=========================
var itemRecord = function itemRecord(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/itemRecord", { params: params });
};
var getItemAll = function getItemAll(itemCode) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/item/all/" + itemCode);
};
var getItemStorList = function getItemStorList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/itemStorList", { params: params });
};
var getItemAllList = function getItemAllList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/item/allItem");
};

var getItemStorListAll = function getItemStorListAll(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/itemStorListAll", { params: params });
};
var deleteItemById = function deleteItemById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/deleteItem/" + id);
};
var getItemRecord = function getItemRecord(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/getItem", { params: params });
};
var updateItemStock = function updateItemStock(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateItem", data);
};
var addItems = function addItems(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/addItems", data);
};
//=======================stockAdj=========================
var getStockList = function getStockList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/stockList", { params: params });
};
var insertStockAdj = function insertStockAdj(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertStockAdj", data);
};
var getStockAdjId = function getStockAdjId(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/stockRecord/" + id);
};
var updateStockAdj = function updateStockAdj(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateStockAdj", data);
};
var getValidateAdjustmentItemCode = function getValidateAdjustmentItemCode(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/stockAdjustment/" + data.id + "/" + data.itemId);
};
var addStockAdjustmentList = function addStockAdjustmentList(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/stockAdjustment/addList", data);
};

var deleteStockAdjustment = function deleteStockAdjustment(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/stockAdjustment/" + id);
};
var getStockAdjustmentImport = function getStockAdjustmentImport(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/stockAdjustment/import", { params: params });
};

var getTaskCalendarList = function getTaskCalendarList() {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/taskCalendarList");
};
var insertTaskCalendar = function insertTaskCalendar(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertTaskCalendar", data);
};
var updateTaskCalendar = function updateTaskCalendar(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/updateTaskCalendar", data);
};
var getTaskCalendarById = function getTaskCalendarById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/taskCalendarRecord/" + id);
};
var deleteTaskCalendarById = function deleteTaskCalendarById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/deleteCalendar/" + id);
};

//=======================feedBack=========================
var getJobOrderList = function getJobOrderList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/jobOrderList", { params: params });
};
var insertJobOrder = function insertJobOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/insertJobOrder", data);
};
var getJobRecord = function getJobRecord(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/jobRecord/" + id);
};
var updateJobOrder = function updateJobOrder(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updateJobOrder", data);
};
var getJobNo = function getJobNo(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/jobNoRecord", { params: params });
};

var getJobJsonList = function getJobJsonList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/jobPrintList", { params: params });
};
var getJobPalletList = function getJobPalletList(params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/jobPallentPrint", { params: params });
};
var updateJobPallet = function updateJobPallet(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updatePallet", data);
};

var updateJobPalletPrint = function updateJobPalletPrint(data) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/updatePrint", data);
};

/***/ }),

/***/ "QPd3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qc+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateStockOut_vue__ = __webpack_require__("Xx/n");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2025c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateStockOut_vue__ = __webpack_require__("O+1d");
function injectStyle (ssrContext) {
  __webpack_require__("luvH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateStockOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2025c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateStockOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Quy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  return function () {
    return __webpack_require__("Opzk")("./" + name + ".vue");
  };
});

/***/ }),

/***/ "RirL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            options4: [],
            salesList: [], //銷售員LIST
            saList: [], //銷售員LIST
            custSalesList: [], //銷售員LIST
            list: [],
            tableloading: false,
            warehousingList: [],
            storIn: [], //入庫詳細資訊
            customerCode: {},
            remarkList: [], //常用列表
            locationList: {}, //架子表信息
            addNum: false,
            updateStorIn: "",
            codeList: [],
            company: [{ value: '籠', label: '籠' }, { value: '盒', label: '盒' }, { value: '板', label: '板' }, { value: '散件', label: '散件' }], //單位
            storInId: 0,
            typeId: 1,
            addWarehousingList: [{ state: 1, second: 1, createDate: null, code: this.RndNum(), addStorIn: true, storInItem: [{ addStorinItem: true, num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', itemShows: true, qtyShow: true, locationIdShows: true }] }],
            show: true, //資訊頁面
            add: false, //添加頁面
            rkCont: null, //入庫和客戶資訊
            submitInfo: true, //是否禁止保存按钮
            code: '',
            pager: {
                page: 0,
                size: 15,
                total: 0
            },
            form: {
                id: null,
                sCode: '',
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false
            },
            searchStorIn: '',
            searchName: '',
            searchSalesId: ''
        };
    },

    methods: {
        handleSelectionChange: function handleSelectionChange() {},
        updateSelSotrIn: function updateSelSotrIn(row) {
            this.$router.push({
                name: '編輯入倉',
                params: {
                    id: row.id,
                    typeId: 1,
                    custId: 0
                }
            });
            var path = "/updateStockin/" + row.id + "/" + 1 + "/" + 0;
            this.$router.push(path);
        },
        selSCode: function selSCode() {
            var _this = this;

            /*查詢入庫單是否重复*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_58" /* selCode */])(this.form.sCode).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    if (res.data !== null) {
                        //数据庫中没有当前入庫單號
                        if (res.data.code !== _this.updateStorIn) {
                            //当前輸入的帐号是否是修改的帐号
                            _this.$alert("當前入庫單號:" + _this.form.sCode + " 已存在!", '提示', {
                                confirmButtonText: '確定',
                                type: 'warning',
                                callback: function callback(action) {
                                    if (_this.updateStorIn !== "") {
                                        _this.form.sCode = _this.updateStorIn;
                                    } else {
                                        _this.form.sCode = "";
                                    }
                                }
                            });
                        }
                    }
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            if (this.typeId == 2) {
                this.$router.go(-1);
            } else {
                this.$router.go(-1);
            }
        },
        remoteMethod: function remoteMethod(query) {
            var _this2 = this;

            /*選擇位置*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this2.loading = false;
                    _this2.options4 = _this2.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodSales: function remoteMethodSales(query) {
            var _this3 = this;

            /*選擇銷售員*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.saList = _this3.salesList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        clickLoad: function clickLoad() {
            /*点击銷售員框时加载*/
            this.saList = [];
            this.saList = this.salesList;
        },
        handleCurrentChange: function handleCurrentChange() {
            this.getWarehousing();
        },
        isDate: function isDate() {
            /*处理日期*/
            this.addWarehousingList.forEach(function (a, i) {
                if (a.createDate) {
                    a.createDate = Math.round(new Date(a.createDate).getTime() / 1000); //new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
                }
            });
        },
        isStringNull: function isStringNull() {
            var _this4 = this;

            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "入庫單不能為空";
            }if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }if (this.form.name === null || this.form.name === "") {
                return "物品不能為空";
            }if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            try {
                this.addWarehousingList.forEach(function (a, i) {
                    if (a.createDate === null || a.createDate === "") {
                        str = "Job00" + (i + 1) + "的時間不能為空";
                        foreach.break = new Error(str);
                    } else {
                        a.storInItem.forEach(function (item, j) {
                            if (item.item === "") {
                                a.storInItem.splice(j, 1); //刪除當前這條沒有值的資料
                            } else {
                                var num = 0;
                                if (_this4.addShow === true) {
                                    //点击新建后把最前面的变为反的
                                    if (i === 0) {
                                        num = _this4.addWarehousingList.length;
                                    } else {
                                        num = i - 1;
                                    }
                                } else {
                                    num = i + 1;
                                }
                                if (item.unit === null || item.unit === "" || item.unit === undefined) {
                                    str = "第" + num + "次的單位不能為空";
                                    foreach.break = new Error(str);
                                }if (item.boxNo === null || item.boxNo === 0) {
                                    str = "第" + num + "次的編號不能為空";
                                    foreach.break = new Error(str);
                                }if (item.item === null || item.item === "") {
                                    str = "第" + num + "次的名稱不能為空";
                                    foreach.break = new Error(str);
                                }if (item.qty === null || item.qty === "") {
                                    str = "第" + num + "次的數量不能為空";
                                    foreach.break = new Error(str);
                                }if (item.locationId === null || item.locationId === "") {
                                    str = "位置不能為空";
                                    foreach.break = new Error(str);
                                }
                                item.qty = Number(item.qty);
                            }
                        });
                    }
                    var nary = _this4.addWarehousingList[i].storInItem.sort(); //查找是否有重复的單位和BOX
                    var obj = {};
                    var obj1 = {};
                    for (var j = 0, l = nary.length; j < l; j++) {
                        if (nary[j].state === 0) {
                            if (obj[nary[j].boxNo + "," + nary[j].unit]) {
                                if (obj1[nary[j].unit]) {
                                    str = "有重複的單位: " + nary[j].unit + " ,和編號: " + nary[j].boxNo;
                                    foreach.break = new Error(str);
                                }
                            } else {
                                obj[nary[j].boxNo + "," + nary[j].unit] = nary[j].boxNo + "," + nary[j].unit;
                                obj1[nary[j].unit] = nary[j].unit;
                            }
                        }
                    }
                });
            } catch (e) {
                return str;
            }
            return str;
        },
        getWarehousing: function getWarehousing() {
            var _this5 = this;

            /*查詢入庫*/
            this.submitInfo = true;
            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, storIn: this.searchStorIn.trim(), custName: this.searchName.trim(), salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_21" /* getStorInList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this5.warehousingList = items;
                    _this5.warehousingList.forEach(function (a, b) {
                        a.storInDate = new Date(a.storInDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this5.$set(_this5.warehousingList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this5.pager.total = total;
                    _this5.pager.page = page;
                    _this5.pager.size = size;
                    _this5.tableloading = false;
                } else {
                    _this5.$message.error(res.errmsg);
                }
            });
        },
        addWarehousing: function addWarehousing() {
            var _this6 = this;

            /*點擊新增後向陣列添加一條資料*/
            this.addShow = true;
            var boxNo = void 0;
            this.addWarehousingList.forEach(function (item, i) {
                //查詢当前BOXNO 最大值 +1
                var index = Number(_this6.addWarehousingList.length - 1);
                var a = Number(_this6.addWarehousingList[index].storInItem.length - 1);
                boxNo = Number(_this6.addWarehousingList[index].storInItem[a].boxNo) + 1;
            });
            this.addWarehousingList.unshift({ state: 0, second: this.addWarehousingList.length + 1, createDate: new Date().Format("yyyy-MM-dd hh:mm:ss"), code: null, addStorIn: true,
                storInItem: [{ state: 0, unitShow: false, num: 1, addStorinItem: true, boxNo: boxNo, item: '', qty: null, locationId: '', value: '', boxNoShow: false, itemShows: true, qtyShow: true, locationIdShows: true }] });
        },
        querySearch: function querySearch(queryString, cb) {
            /*載入數據*/
            var restaurants = this.customerCode;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (restaurant) {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        handleSelect: function handleSelect(item) {
            var _this7 = this;

            /*選擇客編號後*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* getCustomerById */])(item.id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode === 200) {
                    //console.log("resCUS",res);
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this7.form.id = id;
                    _this7.form.code = code;
                    _this7.form.name = name;
                    _this7.form.address = address;
                    _this7.form.phone = phone;
                    _this7.form.sales = sales;
                    if (id != undefined) {
                        _this7.getLocationByCusId(id);
                    }
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        querySearchRemark: function querySearchRemark(queryString, cb) {
            /*載入常用列表數據*/
            var restaurants = this.remarkList;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        selCustimerId: function selCustimerId(id) {
            var _this8 = this;

            /*查詢客戶ID*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_22" /* getStorInListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;
                //console.log(res)

                if (res.errcode === 200) {
                    var _res$data$customer = res.data.customer,
                        _id = _res$data$customer.id,
                        code = _res$data$customer.code,
                        name = _res$data$customer.name,
                        phone = _res$data$customer.phone,
                        address = _res$data$customer.address;

                    _this8.form.id = _id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = res.data.sales;
                    _this8.form.sCode = res.data.scode;
                    if (_id != undefined) {
                        _this8.getLocationByCusId(_id);
                    }
                }
            });
        },
        delAddWarehousingList: function delAddWarehousingList(item, i) {
            var _this9 = this;

            /*删除StorInDate表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this9.addShow === true) {
                    _this9.addWarehousingList.splice(i, 1); //删除数组
                    _this9.addShow = false;
                } else {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["d" /* delStorInDate */])(item.id).then(function (str) {
                        //删除
                        var _str$data = str.data,
                            res = _str$data === undefined ? {} : _str$data;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this9.addWarehousingList.splice(i, 1); //删除数组
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this9.$message({
                            type: 'info',
                            message: mes
                        });
                    });
                }
                //let id = this.addWarehousingList[i].id;
            }).catch(function () {
                _this9.$message({
                    type: 'info',
                    message: '已取消刪除'
                });
            });
        },
        delStorInItem: function delStorInItem(i, index) {
            var _this10 = this;

            /*删除StorInItem表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this10.addWarehousingList[i].storInItem[index].addStorinItem === true) {
                    _this10.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                } else {
                    var id = _this10.addWarehousingList[i].storInItem[index].id;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["e" /* delStorInItem */])(id).then(function (str) {
                        //删除
                        var _str$data2 = str.data,
                            res = _str$data2 === undefined ? {} : _str$data2;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this10.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this10.$message({
                            type: 'info',
                            message: mes
                        });
                    }).catch(function () {
                        _this10.$message({
                            type: 'info',
                            message: '已取消刪除'
                        });
                    });
                }
            });
            //console.log("l",this.addWarehousingList[i].storInItem[index])
        },
        handleSelectState: function handleSelectState(id, i, index) {
            /*選擇位置後 向陣列添加一條新資料*/
            if (this.addWarehousingList[i].storInItem[index].num === 1) {
                //
                var box = Number(this.addWarehousingList[i].storInItem[index].boxNo);
                this.addWarehousingList[i].storInItem.push({ state: 0, unitShow: false, unit: '', num: 1, addStorinItem: true, boxNo: box + 1, item: '', qty: null, locationId: '', value: '', itemShows: false, qtyShow: true, locationIdShows: true });
            }
            this.addWarehousingList[i].storInItem[index].num = 0;
            this.addWarehousingList[i].storInItem[index + 1].unit = this.addWarehousingList[i].storInItem[index].unit;
            this.addWarehousingList[i].storInItem[index].locationId = id; //向選擇位置後的資訊添加位置ID
        },
        isNullOptions4: function isNullOptions4() {
            /*点击时清空当前数组*/
            this.options4 = [];
            //this.getLocationByCusId(this.form.id);
        },
        selSotrIn: function selSotrIn(id, typeId) {
            var _this11 = this;

            /*查詢入庫的詳細資訊*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerInSte", false);
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.addShow = false;
            this.rkCont = false; //入庫和客戶資訊
            this.storInId = id;
            this.typeId = typeId;
            var params = { page: this.pager.page, size: 100, storInId: id };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_59" /* selStorInItem */])(params).then(function (str) {
                //查詢當前入庫單裡有多少資料
                var _str$data3 = str.data,
                    res = _str$data3 === undefined ? {} : _str$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var leagueMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    var cId = void 0;
                    var i = 1;
                    res.data.data.forEach(function (item) {
                        //重新處理下資料
                        _this11.form.createDate = new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        var itemList = {};cId = item.cId;_this11.updateStorIn = item.sCode;
                        var floor = void 0;
                        if (item.floor === 0) {
                            floor = "GF " + item.name;
                        } else {
                            floor = item.floor + "F " + item.name;
                        }
                        if (item.state === 1) {
                            //是否是當天時間 不是當天的時間不能修改
                            itemList = { unitShow: true, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShows: true, qtyShow: true, locationIdShows: true, boxNoShow: true };
                        } else {
                            itemList = { unitShow: false, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShow: false, qtyShow: false, locationIdShow: false };
                        }
                        if (!leagueMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { state: 1, second: i, id: item.storDateId, code: item.sCode, createDate: new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"),
                                addStorIn: false, storInItem: [itemList] };
                            leagueMap.set(item.storDateId, storIdItemList);
                            i++;
                        } else {
                            leagueMap.get(item.storDateId).storInItem.push(itemList);
                        }
                    });
                    _this11.addWarehousingList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(leagueMap.values()));
                    var boxNo = void 0;
                    _this11.addWarehousingList.forEach(function (item, i) {
                        //查詢当前BOX 最大值 +1
                        var index = Number(_this11.addWarehousingList.length - 1);
                        var a = Number(_this11.addWarehousingList[index].storInItem.length - 1);
                        boxNo = Number(_this11.addWarehousingList[index].storInItem[a].boxNo) + 1;
                        item.storInItem.push({ state: 0, unitShow: false, unit: '', num: 1, addStorinItem: true, id: item.id, boxNo: boxNo + i, item: '', qty: null, locationId: '', value: '',
                            itemShows: true, qtyShow: true, locationIdShows: true });
                    });
                    _this11.selCustimerId(id); //查詢客戶id
                    _this11.form.codeShow = true;
                    _this11.form.sCodeShow = false;
                    _this11.form.nameShow = true;
                    _this11.form.phoneShow = true;
                    _this11.form.addressShow = true;
                    _this11.form.salesShow = true;
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this12 = this;

            /*保存資料到資料庫*/
            this.submitInfo = false; //禁止保存按钮
            var str = this.isStringNull();
            var params = {
                code: this.form.sCode,
                storInId: this.storInId,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storInDateList: this.addWarehousingList };
            //console.log("pa",params); WHETHER_PUBLIC 当前架子是否公共使用(0不公用 1公用)
            if (str !== "") {
                this.submitInfo = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error',
                    callback: function callback(action) {
                        var boxNo = void 0;
                        _this12.addWarehousingList.forEach(function (item, i) {
                            //查詢当前BOX 最大值 +1
                            var index = Number(_this12.addWarehousingList.length - 1);
                            var a = Number(_this12.addWarehousingList[index].storInItem.length - 1);
                            boxNo = Number(_this12.addWarehousingList[index].storInItem[a].boxNo) + 1;
                            //console.log(item.storInItem[a]);
                            if (item.storInItem[a].qty !== null || item.storInItem[a].locationId !== "") {
                                item.storInItem.push({ state: 0, unitShow: false, unit: '', num: 0, addStorinItem: true, id: item.id, boxNo: boxNo + i, item: '', qty: null, locationId: '', value: '',
                                    itemShows: true, qtyShow: true, locationIdShows: true });
                            }
                        });
                    }
                });
            } else {
                this.submitInfo = true;
                this.isDate();
                if (this.rkCont === true) {
                    //添加
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_51" /* insertStorIn */])(params).then(function (data) {
                        var _data$data5 = data.data,
                            res = _data$data5 === undefined ? {} : _data$data5;

                        if (res.errcode === 200) {
                            _this12.$message({
                                showClose: true,
                                message: '入庫成功！',
                                type: 'success'
                            });
                            _this12.cancelAdd();
                            _this12.getWarehousing();
                        } else {
                            _this12.$message.error(res.errmsg);
                            _this12.submitInfo = true;
                        }
                    });
                } else {
                    //修改
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_80" /* updateStorIn */])(params).then(function (data) {
                        var _data$data6 = data.data,
                            res = _data$data6 === undefined ? {} : _data$data6;

                        if (res.errcode === 200) {
                            _this12.$message({
                                showClose: true,
                                message: '修改成功！',
                                type: 'success'
                            });
                            _this12.cancelAdd();
                            _this12.getWarehousing();
                            /*  if(this.typeId==2){
                                }*/
                        } else {
                            _this12.$message.error(res.errmsg);
                            _this12.submitInfo = true;
                        }
                    });
                }
            }
        },
        RndNum: function RndNum() {
            //生成一個15位元數的數字
            var rnd = "";
            for (var i = 0; i < 15; i++) {
                rnd += Math.floor(Math.random() * 10);
            }
            return rnd;
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm");
            this.addWarehousingList[0].createDate = new Date().Format("yyyy-MM-dd hh:mm");
            //console.log(this.addWarehousingList);
        },
        cancelAdd: function cancelAdd() {
            /*顯示入庫資訊 關閉添加入庫資訊*/
            this.add = false;
            this.show = true;
            this.nullList();
            this.list = [];
            if (this.typeId == 2) {
                /* this.$store.commit("setCustomerInSte", false);
                 this.$store.commit("closeTab",'stockin');
                 this.$router.go(-1);*/
            }
        },
        addList: function addList(i, index, str) {
            /*修改是否能輸入*/
            if (str === "unit") {
                this.addWarehousingList[i].storInItem[index].boxNoShow = false;
                this.addWarehousingList[i].storInItem[index].itemShows = false;
            }if (str === "cCode") {
                this.addWarehousingList[i].storInItem[index].unitShow = false;
            }if (str === "boxNo") {
                this.addWarehousingList[i].storInItem[index].itemShows = false;
            }if (str === "item") {
                this.addWarehousingList[i].storInItem[index].qtyShow = false;
            }if (str === "qty") {
                this.addWarehousingList[i].storInItem[index].locationIdShows = false;
            }
        },
        selCutomerCode: function selCutomerCode() {
            var _this13 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data7 = data.data,
                    res = _data$data7 === undefined ? {} : _data$data7;

                if (res.errcode === 200) {
                    _this13.customerCode = res.data;
                    _this13.customerCode.forEach(function (a, b) {
                        _this13.$set(_this13.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                    });
                }
            });
        },
        letSalesList: function letSalesList() {
            var _this14 = this;

            /*查詢銷售員LIST*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_11" /* getSalesList */])().then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;
                //console.log(res)

                if (res.errcode === 200) {
                    _this14.salesList = res.data;
                    _this14.salesList.forEach(function (a, b) {
                        _this14.$set(_this14.salesList[b], 'value', a.name); //向陣列裡添加value欄位
                    });
                }
            });
        },
        selLocationState: function selLocationState() {
            var _this15 = this;

            /*查詢位置資訊*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["U" /* getLocationByState */])(Number(0)).then(function (data) {
                var _data$data9 = data.data,
                    res = _data$data9 === undefined ? {} : _data$data9;

                if (res.errcode === 200) {
                    _this15.locationList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this15.locationList.forEach(function (a, b) {
                        if (a.floor === "0") {
                            sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                        } else {
                            sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                        }
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this15.list = list.map(function (item) {
                        return { value: item.id, label: item.location };
                    });
                    //console.log("resL",this.list);
                }
            });
        },
        getLocationByCusId: function getLocationByCusId(id) {
            var _this16 = this;

            /*以客戶ID查詢當前客戶在用的架子*/
            if (this.storInId !== 0) {
                //入庫單ID为空 没有架子
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["v" /* getCIdList */])({ id: this.storInId, cusId: id }).then(function (data) {
                    var _data$data10 = data.data,
                        res = _data$data10 === undefined ? {} : _data$data10;

                    if (res.errcode === 200) {
                        _this16.locationList = res.data;
                        var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                        _this16.locationList.forEach(function (a, b) {
                            if (a.floor === "0") {
                                sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                            } else {
                                sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                            }
                        });
                        var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                        var Tlist = list.map(function (item) {
                            return { value: item.id, label: item.location };
                        });
                        var this_ = _this16;
                        var t1 = setInterval(function () {
                            //定时器 3秒后加载到list
                            for (var i = 0; i < Tlist.length; i++) {
                                this_.list.unshift(Tlist[i]);
                            }
                            clearTimeout(t1);
                        }, 3000);
                    }
                });
            }
        },
        getRemarkList: function getRemarkList() {
            var _this17 = this;

            /*查詢常用列表*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["s" /* getAllRemarkList */])(1).then(function (data) {
                var _data$data11 = data.data,
                    res = _data$data11 === undefined ? {} : _data$data11;

                if (res.errcode === 200) {
                    _this17.remarkList = res.data;
                    _this17.remarkList.forEach(function (a, b) {
                        _this17.$set(_this17.remarkList[b], 'value', a.content); //向陣列裡添加value欄位
                    });
                }
            });
        },
        nullList: function nullList() {
            /*清空*/
            this.addWarehousingList = [{ state: 1, second: 1, createDate: null, code: null, addStorIn: true, storInItem: [{ state: 0, unitShow: true, unit: '', num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', boxNoShow: true, itemShows: true, qtyShow: true, locationIdShows: true }] }];
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null, sCode: ''
            };
            this.updateStorIn = "";
            this.storInId = 0;
            //this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        test: function test() {
            this.show = true;
            this.add = false;
        }
    },
    activated: function activated() {
        /*進入載入*/
        /*getStaffAllList().then(data=>{
            let {data:res={}}=data;
            this.custSalesList=res.data;
        });*/
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getWarehousing();
        //this.cancelAdd();
        //this.selCutomerCode();
        //this.letSalesList();//查詢銷售員
        //this.getRemarkList();//常用列表
        // Math.round(new Date().getTime()/1000); js轉Unix
        //new Date(createDate*1000).Format("yyyy-MM-dd hh:mm:ss") Unix轉js

        //首页查詢功能
        if (this.$store.getters.warehouseSta == true) {
            //                this.$store.commit("setSearchSte",true);
            this.selSotrIn(this.$route.params.id, this.$route.params.typeId);
            this.$store.commit("setSearchSte", true);
        }

        //客戶详情編輯
        if (this.$store.getters.customerInSte == true) {
            //                this.$store.commit("setSearchSte",true);
            this.selSotrIn(this.$route.params.id, this.$route.params.typeId);
        }
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ADD_STOR_IN");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("EDIT_STOR_IN");
        }
    },
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "Rxym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staff_vue__ = __webpack_require__("dXm+");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113cdc91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staff_vue__ = __webpack_require__("l+cy");
function injectStyle (ssrContext) {
  __webpack_require__("Baxo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-113cdc91"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Staff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113cdc91_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Staff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S++V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerManagement_vue__ = __webpack_require__("gXfT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca86bd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerManagement_vue__ = __webpack_require__("2TEi");
function injectStyle (ssrContext) {
  __webpack_require__("kvkd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca86bd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S2+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobOrderList_vue__ = __webpack_require__("xPlv");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f175745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobOrderList_vue__ = __webpack_require__("pNT0");
function injectStyle (ssrContext) {
  __webpack_require__("SGf/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobOrderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f175745_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobOrderList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SGf/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SHlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button__ = __webpack_require__("EMXe");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    // data() {
    // 	return{
    // 		selectid:0,
    // 	}


    // 	 },
    components: { ElButton: __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button__["a" /* default */] },

    methods: {
        getCustomerById: function getCustomerById() {
            var _this = this;

            this.isRhdcx = false;
            this.isChdcx = false;
            this.isQhlb = false;
            this.isQbkc = true;

            this.EDIT_CUST = this.$store.getters.hasPermission("EDIT_CUST"); //查詢是否能修改
            this.ind_main = false;
            this.ruku_list = true;
            this.ruku_listTwo = false;
            this.show = false;
            this.sbtnfr = true;
            this.tableloading = true;
            this.changeRed = 0;
            this.num = 0;
            this.loadingimg = false;
            this.listText = '切換地圖顯示';

            this.locationList = [];
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["D" /* getCustomerById */])(this.$route.params.id).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var obj = res.data;
                    _this.customer = obj[0];
                    _this.storInItem = obj[1];
                    //                        this.getLocationList(obj[1]);
                    _this.getLocationBycusId();
                    _this.tableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        getLocationList: function getLocationList(storInItem) {
            var _this2 = this;

            //載入架子頁面
            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["X" /* getLocationList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode == 200) {
                    var obj = res.data;
                    _this2.locationList = res.data;
                    _this2.floCount = res.data;
                    _this2.storList = obj[3];
                    _this2.tableloading = false;
                    for (var listf in _this2.locationList) {
                        for (var m in _this2.locationList[listf].itemList) {
                            for (var a in storInItem) {
                                if (_this2.locationList[listf].itemList[m].id == storInItem[a].locationId && _this2.locationList[listf].itemList[m].state == 1) {
                                    _this2.locationList[listf].itemList[m].status = 1;
                                }
                            }
                        }
                    }
                    _this2.loadingimg = false;
                    _this2.ind_main = true;
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        remoteMethodSales: function remoteMethodSales(query) {
            var _this3 = this;

            /*選擇銷售員*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.salesList = _this3.saList.filter(function (item) {
                        //                            console.log(item);
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.salesList = [];
            }
        },
        letSalesList: function letSalesList() {
            var _this4 = this;

            /*查詢銷售員LIST*/
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_11" /* getSalesList */])().then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;
                //console.log(res)

                if (res.errcode === 200) {
                    var salesOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                    res.data.forEach(function (item, i) {
                        salesOnMap.set(i, { id: item.id, value: item.name });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(salesOnMap.values()));
                    _this4.saList = list.map(function (item) {
                        return { value: item.value, label: item.value };
                    });
                }
            });
        },
        cusInventory: function cusInventory(id) {
            var _this5 = this;

            //客戶庫存
            this.tkshow = true;
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["x" /* getCusInventory */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;

                if (res.errcode == 200) {
                    var obj = res.data;
                    _this5.locationListB = obj;
                    _this5.custName = _this5.locationListB[0].name;
                } else {
                    _this5.$message.error(res.errmsg);
                }
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            var searchs = this.$store.getters.keywords;
            this.$router.push({
                name: '首頁搜尋網頁面',
                params: {
                    keywords: searchs
                }
            });
        },
        edtSotrIn: function edtSotrIn(id) {
            //入倉出倉編輯界面
            if (this.isInOn == '1') {
                //入倉
                this.$store.commit("setCustomerInSte", true);
                this.$router.push({
                    name: '編輯入倉',
                    params: {
                        id: id,
                        typeId: 2,
                        custId: this.$route.params.id
                    }
                });
            } else {
                this.$store.commit("setCustomerOnSte", true);
                this.$router.push({
                    name: '編輯出倉',
                    params: {
                        id: id,
                        typeId: 2,
                        custId: this.$route.params.id
                    }
                });
            }
        },
        serac: function serac() {
            window.history.back(-1);
        },
        getLocationBycusId: function getLocationBycusId() {
            var _this6 = this;

            if (this.$route.params.id != undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["W" /* getLocationBycusId */])(this.$route.params.id).then(function (data) {
                    var _data$data5 = data.data,
                        res = _data$data5 === undefined ? {} : _data$data5;

                    if (res.errcode == 200) {
                        var obj = res.data;
                        _this6.locationPageList = obj[0];
                        _this6.locationPageList.forEach(function (a) {
                            a.createDate = new Date(a.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        });
                        _this6.floSideCount = obj[1];
                    } else {
                        _this6.$message.error(res.errmsg);
                    }
                });
            }
        },
        isonIn: function isonIn() {
            if (this.isShow == false) {
                this.isShow = true;
            } else {
                this.isShow = false;
            }
        },
        swcList: function swcList() {
            //列表切換
            this.isRhdcx = false;
            this.isChdcx = false;
            this.isQhlb = true;
            this.isQbkc = false;
            this.selectid = 3;
            this.isQbkc = false;
            if (this.ruku_list == false && this.ind_main == true) {
                this.listText = '切換地圖顯示';
                this.ruku_list = true;
                this.ind_main = false;
            } else {
                this.listText = '切換清單顯示';
                if (this.locationList.length == 0) {
                    this.ind_main = false;
                    this.loadingimg = true;
                    this.getLocationList(this.storInItem);
                } else {
                    this.ind_main = true;
                }
                this.ruku_list = false;
            }
            this.show = false;
            this.ruku_listTwo = false;
        },
        swcListTwo: function swcListTwo() {
            //全部庫存
            this.ind_main = false;
            this.selectid = 0;
            this.ruku_list = true;
            this.ruku_listTwo = false;
            this.show = false;
            this.sbtnfr = true;

            this.isRhdcx = false;
            this.isChdcx = false;
            this.isQhlb = false;
            this.isQbkc = true;
        },
        swcListThree: function swcListThree() {
            //入貨單查詢
            this.isQbkc = false;
            this.ind_main = false;
            this.ruku_list = false;
            this.ruku_listTwo = false;
            this.show = true;
            this.selectid = 1;
            this.sbtnfr = false;
            this.getWarehousing();
            this.isInOn = '1';
            //this.selSotrIn(id);
            this.isQbkc = true;

            this.isRhdcx = true;
            this.isChdcx = false;
            this.isQhlb = false;
            this.isQbkc = false;
        },
        swcListFour: function swcListFour() {
            //出貨單查詢
            this.isQbkc = false;
            this.ind_main = false;
            this.ruku_list = false;
            this.ruku_listTwo = false;
            this.show = true;
            this.selectid = 2;
            this.sbtnfr = false;
            this.getStorOnListTwo();
            this.isInOn = '2';

            this.isRhdcx = false;
            this.isChdcx = true;
            this.isQhlb = false;
            this.isQbkc = false;
        },
        listCut: function listCut(index) {
            //切換樓層效果
            this.changeRed = index;
            this.num = index;
        },
        customerEdit: function customerEdit(id) {
            this.dialogName = "編輯客戶資訊", this.dialogDiscEditVisible = true;
            this.resetForm("customerForm");
            this.customerById(id);
            this.letSalesList();
        },
        querySearch: function querySearch(queryString, cb) {
            /*載入數據*/
            var restaurants = this.customerCode;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (restaurant) {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        customerById: function customerById(id) {
            var _this7 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["D" /* getCustomerById */])(id).then(function (data) {
                var item = data.data;
                if (item.errcode == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this7.customerForm, item.data[0]);
                } else {
                    _this7.$message.error(item.errmsg);
                }
            });
        },
        handleCurrencustomerById: function handleCurrencustomerById(id) {
            var _this8 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["D" /* getCustomerById */])(id).then(function (data) {
                var item = data.data;
                if (item.errcode == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this8.customerForm, item.data[0]);
                } else {
                    _this8.$message.error(item.errmsg);
                }
            });
        },
        handleCurrentChange: function handleCurrentChange() {
            if (this.isInOn == '1') {
                this.getWarehousing();
            } else if (this.isInOn == '2') {
                this.getStorOnListTwo();
            }
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        customerSave: function customerSave() {
            var _this9 = this;

            this.$refs.customerForm.validate(function (valid) {
                if (valid) {
                    if (_this9.customerForm.id == "") {
                        //新增
                        _this9.addEidtloading = true;
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this9.customerForm);
                        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_42" /* insertCustomer */])(params).then(function (data) {
                            _this9.addEidtloading = false;
                            var errcode = data.errcode,
                                errmsg = data.errmsg;

                            if (errcode == 200) {
                                _this9.$message.success("新增成功！！");
                                _this9.getCustomerList();
                                _this9.resetForm("customerForm");
                                _this9.dialogDiscEditVisible = false;
                            } else {
                                _this9.$message.error(data.errmsg);
                            }
                        }, function (err) {
                            _this9.addEidtloading = false;
                        });
                    } else {
                        //編輯
                        //var  params=Object.assign({},this.bankForm);
                        var params = { id: _this9.customerForm.id, code: _this9.customerForm.code, name: _this9.customerForm.name, phone: _this9.customerForm.phone, sales: _this9.customerForm.sales, address: _this9.customerForm.address };
                        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_64" /* updateCustomer */])(params).then(function (data) {
                            _this9.addEidtloading = false;
                            var _data$data6 = data.data,
                                res = _data$data6 === undefined ? {} : _data$data6;

                            if (res.errcode == 200) {
                                _this9.$message.success("修改成功");
                                _this9.getCustomerById();
                                _this9.resetForm("customerForm");
                                _this9.dialogDiscEditVisible = false;
                            } else {
                                _this9.$message.error(res.errmsg);
                            }
                        }, function (err) {
                            _this9.addEidtloading = false;
                        });
                    }
                }
            });
        },
        selSotrIn: function selSotrIn(row) {
            var _this10 = this;

            /*查詢入庫的詳細資訊*/
            this.ruku_listTwo = true;
            //this.dialogVisible = true;
            this.add = true;
            this.show = false;
            this.rkCont = false; //入庫和客戶資訊
            var params = { page: this.pager.page, size: this.pager.size, storInId: row.id };
            if (this.isInOn == '1') {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_59" /* selStorInItem */])(params).then(function (str) {
                    //查詢當前入庫單裡有多少資料
                    var _str$data = str.data,
                        res = _str$data === undefined ? {} : _str$data;

                    if (res.errcode === 200) {
                        var leagueMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                        res.data.data.forEach(function (item) {
                            //重新處理下資料
                            var itemList = { id: item.id, boxNo: item.boxNo, state: item.state, unit: item.unit, item: item.item, qty: item.qty, locationId: item.locationId, value: item.name,
                                itemShow: true, qtyShow: true, locationIdShow: true, boxNoShow: true };
                            if (!leagueMap.has(item.storDateId)) {
                                //添加
                                var storIdItemList = { id: item.storDateId, code: item.sCode, createDate: new Date(item.createDate * 1000).Format("yyyy/MM/dd hh:mm:ss"), addStorIn: false, storInItem: [itemList] };
                                leagueMap.set(item.storDateId, storIdItemList);
                                console.log(storIdItemList);
                            } else {
                                leagueMap.get(item.storDateId).storInItem.push(itemList);
                            }
                        });
                        _this10.addWarehousingList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(leagueMap.values()));
                    }
                });
            } else {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_25" /* getStorOnItemStorinIdBy */])(row.id).then(function (data) {
                    var _data$data7 = data.data,
                        res = _data$data7 === undefined ? {} : _data$data7;

                    if (res.errcode === 200) {
                        var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                        var storDateId = null;
                        res.data.forEach(function (item) {
                            //重新處理下資料
                            storDateId = item.storDateId;
                            var itemList = { id: item.id, boxNo: item.boxNo, state: item.state, unit: item.unit, item: item.item, qty: item.qty, locationId: item.locationId, value: item.name,
                                itemShow: true, qtyShow: true, locationIdShow: true, boxNoShow: true };
                            if (!sotrOnMap.has(item.storDateId)) {
                                //添加
                                var storIdItemList = { id: item.storDateId, code: item.sCode, createDate: new Date(item.createDate * 1000).Format("yyyy/MM/dd hh:mm:ss"), addStorIn: false, storInItem: [itemList] };
                                sotrOnMap.set(item.storDateId, storIdItemList);
                            } else {
                                sotrOnMap.get(item.storDateId).storInItem.push(itemList);
                            }
                        });
                        _this10.addWarehousingList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    }
                });
            }
        },
        getWarehousing: function getWarehousing() {
            var _this11 = this;

            /*查詢入庫*/
            this.codeTableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, cusId: this.customer.id };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_23" /* getStorInListTwo */])(params).then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this11.warehousingList = items;
                    _this11.warehousingList.forEach(function (a, b) {
                        a.storInDate = new Date(a.storInDate * 1000).Format("yyyy-MM-dd hh:mm");
                    });
                    _this11.pager.total = total;
                    _this11.pager.page = page;
                    _this11.pager.size = size;
                    _this11.codeTableloading = false;
                } else {
                    _this11.$message.error(res.errmsg);
                }
            });
        },
        getStorOnListTwo: function getStorOnListTwo() {
            var _this12 = this;

            /*查詢出庫*/
            this.codeTableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, cusId: this.customer.id };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_28" /* getStorOnListTwo */])(params).then(function (data) {
                var _data$data9 = data.data,
                    res = _data$data9 === undefined ? {} : _data$data9;

                if (res.errcode === 200) {
                    var _res$data2 = res.data,
                        size = _res$data2.size,
                        page = _res$data2.page,
                        total = _res$data2.total,
                        _res$data2$data = _res$data2.data,
                        items = _res$data2$data === undefined ? [] : _res$data2$data;

                    _this12.warehousingList = items;
                    _this12.warehousingList.forEach(function (a, b) {
                        a.storInDate = new Date(a.storInDate * 1000).Format("yyyy-MM-dd hh:mm");
                    });
                    _this12.pager.total = total;
                    _this12.pager.page = page;
                    _this12.pager.size = size;
                    _this12.codeTableloading = false;
                } else {
                    _this12.$message.error(res.errmsg);
                }
            });
        },
        RndNum: function RndNum() {
            //生成一個15位元數的數字
            var rnd = "";
            for (var i = 0; i < 15; i++) {
                rnd += Math.floor(Math.random() * 10);
            }
            return rnd;
        },

        //清除表單內容
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    data: function data() {
        var _this13 = this;

        //驗證客戶編號是否重複
        var validateCustomerCode = function validateCustomerCode(rule, value, callback) {
            var params = { code: _this13.customerForm.code };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_38" /* getValidateCustomerCode */])(params).then(function (data) {
                if (_this13.customerForm.id == '') {
                    var item = data.data.data;
                    if (item) {
                        callback(new Error('客戶編號重複！'));
                    } else {
                        callback();
                    }
                }
                callback();
            });
            callback();
        };
        return {
            //查詢準則
            isQbkc: true,
            isRhdcx: false,
            isChdcx: false,
            isQhlb: false,
            listText: '切換地圖顯示',
            codeTableloading: false,
            loadingimg: true,
            loading: true,
            salesList: [], //銷售員LIST
            saList: [], //銷售員LIST
            isShow: true,
            tkshow: false,
            custName: '',
            EDIT_CUST: false, //是否可以修改
            searchBankName: "",
            customer: [],
            warehousingList: [],
            ruku_list: true,
            ind_main: false,
            ruku_listTwo: false,
            locationListB: [],
            show: false,
            sbtnfr: true,
            isInOn: '', //判斷是入貨單查詢還是出貨單查詢
            storInItem: [],
            selectionItems: [],
            num: 0,
            selectid: 0, //選擇btnid
            changeRed: 0,
            storList: [],
            locationList: [],
            locationPageList: [],
            floCount: [],
            floSideCount: [],
            addWarehousingList: [{ createDate: null, code: this.RndNum(), addStorIn: true, storInItem: [{ boxNo: '', item: '', qty: null, locationId: '', value: '', itemShow: true, qtyShow: true, locationIdShow: true }] }],
            tableloading: false,
            addEidtloading: false,
            dialogDiscEditVisible: false,
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            dialogName: '',
            customerForm: {
                id: "",
                sales: "",
                code: "",
                name: "",
                phone: "",
                address: ''
            },
            form: {
                id: null,
                sCode: null,
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                createDateShow: true
            },
            //新增客戶資訊表單驗證
            customerRules: {
                code: [{ required: true, message: '請輸入客戶編號', trigger: 'blur' }, { min: 1, max: 18, message: '超過指定長度', trigger: 'blur' }, { validator: validateCustomerCode, trigger: 'blur' }],
                name: [{ required: true, message: '請輸入客戶名', trigger: 'blur' }, { min: 1, max: 15, message: '超過指定長度', trigger: 'blur' }],
                phone: [{ required: true, message: '請輸入手機號', trigger: 'blur' }, { min: 1, max: 13, message: '超過指定長度', trigger: 'blur' }],
                address: [{ required: true, message: '請輸入位址', trigger: 'blur' }, { min: 1, max: 100, message: '長度最大為100', trigger: 'blur' }],
                sales: [{ required: true, message: '請輸入銷售員', trigger: 'blur' }]
            }
        };
    },


    //        mounted() {
    //
    //        },
    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("BANK_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("BANK_EDIT");
        },
        canDel: function canDel() {
            return this.$store.getters.hasPermission("BANK_DEL");
        }
    },
    activated: function activated() {
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getCustomerById();
    }
});

/***/ }),

/***/ "SuXA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGRDAxM0RGMUFDQzkxMUU4OUY3Q0UwMTIxQTlCNTcyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGRDAxM0RGMkFDQzkxMUU4OUY3Q0UwMTIxQTlCNTcyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkZEMDEzREVGQUNDOTExRTg5RjdDRTAxMjFBOUI1NzI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkZEMDEzREYwQUNDOTExRTg5RjdDRTAxMjFBOUI1NzI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+i91ISQAAADFJREFUeNpi/A8EDEQCJiBmJFItIxOMQUghzGQGAhoYkZ3BgEcDI7qbcZmEYRNAgAEANcYEEmuIvSAAAAAASUVORK5CYII="

/***/ }),

/***/ "T7El":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"feedForm",staticClass:"demo-form-inline",staticStyle:{"width":"1500px"},attrs:{"inline":true,"model":_vm.feedForm,"rules":_vm.feedRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"feedDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":"","disabled":"disabled"},model:{value:(_vm.feedForm.feedDate),callback:function ($$v) {_vm.$set(_vm.feedForm, "feedDate", $$v)},expression:"feedForm.feedDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"車號：","prop":"carNumber"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":"disabled"},model:{value:(_vm.feedForm.carNumber),callback:function ($$v) {_vm.$set(_vm.feedForm, "carNumber", $$v)},expression:"feedForm.carNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"積車","prop":"productCar"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldproductCar,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.productCar,_vm.feedOldForm.oldproductCar,'productCar')}},model:{value:(_vm.feedForm.productCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "productCar", $$v)},expression:"feedForm.productCar"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.productCar,_vm.feedOldForm.oldproductCar,'productCar')}},model:{value:(_vm.feedForm.productCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "productCar", $$v)},expression:"feedForm.productCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"搬花網","prop":"wireMesh"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldwireMesh,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.wireMesh,_vm.feedOldForm.oldwireMesh,'wireMesh')}},model:{value:(_vm.feedForm.wireMesh),callback:function ($$v) {_vm.$set(_vm.feedForm, "wireMesh", $$v)},expression:"feedForm.wireMesh"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.wireMesh,_vm.feedOldForm.oldwireMesh,'wireMesh')}},model:{value:(_vm.feedForm.wireMesh),callback:function ($$v) {_vm.$set(_vm.feedForm, "wireMesh", $$v)},expression:"feedForm.wireMesh"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"膠紙冚","prop":"tape"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtape,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tape,_vm.feedOldForm.oldtape,'tape')}},model:{value:(_vm.feedForm.tape),callback:function ($$v) {_vm.$set(_vm.feedForm, "tape", $$v)},expression:"feedForm.tape"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tape,_vm.feedOldForm.oldtape,'tape')}},model:{value:(_vm.feedForm.tape),callback:function ($$v) {_vm.$set(_vm.feedForm, "tape", $$v)},expression:"feedForm.tape"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"坑紙","prop":"pitPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldpitPaper,"disabled":_vm.disabledNum,"clearable":""},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.pitPaper,_vm.feedOldForm.oldpitPaper,'pitPaper')}},model:{value:(_vm.feedForm.pitPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "pitPaper", $$v)},expression:"feedForm.pitPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","disabled":_vm.disabledNum,"clearable":""},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.pitPaper,_vm.feedOldForm.oldpitPaper,'pitPaper')}},model:{value:(_vm.feedForm.pitPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "pitPaper", $$v)},expression:"feedForm.pitPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"報紙","prop":"newsPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldnewsPaper,"disabled":_vm.disabledNum,"clearable":""},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.newsPaper,_vm.feedOldForm.oldnewsPaper,'newsPaper')}},model:{value:(_vm.feedForm.newsPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "newsPaper", $$v)},expression:"feedForm.newsPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","disabled":_vm.disabledNum,"clearable":""},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.newsPaper,_vm.feedOldForm.oldnewsPaper,'newsPaper')}},model:{value:(_vm.feedForm.newsPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "newsPaper", $$v)},expression:"feedForm.newsPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"卜卜膠","prop":"buBu"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldbuBu,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.buBu,_vm.feedOldForm.oldbuBu,'buBu')}},model:{value:(_vm.feedForm.buBu),callback:function ($$v) {_vm.$set(_vm.feedForm, "buBu", $$v)},expression:"feedForm.buBu"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.buBu,_vm.feedOldForm.oldbuBu,'buBu')}},model:{value:(_vm.feedForm.buBu),callback:function ($$v) {_vm.$set(_vm.feedForm, "buBu", $$v)},expression:"feedForm.buBu"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"拷貝紙","prop":"copyPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldcopyPaper,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.copyPaper,_vm.feedOldForm.oldcopyPaper,'copyPaper')}},model:{value:(_vm.feedForm.copyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "copyPaper", $$v)},expression:"feedForm.copyPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.copyPaper,_vm.feedOldForm.oldcopyPaper,'copyPaper')}},model:{value:(_vm.feedForm.copyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "copyPaper", $$v)},expression:"feedForm.copyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"毡","prop":"mat"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldmat,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.mat,_vm.feedOldForm.oldmat,'mat')}},model:{value:(_vm.feedForm.mat),callback:function ($$v) {_vm.$set(_vm.feedForm, "mat", $$v)},expression:"feedForm.mat"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.mat,_vm.feedOldForm.oldmat,'mat')}},model:{value:(_vm.feedForm.mat),callback:function ($$v) {_vm.$set(_vm.feedForm, "mat", $$v)},expression:"feedForm.mat"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"保鮮紙","prop":"tinFoil"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtinFoil,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tinFoil,_vm.feedOldForm.oldtinFoil,'tinFoil')}},model:{value:(_vm.feedForm.tinFoil),callback:function ($$v) {_vm.$set(_vm.feedForm, "tinFoil", $$v)},expression:"feedForm.tinFoil"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tinFoil,_vm.feedOldForm.oldtinFoil,'tinFoil')}},model:{value:(_vm.feedForm.tinFoil),callback:function ($$v) {_vm.$set(_vm.feedForm, "tinFoil", $$v)},expression:"feedForm.tinFoil"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"高木箱","prop":"azusa"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldazusa,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.azusa,_vm.feedOldForm.oldazusa,'azusa')}},model:{value:(_vm.feedForm.azusa),callback:function ($$v) {_vm.$set(_vm.feedForm, "azusa", $$v)},expression:"feedForm.azusa"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.azusa,_vm.feedOldForm.oldazusa,'azusa')}},model:{value:(_vm.feedForm.azusa),callback:function ($$v) {_vm.$set(_vm.feedForm, "azusa", $$v)},expression:"feedForm.azusa"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"矮木箱","prop":"shortWood"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldshortWood,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.shortWood,_vm.feedOldForm.oldshortWood,'shortWood')}},model:{value:(_vm.feedForm.shortWood),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortWood", $$v)},expression:"feedForm.shortWood"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.shortWood,_vm.feedOldForm.oldshortWood,'shortWood')}},model:{value:(_vm.feedForm.shortWood),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortWood", $$v)},expression:"feedForm.shortWood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"鐵車","prop":"ironCar"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldironCar,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.ironCar,_vm.feedOldForm.oldironCar,'ironCar')}},model:{value:(_vm.feedForm.ironCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "ironCar", $$v)},expression:"feedForm.ironCar"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.ironCar,_vm.feedOldForm.oldironCar,'ironCar')}},model:{value:(_vm.feedForm.ironCar),callback:function ($$v) {_vm.$set(_vm.feedForm, "ironCar", $$v)},expression:"feedForm.ironCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"車仔","prop":"chelsea"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldchelsea,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.chelsea,_vm.feedOldForm.oldchelsea,'chelsea')}},model:{value:(_vm.feedForm.chelsea),callback:function ($$v) {_vm.$set(_vm.feedForm, "chelsea", $$v)},expression:"feedForm.chelsea"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.chelsea,_vm.feedOldForm.oldchelsea,'chelsea')}},model:{value:(_vm.feedForm.chelsea),callback:function ($$v) {_vm.$set(_vm.feedForm, "chelsea", $$v)},expression:"feedForm.chelsea"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"軟紙","prop":"softPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldsoftPaper,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.softPaper,_vm.feedOldForm.oldsoftPaper,'softPaper')}},model:{value:(_vm.feedForm.softPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "softPaper", $$v)},expression:"feedForm.softPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.softPaper,_vm.feedOldForm.oldsoftPaper,'softPaper')}},model:{value:(_vm.feedForm.softPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "softPaper", $$v)},expression:"feedForm.softPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"爛紙","prop":"lousyPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldlousyPaper,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.lousyPaper,_vm.feedOldForm.oldlousyPaper,'lousyPaper')}},model:{value:(_vm.feedForm.lousyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "lousyPaper", $$v)},expression:"feedForm.lousyPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.lousyPaper,_vm.feedOldForm.oldlousyPaper,'lousyPaper')}},model:{value:(_vm.feedForm.lousyPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "lousyPaper", $$v)},expression:"feedForm.lousyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"防潮珠","prop":"moistureproof"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldmoistureproof,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.moistureproof,_vm.feedOldForm.oldmoistureproof,'moistureproof')}},model:{value:(_vm.feedForm.moistureproof),callback:function ($$v) {_vm.$set(_vm.feedForm, "moistureproof", $$v)},expression:"feedForm.moistureproof"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.moistureproof,_vm.feedOldForm.oldmoistureproof,'moistureproof')}},model:{value:(_vm.feedForm.moistureproof),callback:function ($$v) {_vm.$set(_vm.feedForm, "moistureproof", $$v)},expression:"feedForm.moistureproof"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電批","prop":"electric"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldelectric,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.electric,_vm.feedOldForm.oldelectric,'electric')}},model:{value:(_vm.feedForm.electric),callback:function ($$v) {_vm.$set(_vm.feedForm, "electric", $$v)},expression:"feedForm.electric"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.electric,_vm.feedOldForm.oldelectric,'electric')}},model:{value:(_vm.feedForm.electric),callback:function ($$v) {_vm.$set(_vm.feedForm, "electric", $$v)},expression:"feedForm.electric"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"叉","prop":"fork"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldfork,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fork,_vm.feedOldForm.oldfork,'fork')}},model:{value:(_vm.feedForm.fork),callback:function ($$v) {_vm.$set(_vm.feedForm, "fork", $$v)},expression:"feedForm.fork"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fork,_vm.feedOldForm.oldfork,'fork')}},model:{value:(_vm.feedForm.fork),callback:function ($$v) {_vm.$set(_vm.feedForm, "fork", $$v)},expression:"feedForm.fork"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"散箱","prop":"bulktank"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldbulktank,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.bulktank,_vm.feedOldForm.oldbulktank,'bulktank')}},model:{value:(_vm.feedForm.bulktank),callback:function ($$v) {_vm.$set(_vm.feedForm, "bulktank", $$v)},expression:"feedForm.bulktank"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.bulktank,_vm.feedOldForm.oldbulktank,'bulktank')}},model:{value:(_vm.feedForm.bulktank),callback:function ($$v) {_vm.$set(_vm.feedForm, "bulktank", $$v)},expression:"feedForm.bulktank"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地膠","prop":"toGlue"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtoGlue,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.toGlue,_vm.feedOldForm.oldtoGlue,'toGlue')}},model:{value:(_vm.feedForm.toGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "toGlue", $$v)},expression:"feedForm.toGlue"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.toGlue,_vm.feedOldForm.oldtoGlue,'toGlue')}},model:{value:(_vm.feedForm.toGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "toGlue", $$v)},expression:"feedForm.toGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙","prop":"gummedPaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldgummedPaper,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.gummedPaper,_vm.feedOldForm.oldgummedPaper,'gummedPaper')}},model:{value:(_vm.feedForm.gummedPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "gummedPaper", $$v)},expression:"feedForm.gummedPaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.gummedPaper,_vm.feedOldForm.oldgummedPaper,'gummedPaper')}},model:{value:(_vm.feedForm.gummedPaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "gummedPaper", $$v)},expression:"feedForm.gummedPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"铁笼","prop":"cage"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldcage,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.cage,_vm.feedOldForm.oldcage,'cage')}},model:{value:(_vm.feedForm.cage),callback:function ($$v) {_vm.$set(_vm.feedForm, "cage", $$v)},expression:"feedForm.cage"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.cage,_vm.feedOldForm.oldcage,'cage')}},model:{value:(_vm.feedForm.cage),callback:function ($$v) {_vm.$set(_vm.feedForm, "cage", $$v)},expression:"feedForm.cage"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"夾板(長)","prop":"plywood"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldplywood,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.plywood,_vm.feedOldForm.oldplywood,'plywood')}},model:{value:(_vm.feedForm.plywood),callback:function ($$v) {_vm.$set(_vm.feedForm, "plywood", $$v)},expression:"feedForm.plywood"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.plywood,_vm.feedOldForm.oldplywood,'plywood')}},model:{value:(_vm.feedForm.plywood),callback:function ($$v) {_vm.$set(_vm.feedForm, "plywood", $$v)},expression:"feedForm.plywood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙卡板","prop":"paperCardBoard"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldpaperCardBoard,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.paperCardBoard,_vm.feedOldForm.oldpaperCardBoard,'paperCardBoard')}},model:{value:(_vm.feedForm.paperCardBoard),callback:function ($$v) {_vm.$set(_vm.feedForm, "paperCardBoard", $$v)},expression:"feedForm.paperCardBoard"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.paperCardBoard,_vm.feedOldForm.oldpaperCardBoard,'paperCardBoard')}},model:{value:(_vm.feedForm.paperCardBoard),callback:function ($$v) {_vm.$set(_vm.feedForm, "paperCardBoard", $$v)},expression:"feedForm.paperCardBoard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"開木箱工具","prop":"tool"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtool,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tool,_vm.feedOldForm.oldtool,'tool')}},model:{value:(_vm.feedForm.tool),callback:function ($$v) {_vm.$set(_vm.feedForm, "tool", $$v)},expression:"feedForm.tool"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.tool,_vm.feedOldForm.oldtool,'tool')}},model:{value:(_vm.feedForm.tool),callback:function ($$v) {_vm.$set(_vm.feedForm, "tool", $$v)},expression:"feedForm.tool"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠(110cm)","prop":"glue"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldglue,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.glue,_vm.feedOldForm.oldglue,'glue')}},model:{value:(_vm.feedForm.glue),callback:function ($$v) {_vm.$set(_vm.feedForm, "glue", $$v)},expression:"feedForm.glue"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.glue,_vm.feedOldForm.oldglue,'glue')}},model:{value:(_vm.feedForm.glue),callback:function ($$v) {_vm.$set(_vm.feedForm, "glue", $$v)},expression:"feedForm.glue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"Plasma","prop":"plasma"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldplasma,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.plasma,_vm.feedOldForm.oldplasma,'plasma')}},model:{value:(_vm.feedForm.plasma),callback:function ($$v) {_vm.$set(_vm.feedForm, "plasma", $$v)},expression:"feedForm.plasma"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.plasma,_vm.feedOldForm.oldplasma,'plasma')}},model:{value:(_vm.feedForm.plasma),callback:function ($$v) {_vm.$set(_vm.feedForm, "plasma", $$v)},expression:"feedForm.plasma"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"縐紋紙","prop":"crepePaper"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldcrepePaper,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.crepePaper,_vm.feedOldForm.oldcrepePaper,'crepePaper')}},model:{value:(_vm.feedForm.crepePaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "crepePaper", $$v)},expression:"feedForm.crepePaper"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.crepePaper,_vm.feedOldForm.oldcrepePaper,'crepePaper')}},model:{value:(_vm.feedForm.crepePaper),callback:function ($$v) {_vm.$set(_vm.feedForm, "crepePaper", $$v)},expression:"feedForm.crepePaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"平衣","prop":"flatClothing"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldflatClothing,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.flatClothing,_vm.feedOldForm.oldflatClothing,'flatClothing')}},model:{value:(_vm.feedForm.flatClothing),callback:function ($$v) {_vm.$set(_vm.feedForm, "flatClothing", $$v)},expression:"feedForm.flatClothing"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.flatClothing,_vm.feedOldForm.oldflatClothing,'flatClothing')}},model:{value:(_vm.feedForm.flatClothing),callback:function ($$v) {_vm.$set(_vm.feedForm, "flatClothing", $$v)},expression:"feedForm.flatClothing"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"冰箱","prop":"refrigerator"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldrefrigerator,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.refrigerator,_vm.feedOldForm.oldrefrigerator,'refrigerator')}},model:{value:(_vm.feedForm.refrigerator),callback:function ($$v) {_vm.$set(_vm.feedForm, "refrigerator", $$v)},expression:"feedForm.refrigerator"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.refrigerator,_vm.feedOldForm.oldrefrigerator,'refrigerator')}},model:{value:(_vm.feedForm.refrigerator),callback:function ($$v) {_vm.$set(_vm.feedForm, "refrigerator", $$v)},expression:"feedForm.refrigerator"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"黑色橡筋","prop":"elastic"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldelastic,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.elastic,_vm.feedOldForm.oldelastic,'elastic')}},model:{value:(_vm.feedForm.elastic),callback:function ($$v) {_vm.$set(_vm.feedForm, "elastic", $$v)},expression:"feedForm.elastic"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.elastic,_vm.feedOldForm.oldelastic,'elastic')}},model:{value:(_vm.feedForm.elastic),callback:function ($$v) {_vm.$set(_vm.feedForm, "elastic", $$v)},expression:"feedForm.elastic"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙板","prop":"cardboard"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldcardboard,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.cardboard,_vm.feedOldForm.oldcardboard,'cardboard')}},model:{value:(_vm.feedForm.cardboard),callback:function ($$v) {_vm.$set(_vm.feedForm, "cardboard", $$v)},expression:"feedForm.cardboard"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.cardboard,_vm.feedOldForm.oldcardboard,'cardboard')}},model:{value:(_vm.feedForm.cardboard),callback:function ($$v) {_vm.$set(_vm.feedForm, "cardboard", $$v)},expression:"feedForm.cardboard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("塊")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"企身","prop":"stiff"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldstiff,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.stiff,_vm.feedOldForm.oldstiff,'stiff')}},model:{value:(_vm.feedForm.stiff),callback:function ($$v) {_vm.$set(_vm.feedForm, "stiff", $$v)},expression:"feedForm.stiff"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.stiff,_vm.feedOldForm.oldstiff,'stiff')}},model:{value:(_vm.feedForm.stiff),callback:function ($$v) {_vm.$set(_vm.feedForm, "stiff", $$v)},expression:"feedForm.stiff"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(長)","prop":"lengthFloor"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldlengthFloor,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.lengthFloor,_vm.feedOldForm.oldlengthFloor,'lengthFloor')}},model:{value:(_vm.feedForm.lengthFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "lengthFloor", $$v)},expression:"feedForm.lengthFloor"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.lengthFloor,_vm.feedOldForm.oldlengthFloor,'lengthFloor')}},model:{value:(_vm.feedForm.lengthFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "lengthFloor", $$v)},expression:"feedForm.lengthFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(短)","prop":"shortFloor"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldshortFloor,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.shortFloor,_vm.feedOldForm.oldshortFloor,'shortFloor')}},model:{value:(_vm.feedForm.shortFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortFloor", $$v)},expression:"feedForm.shortFloor"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.shortFloor,_vm.feedOldForm.oldshortFloor,'shortFloor')}},model:{value:(_vm.feedForm.shortFloor),callback:function ($$v) {_vm.$set(_vm.feedForm, "shortFloor", $$v)},expression:"feedForm.shortFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"吊繩","prop":"theWire"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtheWire,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.theWire,_vm.feedOldForm.oldtheWire,'theWire')}},model:{value:(_vm.feedForm.theWire),callback:function ($$v) {_vm.$set(_vm.feedForm, "theWire", $$v)},expression:"feedForm.theWire"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.theWire,_vm.feedOldForm.oldtheWire,'theWire')}},model:{value:(_vm.feedForm.theWire),callback:function ($$v) {_vm.$set(_vm.feedForm, "theWire", $$v)},expression:"feedForm.theWire"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"滑潤","prop":"smooth"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldsmooth,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.smooth,_vm.feedOldForm.oldsmooth,'smooth')}},model:{value:(_vm.feedForm.smooth),callback:function ($$v) {_vm.$set(_vm.feedForm, "smooth", $$v)},expression:"feedForm.smooth"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.smooth,_vm.feedOldForm.oldsmooth,'smooth')}},model:{value:(_vm.feedForm.smooth),callback:function ($$v) {_vm.$set(_vm.feedForm, "smooth", $$v)},expression:"feedForm.smooth"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"膠(120cm)","prop":"oneGlue"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoneGlue,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneGlue,_vm.feedOldForm.oldoneGlue,'oneGlue')}},model:{value:(_vm.feedForm.oneGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneGlue", $$v)},expression:"feedForm.oneGlue"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneGlue,_vm.feedOldForm.oldoneGlue,'oneGlue')}},model:{value:(_vm.feedForm.oneGlue),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneGlue", $$v)},expression:"feedForm.oneGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(新)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(舊)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"梳化套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"床褥套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"白水松："}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新大","prop":"big"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.agedbig,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.big,_vm.feedOldForm.agedbig,'big')}},model:{value:(_vm.feedForm.big),callback:function ($$v) {_vm.$set(_vm.feedForm, "big", $$v)},expression:"feedForm.big"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.big,_vm.feedOldForm.agedbig,'big')}},model:{value:(_vm.feedForm.big),callback:function ($$v) {_vm.$set(_vm.feedForm, "big", $$v)},expression:"feedForm.big"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊大","prop":"oldBig"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoldBig,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldBig,_vm.feedOldForm.oldoldBig,'oldBig')}},model:{value:(_vm.feedForm.oldBig),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldBig", $$v)},expression:"feedForm.oldBig"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldBig,_vm.feedOldForm.oldoldBig,'oldBig')}},model:{value:(_vm.feedForm.oldBig),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldBig", $$v)},expression:"feedForm.oldBig"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3座位","prop":"threeSeats"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldthreeSeats,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.threeSeats,_vm.feedOldForm.oldthreeSeats,'threeSeats')}},model:{value:(_vm.feedForm.threeSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeSeats", $$v)},expression:"feedForm.threeSeats"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.threeSeats,_vm.feedOldForm.oldthreeSeats,'threeSeats')}},model:{value:(_vm.feedForm.threeSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeSeats", $$v)},expression:"feedForm.threeSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"6呎","prop":"sixRuler"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldsixRuler,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.sixRuler,_vm.feedOldForm.oldsixRuler,'sixRuler')}},model:{value:(_vm.feedForm.sixRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "sixRuler", $$v)},expression:"feedForm.sixRuler"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.sixRuler,_vm.feedOldForm.oldsixRuler,'sixRuler')}},model:{value:(_vm.feedForm.sixRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "sixRuler", $$v)},expression:"feedForm.sixRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"1吋","prop":"oneSmall"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoneSmall,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneSmall,_vm.feedOldForm.oldoneSmall,'oneSmall')}},model:{value:(_vm.feedForm.oneSmall),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSmall", $$v)},expression:"feedForm.oneSmall"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneSmall,_vm.feedOldForm.oldoneSmall,'oneSmall')}},model:{value:(_vm.feedForm.oneSmall),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSmall", $$v)},expression:"feedForm.oneSmall"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新中","prop":"inthe"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.agedinthe,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.inthe,_vm.feedOldForm.agedinthe,'inthe')}},model:{value:(_vm.feedForm.inthe),callback:function ($$v) {_vm.$set(_vm.feedForm, "inthe", $$v)},expression:"feedForm.inthe"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.inthe,_vm.feedOldForm.agedinthe,'inthe')}},model:{value:(_vm.feedForm.inthe),callback:function ($$v) {_vm.$set(_vm.feedForm, "inthe", $$v)},expression:"feedForm.inthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊中","prop":"oldInthe"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoldInthe,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldInthe,_vm.feedOldForm.oldoldInthe,'oldInthe')}},model:{value:(_vm.feedForm.oldInthe),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldInthe", $$v)},expression:"feedForm.oldInthe"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldInthe,_vm.feedOldForm.oldoldInthe,'oldInthe')}},model:{value:(_vm.feedForm.oldInthe),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldInthe", $$v)},expression:"feedForm.oldInthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"2座位","prop":"twoSeats"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldtwoSeats,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.twoSeats,_vm.feedOldForm.oldtwoSeats,'twoSeats')}},model:{value:(_vm.feedForm.twoSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "twoSeats", $$v)},expression:"feedForm.twoSeats"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.twoSeats,_vm.feedOldForm.oldtwoSeats,'twoSeats')}},model:{value:(_vm.feedForm.twoSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "twoSeats", $$v)},expression:"feedForm.twoSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"5呎","prop":"fiveRuler"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldfiveRuler,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fiveRuler,_vm.feedOldForm.oldfiveRuler,'fiveRuler')}},model:{value:(_vm.feedForm.fiveRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fiveRuler", $$v)},expression:"feedForm.fiveRuler"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fiveRuler,_vm.feedOldForm.oldfiveRuler,'fiveRuler')}},model:{value:(_vm.feedForm.fiveRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fiveRuler", $$v)},expression:"feedForm.fiveRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"半吋","prop":"small"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldsmall,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.small,_vm.feedOldForm.oldsmall,'small')}},model:{value:(_vm.feedForm.small),callback:function ($$v) {_vm.$set(_vm.feedForm, "small", $$v)},expression:"feedForm.small"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.small,_vm.feedOldForm.oldsmall,'small')}},model:{value:(_vm.feedForm.small),callback:function ($$v) {_vm.$set(_vm.feedForm, "small", $$v)},expression:"feedForm.small"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新細","prop":"fine"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.agedfine,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fine,_vm.feedOldForm.agedfine,'fine')}},model:{value:(_vm.feedForm.fine),callback:function ($$v) {_vm.$set(_vm.feedForm, "fine", $$v)},expression:"feedForm.fine"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fine,_vm.feedOldForm.agedfine,'fine')}},model:{value:(_vm.feedForm.fine),callback:function ($$v) {_vm.$set(_vm.feedForm, "fine", $$v)},expression:"feedForm.fine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊細","prop":"oldFine"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoldFine,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldFine,_vm.feedOldForm.oldoldFine,'oldFine')}},model:{value:(_vm.feedForm.oldFine),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldFine", $$v)},expression:"feedForm.oldFine"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oldFine,_vm.feedOldForm.oldoldFine,'oldFine')}},model:{value:(_vm.feedForm.oldFine),callback:function ($$v) {_vm.$set(_vm.feedForm, "oldFine", $$v)},expression:"feedForm.oldFine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"1座位","prop":"oneSeats"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldoneSeats,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneSeats,_vm.feedOldForm.oldoneSeats,'oneSeats')}},model:{value:(_vm.feedForm.oneSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSeats", $$v)},expression:"feedForm.oneSeats"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.oneSeats,_vm.feedOldForm.oldoneSeats,'oneSeats')}},model:{value:(_vm.feedForm.oneSeats),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneSeats", $$v)},expression:"feedForm.oneSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"4呎","prop":"fourRuler"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldfourRuler,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fourRuler,_vm.feedOldForm.oldfourRuler,'fourRuler')}},model:{value:(_vm.feedForm.fourRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fourRuler", $$v)},expression:"feedForm.fourRuler"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.fourRuler,_vm.feedOldForm.oldfourRuler,'fourRuler')}},model:{value:(_vm.feedForm.fourRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "fourRuler", $$v)},expression:"feedForm.fourRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3呎","prop":"threeRuler"}},[(_vm.feedForm.status!=1)?_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":_vm.feedOldForm.oldthreeRuler,"clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.threeRuler,_vm.feedOldForm.oldthreeRuler,'threeRuler')}},model:{value:(_vm.feedForm.threeRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeRuler", $$v)},expression:"feedForm.threeRuler"}}):_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateChange(_vm.feedForm.threeRuler,_vm.feedOldForm.oldthreeRuler,'threeRuler')}},model:{value:(_vm.feedForm.threeRuler),callback:function ($$v) {_vm.$set(_vm.feedForm, "threeRuler", $$v)},expression:"feedForm.threeRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"其他：","prop":"oneOther"}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.feedForm.oneOther),callback:function ($$v) {_vm.$set(_vm.feedForm, "oneOther", $$v)},expression:"feedForm.oneOther"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"送盒："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.feedForm.sendBox),callback:function ($$v) {_vm.$set(_vm.feedForm, "sendBox", $$v)},expression:"feedForm.sendBox"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"內部備註："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.feedForm.internal),callback:function ($$v) {_vm.$set(_vm.feedForm, "internal", $$v)},expression:"feedForm.internal"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"40px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[(_vm.feedForm.status==0 && _vm.canImport)?_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(this.loadingSave),expression:"this.loadingSave"}],staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.feedSave(1)}}},[_vm._v("確認入倉")]):_vm._e(),_vm._v(" "),(_vm.feedForm.status==0)?_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(this.loadingSave),expression:"this.loadingSave"}],staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.feedSave(0)}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),(_vm.feedForm.status==1)?_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.updateFeedSave()}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TKq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/rollAdd'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.t_newRolling')))]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getFeedBackList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"車號"}},[_c('el-input',{attrs:{"placeholder":"車號","clearable":""},model:{value:(_vm.serchCarNumber),callback:function ($$v) {_vm.serchCarNumber=$$v},expression:"serchCarNumber"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"date","placeholder":"選擇日期"},model:{value:(_vm.getFeedDate),callback:function ($$v) {_vm.getFeedDate=$$v},expression:"getFeedDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"狀態","clearable":""},model:{value:(_vm.serchStatus),callback:function ($$v) {_vm.serchStatus=$$v},expression:"serchStatus"}},[_c('el-option',{attrs:{"value":"0","label":"未出倉"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"1","label":"已出倉"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getFeedBackList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.rollingList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"feedDate","align":"left","width":"110","label":_vm.$t('m.t_date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.feedDate!=0 && scope.row.feedDate!='' && scope.row.feedDate!=null)?[_vm._v("\n                    "+_vm._s(_vm._f("date")(scope.row.feedDate*1000,'%Y-%m-%d'))+"\n                ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carNumber","align":"left","width":"140","label":"車號"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"internal","align":"left","label":"內部備註"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"outDate","align":"left","width":"140","label":"出倉時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.outDate!=0 && scope.row.outDate!='' && scope.row.outDate!=null)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.outDate*1000,'%Y-%m-%d %H:%M'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"outBy","align":"left","width":"100","label":"出倉人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storageDate","align":"left","width":"140","label":"入倉時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.storageDate!=0 && scope.row.storageDate!='' && scope.row.storageDate!=null)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.storageDate*1000,'%Y-%m-%d %H:%M'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storageBy","align":"left","width":"100","label":"入倉人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","align":"left","width":"80","label":"狀態"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status==0)?[_vm._v("\n                        未出倉\n                    ")]:_vm._e(),_vm._v(" "),(scope.row.status==1)?[(scope.row.feeStatus==0)?[_vm._v("\n                            已出倉\n                        ")]:_vm._e(),_vm._v(" "),(scope.row.feeStatus==1)?[_vm._v("\n                            已入倉\n                        ")]:_vm._e()]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit && scope.row.status==0)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.rollingEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(_vm.canDelete && scope.row.status==0)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.deleteEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("刪除")]):_vm._e(),_vm._v(" "),(_vm.canEdit && scope.row.status==1)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.rollingEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("查看出倉")]):_vm._e(),_vm._v(" "),(_vm.canIn &&scope.row.status==1 && scope.row.feeStatus==0)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.feedEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("入倉")]):_vm._e(),_vm._v(" "),(_vm.canIn && scope.row.status==1 && scope.row.feeStatus==1)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.feedEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("查看入倉")]):_vm._e(),_vm._v(" "),(_vm.canPdf)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pdfDownload(scope.row)}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("PDF")]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TSgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateJobOrder_vue__ = __webpack_require__("03R4");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ba9e3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateJobOrder_vue__ = __webpack_require__("MaJn");
function injectStyle (ssrContext) {
  __webpack_require__("AT53")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateJobOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24ba9e3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateJobOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TwiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"container"},[_c('el-col',{staticClass:"header",attrs:{"span":24}},[_c('el-col',{staticClass:"logo",attrs:{"span":6}},[_c('img',{staticStyle:{"margin-left":"-20px","width":"153px"},attrs:{"src":__webpack_require__("JC9h")}}),_vm._v("\n        "+_vm._s(_vm.$store.getters.collapsed?_vm.sysName:"")+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mob_ser",class:{ active: _vm.isActive, activeTwo: _vm.isActiveTwo }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchs),expression:"searchs"}],staticClass:"inp_sech inp_sech2",attrs:{"type":"text","placeholder":"search..."},domProps:{"value":(_vm.searchs)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchs=$event.target.value}}}),_c('button',{staticClass:"ss_btn",on:{"click":_vm.search}},[_vm._v("搜索")])]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[(_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"tools"},[_c('el-dropdown',{attrs:{"trigger":"click"}},[_c('span',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"fa fa-align-justify fa-lg el-dropdown-link"})]),_vm._v(" "),_c('el-dropdown-menu',{staticStyle:{"margin-top":"-1.5%"},attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.tapClick(1)}}},[_vm._v("倉庫一覽")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.tapClick(2)}}},[_vm._v("客戶")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.tapClick(3)}}},[_vm._v("行事曆")])],1)],1)],1):_vm._e()]),_vm._v(" "),(!_vm.$store.getters.ismobilePhone)?_c('div',{attrs:{"id":"admin_font"}},[_c('el-dropdown',{attrs:{"trigger":"click"}},[(_vm.$store.getters.ismobilePhone)?[_c('span',{staticClass:"el-dropdown-link userinfo-inner"},[_c('i',{staticClass:"fa fa-user-o none"}),_vm._v(" "+_vm._s(_vm.staff.name))])]:[_c('span',{staticStyle:{"margin-right":"40px"}},[_c('i',{staticClass:"fa fa-user-o none"}),_vm._v(" "+_vm._s(_vm.staff.name))])],_vm._v(" "),_c('el-dropdown-menu',{staticStyle:{"margin-top":"-1.5%"},attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){return _vm.updpwd.apply(null, arguments)}}},[_vm._v("修改密碼")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_vm._v("退出登錄")])],1)],2)],1):_vm._e(),_vm._v(" "),(!_vm.$store.getters.ismobilePhone)?_c('div',[_vm._l((_vm.tabs),function(tab){return [_c('span',{staticStyle:{"margin-right":"10px","display":"inline-block","position":"relative"}},[_c('el-button',{attrs:{"size":"medium","type":_vm.$route.name==tab.name?'primary':'info'},on:{"click":function($event){return _vm.toTab(tab)}}},[_vm._v(_vm._s(tab.name))]),_vm._v(" "),(tab.name!=_vm.indexTabName)?_c('img',{staticStyle:{"width":"12px","height":"12px","position":"absolute","right":"-5px","top":"19px","color":"red"},attrs:{"src":__webpack_require__("t/RC")},on:{"click":function($event){return _vm.colseTab(tab.name)}}}):_vm._e()],1)]})],2):_vm._e(),_vm._v(" "),_c('el-col',{staticClass:"topmenu",attrs:{"span":16}},[(_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"el-dropdown"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchs),expression:"searchs"}],staticClass:"inp_sech none",staticStyle:{"position":"relative"},attrs:{"type":"text","placeholder":"search..."},domProps:{"value":(_vm.searchs)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchs=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{attrs:{"id":"phoneAdmin_font"}},[_c('el-dropdown',{attrs:{"trigger":"click"}},[[_c('span',{staticClass:"el-dropdown-link userinfo-inner"},[_c('i',{staticClass:"fa fa-user-o none"}),_vm._v(" "+_vm._s(_vm.staff.name)),_c('i',{staticClass:"el-icon-arrow-down"})])],_vm._v(" "),_c('el-dropdown-menu',{staticStyle:{"margin-top":"-20px","margin-left":"-130px"},attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){return _vm.updpwd.apply(null, arguments)}}},[_vm._v("修改密碼")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_vm._v("退出登錄")])],1)],2)],1):_vm._e()])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改密碼","visible":_vm.dialogFormVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"homeForm",attrs:{"model":_vm.homeForm,"size":"small","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"輸入新密碼","prop":"password"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","widht":"160px","placeholder":"請輸入新密碼"},model:{value:(_vm.homeForm.password),callback:function ($$v) {_vm.$set(_vm.homeForm, "password", $$v)},expression:"homeForm.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"確認新密碼","label-width":"120px","prop":"confirmPassword"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","widht":"160px","placeholder":"請確認新密碼"},model:{value:(_vm.homeForm.confirmPassword),callback:function ($$v) {_vm.$set(_vm.homeForm, "confirmPassword", $$v)},expression:"homeForm.confirmPassword"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","plain":""},on:{"click":function($event){return _vm.modifyStaffPassword(_vm.homeForm)}}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-delete","plain":""},on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")])],1)],1)],1),_vm._v(" "),_c('el-col',{staticClass:"main",attrs:{"span":24}},[_c('aside',{class:_vm.collapsed?'menu-collapsed':'menu-expanded'},[_c('el-menu',{attrs:{"background-color":"#4B78FF","text-color":"#fff","default-active":_vm.onRoutes,"unique-opened":"","router":"","collapse":_vm.$store.getters.ismobilePhone==false?_vm.collapsed:false},on:{"open":_vm.handleopen,"close":_vm.handleclose,"select":_vm.handleselect}},[(!_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"homeGlance",on:{"click":function($event){return _vm.tapClick(1)}}},[_c('div',{staticStyle:{"width":"70px","margin-left":"71px","padding-top":"10px"}},[_vm._v("倉庫一覽")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"50px","margin-top":"-18px"}},[_c('img',{attrs:{"src":__webpack_require__("N0R7")}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.$router.options.routes),function(router,i){return (router.id&&!_vm.$store.getters.ismobilePhone&&router.id!=15)?_c('el-submenu',{key:router.id,staticClass:"elmenu",attrs:{"index":i.toString()}},[_c('template',{slot:"title"},[_c('img',{staticStyle:{"margin-left":"-5px"},attrs:{"src":'../../img/menuicon/'+router.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(router.name))])]),_vm._v(" "),_vm._l((router.children),function(childrens){return (childrens.id!=25)?_c('el-menu-item',{key:childrens.id,staticStyle:{"border":"0px","background-color":"#436DE2","font-size":"12rpx","width":"100%"},attrs:{"index":childrens.path.toString()}},[_vm._v(_vm._s(childrens.name))]):_vm._e()})],2):_vm._e()})],2)],1),_vm._v(" "),_c('section',{staticClass:"content-container"},[_c('div',{staticClass:"grid-content bg-purple-light"},[_c('el-col',{staticClass:"content-wrapper",attrs:{"span":24}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',{attrs:{"exclude":"pro-mail-add-edit"}},[_c('router-view')],1)],1)],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LazyLoading__ = __webpack_require__("Quy2");



/* harmony default export */ __webpack_exports__["a"] = (function (routers, data) {
  //这里之所以要重新遍历一下，是因为，通常我们动态路由的时候，是获取服务端数据，这个component属性是一个字符串，或者可能连字段名都是其他的key
  //所以这里要做一些转换
  parseMenu(routers, data);
});
function parseMenu(routers, data) {
  data.forEach(function (item) {
    var menu = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
    menu.component = Object(__WEBPACK_IMPORTED_MODULE_1__LazyLoading__["a" /* default */])(menu.component);
    if (item.children && item.children.length > 0) {
      menu.children = [];
      parseMenu(menu.children, item.children);
    }
    routers.push(menu);
  });
}

/***/ }),

/***/ "UOlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_router__ = __webpack_require__("JU1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Role__ = __webpack_require__("8pc/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_MenuUtil__ = __webpack_require__("UFO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MenuTree__ = __webpack_require__("yNJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        //            var evt = "onorientationchange" in window ? "orientationchange" : "resize"
        //            window.addEventListener(evt, function(){
        //                alert(1);
        //            },false);


        var checkPwd2 = function checkPwd2(rule, value, callback) {
            if (value === '') {
                callback(new Error("新密碼不能為空"));
            } else if (value.length < 6 || value.length > 20) {
                callback(new Error("新密碼長度在6至20位之間"));
            } else if (value !== _this.homeForm.password) {
                callback(new Error("兩次輸入密碼不一致"));
            } else {
                callback();
            }
        };
        return {
            windowWidth: 0,
            isActive: false,
            isActiveTwo: true,
            sysName: 'ROYAL',
            collapsed: false,
            colseTabid: -1, //关闭tabid
            logBg: true,
            dialogTableVisible: false,
            dialogFormVisible: false,
            conFirmPlaceholder: "",
            searchs: null,
            placeholder: "",
            indexTabName: "倉庫一覽",

            homeForm: {
                region: '',
                delivery: false,
                resource: '',
                desc: '',
                password: '',
                confirmPassword: ''
            }

        };
    },

    components: {
        MenuTree: __WEBPACK_IMPORTED_MODULE_3__components_MenuTree__["a" /* default */]
    },

    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
    },

    methods: {
        getWindowWidth: function getWindowWidth(event) {
            if (document.body.clientWidth < 813) {
                this.$store.commit("setIsmobilePhone", true);
            } else {
                this.$store.commit("setIsmobilePhone", false);
            }
        },
        search: function search() {
            this.isActive = false;
            this.isActiveTwo = true;
            //            location.href = "/location/locationByXY";
            this.$store.commit("setKeywords", this.searchs);
            //                this.$store.commit("setSearchSte",true);
            this.$router.push({
                name: '首頁搜尋網頁面',
                params: {
                    keywords: this.searchs
                }
            });
        },
        tapClick: function tapClick(i) {
            // console.log("etetert");
            if (i == 1) {
                this.$router.push({
                    name: '倉庫一覽'
                });
            } else if (i == 2) {
                this.$router.push({
                    name: '客戶'
                });
            } else {
                this.$router.push({
                    name: '行事曆'
                });
            }
        },
        logClick: function logClick() {
            //this.$router.push('/');
            this.$store.commit("setSta", false);
            this.$store.commit("setIsLoding", true);
            this.$router.push({
                name: '倉庫一覽'
            });
        },
        colseTab: function colseTab(name) {
            // 	console.log(1234);
            // console.log(i);
            var i = this.tabs.findIndex(function (item) {
                return item.name == name;
            });
            this.colseTabid = i;

            this.$store.commit("closeTab", name);
        },
        toTab: function toTab(value) {
            // if(value.name!=this.$route.name)
            // {

            this.$router.push(value.url);

            this.$store.commit("setterClickTab", value.name);
            //}
            // this.selectTabName=value.name;
        },
        onSubmit: function onSubmit() {
            //        console.log('submit!');
        },
        handleopen: function handleopen() {
            console.log('handleopen');
        },
        handleclose: function handleclose() {
            console.log('handleclose');
        },
        handleselect: function handleselect(path, i) {
            console.log('handleselect');
            //选中子菜單，隐藏导航
            this.collapsed = false;
            this.colseTabid = -1;
            // console.log(path);
        },
        logout: function logout() {
            var _this2 = this;

            this.$confirm('是否退出', '提示', {
                type: 'warning'
            }).then(function () {
                //          console.log(router);
                var staffId = _this2.$store.getters.staff.id;
                Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["Y" /* getLogout */])(staffId).then(function (data) {
                    window.sessionStorage.removeItem("staff");
                    _this2.$router.options.routes.splice(2, __WEBPACK_IMPORTED_MODULE_0__router_router__["a" /* default */].options.routes.length - 2);
                    _this2.$router.push('/login');
                });
            }).catch(function () {});
        },
        updpwd: function updpwd() {
            this.homeForm.password = '';
            this.homeForm.confirmPassword = '';
            this.dialogFormVisible = true;
        },
        mobSer: function mobSer() {

            if (this.isActive == true && this.isActiveTwo == false) {
                this.isActive = false;
                this.isActiveTwo = true;
            } else if (this.isActiveTwo == true && this.isActive == false) {
                this.isActive = true;
                this.isActiveTwo = false;
            }
            this.$store.commit("setCollapsed", false);
        },

        //折疊巡覽列
        collapse: function collapse() {
            this.collapsed = !this.collapsed;

            // if (this.collapsed){
            //     this.logBg=false;
            // }else {
            //     this.logBg=true;
            // }
            /* this.collapsed=!this.collapsed;
              if(this.$store.getters.collapsed == false){
                  this.$store.commit("setCollapsed",true);
              }else{
                  this.$store.commit("setCollapsed",false);
              }*/

            this.isActive = false;
            this.isActiveTwo = true;
            //                if (this.collapsed){
            //                    this.logBg=false;
            //                }else {
            //                    this.logBg=true;
            //                }
        },

        //修改密碼
        modifyStaffPassword: function modifyStaffPassword(formName) {
            var _this3 = this;

            var str = this.isNull();
            if (str !== "") {
                this.dialogVisible = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                this.$refs.homeForm.validate(function (valid) {
                    if (valid) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4__api_api__["_57" /* modifyStaffPassword */])(_this3.homeForm.password).then(function (data) {
                            var _data$data = data.data,
                                res = _data$data === undefined ? {} : _data$data;

                            if (res.errcode == 200) {
                                _this3.$message({
                                    message: "修改成功",
                                    type: 'success'
                                });
                                _this3.dialogFormVisible = false;
                                _this3.homeForm.password = '';
                                _this3.homeForm.confirmPassword = '';
                            } else {
                                _this3.$message({
                                    message: "修改失敗",
                                    type: 'warning'
                                });
                            }
                        });
                    }
                });
            }
        },
        isNull: function isNull() {
            /*是否为空*/
            if (this.homeForm.password === "" || this.homeForm.password === null) {
                return "請輸入新密碼";
            }
            if (this.homeForm.password.length < 6 || this.homeForm.password.length > 20) {
                return "輸入新密碼長度在6至20之間";
            }
            if (this.homeForm.confirmPassword === "" || this.homeForm.confirmPassword === null) {
                return "請確認新密碼";
            }
            if (this.homeForm.confirmPassword.length < 6 || this.homeForm.confirmPassword.length > 20) {
                return "確認密碼長度在6至20之間";
            }
            if (this.homeForm.password !== this.homeForm.confirmPassword) {
                return "兩次輸入密碼不一致";
            }
            return "";
        }
    },
    computed: {
        valDataType: function valDataType() {
            return document.body.clientWidth;
        },
        staff: function staff() {
            return this.$store.getters.staff;
        },
        routes: function routes() {
            console.log("routes", this.$router.options.routes);
            return this.$router.options.routes;
        },
        tabs: function tabs() {

            return this.$store.getters.tabs;
        },
        onRoutes: function onRoutes() {

            if (this.colseTabid == -1 || this.colseTabid == 0) {
                // console.log("tabs22222",this.$route.name)
                //  console.log("tabs444",this.selectTabName)
                this.$store.commit("addTab", { name: this.$route.name, url: this.$route.path });
                this.$store.commit("setterClickTab", this.$route.name);
                return "/" + this.$route.path;
            } else {

                this.$router.push({
                    name: this.tabs[this.tabs.length - 1].name

                });
                //  this.$store.commit("addTab",{name:this.tabs[this.tabs.length-1].name,url:this.tabs[this.tabs.length-1].url});
                // this.$store.commit("setterClickTab",this.tabs[this.tabs.length-1].name);
                //  console.log("tabs333",this.tabs[this.tabs.length-1].url)
                // return "/"+this.tabs[this.tabs.length-1].url;  
            }
            // else
            // {

            //  this.$store.commit("addTab",{name:this.tabs[this.tabs.length-1],url:this.tabs.path});
            //  this.$store.commit("setterClickTab",this.tabs.name);
            //  return "/"+this.tabs.path; 
            // }

        }
    },
    created: function created() {
        /* console.log("============>>created");*/
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        /*console.log("============>>beforeRouteEnter");*/
        next();
    },
    beforeMount: function beforeMount() {
        /*console.log("============>>beforeMount");*/
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            window.addEventListener('resize', this.getWindowWidth);
            //Init
            this.getWindowWidth();
        });
        if (document.body.clientWidth < 813) {
            this.$store.commit("setIsmobilePhone", true);
        } else {
            this.$store.commit("setIsmobilePhone", false);
        }
        this.logClick();
    }
});

/***/ }),

/***/ "VTPv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vb2S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XAhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xx/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {
            volumeDisabled: false,
            dialogVisible: false,
            dialogForm: {},
            curIndex: null,
            options4: [],
            options: [],
            list: [],
            tableloading: false,
            show: true,
            add: false,
            addStorOn: false,
            cId: 0,
            storDateId: 0, //當前已出倉的日期表id
            storOnCustomerList: [],
            customerCode: {},
            storOnList: [],
            addStorOnList: [],
            codeList: [],
            codeInList: [], //入庫單號
            addstorOnList: [],
            rkCont: true, //入庫和客戶資訊
            addStorOnMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
            createDate: "", //時間
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            form: {
                id: null,
                sCode: null,
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false
            },
            searchStorOn: '',
            searchName: '',
            searchSalesId: '',
            custSalesList: [],
            typeId: 1,
            custId: 0
        };
    },
    mounted: function mounted() {},

    methods: {
        handleAll: function handleAll(val) {
            if (val == 1) {
                this.dialogForm.volume = this.dialogForm.remainingVolume;
                this.volumeDisabled = true;
                var sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100);
                this.dialogForm.amount = sum / 100;
            }
            if (val == 0) {
                this.dialogForm.volume = null;
                this.volumeDisabled = false;
                this.dialogForm.amount = null;
            }
            if (val == 4) {
                this.volumeDisabled = false;
            }
            this.$forceUpdate();
        },
        formatCurrency: function formatCurrency(amount) {
            var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (!amount) return;
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: decimalPlaces
            });
            return '' + formatter.format(amount);
        },
        handleBlurVolume: function handleBlurVolume() {
            var value = Number(this.dialogForm.volume);
            var regex = /^(0|[1-9][0-9]*)$/;
            var message = '請輸入大於0等于0的整數';
            if (this.dialogForm.unitVolume == '3') {
                regex = /^(([1-9][0-9]{0,2}(,\\d{3})*)|0)(\.\d{1,2})?$/;
                message = '请输入大于等于零最多两位小数的数字';
            } else {
                regex = /^(0|[1-9][0-9]*)$/;
                message = '請輸入大於0等于0的整數';
            }
            if (!regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: message });
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
                this.$forceUpdate();
                return;
            }
            if (value > Number(this.dialogForm.remainingVolume)) {
                this.$message({ type: 'warning', message: '出倉體積不能大於剩餘體積' });
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
                this.$forceUpdate();
                return;
            }

            var sum = Math.ceil(Number(this.dialogForm.unitPrice || 0) * Number(this.dialogForm.volume) * 100);
            this.dialogForm.amount = sum / 100;
            this.$forceUpdate();
        },
        updateSelSotrOut: function updateSelSotrOut(row) {
            this.$router.push({
                name: '編輯出倉',
                params: {
                    id: row.id,
                    typeId: 1,
                    custId: 0
                }
            });
            var path = "/updatesStockout/" + row.id + "/" + 1;
            this.$router.push(path);
        },
        printing: function printing(item) {
            /*打印*/
            if (item !== null) {
                var url = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.baseURL + "/getPrintingList?custId=" + item.cid + "&storOnDateId=" + item.storDateId + "&token=" + this.$store.getters.staff.token;
                window.location.href = url;
            }
        },
        storOn: function storOn(stor) {
            var _this = this;

            /*確定真的出倉了*/
            var params = { storOnItemList: stor.storOnItem };
            this.$confirm('確定是否出倉? ', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_29" /* getStorOnOkList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode === 200) {
                        _this.$message({
                            message: '出倉成功',
                            type: 'success'
                        });
                        _this.getStockOutParams();
                        //this.cancelAdd();
                        //this.getStorOnList();
                    }
                });
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            if (this.typeId == 2) {
                this.$router.push({
                    name: '客戶詳情',
                    params: {
                        id: this.custId
                    }
                });
                this.$store.commit("closeTab", 'updatesStockout');
            } else {
                this.$router.push({
                    name: '出倉',
                    params: { str: new Date().getTime() }
                });
                this.$store.commit("closeTab", 'updatesStockout');
            }
        },
        getCodeList: function getCodeList() {
            var _this2 = this;

            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_24" /* getStorOnCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    _this2.codeList = res.data;
                }
            });
        },
        remoteMethod: function remoteMethod(query) {
            var _this3 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.options4 = _this3.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodIn: function remoteMethodIn(query) {
            var _this4 = this;

            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this4.loading = false;
                    _this4.options = _this4.codeInList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        handleCurrentChange: function handleCurrentChange() {
            /*分頁*/
            this.getStorOnList();
        },
        selSotrOn: function selSotrOn(id, typeId, custId) {
            var _this5 = this;

            /*查詢出倉詳情*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerOnSte", false);
            this.add = true;
            this.show = false;
            this.rkCont = false;
            this.typeId = typeId;
            this.custId = custId;
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_25" /* getStorOnItemStorinIdBy */])(id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                    var storDateId = null;
                    res.data.forEach(function (item, i) {
                        //重新處理下資料
                        if (i === 0) {
                            _this5.createDate = new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm");
                        }
                        _this5.storDateId = item.storDateId;
                        var itemList = {};
                        var floor = void 0;_this5.cId = item.cId;
                        floor = item.name;
                        if (new Date(new Date(item.createDate * 1000)).toDateString() !== new Date().toDateString()) {
                            var _itemList;

                            //是否是當天時間 不是當天的時間不能修改
                            itemList = (_itemList = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId, quantity: item.quantity, volume: item.volume, amount: item.amount, unitVolume: item.unitVolume, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList, 'unitVolume', item.unitVolume), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList, 'unitPrice', item.unitPrice), _itemList);
                        } else {
                            var _itemList2;

                            itemList = (_itemList2 = { storInItemId: item.storInItemId, cid: item.cId, satae: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty,
                                locationId: item.locationId, value: floor, storDateId: item.storDateId, quantity: item.quantity, volume: item.volume, amount: item.amount, unitVolume: item.unitVolume, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList2, 'unitVolume', item.unitVolume), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList2, 'unitPrice', item.unitPrice), _itemList2);
                        }
                        if (!sotrOnMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { id: item.id, state: item.state, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                            sotrOnMap.set(item.storDateId, storIdItemList);
                        } else {
                            sotrOnMap.get(item.storDateId).storOnItem.push(itemList);
                        }
                        // sotrOnMap.set(item.id,itemList)
                    });
                    _this5.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    //console.log( this.storOnList);
                    _this5.selCustimerId(_this5.storDateId); //查詢客戶id
                    _this5.form.codeShow = true;
                    _this5.form.sCodeShow = true;
                    _this5.form.nameShow = true;
                    _this5.form.phoneShow = true;
                    _this5.form.addressShow = true;
                    _this5.form.salesShow = true;
                }
            });

            //				getPrintingListByStorDateId(32).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //				});
            //
            //                getPrintingList({custId:30,storOnDateId:32}).then( data =>{
            //                    let {data:res={}}=data;
            //                    console.log("res",res);
            //                })
        },
        selCustimerId: function selCustimerId(id) {
            var _this6 = this;

            /*查詢客戶ID*/
            //console.log("id",id)
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_27" /* getStorOnListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;

                if (res.data != null) {
                    if (res.errcode === 200) {
                        var _res$data$customer = res.data.customer,
                            _id = _res$data$customer.id,
                            code = _res$data$customer.code,
                            name = _res$data$customer.name,
                            phone = _res$data$customer.phone,
                            address = _res$data$customer.address,
                            sales = _res$data$customer.sales,
                            createDate = _res$data$customer.createDate;

                        _this6.form.id = _id;
                        _this6.form.code = code;
                        _this6.form.name = name;
                        _this6.form.address = address;
                        _this6.form.phone = phone;
                        _this6.form.sales = sales;
                        _this6.form.createDate = new Date(createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this6.form.sCode = res.data.scode;
                    }
                }
            });
        },
        getStorOnList: function getStorOnList() {
            var _this7 = this;

            /*查詢入庫*/
            this.getCodeList();
            this.tableloading = true;
            this.rkCont = true;
            var params = { page: this.pager.page, size: this.pager.size, storOn: this.searchStorOn, custName: this.searchName, salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_26" /* getStorOnList */])(params).then(function (data) {
                var _data$data5 = data.data,
                    res = _data$data5 === undefined ? {} : _data$data5;
                //console.log("res",res)

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this7.storOnCustomerList = items;
                    _this7.storOnCustomerList.forEach(function (a, b) {
                        a.storInDate = new Date(a.onDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this7.$set(_this7.storOnCustomerList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this7.pager.total = total;
                    _this7.pager.page = page;
                    _this7.pager.size = size;
                    _this7.tableloading = false;
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.getInCodeList();
        },
        cancelAdd: function cancelAdd() {
            this.add = false;
            this.show = true;
            this.addStorOn = false;
            this.nullList();
        },
        handleSelect: function handleSelect(cid) {
            var _this8 = this;

            /*選擇出倉后*/
            var str = [];
            if (cid === null || cid === undefined) {
                this.addStorOn = true;
                cid = this.cId;
            } else {
                str = cid.split(',');
                cid = str[0];
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["D" /* getCustomerById */])(cid).then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                if (res.errcode === 200) {
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this8.form.id = id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = sales;
                    var codeId = _this8.form.sCode.split(',');
                    if (codeId[1] !== undefined) {
                        //確定codeID中是否有值
                        code = codeId[1];
                    } else {
                        code = _this8.form.sCode;
                    }
                    var params = { page: _this8.pager.page, size: _this8.pager.size, id: id, code: code };
                    //console.log("2",params);
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_60" /* selStorInItemCustomerId */])(params).then(function (data) {
                        var _data$data7 = data.data,
                            res = _data$data7 === undefined ? {} : _data$data7;

                        if (res.errcode === 200) {
                            var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                            res.data.data.forEach(function (item, i) {
                                var _itemList3;

                                //重新處理下資料
                                var floor = void 0;
                                if (item.floor === 0) {
                                    floor = "GF " + item.name;
                                } else {
                                    floor = item.floor + "F " + item.name;
                                }
                                var itemList = (_itemList3 = { state: 0, unit: item.unit, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, storDateId: _this8.storDateId, volume: item.volume, amount: item.amount, unitVolume: item.unitVolume, remainingQuantity: item.remainingQuantity, remainingVolume: item.remainingVolume }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList3, 'unitVolume', item.unitVolume), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList3, 'unitPrice', item.unitPrice), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList3, 'quantity', item.quantity), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_itemList3, 'checked', false), _itemList3);
                                if (i === 0) {
                                    //添加
                                    var storIdItemList = { id: item.id, createDate: new Date(item.createDate * 1000).Format("yyyy年MM月dd日 hh:mm"), storOnItem: [itemList] };
                                    sotrOnMap.set(i, storIdItemList);
                                } else {
                                    sotrOnMap.get(0).storOnItem.push(itemList);
                                }
                            });

                            if (_this8.addStorOn === true) {
                                _this8.addStorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            } else {
                                _this8.storOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                            }
                        }
                    });
                }
            });
        },
        selCutomerCode: function selCutomerCode() {
            var _this9 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    _this9.customerCode = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                    _this9.customerCode.forEach(function (a, b) {
                        _this9.$set(_this9.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this9.list = list.map(function (item) {
                        return { value: item.id, label: item.code };
                    });
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this10 = this;

            /*出倉*/
            var addstorOnList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.addStorOnMap.values()));
            var codeId = this.form.sCode.split(',');
            var code = "";
            if (this.rkCont === true) {
                this.codeList.forEach(function (item) {
                    if (item.code === codeId[1]) {
                        _this10.addStorOn = true;
                    }
                });
            }
            if (this.addStorOn == true && addstorOnList.length == 0) {
                return this.$alert("請選擇出倉記錄", '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            }
            if (codeId[1] !== undefined) {
                //確定codeID中是否有值
                code = codeId[1];
            } else {
                code = this.form.sCode;
            }
            var params = {
                code: code,
                addStorOn: this.addStorOn,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storOnItemList: addstorOnList
            };
            //console.log("params",params);
            var str = this.isStringNull();
            if (str !== "") {
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                this.$confirm('確定是否出倉? ', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_52" /* insertStorOn */])(params).then(function (data) {
                        var _data$data9 = data.data,
                            res = _data$data9 === undefined ? {} : _data$data9;

                        if (res.errcode === 200) {
                            _this10.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            _this10.cancelAdd();
                            _this10.getStorOnList();
                            _this10.addStorOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                            if (_this10.typeId == 2) {
                                _this10.$router.push({
                                    name: '客戶詳情',
                                    params: {
                                        id: _this10.custId
                                    }
                                });
                                _this10.$store.commit("closeTab", 'updatesStockout');
                            } else {
                                _this10.$router.push({
                                    name: '出倉',
                                    params: { str: new Date().getTime() }
                                });
                                _this10.$store.commit("closeTab", 'updatesStockout');
                            }
                        } else {
                            _this10.$message.error(res.errmsg);
                        }
                    });
                }).catch(function () {
                    _this10.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        },
        checkedOne: function checkedOne(index) {
            var _storOn;

            var list = {};
            if (this.addStorOn === false) {
                list = this.storOnList[0].storOnItem[index];
            } else {
                list = this.addStorOnList[0].storOnItem[index];
            }
            var storOn = (_storOn = { storInItemId: list.id, state: 1, unit: list.unit, id: list.id, boxNo: list.boxNo, item: list.item, qty: list.qty, locationId: list.locationId, value: list.value, storDateId: list.storDateId, quantity: list.quantity, volume: list.volume, amount: list.amount, unitVolume: list.unitVolume, remainingQuantity: list.remainingQuantity, remainingVolume: list.remainingVolume }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_storOn, 'unitVolume', list.unitVolume), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_storOn, 'unitPrice', list.unitPrice), _storOn);
            if (!this.addStorOnMap.has(list.id)) {
                if (this.addStorOnList.length !== 0) {
                    this.addStorOnList[0].storOnItem[index].state = 1;
                }
                this.addStorOnMap.set(list.id, storOn);
            } else {
                this.addStorOnList[0].storOnItem[index].state = 0;
                this.addStorOnMap.delete(list.id);
            }
        },

        // changeOne(val, row, index) {
        //     row.state = 1
        //     row.quantity = row.remainingQuantity
        //     let list = {}
        //     if(this.addStorOn===false){
        //         list = this.storOnList[0].storOnItem[index];
        //     }else{
        //         list = this.addStorOnList[0].storOnItem[index];
        //     }
        //     let storOn = {storInItemId:list.id,state:1,unit:list.unit,id:list.id,boxNo:list.boxNo,item:list.item,qty:list.qty,locationId:list.locationId,value:list.value,storDateId:list.storDateId,volume:list.volume,amount:list.amount,unitVolume:list.unitVolume,remainingQuantity:list.remainingQuantity,remainingVolume:list.remainingVolume,unitVolume:list.unitVolume,unitPrice:list.unitPrice,quantity:list.quantity,checked:true};
        //     if(val){
        //         row.remark = '出整' + list.unit + '，共' + this.dialogForm.quantity +'件' 
        //         if(!this.addStorOnMap.has(list.id)){
        //             if(this.addStorOnList.length !== 0){
        //                 this.addStorOnList[0].storOnItem[index].state = 1;
        //             }
        //             this.addStorOnMap.set(list.id,storOn)
        //         }else{
        //             this.addStorOnList[0].storOnItem[index].state =1;
        //         }
        //     }else{
        //         if(this.addStorOnMap.has(list.id)){
        //             if(this.addStorOnList.length !== 0){
        //                 this.addStorOnList[0].storOnItem[index].state = 0;
        //             }
        //             row.state = 0
        //             row.remark = ''
        //             this.addStorOnMap.delete(list.id)
        //         }
        //     }
        //     this.$forceUpdate()
        // },
        handleStor: function handleStor(index) {
            this.curIndex = index;
            if (this.addStorOn === false) {
                this.dialogForm = this.storOnList[0].storOnItem[index];
            } else {
                this.dialogForm = this.addStorOnList[0].storOnItem[index];
            }
            if (!this.dialogForm.checked) {
                this.dialogForm.quantity = 1;
                this.dialogForm.volume = null;
                this.dialogForm.amount = 0;
            }
            this.dialogVisible = true;
        },
        handleItem: function handleItem() {
            var id = this.dialogForm.id;
            var unit = this.dialogForm.unitVolume == '1' ? '箱' : this.dialogForm.unitVolume == '2' ? 'cu.ft' : this.dialogForm.unitVolume == '3' ? 'm³' : '';
            if (this.dialogForm.state == 1 || this.dialogForm.state == 4) {
                this.dialogForm.checked = true;
                if (this.dialogForm.quantity == this.dialogForm.remainingQuantity) this.dialogForm.state = 1;
                if (this.dialogForm.state == 1) {
                    this.dialogForm.quantity = this.dialogForm.remainingQuantity;
                    this.dialogForm.remark = '\u51FA\u6574' + this.dialogForm.unit + '\uFF0C\u5171' + this.dialogForm.quantity + '\u4EF6' + (this.dialogForm.volume ? '，體積' + this.dialogForm.volume + unit : '');
                }
                if (this.dialogForm.state == 4) {
                    this.dialogForm.remark = '\u51FA\u90E8\u5206\uFF0C' + this.dialogForm.quantity + '\u4EF6' + (this.dialogForm.volume ? '，體積' + this.dialogForm.volume + unit : '');
                }
                if (!this.addStorOnMap.has(id)) {
                    if (this.addStorOnList.length !== 0) {
                        this.addStorOnList[0].storOnItem[this.curIndex].state = this.dialogForm.state;
                    }
                    this.addStorOnMap.set(id, this.dialogForm);
                } else {
                    this.addStorOnMap.set(id, this.dialogForm);
                }
            } else {
                this.dialogForm.state = 0;
                this.dialogForm.remark = '';
                this.dialogForm.checked = false;
                if (this.addStorOnMap.has(id)) {
                    if (this.addStorOnList.length !== 0) {
                        this.addStorOnList[0].storOnItem[this.curIndex].state = 0;
                    }
                    this.addStorOnMap.delete(id);
                }
            }
            this.dialogVisible = false;
        },
        nullList: function nullList() {
            /*清空*/
            this.storOnList = [];
            this.addStorOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
            this.addStorOnList = [];
            this.storOnList = [];
            this.storDateId = 0;
            this.isNullOptions();
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null
            };
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        isStringNull: function isStringNull() {
            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "出庫單不能為空";
            }if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }if (this.form.name === null || this.form.name === "") {
                return "姓名不能為空";
            }if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            return str;
        },
        test: function test() {
            this.show = true;
            this.add = false;
        },
        getInCodeList: function getInCodeList() {
            var _this11 = this;

            /*查詢入庫單號*/
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_20" /* getStorInCodeList */])().then(function (data) {
                /*查詢所有的入庫單 然後對比是否有當前輸入的單號一樣 有返回出去提示*/
                var _data$data10 = data.data,
                    res = _data$data10 === undefined ? {} : _data$data10;
                //console.log("11",res);

                if (res.errcode === 200) {
                    _this11.codeInList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
                    _this11.codeInList.forEach(function (a, b) {
                        _this11.$set(_this11.codeInList[b], 'value', a.code); //向陣列裡添加value欄位
                        sotrOnMap.set(b, { id: a.id, code: a.code });
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this11.codeInList = list.map(function (item) {
                        return { value: item.id + "," + item.code, label: item.code };
                    });
                } else {
                    _this11.$message.error(res.errmsg);
                }
            });
        },
        isNullOptions: function isNullOptions() {
            this.options = [];
        },
        getStockOutParams: function getStockOutParams() {
            this.selSotrOn(this.$route.params.id, this.$route.params.typeId, this.$route.params.custId);
        }
    },
    activated: function activated() {
        var _this12 = this;

        this.cancelAdd();
        Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data11 = data.data,
                res = _data$data11 === undefined ? {} : _data$data11;

            _this12.custSalesList = res.data;
        });
        /*進入載入*/
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getStorOnList();
        this.selCutomerCode();
        this.getStockOutParams();
        /*  //首页查詢功能
          if(this.$store.getters.storonSta == true){
              this.selSotrOn(this.$route.params.id);
              this.$store.commit("setSearchSte",true);
          }
            //客戶详情編輯
          if(this.$store.getters.customerOnSte == true){
        //                this.$store.commit("setSearchSte",true);
              this.selSotrOn(this.$route.params.id);
          }*/
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ADD_STOR_ON");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("EDIT_STOR_ON");
        }
    },
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "Y3O9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.handleAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("新增角色")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.requestRoleList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"角色名","clearable":""},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.requestRoleList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.roleTableloading),expression:"roleTableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.roles,"empty-text":"无数据","stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"name","align":"left","label":"角色"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"addBy","align":"left","label":"創建人"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"addTime","align":"left","label":"創建時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n      "+_vm._s(_vm._f("date")(scope.row.addTime*1000,'%Y-%m-%d %T'))+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","width":"100","align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v("操作\n                ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯")]):_vm._e(),_vm._v(" "),(_vm.canDelete)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" 刪除")]):_vm._e(),_vm._v(" "),(_vm.canAdd)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleAddByCopy(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("複制")]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogRoleFormVisible,"width":"420px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogRoleFormVisible=$event}}},[_c('el-form',{ref:"roleForm",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.roleForm,"rules":_vm.roleRules,"label-width":"200px","size":"small"}},[_c('el-form-item',{attrs:{"label":"角色名稱","prop":"name","label-width":"120px"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.roleForm.name),callback:function ($$v) {_vm.$set(_vm.roleForm, "name", $$v)},expression:"roleForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"權限設置","prop":"pids","label-width":"120px"}},[_c('el-tree',{ref:"permissionTree",attrs:{"data":_vm.permissionTreeData,"props":_vm.permissionTreeProps,"show-checkbox":"","accordion":"","node-key":"uid","default-expand-all":false,"auto-expand-parent":true},on:{"check-change":_vm.handleCheckChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[(!data.children)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":data.remark,"placement":"right"}},[_c('span',[_vm._v(_vm._s(node.label))])]):_c('span',[_vm._v(_vm._s(node.label))])],1)}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogRoleFormVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.roleSaveloading},on:{"click":_vm.handleSave}},[_vm._v("保存")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZqOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[(_vm.addCustTask)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.addCustTask}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.t_newTask')))]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getTaskList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_search')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.t_custcode'),"clearable":""},model:{value:(_vm.serchCustNo),callback:function ($$v) {_vm.serchCustNo=$$v},expression:"serchCustNo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":this.$t('m.t_salesName')},model:{value:(_vm.serchSalesId),callback:function ($$v) {_vm.serchSalesId=$$v},expression:"serchSalesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.t_booking'),"clearable":""},model:{value:(_vm.serchBooking),callback:function ($$v) {_vm.serchBooking=$$v},expression:"serchBooking"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.t_site'),"clearable":""},model:{value:(_vm.serchSite),callback:function ($$v) {_vm.serchSite=$$v},expression:"serchSite"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"date","placeholder":"選擇日期"},model:{value:(_vm.getTaskDate),callback:function ($$v) {_vm.getTaskDate=$$v},expression:"getTaskDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getTaskList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.custTaskList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"custNo","align":"left","label":_vm.$t('m.t_customer')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(scope.row.custNo)+","+_vm._s(scope.row.custName)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salesName","align":"left","label":_vm.$t('m.t_salesName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"booking","align":"left","label":_vm.$t('m.t_booking')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"site","align":"left","label":_vm.$t('m.t_site')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskDate","align":"left","label":_vm.$t('m.t_taskDate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.taskDate!=0)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.taskDate*1000,'%Y-%m-%d'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.custTaskEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.taskEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(_vm.custTaskDelete)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.deleteTask(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "+_vm._s(_vm.$t('m.t_delete')))]):_vm._e(),_vm._v(" "),(_vm.canFile)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.fileListEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-cloud-upload"}),_vm._v(" "+_vm._s(_vm.$t('m.t_enclosureadmin')))]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogDiscEditVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"taskForm",attrs:{"model":_vm.taskForm,"label-width":"130px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_customer')+'：',"prop":"custNo"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"default-first-option":"","valueKey":"id","placeholder":"","filterable":"","remote":"","remote-method":_vm.itemRemoteMethod},on:{"change":_vm.custChange},model:{value:(_vm.taskForm.custNo),callback:function ($$v) {_vm.$set(_vm.taskForm, "custNo", $$v)},expression:"taskForm.custNo"}},_vm._l((_vm.custOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.code,"value":item}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.code))]),_vm._v(" \n                                "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"銷售員：","prop":"salesId"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"filterable":"","placeholder":""},model:{value:(_vm.taskForm.salesId),callback:function ($$v) {_vm.$set(_vm.taskForm, "salesId", $$v)},expression:"taskForm.salesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"任务時間：","prop":"taskDate"}},[_c('el-date-picker',{staticStyle:{"width":"200px"},attrs:{"type":"date","placeholder":""},model:{value:(_vm.taskForm.taskDate),callback:function ($$v) {_vm.$set(_vm.taskForm, "taskDate", $$v)},expression:"taskForm.taskDate"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"搬迁预订:","prop":"booking"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.taskForm.booking),callback:function ($$v) {_vm.$set(_vm.taskForm, "booking", $$v)},expression:"taskForm.booking"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"现场调查:","prop":"site"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.taskForm.site),callback:function ($$v) {_vm.$set(_vm.taskForm, "site", $$v)},expression:"taskForm.site"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","plain":""},on:{"click":_vm.taskManagementSave}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-delete","plain":""},on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v("取 消")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogFileListName,"visible":_vm.dialogFileListVisible,"width":"80%"},on:{"update:visible":function($event){_vm.dialogFileListVisible=$event}}},[_c('div',[_c('div',{staticStyle:{"float":"right"}},[(_vm.canFileAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.custFileAdd}},[_c('i',{staticClass:"fa fa-cloud-upload"}),_vm._v(_vm._s(_vm.$t('m.b_uploadfile')))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.fileList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionFileChange}},[_c('el-table-column',{attrs:{"prop":"fileName","align":"left","width":"160","label":_vm.$t('m.t_filename')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.pictureImg(scope.$index, scope.row))?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.getImageUrl(scope.$index, scope.row)}})]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('el-tag',{attrs:{"size":"medium"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openFile(scope.$index, scope.row)}}},[_vm._v(_vm._s(scope.row.fileName))])])],1)]):_vm._e(),_vm._v(" "),(_vm.canFileDow&&!_vm.pictureImg(scope.$index, scope.row))?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.fileDownload(scope.$index, scope.row)}}},[_vm._v(_vm._s(scope.row.fileName))]):_vm._e(),_vm._v(" "),(!_vm.canFileDow&&!_vm.pictureImg(scope.$index, scope.row))?_c('span',[_vm._v(_vm._s(scope.row.fileName))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"comment","align":"left","label":_vm.$t('m.t_remarks')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"uploadBy","align":"left","width":"120","label":_vm.$t('m.t_uploadby')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel2","align":"left","width":"160","label":_vm.$t('m.t_uploadtime')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.uploadTime*1000,'%Y-%m-%d %T'))+"\n                    ")]}}])}),_vm._v(" "),(_vm.canFileDow||_vm.canFileDel)?_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                                ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canFileDow)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.fileDownload(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('m.t_download')))]):_vm._e(),_vm._v(" "),(_vm.canFileDel)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.deleteCustFile(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(_vm._s(_vm.$t('m.b_delete')))]):_vm._e()],1)],1)]]}}],null,false,626878345)}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.fileListPager.page,"page-size":_vm.fileListPager.size,"total":_vm.fileListPager.total},on:{"current-change":_vm.handleFileListChange,"update:currentPage":function($event){return _vm.$set(_vm.fileListPager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.fileListPager, "page", $event)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"50px"}}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFileListVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogFileName,"visible":_vm.dialogFileVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFileVisible=$event}}},[_c('el-form',{ref:"custFile",attrs:{"model":_vm.custFile,"rules":_vm.custFileRules,"label-width":"100px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_file'),"prop":"file"}},[_c('div',[_c('a',{staticClass:"blueButton",attrs:{"href":"javascript:void(0);"}},[_vm._v(_vm._s(_vm.$t('m.t_selectthefile')))]),_vm._v(" "),_c('input',{staticClass:"myFileUpload",attrs:{"type":"file","id":"file"},on:{"change":function($event){return _vm.getFile($event)}}}),_vm._v(" "),_c('div',{staticClass:"show",attrs:{"id":"file_name"}})])])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_remarks'),"prop":"comment"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 2, maxRows: 4},"placeholder":""},model:{value:(_vm.custFile.comment),callback:function ($$v) {_vm.$set(_vm.custFile, "comment", $$v)},expression:"custFile.comment"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFileVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.custFileSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a8uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            options4: [],
            salesList: [], //銷售員LIST
            saList: [], //銷售員LIST
            custSalesList: [], //銷售員LIST
            list: [],
            tableloading: false,
            warehousingList: [],
            storIn: [], //入庫詳細資訊
            customerCode: {},
            remarkList: [], //常用列表
            locationList: {}, //架子表信息
            addNum: false,
            updateStorIn: "",
            codeList: [],
            company: [{ value: '籠', label: '籠' }, { value: '盒', label: '盒' }, { value: '板', label: '板' }, { value: '散件', label: '散件' }], //單位
            storInId: 0,
            typeId: 1,
            custId: 0,
            addWarehousingList: [{ state: 1, second: 1, createDate: null, code: this.RndNum(), addStorIn: true, storInItem: [{ addStorinItem: true, num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', itemShows: true, qtyShow: true, locationIdShows: true }] }],
            show: true, //資訊頁面
            add: false, //添加頁面
            rkCont: null, //入庫和客戶資訊
            submitInfo: true, //是否禁止保存按钮
            code: '',
            pager: {
                page: 0,
                size: 15,
                total: 0
            },
            form: {
                id: null,
                sCode: '',
                code: null,
                name: null,
                phone: null,
                address: null,
                sales: null,
                createDate: null,
                sCodeShow: false,
                codeShow: false,
                nameShow: false,
                phoneShow: false,
                addressShow: false,
                salesShow: false,
                price: null,
                unitVolume: null,
                totalPrice: null,
                totalVolume: null
            },
            searchStorIn: '',
            searchName: '',
            searchSalesId: ''
        };
    },

    methods: {
        formatCurrency: function formatCurrency(amount) {
            var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (!amount) return;
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 0,
                maximumFractionDigits: decimalPlaces
            });
            return '' + formatter.format(amount);
        },
        selSCode: function selSCode() {
            var _this = this;

            /*查詢入庫單是否重复*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_58" /* selCode */])(this.form.sCode).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode === 200) {
                    if (res.data !== null) {
                        //数据庫中没有当前入庫單號
                        if (res.data.code !== _this.updateStorIn) {
                            //当前輸入的帐号是否是修改的帐号
                            _this.$alert("當前入庫單號:" + _this.form.sCode + " 已存在!", '提示', {
                                confirmButtonText: '確定',
                                type: 'warning',
                                callback: function callback(action) {
                                    if (_this.updateStorIn !== "") {
                                        _this.form.sCode = _this.updateStorIn;
                                    } else {
                                        _this.form.sCode = "";
                                    }
                                }
                            });
                        }
                    }
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        retSearch: function retSearch() {
            //返回搜索界面
            /* if(this.typeId==2){
                 this.$router.go(-1);
             }else{
                 this.$router.go(-1);
             }*/
            this.$router.push({
                name: '出倉',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", 'addStockin');
        },
        remoteMethod: function remoteMethod(query) {
            var _this2 = this;

            /*選擇位置*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this2.loading = false;
                    _this2.options4 = _this2.list.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        remoteMethodSales: function remoteMethodSales(query) {
            var _this3 = this;

            /*選擇銷售員*/
            if (query !== '') {
                this.loading = true;
                setTimeout(function () {
                    _this3.loading = false;
                    _this3.saList = _this3.salesList.filter(function (item) {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options4 = [];
            }
        },
        clickLoad: function clickLoad() {
            /*点击銷售員框时加载*/
            this.saList = [];
            this.saList = this.salesList;
        },
        handleCurrentChange: function handleCurrentChange() {
            this.getWarehousing();
        },
        isDate: function isDate() {
            /*处理日期*/
            this.addWarehousingList.forEach(function (a, i) {
                if (a.createDate) {
                    a.createDate = Math.round(new Date(a.createDate).getTime() / 1000); //new Date(a.createDate*1000).Format("yyyy-MM-dd hh:mm")
                }
            });
        },
        isStringNull: function isStringNull() {
            var _this4 = this;

            /*檢查是否為空*/
            var str = "";
            if (this.form.sCode === null || this.form.sCode === "" || this.form.sCode === undefined) {
                return "工作單號不能為空";
            }if (this.form.code === null || this.form.code === "") {
                return "客戶編號不能為空";
            }if (this.form.name === null || this.form.name === "") {
                return "物品不能為空";
            }if (this.form.phone === null || this.form.phone === "") {
                return "電話不能為空";
            }if (this.form.address === null || this.form.address === "") {
                return "位址不能為空";
            }if (this.form.sales === null || this.form.sales === "") {
                return "銷售員不能為空";
            }if (this.form.createDate === null || this.form.createDate === "") {
                return "時間不能為空";
            }
            try {
                this.addWarehousingList.forEach(function (a, i) {
                    if (a.createDate === null || a.createDate === "") {
                        str = "Job00" + (i + 1) + "的時間不能為空";
                        foreach.break = new Error(str);
                    } else {
                        a.storInItem.forEach(function (item, j) {
                            if (item.item === "") {
                                a.storInItem.splice(j, 1); //刪除當前這條沒有值的資料
                            } else {
                                var num = 0;
                                if (_this4.addShow === true) {
                                    //点击新建后把最前面的变为反的
                                    if (i === 0) {
                                        num = _this4.addWarehousingList.length;
                                    } else {
                                        num = i - 1;
                                    }
                                } else {
                                    num = i + 1;
                                }
                                if (item.unit === null || item.unit === "" || item.unit === undefined) {
                                    str = "第" + num + "次的單位不能為空";
                                    foreach.break = new Error(str);
                                }
                                if (item.boxNo === null || item.boxNo === 0) {
                                    str = "第" + num + "次的編號不能為空";
                                    foreach.break = new Error(str);
                                }
                                if (item.item === null || item.item === "") {
                                    str = "第" + num + "次的名稱不能為空";
                                    foreach.break = new Error(str);
                                }
                                // if(item.qty === null || item.qty === ""){
                                //     str = "第"+ num +"次的數量不能為空";
                                //     foreach.break = new Error(str);
                                // }
                                if (item.quantity === null || item.quantity === "" || item.quantity == 0) {
                                    str = "第" + num + "次的件數不能為空";
                                    foreach.break = new Error(str);
                                }
                                if (item.locationId === null || item.locationId === "") {
                                    str = "位置不能為空";
                                    foreach.break = new Error(str);
                                }
                                // item.qty = Number(item.qty);
                                item.qty = 1;
                                item.quantity = Number(item.quantity);
                            }
                        });
                    }
                    var nary = _this4.addWarehousingList[i].storInItem.sort(); //查找是否有重复的單位和BOX
                    var obj = {};
                    var obj1 = {};
                    for (var j = 0, l = nary.length; j < l; j++) {
                        if (nary[j].state === 0) {
                            if (obj[nary[j].boxNo + "," + nary[j].unit]) {
                                if (obj1[nary[j].unit]) {
                                    str = "有重複的單位: " + nary[j].unit + " ,和編號: " + nary[j].boxNo;
                                    foreach.break = new Error(str);
                                }
                            } else {
                                obj[nary[j].boxNo + "," + nary[j].unit] = nary[j].boxNo + "," + nary[j].unit;
                                obj1[nary[j].unit] = nary[j].unit;
                            }
                        }
                    }
                });
            } catch (e) {
                return str;
            }
            return str;
        },
        getWarehousing: function getWarehousing() {
            var _this5 = this;

            /*查詢入庫*/
            this.submitInfo = true;
            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, storIn: this.searchStorIn.trim(), custName: this.searchName.trim(), salesId: this.searchSalesId };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_21" /* getStorInList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this5.warehousingList = items;
                    _this5.warehousingList.forEach(function (a, b) {
                        a.storInDate = new Date(a.storInDate * 1000).Format("yyyy-MM-dd hh:mm");
                        _this5.$set(_this5.warehousingList[b], 'value', a.customer.code); //向陣列裡添加value欄位
                    });
                    _this5.pager.total = total;
                    _this5.pager.page = page;
                    _this5.pager.size = size;
                    _this5.tableloading = false;
                } else {
                    _this5.$message.error(res.errmsg);
                }
            });
        },
        addWarehousing: function addWarehousing() {
            var _this6 = this;

            /*點擊新增後向陣列添加一條資料*/
            this.addShow = true;
            var boxNo = void 0;
            this.addWarehousingList.forEach(function (item, i) {
                //查詢当前BOXNO 最大值 +1
                var index = Number(_this6.addWarehousingList.length - 1);
                var a = Number(_this6.addWarehousingList[index].storInItem.length - 1);
                boxNo = Number(_this6.addWarehousingList[index].storInItem[a].boxNo) + 1;
            });
            this.addWarehousingList.unshift({ state: 0, second: this.addWarehousingList.length + 1, createDate: new Date().Format("yyyy-MM-dd hh:mm:ss"), code: null, addStorIn: true,
                storInItem: [{ state: 0, unitShow: true, num: 1, addStorinItem: true, boxNo: boxNo, item: '', qty: null, locationId: '', value: '', boxNoShow: false, itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, countVolume: null, inItemPrice: 0, quantity: null, quantityShow: true }] });
        },
        querySearch: function querySearch(queryString, cb) {
            /*載入數據*/
            var restaurants = this.customerCode;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (restaurant) {
                return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        handleSelect: function handleSelect(item) {
            var _this7 = this;

            /*選擇客編號後*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* getCustomerById */])(item.id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode === 200) {
                    //console.log("resCUS",res);
                    var _res$data$ = res.data[0],
                        id = _res$data$.id,
                        code = _res$data$.code,
                        name = _res$data$.name,
                        phone = _res$data$.phone,
                        address = _res$data$.address,
                        sales = _res$data$.sales;

                    _this7.form.id = id;
                    _this7.form.code = code;
                    _this7.form.name = name;
                    _this7.form.address = address;
                    _this7.form.phone = phone;
                    _this7.form.sales = sales;
                    if (id != undefined) {
                        _this7.getLocationByCusId(id);
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_1" /* getPrePrice */])({ custId: id }).then(function (result) {
                            if (result) {
                                var _result$data$data = result.data.data,
                                    price = _result$data$data.price,
                                    storInCode = _result$data$data.code,
                                    storInTime = _result$data$data.storInTime;

                                _this7.form.prePrice = price;
                                _this7.form.storInCode = storInCode;
                                _this7.form.storInTime = storInTime;
                                _this7.$forceUpdate();
                            }
                        }).catch(function () {});
                    }
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        querySearchRemark: function querySearchRemark(queryString, cb) {
            /*載入常用列表數據*/
            var restaurants = this.remarkList;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 調用 callback 返回建議清單的資料
            cb(results);
        },
        selCustimerId: function selCustimerId(id) {
            var _this8 = this;

            /*查詢客戶ID*/
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_22" /* getStorInListId */])(id).then(function (data) {
                var _data$data4 = data.data,
                    res = _data$data4 === undefined ? {} : _data$data4;
                //console.log(res)

                if (res.errcode === 200) {
                    var _res$data$customer = res.data.customer,
                        _id = _res$data$customer.id,
                        code = _res$data$customer.code,
                        name = _res$data$customer.name,
                        phone = _res$data$customer.phone,
                        address = _res$data$customer.address;

                    _this8.form.id = _id;
                    _this8.form.code = code;
                    _this8.form.name = name;
                    _this8.form.address = address;
                    _this8.form.phone = phone;
                    _this8.form.sales = res.data.sales;
                    _this8.form.sCode = res.data.scode;
                    _this8.form.price = res.data.price;
                    _this8.form.totalPrice = res.data.totalPrice;
                    _this8.form.totalVolume = res.data.totalVolume;
                    if (_id != undefined) {
                        _this8.getLocationByCusId(_id);
                    }
                }
            });
        },
        delAddWarehousingList: function delAddWarehousingList(item, i) {
            var _this9 = this;

            /*删除StorInDate表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this9.addShow === true) {
                    _this9.addWarehousingList.splice(i, 1); //删除数组
                    _this9.addShow = false;
                } else {
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["d" /* delStorInDate */])(item.id).then(function (str) {
                        //删除
                        var _str$data = str.data,
                            res = _str$data === undefined ? {} : _str$data;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this9.addWarehousingList.splice(i, 1); //删除数组
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this9.$message({
                            type: 'info',
                            message: mes
                        });
                    });
                }
                //let id = this.addWarehousingList[i].id;
            }).catch(function () {
                _this9.$message({
                    type: 'info',
                    message: '已取消刪除'
                });
            });
        },
        delStorInItem: function delStorInItem(i, index) {
            var _this10 = this;

            /*删除StorInItem表中数据*/
            this.$confirm('此操作將永久刪除該數據, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                if (_this10.addWarehousingList[i].storInItem[index].addStorinItem === true) {
                    _this10.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                } else {
                    var id = _this10.addWarehousingList[i].storInItem[index].id;
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["e" /* delStorInItem */])(id).then(function (str) {
                        //删除
                        var _str$data2 = str.data,
                            res = _str$data2 === undefined ? {} : _str$data2;

                        var mes = "";
                        if (res.errcode === 200) {
                            _this10.addWarehousingList[i].storInItem.splice(index, 1); //删除数据
                            mes = "刪除成功";
                        } else {
                            mes = "刪除失敗";
                        }
                        _this10.$message({
                            type: 'info',
                            message: mes
                        });
                    }).catch(function () {
                        _this10.$message({
                            type: 'info',
                            message: '已取消刪除'
                        });
                    });
                }
            });
            //console.log("l",this.addWarehousingList[i].storInItem[index])
        },
        handleSelectState: function handleSelectState(id, i, index) {
            /*選擇位置後 向陣列添加一條新資料*/
            this.addWarehousingList[i].storInItem[index].unitShow = false;
            this.addWarehousingList[i].storInItem[index].locationId = id; //向選擇位置後的資訊添加位置ID
            return;
            if (this.addWarehousingList[i].storInItem[index].num === 1) {
                //
                var box = Number(this.addWarehousingList[i].storInItem[index].boxNo);
                this.addWarehousingList[i].storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, boxNo: box + 1, item: '', qty: null, locationId: '', value: '', itemShows: false, qtyShow: true, locationIdShows: false });
            }
            this.addWarehousingList[i].storInItem[index].num = 0;
            this.addWarehousingList[i].storInItem[index + 1].unit = this.addWarehousingList[i].storInItem[index].unit;
            this.addWarehousingList[i].storInItem[index].locationId = id; //向選擇位置後的資訊添加位置ID
        },
        isNullOptions4: function isNullOptions4() {
            /*点击时清空当前数组*/
            this.options4 = [];
            //this.getLocationByCusId(this.form.id);
        },
        selSotrIn: function selSotrIn(id, typeId) {
            var _this11 = this;

            /*查詢入庫的詳細資訊*/
            this.$store.commit("setSearchSte", false);
            this.$store.commit("setCustomerInSte", false);
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.addShow = false;
            this.rkCont = false; //入庫和客戶資訊
            this.storInId = id;
            this.typeId = typeId;
            var params = { page: this.pager.page, size: 100, storInId: id };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_59" /* selStorInItem */])(params).then(function (str) {
                //查詢當前入庫單裡有多少資料
                var _str$data3 = str.data,
                    res = _str$data3 === undefined ? {} : _str$data3;
                //console.log("res",res);

                if (res.errcode === 200) {
                    var leagueMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    var cId = void 0;
                    var i = 1;
                    res.data.data.forEach(function (item) {
                        //重新處理下資料
                        _this11.form.createDate = new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm");
                        var itemList = {};cId = item.cId;_this11.updateStorIn = item.sCode;
                        var floor = void 0;
                        if (item.floor === 0) {
                            floor = "GF " + item.name;
                        } else {
                            floor = item.floor + "F " + item.name;
                        }
                        if (item.state === 1) {
                            //是否是當天時間 不是當天的時間不能修改
                            itemList = { unitShow: true, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShows: true, qtyShow: true, locationIdShows: true, boxNoShow: true, length: item.length, wide: item.wide, high: item.high, ckgShow: true, volume: item.volume, countVolume: item.countVolume, inItemPrice: item.inItemPrice, quantity: item.quantity, quantityShow: true };
                        } else {
                            itemList = { unitShow: false, unit: item.unit, num: 0, addStorinItem: false, id: item.id, boxNo: item.boxNo, item: item.item, qty: item.qty, locationId: item.locationId, value: floor, state: item.state,
                                itemShow: false, qtyShow: false, locationIdShow: false, length: item.length, wide: item.wide, high: item.high, ckgShow: false, volume: item.volume, countVolume: item.countVolume, inItemPrice: item.inItemPrice, quantity: item.quantity, quantityShow: false };
                        }
                        if (!leagueMap.has(item.storDateId)) {
                            //添加
                            var storIdItemList = { state: 1, second: i, id: item.storDateId, code: item.sCode, createDate: new Date(item.createDate * 1000).Format("yyyy-MM-dd hh:mm:ss"),
                                addStorIn: false, storInItem: [itemList] };
                            leagueMap.set(item.storDateId, storIdItemList);
                            i++;
                        } else {
                            leagueMap.get(item.storDateId).storInItem.push(itemList);
                        }
                    });
                    _this11.addWarehousingList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(leagueMap.values()));
                    var boxNo = void 0;
                    _this11.addWarehousingList.forEach(function (item, i) {
                        //查詢当前BOX 最大值 +1
                        var index = Number(_this11.addWarehousingList.length - 1);
                        var a = Number(_this11.addWarehousingList[index].storInItem.length - 1);
                        boxNo = Number(_this11.addWarehousingList[index].storInItem[a].boxNo) + 1;
                        item.storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, id: item.id, boxNo: boxNo + i, item: '', qty: null, locationId: '', value: '',
                            itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, countVolume: null, inItemPrice: 0, quantity: null, quantityShow: true });
                    });
                    _this11.selCustimerId(id); //查詢客戶id
                    _this11.form.codeShow = true;
                    _this11.form.sCodeShow = false;
                    _this11.form.nameShow = true;
                    _this11.form.phoneShow = true;
                    _this11.form.addressShow = true;
                    _this11.form.salesShow = true;
                }
            });
        },
        submitStorIn: function submitStorIn() {
            var _this12 = this;

            /*保存資料到資料庫*/
            this.submitInfo = false; //禁止保存按钮
            var str = this.isStringNull();
            var params = {
                code: this.form.sCode,
                storInId: this.storInId,
                totalVolume: Number(this.form.totalVolume),
                price: Number(this.form.price),
                totalPrice: this.form.totalPrice,
                unitVolume: this.form.unitVolume,
                customers: {
                    id: this.form.id,
                    code: this.form.code,
                    name: this.form.name,
                    address: this.form.address,
                    phone: this.form.phone,
                    sales: this.form.sales,
                    createDate: Math.round(new Date(this.form.createDate).getTime() / 1000)
                }, storInDateList: this.addWarehousingList };
            //console.log("pa",params); WHETHER_PUBLIC 当前架子是否公共使用(0不公用 1公用)
            if (str !== "") {
                this.submitInfo = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error',
                    callback: function callback(action) {
                        var boxNo = void 0;
                        _this12.addWarehousingList.forEach(function (item, i) {
                            //查詢当前BOX 最大值 +1
                            var index = Number(_this12.addWarehousingList.length - 1);
                            var a = Number(_this12.addWarehousingList[index].storInItem.length - 1);
                            boxNo = Number(_this12.addWarehousingList[index].storInItem[a].boxNo) + 1;
                            //console.log(item.storInItem[a]);
                            if (item.storInItem[a].quantity !== null || item.storInItem[a].locationId !== "") {
                                item.storInItem.push({ state: 0, unitShow: true, unit: '', num: 0, addStorinItem: true, id: item.id, boxNo: boxNo + i, item: '', qty: null, locationId: '', value: '',
                                    itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, countVolume: null, inItemPrice: 0, quantity: null, quantityShow: true });
                            }
                        });
                    }
                });
            } else {
                this.isDate();
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_51" /* insertStorIn */])(params).then(function (data) {
                    var _data$data5 = data.data,
                        res = _data$data5 === undefined ? {} : _data$data5;

                    if (res.errcode === 200) {
                        _this12.$message({
                            showClose: true,
                            message: '入庫成功！',
                            type: 'success'
                        });
                        _this12.cancelAdd();
                        _this12.$router.push({
                            name: '入倉',
                            params: { str: new Date().getTime() }
                        });
                        _this12.$store.commit("closeTab", 'addStockin');
                    } else {
                        _this12.$message.error(res.errmsg);
                        _this12.submitInfo = true;
                    }
                });
            }
        },
        RndNum: function RndNum() {
            //生成一個15位元數的數字
            var rnd = "";
            for (var i = 0; i < 15; i++) {
                rnd += Math.floor(Math.random() * 10);
            }
            return rnd;
        },
        storInAdd: function storInAdd() {
            /*顯示添加入庫資訊 關閉入庫資訊*/
            this.selLocationState(); //查詢架子
            this.add = true;
            this.show = false;
            this.rkCont = true;
            this.nullList();
            this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm");
            this.addWarehousingList[0].createDate = new Date().Format("yyyy-MM-dd hh:mm");
            //console.log(this.addWarehousingList);
        },
        cancelAdd: function cancelAdd() {
            /*顯示入庫資訊 關閉添加入庫資訊*/
            this.add = false;
            this.show = true;
            this.nullList();
            this.list = [];
        },
        addList: function addList(i, index, str) {
            /*修改是否能輸入*/
            if (str === "cCode") {
                this.addWarehousingList[i].storInItem[index].locationIdShows = false;
                return;
            }
            if (str === "unit") {
                this.addWarehousingList[i].storInItem[index].itemShows = false;
                return;
            }
            if (str === "item") {
                this.addWarehousingList[i].storInItem[index].ckgShow = false;
                return;
            }
            if (str === "quantity") {
                var box = Number(this.addWarehousingList[i].storInItem.length);
                var temp = this.addWarehousingList[i].storInItem[box - 1];
                if (temp.locationId && temp.unit && temp.item && temp.quantity) {
                    this.addWarehousingList[i].storInItem.push({ state: 0, unitShow: true, unit: '', num: 1, addStorinItem: true, boxNo: box + 1, item: '', qty: null, locationId: '', value: '', itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, volume: null, countVolume: null, inItemPrice: 0, ckgShow: true, quantity: null, quantityShow: true });
                }
            }
        },
        handleBlurVolume: function handleBlurVolume(item, i) {
            var value = item.volume;
            var regex = /^[1-9]\d*$/;
            var message = '請輸入大於0的整數';
            if (this.form.unitVolume == '3') {
                regex = /(^(\d+)(\.\d{1,2})?$)/;
                message = '请输入非零最多两位小数的数字';
            } else {
                regex = /^[1-9]\d*$/;
                message = '請輸入大於0的整數';
            }
            if (value == 0 || !regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: message });
                item.volume = null;
                item.inItemPrice = 0;

                // 總體積
                var _num = 0;
                this.addWarehousingList[i].storInItem.map(function (v) {
                    _num = Number(v.volume || 0) * 100 + _num;
                });
                this.form.totalVolume = _num / 100;

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                }
                this.$forceUpdate();
                return;
            }

            var sum = Math.ceil(Number(this.form.price || 0) * item.volume * 100);
            item.inItemPrice = sum / 100;

            // 總體積
            var num = 0;
            this.addWarehousingList[i].storInItem.map(function (v) {
                num = Number(v.volume || 0) * 100 + num;
            });
            this.form.totalVolume = num / 100;

            if (this.form.price) {
                var _amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                this.form.totalPrice = _amount / 100;
            } else {
                this.form.totalPrice = null;
            }
            this.$forceUpdate();
        },
        handleArea: function handleArea(field, item, i) {
            var value = item[field];
            var regex = /^[1-9]\d*$/;
            if (value == 0 || !regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: '請輸入大於0的整數' });
                item[field] = null;
                item.volume = null;
                item.countVolume = null;
                item.inItemPrice = 0;
                // 總體積
                var _num2 = 0;
                this.addWarehousingList[i].storInItem.map(function (v) {
                    _num2 = Number(v.volume || 0) * 100 + _num2;
                });
                this.form.totalVolume = (_num2 / 100).toFixed(2);

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                }
                this.$forceUpdate();
                return;
            }
            // volume 統計
            if (item.high && item.wide && item.length) {
                var area = Math.ceil(item.length * item.wide * item.high * 35.314 / 1000000);
                item.countVolume = area;
                item.volume = area;

                var sum = Math.ceil(Number(this.form.price || 0) * item.volume * 100);
                item.inItemPrice = sum / 100;

                item.quantityShow = false;
            }
            // 總體積
            var num = 0;
            this.addWarehousingList[i].storInItem.map(function (v) {
                num = Number(v.volume || 0) * 100 + num;
            });
            this.form.totalVolume = (num / 100).toFixed(2);

            if (this.form.price) {
                var _amount2 = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                this.form.totalPrice = _amount2 / 100;
            }
            this.$forceUpdate();
        },
        handlePrice: function handlePrice(val) {
            var _this13 = this;

            var value = val;
            var regex = /(^(\d+)(\.\d{1,2})?$)/;
            if (!regex.test(value)) {
                if (value == '' || value == null) {} else this.$message({ type: 'warning', message: '请输入非零最多两位小数的数字' });
                this.form.price = null;
                this.form.totalPrice = null;
                this.addWarehousingList[0].storInItem.map(function (v) {
                    v.inItemPrice = 0;
                });
                this.$forceUpdate();
                return;
            }

            this.addWarehousingList[0].storInItem.map(function (v) {
                var sum = Math.ceil(Number(_this13.form.price || 0) * Number(v.volume || 0) * 100);
                v.inItemPrice = sum / 100;
            });
            if (this.form.totalVolume) {
                var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume || 0) * 100);
                this.form.totalPrice = amount / 100;
            } else {
                this.form.totalPrice = null;
            }
            this.$forceUpdate();
        },
        handleChangeUnit: function handleChangeUnit(val) {
            var _this14 = this;

            if (val != '3') {
                var num = 0; // 总体积
                this.addWarehousingList[0].storInItem.map(function (v) {
                    if (v.volume !== 0 && v.volume !== null) {
                        v.volume = Math.ceil(v.volume || 0);
                        v.inItemPrice = Number(_this14.form.price || 0) * Number(v.volume || 0);
                    }
                    num = Number(v.volume || 0) * 100 + num;
                });
                this.form.totalVolume = num / 100;

                if (this.form.price) {
                    var amount = Math.ceil(Number(this.form.price) * Number(this.form.totalVolume) * 100);
                    this.form.totalPrice = amount / 100;
                } else {
                    this.form.totalPrice = null;
                }
            }
            $forceUpdate();
        },
        selCutomerCode: function selCutomerCode() {
            var _this15 = this;

            /*查詢客戶編號*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* getCustomerCodeList */])().then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                if (res.errcode === 200) {
                    _this15.customerCode = res.data;
                    _this15.customerCode.forEach(function (a, b) {
                        _this15.$set(_this15.customerCode[b], 'value', a.code); //向陣列裡添加value欄位
                    });
                }
            });
        },
        letSalesList: function letSalesList() {
            var _this16 = this;

            /*查詢銷售員LIST*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_11" /* getSalesList */])().then(function (data) {
                var _data$data7 = data.data,
                    res = _data$data7 === undefined ? {} : _data$data7;
                //console.log(res)

                if (res.errcode === 200) {
                    _this16.salesList = res.data;
                    _this16.salesList.forEach(function (a, b) {
                        _this16.$set(_this16.salesList[b], 'value', a.name); //向陣列裡添加value欄位
                    });
                }
            });
        },
        selLocationState: function selLocationState() {
            var _this17 = this;

            /*查詢位置資訊*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["U" /* getLocationByState */])(Number(0)).then(function (data) {
                var _data$data8 = data.data,
                    res = _data$data8 === undefined ? {} : _data$data8;

                if (res.errcode === 200) {
                    _this17.locationList = res.data;
                    var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    _this17.locationList.forEach(function (a, b) {
                        if (a.floor === "0") {
                            sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                        } else {
                            sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                        }
                    });
                    var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                    _this17.list = list.map(function (item) {
                        return { value: item.id, label: item.location };
                    });
                    //console.log("resL",this.list);
                }
            });
        },
        getLocationByCusId: function getLocationByCusId(id) {
            var _this18 = this;

            /*以客戶ID查詢當前客戶在用的架子*/
            if (this.storInId !== 0) {
                //入庫單ID为空 没有架子
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["v" /* getCIdList */])({ id: this.storInId, cusId: id }).then(function (data) {
                    var _data$data9 = data.data,
                        res = _data$data9 === undefined ? {} : _data$data9;

                    if (res.errcode === 200) {
                        _this18.locationList = res.data;
                        var sotrOnMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                        _this18.locationList.forEach(function (a, b) {
                            if (a.floor === "0") {
                                sotrOnMap.set(b, { id: a.id, location: "GF " + a.name });
                            } else {
                                sotrOnMap.set(b, { id: a.id, location: a.floor + "F " + a.name });
                            }
                        });
                        var list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sotrOnMap.values()));
                        var Tlist = list.map(function (item) {
                            return { value: item.id, label: item.location };
                        });
                        var this_ = _this18;
                        var t1 = setInterval(function () {
                            //定时器 3秒后加载到list
                            for (var i = 0; i < Tlist.length; i++) {
                                this_.list.unshift(Tlist[i]);
                            }
                            clearTimeout(t1);
                        }, 3000);
                    }
                });
            }
        },
        getRemarkList: function getRemarkList() {
            var _this19 = this;

            /*查詢常用列表*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["s" /* getAllRemarkList */])(1).then(function (data) {
                var _data$data10 = data.data,
                    res = _data$data10 === undefined ? {} : _data$data10;

                if (res.errcode === 200) {
                    _this19.remarkList = res.data;
                    _this19.remarkList.forEach(function (a, b) {
                        _this19.$set(_this19.remarkList[b], 'value', a.content); //向陣列裡添加value欄位
                    });
                }
            });
        },
        nullList: function nullList() {
            /*清空*/
            this.addWarehousingList = [{ state: 1, second: 1, createDate: null, code: null, addStorIn: true, storInItem: [{ state: 0, unitShow: true, unit: '', num: 1, boxNo: 1, item: '', qty: null, locationId: '', value: '', boxNoShow: false, itemShows: true, qtyShow: true, locationIdShows: false, length: null, wide: null, high: null, ckgShow: true, volume: null, countVolume: null, inItemPrice: 0, quantity: null, quantityShow: true }] }];
            this.form = {
                id: null, code: null, name: null, phone: null, address: null, sales: null, createDate: null, sCode: ''
            };
            this.updateStorIn = "";
            this.storInId = 0;
            //this.form.createDate = new Date().Format("yyyy-MM-dd hh:mm:ss");
        },
        test: function test() {
            this.show = true;
            this.add = false;
        }
    },
    activated: function activated() {
        var _this20 = this;

        /*進入載入*/
        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data11 = data.data,
                res = _data$data11 === undefined ? {} : _data$data11;

            _this20.custSalesList = res.data;
        });
        Date.prototype.Format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小時
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }return fmt;
        };
        this.getWarehousing();
        this.cancelAdd();
        this.selCutomerCode();
        this.letSalesList(); //查詢銷售員
        this.getRemarkList(); //常用列表
        // Math.round(new Date().getTime()/1000); js轉Unix
        //new Date(createDate*1000).Format("yyyy-MM-dd hh:mm:ss") Unix轉js

        //首页查詢功能
        if (this.$store.getters.warehouseSta == true) {
            //                this.$store.commit("setSearchSte",true);
            this.selSotrIn(this.$route.params.id, this.$route.params.typeId);
            this.$store.commit("setSearchSte", true);
        }

        //客戶详情編輯
        if (this.$store.getters.customerInSte == true) {
            //                this.$store.commit("setSearchSte",true);
            this.selSotrIn(this.$route.params.id, this.$route.params.typeId);
        }
        this.storInAdd();
    },

    computed: {},
    watch: {
        '$route': 'test'
    }
});

/***/ }),

/***/ "aT0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddStockOut_vue__ = __webpack_require__("1RGA");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c772754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddStockOut_vue__ = __webpack_require__("5Qma");
function injectStyle (ssrContext) {
  __webpack_require__("QPd3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddStockOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c772754_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddStockOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bTY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cjmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.handleTypeAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增類別")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.handleAdd}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增備註")])],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.requestRemarkList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":"備註內容","clearable":""},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"placeholder":"類別","clearable":""},model:{value:(_vm.searchType),callback:function ($$v) {_vm.searchType=$$v},expression:"searchType"}},_vm._l((_vm.remarkList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.typeName,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"background-color":"#4B78FF"},attrs:{"type":"primary"},on:{"click":_vm.requestRemarkList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" 搜索")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('el-table',{staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.staffs,"empty-text":"无数据","stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"content","align":"left","label":"備註內容"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeName","align":"left","label":"類別"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ordering","align":"left","label":"排序"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","width":"100","align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v("操作\n\t\t\t                ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" 刪除")])],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogTypeName,"visible":_vm.dialogTypeVisible,"width":"350px"},on:{"update:visible":function($event){_vm.dialogTypeVisible=$event}}},[_c('el-form',{ref:"typeForm",attrs:{"model":_vm.typeForm,"size":"small","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"類別名：","prop":"content"}},[_c('el-input',{attrs:{"auto-complete":"off","widht":"160px","placeholder":"請輸入類別名"},model:{value:(_vm.typeForm.typeName),callback:function ($$v) {_vm.$set(_vm.typeForm, "typeName", $$v)},expression:"typeForm.typeName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","plain":""},on:{"click":_vm.handleTypeSave}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-delete","plain":""},on:{"click":function($event){_vm.dialogTypeVisible = false}}},[_vm._v("取 消")])],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogFormVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"homeForm",attrs:{"model":_vm.homeForm,"size":"small","label-width":"120px"}},[_c('el-form-item',{staticStyle:{"display":"none"},attrs:{"label":"ID"}},[_c('el-input',{attrs:{"auto-complete":"off"},model:{value:(_vm.homeForm.id),callback:function ($$v) {_vm.$set(_vm.homeForm, "id", $$v)},expression:"homeForm.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"類別："}},[_c('el-select',{staticStyle:{"width":"240px"},attrs:{"placeholder":"請選擇類別"},model:{value:(_vm.homeForm.typeId),callback:function ($$v) {_vm.$set(_vm.homeForm, "typeId", $$v)},expression:"homeForm.typeId"}},_vm._l((_vm.remarkList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.typeName,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"備註內容：","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","auto-complete":"off","widht":"160px","placeholder":"請輸入內容"},model:{value:(_vm.homeForm.content),callback:function ($$v) {_vm.$set(_vm.homeForm, "content", $$v)},expression:"homeForm.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"排序：","prop":"ordering"}},[_c('el-input-number',{staticStyle:{"width":"240px"},attrs:{"controls-position":"right","min":1},model:{value:(_vm.homeForm.ordering),callback:function ($$v) {_vm.$set(_vm.homeForm, "ordering", $$v)},expression:"homeForm.ordering"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","plain":""},on:{"click":_vm.handleSave}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-delete","plain":""},on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dHlV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.ismobilePhone)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"border":"","data":_vm.customerList},on:{"row-click":_vm.selDetails}},[_c('el-table-column',{attrs:{"prop":"code","label":"客戶編號"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","width":"190px"}})],1):_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.customerList}},[_c('el-table-column',{attrs:{"prop":"name","label":"姓名","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phone","label":"電話","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales","label":"銷售員","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"地址"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createDate","label":"創建時間"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("date")(scope.row.createDate*1000,'%Y-%m-%d %H:%M')))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"操作","fixed":"right","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.selDetails(scope.row)}}},[_c('i',{staticClass:"fa fa-search-plus"}),_vm._v(" 详情")])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogDiscEditVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"customerForm",attrs:{"model":_vm.customerForm,"rules":_vm.customerRules,"label-width":"130px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"客戶編號:","prop":"code"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text"},model:{value:(_vm.customerForm.code),callback:function ($$v) {_vm.$set(_vm.customerForm, "code", $$v)},expression:"customerForm.code"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"姓名:","prop":"name"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.name),callback:function ($$v) {_vm.$set(_vm.customerForm, "name", $$v)},expression:"customerForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"電話:","prop":"phone"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.phone),callback:function ($$v) {_vm.$set(_vm.customerForm, "phone", $$v)},expression:"customerForm.phone"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"地址:","prop":"address"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.address),callback:function ($$v) {_vm.$set(_vm.customerForm, "address", $$v)},expression:"customerForm.address"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"銷售員:","prop":"sales"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.sales),callback:function ($$v) {_vm.$set(_vm.customerForm, "sales", $$v)},expression:"customerForm.sales"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.customerSave}},[_vm._v("確認")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dOt5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarList_vue__ = __webpack_require__("J2a8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f813f260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarList_vue__ = __webpack_require__("yoRr");
function injectStyle (ssrContext) {
  __webpack_require__("ia5X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalendarList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f813f260_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalendarList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dQMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1000px"}},[_c('el-form',{ref:"jobOrderForm",staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.jobOrderForm,"rules":_vm.jobRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"工作單號：","prop":"jobNo"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"size":"medium"},model:{value:(_vm.jobOrderForm.jobNo),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "jobNo", $$v)},expression:"jobOrderForm.jobNo"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"startDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},on:{"change":_vm.getTimes},model:{value:(_vm.jobOrderForm.startDate),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "startDate", $$v)},expression:"jobOrderForm.startDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":0.5}},[_c('div',{staticStyle:{"margin-top":"5px","margin-right":"7px"}},[_vm._v("~")])]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-form-item',{attrs:{"prop":"endDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":""},model:{value:(_vm.jobOrderForm.endDate),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "endDate", $$v)},expression:"jobOrderForm.endDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"時間：","prop":"jobTime"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.jobTime),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "jobTime", $$v)},expression:"jobOrderForm.jobTime"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"服務類別：","prop":"service"}},[_c('el-select',{staticStyle:{"width":"160px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.service),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "service", $$v)},expression:"jobOrderForm.service"}},_vm._l((_vm.serviceOption),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"客戶：","prop":"custNo"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"default-first-option":"","valueKey":"id","placeholder":"","filterable":"","remote":"","remote-method":_vm.itemRemoteMethod},on:{"change":_vm.custChange},model:{value:(_vm.jobOrderForm.custNo),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "custNo", $$v)},expression:"jobOrderForm.custNo"}},_vm._l((_vm.custOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.code,"value":item}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.code))]),_vm._v(" \n\t\t\t\t\t\t\t\t                                      "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"姓名："}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t         "+_vm._s(_vm.jobOrderForm.custName)+"\n\t\t\t\t\t\t\t\t\t\t\t\t      ")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"大小容量：","prop":"volume"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.volume),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "volume", $$v)},expression:"jobOrderForm.volume"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"起點：","prop":"origin"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.origin),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "origin", $$v)},expression:"jobOrderForm.origin"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"目的地：","prop":"dest"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.dest),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "dest", $$v)},expression:"jobOrderForm.dest"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"聯絡人：","prop":"contactP"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.contactP),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "contactP", $$v)},expression:"jobOrderForm.contactP"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電話號碼：","prop":"contactT"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.contactT),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "contactT", $$v)},expression:"jobOrderForm.contactT"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"主管：","prop":"supervisor"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.supervisor),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "supervisor", $$v)},expression:"jobOrderForm.supervisor"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"打印代碼：","prop":"printCode"}},[_c('el-input',{staticStyle:{"width":"170px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.printCode),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "printCode", $$v)},expression:"jobOrderForm.printCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5.3}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"是否收錢：","prop":"cashOrder"}},[_c('el-input',{staticStyle:{"width":"240px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.cashOrder),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "cashOrder", $$v)},expression:"jobOrderForm.cashOrder"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"備註：","prop":"remark"}},[_c('el-select',{staticStyle:{"width":"800px"},attrs:{"label-width":"100px","placeholder":"備註","prop":"remark"},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}},_vm._l((_vm.remarkList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.content,"value":item.content}})}),1)],1),_vm._v(" "),_c('el-button',{staticStyle:{"background-color":"#b68e38","border-color":"#b68e38"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.addRemark}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 添加")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',[_c('el-form-item',{attrs:{"label-width":"100px","label":"工作內容：","prop":"jobDetail"}},[_c('el-input',{staticStyle:{"width":"800px"},attrs:{"id":"textareaid","type":"textarea","autosize":{ minRows: 8, maxRows:18},"placeholder":""},model:{value:(_vm.jobOrderForm.jobDetail),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "jobDetail", $$v)},expression:"jobOrderForm.jobDetail"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"預計箱：","prop":"estQty1"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.estQty1),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "estQty1", $$v)},expression:"jobOrderForm.estQty1"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"真實箱：","prop":"realQty1"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.realQty1),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "realQty1", $$v)},expression:"jobOrderForm.realQty1"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"預計板：","prop":"estQty2"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.estQty2),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "estQty2", $$v)},expression:"jobOrderForm.estQty2"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"真實板：","prop":"realQty2"}},[_c('el-input',{staticStyle:{"width":"140px"},attrs:{"placeholder":""},model:{value:(_vm.jobOrderForm.realQty2),callback:function ($$v) {_vm.$set(_vm.jobOrderForm, "realQty2", $$v)},expression:"jobOrderForm.realQty2"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.jobSave}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXm+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var validateName = function validateName(rule, value, callback) {
            if (value === '') {
                callback(new Error("帳號不能為空"));
            } else {
                callback();
            }
        };
        return {
            staffs: [],
            roleList: [],
            addList: true,
            dialogVisible: false,
            dialogFormVisible: false,
            title: "", //名称
            staffTableloading: false,
            updateStaff: "", //修改时验证是否是当前修改的用户
            searchName: '',
            searchRids: '',
            searchCanLogin: '',
            pager: {
                page: 0,
                size: 15,
                total: 0
            },
            openStopOptions: [{
                value: 1,
                label: this.$t('m.t_enable')
            }, {
                value: 2,
                label: this.$t('m.t_stop')
            }],
            staffForm: {
                loginName: '',
                password: '',
                password1: '',
                name: '',
                rName: '',
                email: '',
                canLogin: 1,
                id: 0,
                roleId: 0
            },
            validatNum: 0
        };
    },

    methods: {
        selLoginName: function selLoginName(loginName, num) {
            var _this = this;

            /*查詢当前的帐号是否重复*/
            if (loginName.toUpperCase() == this.staffLL.toUpperCase() && num == 0) {
                this.staffForm.loginName = "";
                this.validatNum = 1;
            } else {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_14" /* getStaffByLoginName */])(loginName).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode === 200) {
                        if (res.data != null) {
                            if (res.data.loginName !== _this.updateStaff) {
                                //当前輸入的帐号是否是修改的帐号
                                _this.$alert("当前员工:" + _this.staffForm.loginName + " 已存在!", '提示', {
                                    confirmButtonText: '確定',
                                    type: 'warning',
                                    callback: function callback(action) {
                                        _this.staffForm.loginName = "";
                                    }
                                });
                            }
                        }
                    } else {
                        _this.$message.error(res.errmsg);
                    }
                });
            }
        },
        requestStaffList: function requestStaffList() {
            var _this2 = this;

            /*查詢所有的员工*/
            this.staffTableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, name: this.searchName.trim(), staffId: this.searchRids, loginId: this.searchCanLogin };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_15" /* getStaffList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode === 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        staffs = _res$data$data === undefined ? [] : _res$data$data;

                    _this2.staffs = staffs;
                    _this2.pager.total = total;
                    _this2.pager.page = page;
                    _this2.pager.size = size;
                    _this2.staffTableloading = false;
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        selRole: function selRole() {
            var _this3 = this;

            /*查詢角色*/
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["t" /* getAllRoleList */])().then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode === 200) {
                    var roleMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
                    res.data.forEach(function (item, i) {
                        roleMap.set(i, { value: item.id, label: item.name });
                    });
                    _this3.roleList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(roleMap.values()));
                }
            });
        },
        delStaff: function delStaff(id, name) {
            var _this4 = this;

            /*删除会员*/
            this.$confirm('確定要刪除員工' + name + '?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["o" /* deleteStaff */])(id).then(function (data) {
                    var _data$data4 = data.data,
                        res = _data$data4 === undefined ? {} : _data$data4;

                    if (res.errcode === 200) {
                        _this4.$message({
                            type: 'success',
                            message: '刪除成功!'
                        });
                        _this4.isEmptyNull();
                        _this4.requestStaffList();
                    }
                });
            });
        },
        roleIdName: function roleIdName() {
            /*選擇角色*/
            this.staffForm.roleId = this.staffForm.rName;
        },
        addStaff: function addStaff(item, str) {
            /*点击添加*/
            this.validatNum = 0;
            this.updateStaff = "";
            this.isEmptyNull();
            this.dialogVisible = true;
            if (str === "添加") {
                this.title = "添加員工";
                this.addList = true;
            } else {
                this.updateStaff = item.loginName;
                this.addList = false;
                this.title = "修改員工";
                this.staffForm.loginName = item.loginName;
                this.staffForm.name = item.name;
                this.staffForm.rName = item.rName;
                this.staffForm.roleId = item.roles[0].id;
                this.staffForm.email = item.email;
                this.staffForm.id = item.id;
                this.staffForm.canLogin = item.canLogin;
                if (item.canLogin == 1) {
                    this.openStopOptions[0].value = item.canLogin;
                } else {
                    this.openStopOptions[1].value = item.canLogin;
                }
            }
        },
        addStaffPwd: function addStaffPwd(item, str) {
            /*修改员工密码*/
            this.staffForm.id = item.id;
            this.dialogFormVisible = true;
        },
        modifyStaffPassword: function modifyStaffPassword(formName) {
            var _this5 = this;

            //修改密碼
            var str = "";
            if (this.staffForm.password === "" || this.staffForm.password === null) {
                str = "登錄密碼不能為空";
            }if (this.staffForm.password1 === "" || this.staffForm.password1 === null) {
                str = "確認密碼不能為空";
            }if (this.staffForm.password1 !== this.staffForm.password) {
                str = "兩次密碼不一樣";
            }
            if (str !== "") {
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
                this.staffForm.password = "";
                this.staffForm.password1 = "";
            } else {
                this.$refs.form.validate(function (valid) {
                    if (valid) {
                        return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_56" /* modifyStaffByIdPassword */])({ password: _this5.staffForm.password, id: _this5.staffForm.id }).then(function (data) {
                            var _data$data5 = data.data,
                                res = _data$data5 === undefined ? {} : _data$data5;

                            if (res.errcode === 200) {
                                _this5.$message({
                                    message: "修改成功",
                                    type: 'success'
                                });
                                _this5.dialogFormVisible = false;
                                _this5.staffForm.password = '';
                                _this5.staffForm.password1 = '';
                                _this5.isEmptyNull();
                            } else {
                                _this5.$message({
                                    message: "修改失敗",
                                    type: 'warning'
                                });
                            }
                        });
                    }
                });
            }
        },
        handleCurrentChange: function handleCurrentChange() {
            /*分頁*/
            this.requestStaffList();
        },
        submitStaff: function submitStaff() {
            var _this6 = this;

            /*添加员工*/
            if (this.staffForm.loginName == "" || this.staffForm.loginName == null) {
                return "帳號不能為空";
            }
            this.dialogVisible = false;
            var str = this.isNull();
            if (str !== "") {
                this.dialogVisible = true;
                this.$alert(str, '提示', {
                    confirmButtonText: '確定',
                    type: 'error'
                });
            } else {
                var params = {
                    loginName: this.staffForm.loginName,
                    password: this.staffForm.password1,
                    name: this.staffForm.name,
                    email: this.staffForm.email,
                    roleId: this.staffForm.roleId,
                    canLogin: this.staffForm.canLogin,
                    id: this.staffForm.id
                };

                if (this.addList === true) {
                    //添加员工
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_50" /* insertStaff */])(params).then(function (data) {
                        var _data$data6 = data.data,
                            res = _data$data6 === undefined ? {} : _data$data6;
                        //console.log("res",res);

                        if (res.errcode === 200) {
                            _this6.$alert('添加員工成功!', '添加員工', {
                                confirmButtonText: '確定',
                                callback: function callback(action) {
                                    _this6.isEmptyNull();
                                    _this6.requestStaffList();
                                }
                            });
                        } else {
                            _this6.$message.error("添加員工失败！");
                        }
                    });
                } else {
                    //修改员工
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_78" /* updateStaff */])(params).then(function (data) {
                        var _data$data7 = data.data,
                            res = _data$data7 === undefined ? {} : _data$data7;
                        //console.log("res",res);

                        if (res.errcode === 200) {
                            _this6.$alert('修改員工成功!', '員工', {
                                confirmButtonText: '確定',
                                callback: function callback(action) {
                                    _this6.isEmptyNull();
                                    _this6.requestStaffList();
                                }
                            });
                        } else {
                            _this6.$message.error("修改員工失败！");
                        }
                    });
                }
            }
        },
        cancelAddStaff: function cancelAddStaff() {
            this.dialogVisible = false;
            this.isEmptyNull();
        },
        isEmptyNull: function isEmptyNull() {
            /*清空*/
            this.staffForm.loginName = '';
            this.staffForm.password = '';
            this.staffForm.password1 = '';
            this.staffForm.name = '';
            this.staffForm.rName = '';
            this.staffForm.email = '';
            this.updateStaff = "";
            this.validatNum = 0;
        },
        isNull: function isNull() {
            /*是否为空*/
            if (this.staffForm.loginName === "" || this.staffForm.loginName === null) {
                return "帳號不能為空";
            }
            if (this.addList === true) {
                if (this.staffForm.password === "" || this.staffForm.password === null) {
                    return "登錄密碼不能為空";
                }if (this.staffForm.password1 === "" || this.staffForm.password1 === null) {
                    return "確認密碼不能為空";
                }
            }
            if (this.staffForm.password1 !== this.staffForm.password) {
                return "兩次密碼不一樣";
            }if (this.staffForm.name === "" || this.staffForm.name === null) {
                return "姓名不能為空";
            }if (this.staffForm.rName === "" || this.staffForm.rName === null) {
                return "角色不能為空";
            }
            if (this.staffForm.email != null && this.staffForm.email != "") {
                var reg = /^((([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6}\;))*(([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})))$/;
                if (!reg.test(this.staffForm.email)) {
                    return "請輸入正确的邮箱地址";
                }
            }
            return "";
        }
    },
    mounted: function mounted() {},

    computed: {
        staffLL: function staffLL() {
            return this.$store.getters.staff.loginName;
        },
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("STAFF_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("STAFF_EDIT");
        },
        canDel: function canDel() {
            return this.$store.getters.hasPermission("STAFF_DEL");
        },
        editPwd: function editPwd() {
            return this.$store.getters.hasPermission("EDIT_FTAFF_PWD");
        }
    },
    activated: function activated() {
        //初始化員工類型
        this.selRole();
        this.requestStaffList();
    }
});

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fqUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            rollingForm: {
                id: '',
                feedDate: "",
                carNumber: '',
                oneCar: '0.5',
                twoCar: '1',
                threeCar: '2',
                sendBox: '',
                oneOther: '',
                internal: ''
            },
            rollingRules: {
                feedDate: [{ required: true, message: '日期不能為空', trigger: 'change' }],
                carNumber: [{ required: true, message: '車號不能為空', trigger: 'change' }],
                oneCar: [{ required: true, message: '扎車坑紙不能為空', trigger: 'change' }],
                twoCar: [{ required: true, message: '扎車地膠不能為空', trigger: 'change' }],
                threeCar: [{ required: true, message: '扎車縐紋紙不能為空', trigger: 'change' }]
            },
            acctId: '',
            poiItemList: [],
            poiItem: {},
            itemOptions: [],
            disabledNum: false,
            index: 0,
            delRollItemList: [],
            loadingSave: false,
            oldoneCar: '',
            oldtwoCar: '',
            oldthreeCar: '',
            feedOldForm: {
                oldfork: '',
                oldchelsea: '',
                oldpitPaper: '', //坑紙
                oldnewsPaper: '', //报纸
                oldbuBu: '',
                oldcopyPaper: '',
                oldmat: '', //毡
                oldtinFoil: '', //保鲜纸
                oldazusa: '',
                oldshortWood: '', //矮木
                oldironCar: '',
                oldtoGlue: '',
                oldsoftPaper: '',
                oldlousyPaper: '', //烂纸
                oldmoistureproof: '',
                oldelectric: '',
                oldgummedPaper: '',
                oldbig: '',
                oldinthe: '',
                oldfine: '',
                oldoldBig: '',
                oldoldInthe: '',
                oldoldFine: '',
                oldplasma: '',
                oldcrepePaper: '',
                oldflatClothing: '', //平衣
                oldrefrigerator: '',
                oldelastic: '', //黑色橡筋
                oldcardboard: '',
                oldstiff: '',
                oldbulktank: '',
                oldpaperCardBoard: '',
                oldthreeSeats: '',
                oldtwoSeats: '',
                oldoneSeats: '',
                oldthreeRuler: '',
                oldfourRuler: '',
                oldfiveRuler: '',
                oldsixRuler: '',
                oldoneSmall: '',
                oldsmall: '',
                oldtool: '',
                oldglue: '',
                oldtoCounter: '',
                oldcage: '', //铁笼
                oldtheWire: '',
                oldplywood: '',
                oldoneGlue: '',
                oldwireMesh: '',
                oldproductCar: '',
                oldtape: '',
                oldother: '',
                oldstatus: '',
                oldoneCar: '',
                oldtwoCar: '',
                oldthreeCar: '',
                oldsmooth: '',
                oldlengthFloor: '',
                oldshortFloor: ''
            },

            paramsId: '',
            updateId: 0
        };
    },

    methods: {
        removeRollItem: function removeRollItem(index) {
            var i = 0;
            var delIndexId = 0;
            for (i; i < this.poiItemList.length; i++) {
                console.log("index==" + index);
                console.log("this.poiItemList[i].index==" + this.poiItemList[i].index);
                console.log("this.poiItemList[i].id==" + this.poiItemList[i].id);
                if (index == this.poiItemList[i].index) {
                    if (this.poiItemList[i].id != null) {
                        delIndexId = this.poiItemList[i].id;
                        this.delRollItemList.push(delIndexId);
                    }
                    break;
                }
            }
            this.poiItemList.splice(i, 1);
            this.rearrIndex();
        },

        //當發票商品刪除的時候， 重新給每個index 賦值
        rearrIndex: function rearrIndex() {
            var i = 0;
            for (i = 0; i < this.poiItemList.length; i++) {
                this.poiItemList[i].index = i + 1;
            }
            this.index = i;
        },
        updateRollSave: function updateRollSave() {
            var _this = this;

            if (this.rollingForm.feedDate == '') {
                this.rollingForm.feedDate = 0;
            }
            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.rollingForm);
            params.delRollItemList = this.delRollItemList;
            delete params.poiItemsList;
            params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_76" /* updateRollSave */])(params).then(function (data) {
                var _data$data = data.data,
                    errcode = _data$data.errcode,
                    errmsg = _data$data.errmsg;

                if (errcode == 200) {
                    _this.$message.success("保存成功");
                    _this.resetForm("rollingForm");
                    _this.resetForm("poiItem");
                    _this.disabledNum = false;
                    _this.poiItemList = [];
                    _this.acctId = '';
                    _this.updateId = 0;
                    _this.$router.push({
                        name: '物料出入倉',
                        params: { str: new Date().getTime() }
                    });
                    _this.$store.commit("closeTab", 'rollEdit');
                    _this.initalRolling();
                } else {
                    _this.$message.error(errmsg);
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        msgBox: function msgBox(value) {
            this.$alert(value, this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true
            });
        },
        validateCarNumber: function validateCarNumber(Number) {
            if (Number != '' && Number != null) {
                if (Number.length > 6) {
                    return this.$message.error("車號最多是6個位");
                }
            }
        },
        validatePitPaperTitle: function validatePitPaperTitle(oneCar) {
            var _this2 = this;

            if (oneCar != '' && oneCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(oneCar)) {
                    this.rollingForm.oneCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (oneCar == 0) {
                        return this.$message.error("輸入的數字要大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].pitPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '') {
                                    num = num + parseFloat(this.poiItemList[i].pitPaper);
                                }
                            }
                        }
                        var params = { itemName: "坑紙" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (_this2.rollingForm.id != null && _this2.rollingForm.id != '') {
                                    var _params = { rollId: _this2.rollingForm.id, field: "PIT_PAPER" };
                                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params).then(function (data) {
                                        var items = data.data.data;
                                        if (num + parseFloat(oneCar) > number + items + parseFloat(_this2.oldoneCar)) {
                                            _this2.rollingForm.oneCar = "";
                                            return _this2.$message.error("坑紙出倉數量大於倉存數！");
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            };
        },
        validateTwoCarTitle: function validateTwoCarTitle(twoCar) {
            var _this3 = this;

            if (twoCar != '' && twoCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(twoCar)) {
                    this.rollingForm.twoCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (twoCar == 0) {
                        return this.$message.error("輸入的數字大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].toGlue == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '') {
                                    num = num + parseFloat(this.poiItemList[i].toGlue);
                                }
                            }
                        }
                        var params = { itemName: "地膠" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (_this3.rollingForm.id != null && _this3.rollingForm.id != '') {
                                    var _params2 = { rollId: _this3.rollingForm.id, field: "TOGLUE" };
                                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params2).then(function (data) {
                                        var items = data.data.data;
                                        if (num + parseFloat(twoCar) > number + items + parseFloat(_this3.oldtwoCar)) {
                                            _this3.rollingForm.twoCar = "";
                                            return _this3.$message.error("坑紙出倉數量大於倉存數！");
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            };
        },
        validateThreeTitle: function validateThreeTitle(threeCar) {
            var _this4 = this;

            if (threeCar != '' && threeCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(threeCar)) {
                    this.rollingForm.threeCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (threeCar == 0) {
                        return this.$message.error("輸入的數字大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].crepePaper == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '') {
                                    num = num + parseFloat(this.poiItemList[i].crepePaper);
                                }
                            }
                        }
                        var params = { itemName: "縐紋紙" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (_this4.rollingForm.id != null && _this4.rollingForm.id != '') {
                                    var _params3 = { rollId: _this4.rollingForm.id, field: "CREPE_PAPER" };
                                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params3).then(function (data) {
                                        var items = data.data.data;
                                        if (num + parseFloat(threeCar) > number + items + parseFloat(_this4.oldthreeCar)) {
                                            _this4.rollingForm.threeCar = "";
                                            return _this4.$message.error("縐紋紙出倉數量大於倉存數！");
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            };
        },
        validatePitPaper: function validatePitPaper(poiItem) {
            var _this5 = this;

            if (poiItem.pitPaper != '' && poiItem.pitPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.pitPaper)) {
                    poiItem.pitPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].pitPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].pitPaper);
                            }
                        }
                    }
                    if (this.rollingForm.oneCar != "" && this.rollingForm.oneCar != null) {
                        num = num + parseFloat(this.rollingForm.oneCar);
                    }
                    var params = { itemName: "坑紙" };
                    return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params4 = { rollId: _this5.rollingForm.id, field: "PIT_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params4).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items + parseFloat(_this5.oldoneCar)) {
                                        poiItem.pitPaper = "";
                                        return _this5.$message.error("坑紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number + parseFloat(_this5.oldoneCar)) {
                                    poiItem.pitPaper = "";
                                    return _this5.$message.error("坑紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatenewsPaper: function validatenewsPaper(poiItem) {
            var _this6 = this;

            if (poiItem.newsPaper != '' && poiItem.newsPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.newsPaper)) {
                    poiItem.newsPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].newsPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].newsPaper != null && this.poiItemList[i].newsPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].newsPaper);
                            }
                        }
                    }
                    var params = { itemName: "報紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params5 = { rollId: _this6.rollingForm.id, field: "NEWS_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params5).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.newsPaper = "";
                                        return _this6.$message.error("坑紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.newsPaper = "";
                                    return _this6.$message.error("坑紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatebuBu: function validatebuBu(poiItem) {
            var _this7 = this;

            if (poiItem.buBu != '' && poiItem.buBu != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.buBu)) {
                    poiItem.buBu = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].buBu == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].buBu != null && this.poiItemList[i].buBu != '') {
                                num = num + parseFloat(this.poiItemList[i].buBu);
                            }
                        }
                    }
                    var params = { itemName: "卜卜膠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params6 = { rollId: _this7.rollingForm.id, field: "BUBU" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params6).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.buBu = "";
                                        return _this7.$message.error("卜卜膠出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.buBu = "";
                                    return _this7.$message.error("卜卜膠出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatecopyPaper: function validatecopyPaper(poiItem) {
            var _this8 = this;

            if (poiItem.copyPaper != '' && poiItem.copyPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.copyPaper)) {
                    poiItem.copyPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].copyPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].copyPaper != null && this.poiItemList[i].copyPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].copyPaper);
                            }
                        }
                    }
                    var params = { itemName: "拷貝紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params7 = { rollId: _this8.rollingForm.id, field: "COPY_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params7).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.copyPaper = "";
                                        return _this8.$message.error("拷貝紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.copyPaper = "";
                                    return _this8.$message.error("拷貝紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatemat: function validatemat(poiItem) {
            var _this9 = this;

            if (poiItem.mat != '' && poiItem.mat != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.mat)) {
                    poiItem.mat = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].mat == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].mat != null && this.poiItemList[i].mat != '') {
                                num = num + parseFloat(this.poiItemList[i].mat);
                            }
                        }
                    }
                    var params = { itemName: "毡" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params8 = { rollId: _this9.rollingForm.id, field: "MAT" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params8).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.mat = "";
                                        return _this9.$message.error("毡出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.mat = "";
                                    return _this9.$message.error("毡出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetinFoil: function validatetinFoil(poiItem) {
            var _this10 = this;

            if (poiItem.tinFoil != '' && poiItem.tinFoil != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tinFoil)) {
                    poiItem.tinFoil = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tinFoil == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].tinFoil != null && this.poiItemList[i].tinFoil != '') {
                                num = num + parseFloat(this.poiItemList[i].tinFoil);
                            }
                        }
                    }
                    var params = { itemName: "保鮮紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params9 = { rollId: _this10.rollingForm.id, field: "TIN_FOIL" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params9).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.tinFoil = "";
                                        return _this10.$message.error("保鮮紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.tinFoil = "";
                                    return _this10.$message.error("保鮮紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateazusa: function validateazusa(poiItem) {
            var _this11 = this;

            if (poiItem.azusa != '' && poiItem.azusa != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.azusa)) {
                    poiItem.azusa = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].azusa == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].azusa != null && this.poiItemList[i].azusa != '') {
                                num = num + parseFloat(this.poiItemList[i].azusa);
                            }
                        }
                    }
                    var params = { itemName: "高木箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params10 = { rollId: _this11.rollingForm.id, field: "AZUSA" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params10).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.azusa = "";
                                        return _this11.$message.error("高木箱出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.azusa = "";
                                    return _this11.$message.error("高木箱出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateshortWood: function validateshortWood(poiItem) {
            var _this12 = this;

            if (poiItem.shortWood != '' && poiItem.shortWood != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.shortWood)) {
                    poiItem.shortWood = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].shortWood == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].shortWood != null && this.poiItemList[i].shortWood != '') {
                                num = num + parseFloat(this.poiItemList[i].shortWood);
                            }
                        }
                    }
                    var params = { itemName: "矮木箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params11 = { rollId: _this12.rollingForm.id, field: "SHORT_WOOD" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params11).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.shortWood = "";
                                        return _this12.$message.error("矮木箱出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.shortWood = "";
                                    return _this12.$message.error("矮木箱出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateironCar: function validateironCar(poiItem) {
            var _this13 = this;

            if (poiItem.ironCar != '' && poiItem.ironCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.ironCar)) {
                    poiItem.ironCar = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].ironCar == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].ironCar != null && this.poiItemList[i].ironCar != '') {
                                num = num + parseFloat(this.poiItemList[i].ironCar);
                            }
                        }
                    }
                    var params = { itemName: "鐵車" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params12 = { rollId: _this13.rollingForm.id, field: "IRON_CAR" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params12).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.ironCar = "";
                                        return _this13.$message.error("鐵車出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.ironCar = "";
                                    return _this13.$message.error("鐵車出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetoGlue: function validatetoGlue(poiItem) {
            var _this14 = this;

            if (poiItem.toGlue != '' && poiItem.toGlue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.toGlue)) {
                    poiItem.toGlue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].toGlue == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '') {
                                num = num + parseFloat(this.poiItemList[i].toGlue);
                            }
                        }
                    }
                    if (this.rollingForm.twoCar != "" && this.rollingForm.twoCar != null) {
                        num = num + parseFloat(this.rollingForm.twoCar);
                    }
                    var params = { itemName: "地膠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params13 = { rollId: _this14.rollingForm.id, field: "TOGLUE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params13).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items + parseFloat(_this14.oldtwoCar)) {
                                        poiItem.toGlue = "";
                                        return _this14.$message.error("地膠出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number + parseFloat(_this14.oldtwoCar)) {
                                    poiItem.toGlue = "";
                                    return _this14.$message.error("地膠出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatesoftPaper: function validatesoftPaper(poiItem) {
            var _this15 = this;

            if (poiItem.softPaper != '' && poiItem.softPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.softPaper)) {
                    poiItem.softPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].softPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].softPaper != null && this.poiItemList[i].softPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].softPaper);
                            }
                        }
                    }
                    var params = { itemName: "軟紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params14 = { rollId: _this15.rollingForm.id, field: "SOFT_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params14).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.softPaper = "";
                                        return _this15.$message.error("軟紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.softPaper = "";
                                    return _this15.$message.error("軟紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatelousyPaper: function validatelousyPaper(poiItem) {
            var _this16 = this;

            if (poiItem.lousyPaper != '' && poiItem.lousyPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.lousyPaper)) {
                    poiItem.lousyPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].lousyPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].lousyPaper != null && this.poiItemList[i].lousyPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].lousyPaper);
                            }
                        }
                    }
                    var params = { itemName: "爛紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params15 = { rollId: _this16.rollingForm.id, field: "LOUSY_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params15).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.lousyPaper = "";
                                        return _this16.$message.error("爛紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.lousyPaper = "";
                                    return _this16.$message.error("爛紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatemoistureproof: function validatemoistureproof(poiItem) {
            var _this17 = this;

            if (poiItem.moistureproof != '' && poiItem.moistureproof != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.moistureproof)) {
                    poiItem.moistureproof = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].moistureproof == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].moistureproof != null && this.poiItemList[i].moistureproof != '') {
                                num = num + parseFloat(this.poiItemList[i].moistureproof);
                            }
                        }
                    }
                    var params = { itemName: "防潮珠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params16 = { rollId: _this17.rollingForm.id, field: "MOISTUREPROOF" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params16).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.moistureproof = "";
                                        return _this17.$message.error("防潮珠出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.moistureproof = "";
                                    return _this17.$message.error("防潮珠出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateelectric: function validateelectric(poiItem) {
            var _this18 = this;

            if (poiItem.electric != '' && poiItem.electric != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.electric)) {
                    poiItem.electric = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].electric == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].electric != null && this.poiItemList[i].electric != '') {
                                num = num + parseFloat(this.poiItemList[i].electric);
                            }
                        }
                    }
                    var params = { itemName: "電批" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params17 = { rollId: _this18.rollingForm.id, field: "ELECTRIC" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params17).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.electric = "";
                                        return _this18.$message.error("電批出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.electric = "";
                                    return _this18.$message.error("電批出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validategummedPaper: function validategummedPaper(poiItem) {
            var _this19 = this;

            if (poiItem.gummedPaper != '' && poiItem.gummedPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.gummedPaper)) {
                    poiItem.gummedPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].gummedPaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].gummedPaper != null && this.poiItemList[i].gummedPaper != '') {
                                num = num + parseFloat(this.poiItemList[i].gummedPaper);
                            }
                        }
                    }
                    var params = { itemName: "膠紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params18 = { rollId: _this19.rollingForm.id, field: "GUMMED_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params18).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.gummedPaper = "";
                                        return _this19.$message.error("膠紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.gummedPaper = "";
                                    return _this19.$message.error("膠紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatebig: function validatebig(poiItem) {
            var _this20 = this;

            if (poiItem.big != '' && poiItem.big != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.big)) {
                    poiItem.big = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].big == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].big != null && this.poiItemList[i].big != '') {
                                num = num + parseFloat(this.poiItemList[i].big);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(新大)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params19 = { rollId: _this20.rollingForm.id, field: "BIG" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params19).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.big = "";
                                        return _this20.$message.error("紙盒(新大)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.big = "";
                                    return _this20.$message.error("紙盒(新大)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoldbig: function validateoldbig(poiItem) {
            var _this21 = this;

            if (poiItem.oldBig != '' && poiItem.oldBig != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldBig)) {
                    poiItem.oldBig = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldBig == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oldBig != null && this.poiItemList[i].oldBig != '') {
                                num = num + parseFloat(this.poiItemList[i].oldBig);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(舊大)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params20 = { rollId: _this21.rollingForm.id, field: "OLD_BIG" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params20).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oldBig = "";
                                        return _this21.$message.error("紙盒(舊大)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oldBig = "";
                                    return _this21.$message.error("紙盒(舊大)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateinthe: function validateinthe(poiItem) {
            var _this22 = this;

            if (poiItem.inthe != '' && poiItem.inthe != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.inthe)) {
                    poiItem.inthe = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].inthe == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].inthe != null && this.poiItemList[i].inthe != '') {
                                num = num + parseFloat(this.poiItemList[i].inthe);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(新中)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params21 = { rollId: _this22.rollingForm.id, field: "INTHE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params21).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.inthe = "";
                                        return _this22.$message.error("紙盒(新中)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.inthe = "";
                                    return _this22.$message.error("紙盒(新中)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoldinthe: function validateoldinthe(poiItem) {
            var _this23 = this;

            if (poiItem.oldInthe != '' && poiItem.oldInthe != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldInthe)) {
                    poiItem.oldInthe = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldInthe == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oldInthe != null && this.poiItemList[i].oldInthe != '') {
                                num = num + parseFloat(this.poiItemList[i].oldInthe);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(舊中)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params22 = { rollId: _this23.rollingForm.id, field: "OLD_INTHE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params22).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oldInthe = "";
                                        return _this23.$message.error("紙盒(舊中)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oldInthe = "";
                                    return _this23.$message.error("紙盒(舊中)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatefine: function validatefine(poiItem) {
            var _this24 = this;

            if (poiItem.fine != '' && poiItem.fine != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fine)) {
                    poiItem.fine = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fine == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].fine != null && this.poiItemList[i].fine != '') {
                                num = num + parseFloat(this.poiItemList[i].fine);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(新細)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params23 = { rollId: _this24.rollingForm.id, field: "FINE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params23).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.fine = "";
                                        return _this24.$message.error("紙盒(新細)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.fine = "";
                                    return _this24.$message.error("紙盒(新細)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoldfine: function validateoldfine(poiItem) {
            var _this25 = this;

            if (poiItem.oldFine != '' && poiItem.oldFine != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldFine)) {
                    poiItem.oldFine = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldFine == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oldFine != null && this.poiItemList[i].oldFine != '') {
                                num = num + parseFloat(this.poiItemList[i].oldFine);
                            }
                        }
                    }
                    var params = { itemName: "紙盒(舊細)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params24 = { rollId: _this25.rollingForm.id, field: "OLD_FINE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params24).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oldFine = "";
                                        return _this25.$message.error("紙盒(舊細)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oldFine = "";
                                    return _this25.$message.error("紙盒(舊細)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateplasma: function validateplasma(poiItem) {
            var _this26 = this;

            if (poiItem.plasma != '' && poiItem.plasma != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.plasma)) {
                    poiItem.plasma = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].plasma == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].plasma != null && this.poiItemList[i].plasma != '') {
                                num = num + parseFloat(this.poiItemList[i].plasma);
                            }
                        }
                    }
                    var params = { itemName: "Plasma" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params25 = { rollId: _this26.rollingForm.id, field: "PLASMA" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params25).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.plasma = "";
                                        return _this26.$message.error("Plasma出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.plasma = "";
                                    return _this26.$message.error("Plasma出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatecrepePaper: function validatecrepePaper(poiItem) {
            var _this27 = this;

            if (poiItem.crepePaper != '' && poiItem.crepePaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.crepePaper)) {
                    poiItem.crepePaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].crepePaper == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '') {
                                num = num + parseFloat(this.poiItemList[i].crepePaper);
                            }
                        }
                    }
                    if (this.rollingForm.threeCar != "" && this.rollingForm.threeCar != null) {
                        num = num + parseFloat(this.rollingForm.threeCar);
                    }
                    var params = { itemName: "縐紋紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params26 = { rollId: _this27.rollingForm.id, field: "CREPE_PAPER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params26).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items + parseFloat(_this27.oldthreeCar)) {
                                        poiItem.crepePaper = "";
                                        return _this27.$message.error("縐紋紙出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number + +parseFloat(_this27.oldthreeCar)) {
                                    poiItem.crepePaper = "";
                                    return _this27.$message.error("縐紋紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateflatClothing: function validateflatClothing(poiItem) {
            var _this28 = this;

            if (poiItem.flatClothing != '' && poiItem.flatClothing != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.flatClothing)) {
                    poiItem.flatClothing = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].flatClothing == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].flatClothing != null && this.poiItemList[i].flatClothing != '') {
                                num = num + parseFloat(this.poiItemList[i].flatClothing);
                            }
                        }
                    }
                    var params = { itemName: "平衣" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params27 = { rollId: _this28.rollingForm.id, field: "FLATCLOTHING" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params27).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.flatClothing = "";
                                        return _this28.$message.error("平衣出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.flatClothing = "";
                                    return _this28.$message.error("平衣出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validaterefrigerator: function validaterefrigerator(poiItem) {
            var _this29 = this;

            if (poiItem.refrigerator != '' && poiItem.refrigerator != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.refrigerator)) {
                    poiItem.refrigerator = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].refrigerator == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].refrigerator != null && this.poiItemList[i].refrigerator != '') {
                                num = num + parseFloat(this.poiItemList[i].refrigerator);
                            }
                        }
                    }
                    var params = { itemName: "冰箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params28 = { rollId: _this29.rollingForm.id, field: "REFRIGERATOR" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params28).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.refrigerator = "";
                                        return _this29.$message.error("冰箱出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.refrigerator = "";
                                    return _this29.$message.error("冰箱出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateelastic: function validateelastic(poiItem) {
            var _this30 = this;

            if (poiItem.elastic != '' && poiItem.elastic != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.elastic)) {
                    poiItem.elastic = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].elastic == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].elastic != null && this.poiItemList[i].elastic != '') {
                                num = num + parseFloat(this.poiItemList[i].elastic);
                            }
                        }
                    }
                    var params = { itemName: "黑色橡筋" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params29 = { rollId: _this30.rollingForm.id, field: "ELASTIC" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params29).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.elastic = "";
                                        return _this30.$message.error("黑色橡筋出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.elastic = "";
                                    return _this30.$message.error("黑色橡筋出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatecardboard: function validatecardboard(poiItem) {
            var _this31 = this;

            if (poiItem.cardboard != '' && poiItem.cardboard != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.cardboard)) {
                    poiItem.cardboard = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].cardboard == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].cardboard != null && this.poiItemList[i].cardboard != '') {
                                num = num + parseFloat(this.poiItemList[i].cardboard);
                            }
                        }
                    }
                    var params = { itemName: "紙板" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params30 = { rollId: _this31.rollingForm.id, field: "CARDBOARD" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params30).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.cardboard = "";
                                        return _this31.$message.error("紙板出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.cardboard = "";
                                    return _this31.$message.error("紙板出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatestiff: function validatestiff(poiItem) {
            var _this32 = this;

            if (poiItem.stiff != '' && poiItem.stiff != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.stiff)) {
                    poiItem.stiff = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].stiff == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].stiff != null && this.poiItemList[i].stiff != '') {
                                num = num + parseFloat(this.poiItemList[i].stiff);
                            }
                        }
                    }
                    var params = { itemName: "企身" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params31 = { rollId: _this32.rollingForm.id, field: "STIFF" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params31).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.stiff = "";
                                        return _this32.$message.error("企身出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.stiff = "";
                                    return _this32.$message.error("企身出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatebulktank: function validatebulktank(poiItem) {
            var _this33 = this;

            if (poiItem.bulktank != '' && poiItem.bulktank != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.bulktank)) {
                    poiItem.bulktank = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].bulktank == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].bulktank != null && this.poiItemList[i].bulktank != '') {
                                num = num + parseFloat(this.poiItemList[i].bulktank);
                            }
                        }
                    }
                    var params = { itemName: "散箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params32 = { rollId: _this33.rollingForm.id, field: "BULKTANK" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params32).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.bulktank = "";
                                        return _this33.$message.error("散箱出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.bulktank = "";
                                    return _this33.$message.error("散箱出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatepaperCardBoard: function validatepaperCardBoard(poiItem) {
            var _this34 = this;

            if (poiItem.paperCardBoard != '' && poiItem.paperCardBoard != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.paperCardBoard)) {
                    poiItem.paperCardBoard = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].paperCardBoard == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].paperCardBoard != null && this.poiItemList[i].paperCardBoard != '') {
                                num = num + parseFloat(this.poiItemList[i].paperCardBoard);
                            }
                        }
                    }
                    var params = { itemName: "紙卡板" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params33 = { rollId: _this34.rollingForm.id, field: "PAPERCARDBOARD" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params33).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.paperCardBoard = "";
                                        return _this34.$message.error("紙卡板出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.paperCardBoard = "";
                                    return _this34.$message.error("紙卡板出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatethreeSeats: function validatethreeSeats(poiItem) {
            var _this35 = this;

            if (poiItem.threeSeats != '' && poiItem.threeSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.threeSeats)) {
                    poiItem.threeSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].threeSeats == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].threeSeats != null && this.poiItemList[i].threeSeats != '') {
                                num = num + parseFloat(this.poiItemList[i].threeSeats);
                            }
                        }
                    }
                    var params = { itemName: "梳化套(3座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params34 = { rollId: _this35.rollingForm.id, field: "THREESEATS" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params34).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.threeSeats = "";
                                        return _this35.$message.error("梳化套(3座位)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.threeSeats = "";
                                    return _this35.$message.error("梳化套(3座位)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetwoSeats: function validatetwoSeats(poiItem) {
            var _this36 = this;

            if (poiItem.twoSeats != '' && poiItem.twoSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.twoSeats)) {
                    poiItem.twoSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].twoSeats == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].twoSeats != null && this.poiItemList[i].twoSeats != '') {
                                num = num + parseFloat(this.poiItemList[i].twoSeats);
                            }
                        }
                    }
                    var params = { itemName: "梳化套(2座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params35 = { rollId: _this36.rollingForm.id, field: "TWOSEATS" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params35).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.twoSeats = "";
                                        return _this36.$message.error("梳化套(2座位)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.twoSeats = "";
                                    return _this36.$message.error("梳化套(2座位)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoneSeats: function validateoneSeats(poiItem) {
            var _this37 = this;

            if (poiItem.oneSeats != '' && poiItem.oneSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneSeats)) {
                    poiItem.oneSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneSeats == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oneSeats != null && this.poiItemList[i].oneSeats != '') {
                                num = num + parseFloat(this.poiItemList[i].oneSeats);
                            }
                        }
                    }
                    var params = { itemName: "梳化套(1座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params36 = { rollId: _this37.rollingForm.id, field: "ONESEATS" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params36).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oneSeats = "";
                                        return _this37.$message.error("梳化套(1座位)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oneSeats = "";
                                    return _this37.$message.error("梳化套(1座位)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatesixRuler: function validatesixRuler(poiItem) {
            var _this38 = this;

            if (poiItem.sixRuler != '' && poiItem.sixRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.sixRuler)) {
                    poiItem.sixRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].sixRuler == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].sixRuler != null && this.poiItemList[i].sixRuler != '') {
                                num = num + parseFloat(this.poiItemList[i].sixRuler);
                            }
                        }
                    }
                    var params = { itemName: "床褥套(6呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params37 = { rollId: _this38.rollingForm.id, field: "SIXRULER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params37).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.sixRuler = "";
                                        return _this38.$message.error("床褥套(6呎)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.sixRuler = "";
                                    return _this38.$message.error("床褥套(6呎)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatefiveRuler: function validatefiveRuler(poiItem) {
            var _this39 = this;

            if (poiItem.fiveRuler != '' && poiItem.fiveRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fiveRuler)) {
                    poiItem.fiveRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fiveRuler == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].fiveRuler != null && this.poiItemList[i].fiveRuler != '') {
                                num = num + parseFloat(this.poiItemList[i].fiveRuler);
                            }
                        }
                    }
                    var params = { itemName: "床褥套(5呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params38 = { rollId: _this39.rollingForm.id, field: "FIVERULER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params38).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.fiveRuler = "";
                                        return _this39.$message.error("床褥套(5呎)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.fiveRuler = "";
                                    return _this39.$message.error("床褥套(5呎)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatefourRuler: function validatefourRuler(poiItem) {
            var _this40 = this;

            if (poiItem.fourRuler != '' && poiItem.fourRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fourRuler)) {
                    poiItem.fourRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fourRuler == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].fiveRuler != null && this.poiItemList[i].fourRuler != '') {
                                num = num + parseFloat(this.poiItemList[i].fourRuler);
                            }
                        }
                    }
                    var params = { itemName: "床褥套(4呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params39 = { rollId: _this40.rollingForm.id, field: "FOURRULER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params39).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.fourRuler = "";
                                        return _this40.$message.error("床褥套(4呎)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.fourRuler = "";
                                    return _this40.$message.error("床褥套(4呎)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatethreeRuler: function validatethreeRuler(poiItem) {
            var _this41 = this;

            if (poiItem.threeRuler != '' && poiItem.threeRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.threeRuler)) {
                    poiItem.threeRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].threeRuler == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].threeRuler != null && this.poiItemList[i].threeRuler != '') {
                                num = num + parseFloat(this.poiItemList[i].threeRuler);
                            }
                        }
                    }
                    var params = { itemName: "床褥套(3呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params40 = { rollId: _this41.rollingForm.id, field: "THREERULER" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params40).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.threeRuler = "";
                                        return _this41.$message.error("床褥套(3呎)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.threeRuler = "";
                                    return _this41.$message.error("床褥套(3呎)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoneSmall: function validateoneSmall(poiItem) {
            var _this42 = this;

            if (poiItem.oneSmall != '' && poiItem.oneSmall != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneSmall)) {
                    poiItem.oneSmall = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneSmall == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oneSmall != null && this.poiItemList[i].oneSmall != '') {
                                num = num + parseFloat(this.poiItemList[i].oneSmall);
                            }
                        }
                    }
                    var params = { itemName: "白水松(1吋)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params41 = { rollId: _this42.rollingForm.id, field: "ONESMALL" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params41).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oneSmall = "";
                                        return _this42.$message.error("白水松(1吋)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oneSmall = "";
                                    return _this42.$message.error("白水松(1吋)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatesmall: function validatesmall(poiItem) {
            var _this43 = this;

            if (poiItem.small != '' && poiItem.small != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.small)) {
                    poiItem.small = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].small == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].small != null && this.poiItemList[i].small != '') {
                                num = num + parseFloat(this.poiItemList[i].small);
                            }
                        }
                    }
                    var params = { itemName: "白水松(半吋)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params42 = { rollId: _this43.rollingForm.id, field: "SMALL" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params42).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.small = "";
                                        return _this43.$message.error("白水松(半吋)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.small = "";
                                    return _this43.$message.error("白水松(半吋)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetool: function validatetool(poiItem) {
            var _this44 = this;

            if (poiItem.tool != '' && poiItem.tool != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tool)) {
                    poiItem.tool = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tool == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].tool != null && this.poiItemList[i].tool != '') {
                                num = num + parseFloat(this.poiItemList[i].tool);
                            }
                        }
                    }
                    var params = { itemName: "開木箱工具" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params43 = { rollId: _this44.rollingForm.id, field: "TOOL" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params43).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.tool = "";
                                        return _this44.$message.error("開木箱工具出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.tool = "";
                                    return _this44.$message.error("開木箱工具出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateglue: function validateglue(poiItem) {
            var _this45 = this;

            if (poiItem.glue != '' && poiItem.glue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.glue)) {
                    poiItem.glue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].glue == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].glue != null && this.poiItemList[i].glue != '') {
                                num = num + parseFloat(this.poiItemList[i].glue);
                            }
                        }
                    }
                    var params = { itemName: "膠(110cm)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params44 = { rollId: _this45.rollingForm.id, field: "GLUE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params44).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.glue = "";
                                        return _this45.$message.error("膠(110cm)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.glue = "";
                                    return _this45.$message.error("膠(110cm)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatelengthFloor: function validatelengthFloor(poiItem) {
            var _this46 = this;

            if (poiItem.lengthFloor != '' && poiItem.lengthFloor != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.lengthFloor)) {
                    poiItem.lengthFloor = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].lengthFloor == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].lengthFloor != null && this.poiItemList[i].lengthFloor != '') {
                                num = num + parseFloat(this.poiItemList[i].lengthFloor);
                            }
                        }
                    }
                    var params = { itemName: "地台板(長)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params45 = { rollId: _this46.rollingForm.id, field: "LENGTH_FLOOR" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params45).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.lengthFloor = "";
                                        return _this46.$message.error("地台板(長)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.lengthFloor = "";
                                    return _this46.$message.error("地台板(長)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateshortFloor: function validateshortFloor(poiItem) {
            var _this47 = this;

            if (poiItem.shortFloor != '' && poiItem.shortFloor != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.shortFloor)) {
                    poiItem.shortFloor = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].shortFloor == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].shortFloor != null && this.poiItemList[i].shortFloor != '') {
                                num = num + parseFloat(this.poiItemList[i].shortFloor);
                            }
                        }
                    }
                    var params = { itemName: "地台板(短)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params46 = { rollId: _this47.rollingForm.id, field: "SHORT_FLOOR" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params46).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.lengthFloor = "";
                                        return _this47.$message.error("地台板(短)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.lengthFloor = "";
                                    return _this47.$message.error("地台板(短)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatecage: function validatecage(poiItem) {
            var _this48 = this;

            if (poiItem.cage != '' && poiItem.cage != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.cage)) {
                    poiItem.cage = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].cage == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].cage != null && this.poiItemList[i].cage != '') {
                                num = num + parseFloat(this.poiItemList[i].cage);
                            }
                        }
                    }
                    var params = { itemName: "铁笼" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params47 = { rollId: _this48.rollingForm.id, field: "CAGE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params47).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.cage = "";
                                        return _this48.$message.error("铁笼出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.cage = "";
                                    return _this48.$message.error("铁笼出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateplywood: function validateplywood(poiItem) {
            var _this49 = this;

            if (poiItem.plywood != '' && poiItem.plywood != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.plywood)) {
                    poiItem.plywood = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].plywood == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].plywood != null && this.poiItemList[i].plywood != '') {
                                num = num + parseFloat(this.poiItemList[i].plywood);
                            }
                        }
                    }
                    var params = { itemName: "夾板(長)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params48 = { rollId: _this49.rollingForm.id, field: "PLYWOOD" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params48).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.plywood = "";
                                        return _this49.$message.error("夾板(長)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.plywood = "";
                                    return _this49.$message.error("夾板(長)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetheWire: function validatetheWire(poiItem) {
            var _this50 = this;

            if (poiItem.theWire != '' && poiItem.theWire != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.theWire)) {
                    poiItem.theWire = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].theWire == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].theWire != null && this.poiItemList[i].theWire != '') {
                                num = num + parseFloat(this.poiItemList[i].theWire);
                            }
                        }
                    }
                    var params = { itemName: "吊繩" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params49 = { rollId: _this50.rollingForm.id, field: "THEWIRE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params49).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.theWire = "";
                                        return _this50.$message.error("吊繩出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.theWire = "";
                                    return _this50.$message.error("吊繩出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateoneGlue: function validateoneGlue(poiItem) {
            var _this51 = this;

            if (poiItem.oneGlue != '' && poiItem.oneGlue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneGlue)) {
                    poiItem.oneGlue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneGlue == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].oneGlue != null && this.poiItemList[i].oneGlue != '') {
                                num = num + parseFloat(this.poiItemList[i].oneGlue);
                            }
                        }
                    }
                    var params = { itemName: "膠(120cm)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params50 = { rollId: _this51.rollingForm.id, field: "ONEGLUE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params50).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.oneGlue = "";
                                        return _this51.$message.error("膠(120cm)出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.oneGlue = "";
                                    return _this51.$message.error("膠(120cm)出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatewireMesh: function validatewireMesh(poiItem) {
            var _this52 = this;

            if (poiItem.wireMesh != '' && poiItem.wireMesh != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.wireMesh)) {
                    poiItem.wireMesh = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].wireMesh == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].wireMesh != null && this.poiItemList[i].wireMesh != '') {
                                num = num + parseFloat(this.poiItemList[i].wireMesh);
                            }
                        }
                    }
                    var params = { itemName: "搬花網" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params51 = { rollId: _this52.rollingForm.id, field: "WIREMESH" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params51).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.wireMesh = "";
                                        return _this52.$message.error("搬花網出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.wireMesh = "";
                                    return _this52.$message.error("搬花網出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateproductCar: function validateproductCar(poiItem) {
            var _this53 = this;

            if (poiItem.productCar != '' && poiItem.productCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.productCar)) {
                    poiItem.productCar = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].productCar == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].productCar != null && this.poiItemList[i].productCar != '') {
                                num = num + parseFloat(this.poiItemList[i].productCar);
                            }
                        }
                    }
                    var params = { itemName: "積車" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params52 = { rollId: _this53.rollingForm.id, field: "PRODUCTCAR" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params52).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.productCar = "";
                                        return _this53.$message.error("積車出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.productCar = "";
                                    return _this53.$message.error("積車出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatetape: function validatetape(poiItem) {
            var _this54 = this;

            if (poiItem.tape != '' && poiItem.tape != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tape)) {
                    poiItem.tape = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tape == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].tape != null && this.poiItemList[i].tape != '') {
                                num = num + parseFloat(this.poiItemList[i].tape);
                            }
                        }
                    }
                    var params = { itemName: "膠紙冚" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params53 = { rollId: _this54.rollingForm.id, field: "TAPE" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params53).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.tape = "";
                                        return _this54.$message.error("膠紙冚出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.tape = "";
                                    return _this54.$message.error("膠紙冚出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatefork: function validatefork(poiItem) {
            var _this55 = this;

            if (poiItem.fork != '' && poiItem.fork != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fork)) {
                    poiItem.fork = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fork == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].fork != null && this.poiItemList[i].fork != '') {
                                num = num + parseFloat(this.poiItemList[i].fork);
                            }
                        }
                    }
                    var params = { itemName: "叉" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params54 = { rollId: _this55.rollingForm.id, field: "FORK" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params54).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.fork = "";
                                        return _this55.$message.error("叉出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.fork = "";
                                    return _this55.$message.error("叉出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatechelsea: function validatechelsea(poiItem) {
            var _this56 = this;

            if (poiItem.chelsea != '' && poiItem.chelsea != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.chelsea)) {
                    poiItem.chelsea = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].chelsea == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].chelsea != null && this.poiItemList[i].chelsea != '') {
                                num = num + parseFloat(this.poiItemList[i].chelsea);
                            }
                        }
                    }
                    var params = { itemName: "車仔" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params55 = { rollId: _this56.rollingForm.id, field: "CHELSEA" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params55).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.chelsea = "";
                                        return _this56.$message.error("車仔出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.chelsea = "";
                                    return _this56.$message.error("車仔出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatesmooth: function validatesmooth(poiItem) {
            var _this57 = this;

            if (poiItem.smooth != '' && poiItem.smooth != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.smooth)) {
                    poiItem.smooth = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].smooth == "半") {
                            num = num + 0.5;
                        } else {
                            if (this.poiItemList[i].smooth != null && this.poiItemList[i].smooth != '') {
                                num = num + parseFloat(this.poiItemList[i].smooth);
                            }
                        }
                    }
                    var params = { itemName: "滑潤" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (poiItem.id != null && poiItem.id != '') {
                                var _params56 = { rollId: _this57.rollingForm.id, field: "SMOOTH" };
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_6" /* getRollingItemRecordById */])(_params56).then(function (data) {
                                    var items = data.data.data;
                                    if (num > number + items) {
                                        poiItem.smooth = "";
                                        return _this57.$message.error("滑潤出倉數量大於倉存數！");
                                    }
                                });
                            } else {
                                if (num > number) {
                                    poiItem.smooth = "";
                                    return _this57.$message.error("滑潤出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        rollSave: function rollSave(ev) {
            var _this58 = this;

            if (ev == 1) {
                this.$confirm(this.$t('m.m_outconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(function () {
                    _this58.rollIngsSave(ev);
                });
            } else {
                this.rollIngsSave(ev);
            }
        },
        rollIngsSave: function rollIngsSave(ev) {
            var _this59 = this;

            if (this.poiItemList.length == 0) {
                return this.$message.error("請新增單信息！");
            }
            this.$refs.rollingForm.validate(function (valid) {
                if (valid) {
                    if (_this59.rollingForm.carNumber != '' && _this59.rollingForm.carNumber != null) {
                        if (_this59.rollingForm.carNumber.length > 6) {
                            return _this59.$message.error("車號最多是6個位");
                        }
                    }
                    _this59.loadingSave = true;
                    if (_this59.rollingForm.feedDate == '') {
                        _this59.rollingForm.feedDate = 0;
                    }
                    if (_this59.poiItemList.length != 0) {
                        _this59.rollingForm.poiItemsList = _this59.poiItemsJson();
                    }
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this59.rollingForm);
                    params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                    params.delRollItemList = _this59.delRollItemList;
                    params.status = ev;
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_77" /* updateRolling */])(params).then(function (data) {
                        var _data$data2 = data.data,
                            errcode = _data$data2.errcode,
                            errmsg = _data$data2.errmsg;

                        if (errcode == 200) {
                            if (ev == 1) {
                                _this59.$message.success("出倉成功");
                            } else {
                                _this59.$message.success("保存成功");
                            }
                            _this59.loadingSave = false;
                            _this59.resetForm("rollingForm");
                            _this59.resetForm("poiItem");
                            _this59.disabledNum = false;
                            _this59.poiItemList = [];
                            _this59.acctId = '';
                            _this59.updateId = 0;
                            _this59.$router.push({
                                name: '物料出入倉',
                                params: { str: new Date().getTime() }
                            });
                            _this59.$store.commit("closeTab", 'rollEdit');
                            _this59.initalRolling();
                        } else {
                            _this59.$message.error(errmsg);
                            _this59.loadingSave = false;
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.updateId = 0;
            this.$router.push({
                name: '物料出入倉',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "rollEdit");
            this.initalRolling();
        },
        createPoiItem: function createPoiItem() {
            this.poiItem = { index: this.index += 1, pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '',
                copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '',
                softPaper: '',
                lousyPaper: '',
                moistureproof: '',
                electric: '',
                gummedPaper: '',
                big: '',
                inthe: '',
                fine: '',
                oldBig: '',
                oldInthe: '',
                oldFine: '',
                plasma: '',
                crepePaper: '',
                flatClothing: '',
                refrigerator: '',
                elastic: '',
                cardboard: '',
                stiff: '',
                bulktank: '',
                paperCardBoard: '',
                threeSeats: '',
                twoSeats: '',
                oneSeats: '',
                threeRuler: '',
                fourRuler: '',
                fiveRuler: '',
                sixRuler: '',
                oneSmall: '',
                small: '',
                tool: '',
                glue: '',
                lengthFloor: '',
                cage: '',
                theWire: '',
                plywood: '',
                oneGlue: '',
                wireMesh: '',
                productCar: '',
                tape: '',
                other: ''
            };

            /*for (var i = 0; i < this.itemOptions.length; i++) {
                if(this.itemOptions[i].itemName=="坑紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                      /!*  if (this.poiItemList[j].id != null && this.poiItemList[j].id != '') {
                            let params = {rollId: this.rollingForm.id, field: "NEWS_PAPER"};
                            getRollingItemRecordById(params).then(data => {
                                let items = data.data.data;
                                oldnumber = oldnumber + items;
                            });
                        }*!/
                        if (this.poiItemList[j].pitPaper != '' && this.poiItemList[j].pitPaper != null) {
                            number = number + parseFloat(this.poiItemList[j].pitPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldoneCar)+this.feedOldForm.oldoneCar;
                    if(numValue!=0){
                        if(this.rollingForm.oneCar !='' && this.rollingForm.oneCar !=null){
                            if (numValue-parseFloat(this.rollingForm.oneCar) > 0) {
                                this.poiItem.pitPaper=numValue-parseFloat(this.rollingForm.oneCar);
                            }else{
                                this.poiItem.pitPaper="";
                            }
                        }else {
                            this.poiItem.pitPaper=numValue;
                        }
                    }else{
                        this.poiItem.pitPaper='';
                    }
                }else if(this.itemOptions[i].itemName=="報紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].newsPaper!='' && this.poiItemList[j].newsPaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].newsPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldnewsPaper;
                    if(numValue!=0){
                        this.poiItem.newsPaper=numValue;
                    }else{
                        this.poiItem.newsPaper='';
                    }
                    // this.poiItem.newsPaper=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                }else if(this.itemOptions[i].itemName=="卜卜膠"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].buBu!='' && this.poiItemList[j].buBu!=null) {
                            number = number + parseFloat(this.poiItemList[j].buBu);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbuBu;
                    if(numValue!=0){
                        this.poiItem.buBu=numValue;
                    }else{
                        this.poiItem.buBu='';
                    }
                }else if(this.itemOptions[i].itemName=="拷貝紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].copyPaper!='' && this.poiItemList[j].copyPaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].copyPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcopyPaper;
                    if(numValue!=0){
                        this.poiItem.copyPaper=numValue;
                    }else{
                        this.poiItem.copyPaper='';
                    }
                }else if(this.itemOptions[i].itemName=="毡"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].mat!='' && this.poiItemList[j].mat!=null) {
                            number = number + parseFloat(this.poiItemList[j].mat);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldmat;
                    if(numValue!=0){
                        this.poiItem.mat=numValue;
                    }else{
                        this.poiItem.mat='';
                    }
                }else if(this.itemOptions[i].itemName=="保鮮紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].tinFoil!='' && this.poiItemList[j].tinFoil!=null) {
                            number = number + parseFloat(this.poiItemList[j].tinFoil);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtinFoil;
                    if(numValue!=0){
                        this.poiItem.tinFoil=numValue;
                    }else{
                        this.poiItem.tinFoil='';
                    }
                }else if(this.itemOptions[i].itemName=="高木箱"){
                    let number = 0
                    let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].azusa!='' && this.poiItemList[j].azusa!=null) {
                            number = number + parseFloat(this.poiItemList[j].azusa);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldazusa;
                    if(numValue!=0){
                        this.poiItem.azusa=numValue;
                    }else{
                        this.poiItem.azusa='';
                    }
                }else if(this.itemOptions[i].itemName=="矮木箱"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].shortWood!='' && this.poiItemList[j].shortWood!=null) {
                            number = number + parseFloat(this.poiItemList[j].shortWood);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldshortWood;
                    if(numValue!=0){
                        this.poiItem.shortWood=numValue;
                    }else{
                        this.poiItem.shortWood='';
                    }
                }else if(this.itemOptions[i].itemName=="鐵車"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].ironCar!='' && this.poiItemList[j].ironCar!=null) {
                            number = number + parseFloat(this.poiItemList[j].ironCar);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldironCar;
                    if(numValue!=0){
                        this.poiItem.ironCar=numValue;
                    }else{
                        this.poiItem.ironCar='';
                    }
                }else if(this.itemOptions[i].itemName=="車仔"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].chelsea!='' && this.poiItemList[j].chelsea!=null) {
                            number = number + parseFloat(this.poiItemList[j].chelsea);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldchelsea;
                    if(numValue!=0){
                        this.poiItem.chelsea=numValue;
                    }else{
                        this.poiItem.chelsea='';
                    }
                }else if(this.itemOptions[i].itemName=="軟紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].softPaper!='' && this.poiItemList[j].softPaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].softPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsoftPaper;
                    if(numValue!=0){
                        this.poiItem.softPaper=numValue;
                    }else{
                        this.poiItem.softPaper='';
                    }
                }else if(this.itemOptions[i].itemName=="爛紙"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].lousyPaper!='' && this.poiItemList[j].lousyPaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].lousyPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldlousyPaper;
                    if(numValue!=0){
                        this.poiItem.lousyPaper=numValue;
                    }else{
                        this.poiItem.lousyPaper='';
                    }
                }else if(this.itemOptions[i].itemName=="防潮珠"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].moistureproof!='' && this.poiItemList[j].moistureproof!=null) {
                            number = number + parseFloat(this.poiItemList[j].moistureproof);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldmoistureproof;
                    if(numValue!=0){
                        this.poiItem.moistureproof=numValue;
                    }else{
                        this.poiItem.moistureproof='';
                    }
                }else if(this.itemOptions[i].itemName=="電批"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].electric!='' && this.poiItemList[j].electric!=null) {
                            number = number + parseFloat(this.poiItemList[j].electric);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldelectric;
                    if(numValue!=0){
                        this.poiItem.electric=numValue;
                    }else{
                        this.poiItem.electric='';
                    }
                }else if(this.itemOptions[i].itemName=="叉"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].fork!='' && this.poiItemList[j].fork!=null) {
                            number = number + parseFloat(this.poiItemList[j].fork);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfork;
                    if(numValue!=0){
                        this.poiItem.fork=numValue;
                    }else{
                        this.poiItem.fork='';
                    }
                }else if(this.itemOptions[i].itemName=="地膠"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].toGlue!='' && this.poiItemList[j].toGlue!=null) {
                            number = number + parseFloat(this.poiItemList[j].toGlue);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldtwoCar)+this.feedOldForm.oldtoGlue;
                    if(numValue!=0){
                        if(this.rollingForm.twoCar !='' && this.rollingForm.twoCar !=null){
                            if ( numValue-parseFloat(this.rollingForm.twoCar) > 0) {
                                this.poiItem.toGlue=numValue-parseFloat(this.rollingForm.twoCar);
                            }else{
                                this.poiItem.toGlue="";
                            }
                        }else {
                            this.poiItem.toGlue=numValue;
                        }
                    }else{
                        this.poiItem.toGlue='';
                    }
                }else if(this.itemOptions[i].itemName=="膠紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].gummedPaper!='' && this.poiItemList[j].gummedPaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].gummedPaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldgummedPaper;
                    if(numValue!=0){
                        this.poiItem.gummedPaper=numValue;
                    }else{
                        this.poiItem.gummedPaper='';
                    }
                }else if(this.itemOptions[i].itemName=="铁笼"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].cage!='' && this.poiItemList[j].cage!=null) {
                            number = number + parseFloat(this.poiItemList[j].cage);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcage;
                    if(numValue!=0){
                        this.poiItem.cage=numValue;
                    }else{
                        this.poiItem.cage='';
                    }
                }else if(this.itemOptions[i].itemName=="夾板(長)"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].plywood!='' && this.poiItemList[j].plywood!=null) {
                            number = number + parseFloat(this.poiItemList[j].plywood);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldplywood;
                    if(numValue!=0){
                        this.poiItem.plywood=numValue;
                    }else{
                        this.poiItem.plywood='';
                    }
                }else if(this.itemOptions[i].itemName=="新大"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].big!='' && this.poiItemList[j].big!=null) {
                            number = number + parseFloat(this.poiItemList[j].big);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbig;
                    if(numValue!=0){
                        this.poiItem.big=numValue;
                    }else{
                        this.poiItem.big='';
                    }
                }else if(this.itemOptions[i].itemName=="新中"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].inthe!='' && this.poiItemList[j].inthe!=null) {
                            number = number + parseFloat(this.poiItemList[j].inthe);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldinthe;
                    if(numValue!=0){
                        this.poiItem.inthe=numValue;
                    }else{
                        this.poiItem.inthe='';
                    }
                }else if(this.itemOptions[i].itemName=="新細"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].fine!='' && this.poiItemList[j].fine!=null) {
                            number = number + parseFloat(this.poiItemList[j].fine);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfine;
                    if(numValue!=0){
                        this.poiItem.fine=numValue;
                    }else{
                        this.poiItem.fine='';
                    }
                }else if(this.itemOptions[i].itemName=="舊大"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oldBig!='' && this.poiItemList[j].oldBig!=null) {
                            number = number + parseFloat(this.poiItemList[j].oldBig);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldBig;
                    if(numValue!=0){
                        this.poiItem.oldBig=numValue;
                    }else{
                        this.poiItem.oldBig='';
                    }
                }else if(this.itemOptions[i].itemName=="舊中"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oldInthe!='' && this.poiItemList[j].oldInthe!=null) {
                            number = number + parseFloat(this.poiItemList[j].oldInthe);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldInthe;
                    if(numValue!=0){
                        this.poiItem.oldInthe=numValue;
                    }else{
                        this.poiItem.oldInthe='';
                    }
                }else if(this.itemOptions[i].itemName=="舊細"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oldFine!='' && this.poiItemList[j].oldFine!=null) {
                            number = number + parseFloat(this.poiItemList[j].oldFine);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoldFine;
                    if(numValue!=0){
                        this.poiItem.oldFine=numValue;
                    }else{
                        this.poiItem.oldFine='';
                    }
                }else if(this.itemOptions[i].itemName=="Plasma"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].plasma!='' && this.poiItemList[j].plasma!=null) {
                            number = number + parseFloat(this.poiItemList[j].plasma);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldplasma;
                    if(numValue!=0){
                        this.poiItem.plasma=numValue;
                    }else{
                        this.poiItem.plasma='';
                    }
                }else if(this.itemOptions[i].itemName=="縐紋紙"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].crepePaper!='' && this.poiItemList[j].crepePaper!=null) {
                            number = number + parseFloat(this.poiItemList[j].crepePaper);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+parseFloat(this.oldthreeCar)+this.feedOldForm.oldcrepePaper;
                    if(numValue!=0){
                        if(this.rollingForm.threeCar !='' && this.rollingForm.threeCar !=null){
                            if ( numValue-parseFloat(this.rollingForm.threeCar) > 0) {
                                this.poiItem.crepePaper=numValue-parseFloat(this.rollingForm.threeCar);
                            }else{
                                this.poiItem.crepePaper="";
                            }
                        }else {
                            this.poiItem.crepePaper=numValue;
                        }
                    }else{
                        this.poiItem.crepePaper='';
                    }
                }else if(this.itemOptions[i].itemName=="冰箱"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].refrigerator!='' && this.poiItemList[j].refrigerator!=null) {
                            number = number + parseFloat(this.poiItemList[j].refrigerator);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldrefrigerator;
                    if(numValue!=0){
                        this.poiItem.refrigerator=numValue;
                    }else{
                        this.poiItem.refrigerator='';
                    }
                }else if(this.itemOptions[i].itemName=="黑色橡筋"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].elastic!='' && this.poiItemList[j].elastic!=null) {
                            number = number + parseFloat(this.poiItemList[j].elastic);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldelastic;
                    if(numValue!=0){
                        this.poiItem.elastic=numValue;
                    }else{
                        this.poiItem.elastic='';
                    }
                }else if(this.itemOptions[i].itemName=="紙板"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].cardboard!='' && this.poiItemList[j].cardboard!=null) {
                            number = number + parseFloat(this.poiItemList[j].cardboard);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldcardboard;
                    if(numValue!=0){
                        this.poiItem.cardboard=numValue;
                    }else{
                        this.poiItem.cardboard='';
                    }
                }else if(this.itemOptions[i].itemName=="企身"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].stiff!='' && this.poiItemList[j].stiff!=null) {
                            number = number + parseFloat(this.poiItemList[j].stiff);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldstiff;
                    if(numValue!=0){
                        this.poiItem.stiff=numValue;
                    }else{
                        this.poiItem.stiff='';
                    }
                }else if(this.itemOptions[i].itemName=="散箱"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].bulktank!='' && this.poiItemList[j].bulktank!=null) {
                            number = number + parseFloat(this.poiItemList[j].bulktank);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldbulktank;
                    if(numValue!=0){
                        this.poiItem.bulktank=numValue;
                    }else{
                        this.poiItem.bulktank='';
                    }
                }else if(this.itemOptions[i].itemName=="紙卡板"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].paperCardBoard!='' && this.poiItemList[j].paperCardBoard!=null) {
                            number = number + parseFloat(this.poiItemList[j].paperCardBoard);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldpaperCardBoard;
                    if(numValue!=0){
                        this.poiItem.paperCardBoard=numValue;
                    }else{
                        this.poiItem.paperCardBoard='';
                    }
                }else if(this.itemOptions[i].itemName=="3座位"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].threeSeats!='' && this.poiItemList[j].threeSeats!=null) {
                            number = number + parseFloat(this.poiItemList[j].threeSeats);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldthreeSeats;
                    if(numValue!=0){
                        this.poiItem.threeSeats=numValue;
                    }else{
                        this.poiItem.threeSeats='';
                    }
                }else if(this.itemOptions[i].itemName=="2座位"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].twoSeats!='' && this.poiItemList[j].twoSeats!=null) {
                            number = number + parseFloat(this.poiItemList[j].twoSeats);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtwoSeats;
                    if(numValue!=0){
                        this.poiItem.twoSeats=numValue;
                    }else{
                        this.poiItem.twoSeats='';
                    }
                }else if(this.itemOptions[i].itemName=="1座位"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oneSeats!='' && this.poiItemList[j].oneSeats!=null) {
                            number = number + parseFloat(this.poiItemList[j].oneSeats);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneSeats;
                    if(numValue!=0){
                        this.poiItem.oneSeats=numValue;
                    }else{
                        this.poiItem.oneSeats='';
                    }
                }else if(this.itemOptions[i].itemName=="6呎"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].sixRuler!='' && this.poiItemList[j].sixRuler!=null) {
                            number = number + parseFloat(this.poiItemList[j].sixRuler);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsixRuler;
                    if(numValue!=0){
                        this.poiItem.sixRuler=numValue;
                    }else{
                        this.poiItem.sixRuler='';
                    }
                }else if(this.itemOptions[i].itemName=="5呎"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].fiveRuler!='' && this.poiItemList[j].fiveRuler!=null) {
                            number = number + parseFloat(this.poiItemList[j].fiveRuler);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfiveRuler;
                    if(numValue!=0){
                        this.poiItem.fiveRuler=numValue;
                    }else{
                        this.poiItem.fiveRuler='';
                    }
                }else if(this.itemOptions[i].itemName=="4呎"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItem.index!=this.poiItemList[j].index && this.poiItemList[j].id==''&& this.poiItemList[j].id==null){
                            if(this.poiItemList[j].fourRuler!='' && this.poiItemList[j].fourRuler!=null) {
                                number = number + parseFloat(this.poiItemList[j].fourRuler);
                            }
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldfourRuler;
                    if(numValue!=0){
                        this.poiItem.fourRuler=numValue;
                    }else{
                        this.poiItem.fourRuler='';
                    }
                }else if(this.itemOptions[i].itemName=="3呎"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].threeRuler!='' && this.poiItemList[j].threeRuler!=null) {
                            number = number + parseFloat(this.poiItemList[j].threeRuler);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldthreeRuler;
                    if(numValue!=0){
                        this.poiItem.threeRuler=numValue;
                    }else{
                        this.poiItem.threeRuler='';
                    }
                }else if(this.itemOptions[i].itemName=="1吋"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oneSmall!='' && this.poiItemList[j].oneSmall!=null) {
                            number = number + parseFloat(this.poiItemList[j].oneSmall);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneSmall;
                    if(numValue!=0){
                        this.poiItem.oneSmall=numValue;
                    }else{
                        this.poiItem.oneSmall='';
                    }
                }else if(this.itemOptions[i].itemName=="半吋"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].small!='' && this.poiItemList[j].small!=null) {
                            number = number + parseFloat(this.poiItemList[j].small);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsmall;
                    if(numValue!=0){
                        this.poiItem.small=numValue;
                    }else{
                        this.poiItem.small='';
                    }
                }else if(this.itemOptions[i].itemName=="吊繩"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].theWire!='' && this.poiItemList[j].theWire!=null) {
                            number = number + parseFloat(this.poiItemList[j].theWire);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtheWire;
                    if(numValue!=0){
                        this.poiItem.theWire=numValue;
                    }else{
                        this.poiItem.theWire='';
                    }
                    //this.poiItem.theWire=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                }else if(this.itemOptions[i].itemName=="搬花網"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].wireMesh!='' && this.poiItemList[j].wireMesh!=null) {
                            number = number + parseFloat(this.poiItemList[j].wireMesh);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldwireMesh;
                    if(numValue!=0){
                        this.poiItem.wireMesh=numValue;
                    }else{
                        this.poiItem.wireMesh='';
                    }
                }else if(this.itemOptions[i].itemName=="開木箱工具"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].tool!='' && this.poiItemList[j].tool!=null) {
                            number = number + parseFloat(this.poiItemList[j].tool);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtool;
                    if(numValue!=0){
                        this.poiItem.tool=numValue;
                    }else{
                        this.poiItem.tool='';
                    }
                }else if(this.itemOptions[i].itemName=="地台板(長)"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].lengthFloor!='' && this.poiItemList[j].lengthFloor!=null) {
                            number = number + parseFloat(this.poiItemList[j].lengthFloor);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldlengthFloor;
                    if(numValue!=0){
                        this.poiItem.lengthFloor=numValue;
                    }else{
                        this.poiItem.lengthFloor='';
                    }
                }else if(this.itemOptions[i].itemName=="滑潤"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].smooth!='' && this.poiItemList[j].smooth!=null) {
                            number = number + parseFloat(this.poiItemList[j].smooth);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldsmooth;
                    if(numValue!=0){
                        this.poiItem.smooth=numValue;
                    }else{
                        this.poiItem.smooth='';
                    }
                }else if(this.itemOptions[i].itemName=="積車"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].productCar!='' && this.poiItemList[j].productCar!=null) {
                            number = number + parseFloat(this.poiItemList[j].productCar);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldproductCar;
                    if(numValue!=0){
                        this.poiItem.productCar=numValue;
                    }else{
                        this.poiItem.productCar='';
                    }
                }else if(this.itemOptions[i].itemName=="膠(110cm)"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].glue!='' && this.poiItemList[j].glue!=null) {
                            number = number + parseFloat(this.poiItemList[j].glue);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldglue;
                    if(numValue!=0){
                        this.poiItem.glue=numValue;
                    }else{
                        this.poiItem.glue='';
                    }
                }else if(this.itemOptions[i].itemName=="地台板(短)"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].shortFloor!='' && this.poiItemList[j].shortFloor!=null) {
                            number = number + parseFloat(this.poiItemList[j].shortFloor);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldshortFloor;
                    if(numValue!=0){
                        this.poiItem.shortFloor=numValue;
                    }else{
                        this.poiItem.shortFloor='';
                    }
                    //this.poiItem.shortFloor=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                }else if(this.itemOptions[i].itemName=="膠(120cm)"){
                    let number = 0
                     let oldnumber = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].oneGlue!='' && this.poiItemList[j].oneGlue!=null) {
                            number = number + parseFloat(this.poiItemList[j].oneGlue);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldoneGlue;
                    if(numValue!=0){
                        this.poiItem.oneGlue=numValue;
                    }else{
                        this.poiItem.oneGlue='';
                    }
                }else if(this.itemOptions[i].itemName=="膠紙冚"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if (this.poiItemList[j].tape != '' && this.poiItemList[j].tape != null) {
                            number = number + parseFloat(this.poiItemList[j].tape);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldtape;
                    if(numValue!=0){
                        this.poiItem.tape=numValue;
                    }else{
                        this.poiItem.tape='';
                    }
                }else if(this.itemOptions[i].itemName=="平衣"){
                    let number = 0
                    for (var j = 0; j < this.poiItemList.length; j++) {
                        if(this.poiItemList[j].flatClothing!='' && this.poiItemList[j].flatClothing!=null) {
                            number = number + parseFloat(this.poiItemList[j].flatClothing);
                        }
                    }
                    let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number+this.feedOldForm.oldflatClothing;
                    if(numValue!=0){
                        this.poiItem.flatClothing=numValue;
                    }else{
                        this.poiItem.flatClothing='';
                    }
                }
            }*/
            this.poiItemList.push(this.poiItem);
            //}
        },

        // 提交時, 把所有報價單商品轉換成json Str
        poiItemsJson: function poiItemsJson() {
            var jsonStr = '[';
            for (var i = 0; i < this.poiItemList.length; i++) {
                jsonStr += '{';
                if (this.poiItemList[i].id != null) {
                    jsonStr += "\"id\":\"" + this.poiItemList[i].id + "\",";
                }
                if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '' && this.poiItemList[i].pitPaper != undefined) {
                    jsonStr += "\"pitPaper\":\"" + this.poiItemList[i].pitPaper + "\",";
                }
                if (this.poiItemList[i].newsPaper != null && this.poiItemList[i].newsPaper != '' && this.poiItemList[i].newsPaper != undefined) {
                    jsonStr += "\"newsPaper\":\"" + this.poiItemList[i].newsPaper + "\",";
                }
                if (this.poiItemList[i].buBu != null && this.poiItemList[i].buBu != '' && this.poiItemList[i].buBu != undefined) {
                    jsonStr += "\"buBu\":\"" + this.poiItemList[i].buBu + "\",";
                }
                if (this.poiItemList[i].copyPaper != null && this.poiItemList[i].copyPaper != '' && this.poiItemList[i].copyPaper != undefined) {
                    jsonStr += "\"copyPaper\":\"" + this.poiItemList[i].copyPaper + "\",";
                }
                if (this.poiItemList[i].mat != null && this.poiItemList[i].mat != '' && this.poiItemList[i].mat != undefined) {
                    jsonStr += "\"mat\":\"" + this.poiItemList[i].mat + "\",";
                }
                if (this.poiItemList[i].tinFoil != null && this.poiItemList[i].tinFoil != '' && this.poiItemList[i].tinFoil != undefined) {
                    jsonStr += "\"tinFoil\":\"" + this.poiItemList[i].tinFoil + "\",";
                }
                if (this.poiItemList[i].azusa != null && this.poiItemList[i].azusa != '' && this.poiItemList[i].azusa != undefined) {
                    jsonStr += "\"azusa\":\"" + this.poiItemList[i].azusa + "\",";
                }
                if (this.poiItemList[i].shortWood != null && this.poiItemList[i].shortWood != '' && this.poiItemList[i].shortWood != undefined) {
                    jsonStr += "\"shortWood\":\"" + this.poiItemList[i].shortWood + "\",";
                }
                if (this.poiItemList[i].ironCar != null && this.poiItemList[i].ironCar != '' && this.poiItemList[i].ironCar != undefined) {
                    jsonStr += "\"ironCar\":\"" + this.poiItemList[i].ironCar + "\",";
                }
                if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '' && this.poiItemList[i].toGlue != undefined) {
                    jsonStr += "\"toGlue\":\"" + this.poiItemList[i].toGlue + "\",";
                }
                if (this.poiItemList[i].softPaper != null && this.poiItemList[i].softPaper != '' && this.poiItemList[i].softPaper != undefined) {
                    jsonStr += "\"softPaper\":\"" + this.poiItemList[i].softPaper + "\",";
                }
                if (this.poiItemList[i].lousyPaper != null && this.poiItemList[i].lousyPaper != '' && this.poiItemList[i].lousyPaper != undefined) {
                    jsonStr += "\"lousyPaper\":\"" + this.poiItemList[i].lousyPaper + "\",";
                }
                if (this.poiItemList[i].moistureproof != null && this.poiItemList[i].moistureproof != '' && this.poiItemList[i].moistureproof != undefined) {
                    jsonStr += "\"moistureproof\":\"" + this.poiItemList[i].moistureproof + "\",";
                }
                if (this.poiItemList[i].electric != null && this.poiItemList[i].electric != '' && this.poiItemList[i].electric != undefined) {
                    jsonStr += "\"electric\":\"" + this.poiItemList[i].electric + "\",";
                }
                if (this.poiItemList[i].gummedPaper != null && this.poiItemList[i].gummedPaper != '' && this.poiItemList[i].gummedPaper != undefined) {
                    jsonStr += "\"gummedPaper\":\"" + this.poiItemList[i].gummedPaper + "\",";
                }
                if (this.poiItemList[i].big != null && this.poiItemList[i].big != '' && this.poiItemList[i].big != undefined) {
                    jsonStr += "\"big\":\"" + this.poiItemList[i].big + "\",";
                }
                if (this.poiItemList[i].inthe != null && this.poiItemList[i].inthe != '' && this.poiItemList[i].inthe != undefined) {
                    jsonStr += "\"inthe\":\"" + this.poiItemList[i].inthe + "\",";
                }
                if (this.poiItemList[i].fine != null && this.poiItemList[i].fine != '' && this.poiItemList[i].fine != undefined) {
                    jsonStr += "\"fine\":\"" + this.poiItemList[i].fine + "\",";
                }
                if (this.poiItemList[i].oldBig != null && this.poiItemList[i].oldBig != '' && this.poiItemList[i].oldBig != undefined) {
                    jsonStr += "\"oldBig\":\"" + this.poiItemList[i].oldBig + "\",";
                }
                if (this.poiItemList[i].oldInthe != null && this.poiItemList[i].oldInthe != '' && this.poiItemList[i].oldInthe != undefined) {
                    jsonStr += "\"oldInthe\":\"" + this.poiItemList[i].oldInthe + "\",";
                }
                if (this.poiItemList[i].oldFine != null && this.poiItemList[i].oldFine != '' && this.poiItemList[i].oldFine != undefined) {
                    jsonStr += "\"oldFine\":\"" + this.poiItemList[i].oldFine + "\",";
                }
                if (this.poiItemList[i].plasma != null && this.poiItemList[i].plasma != '' && this.poiItemList[i].plasma != undefined) {
                    jsonStr += "\"plasma\":\"" + this.poiItemList[i].plasma + "\",";
                }
                if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '' && this.poiItemList[i].crepePaper != undefined) {
                    jsonStr += "\"crepePaper\":\"" + this.poiItemList[i].crepePaper + "\",";
                }
                if (this.poiItemList[i].flatClothing != null && this.poiItemList[i].flatClothing != '' && this.poiItemList[i].flatClothing != undefined) {
                    jsonStr += "\"flatClothing\":\"" + this.poiItemList[i].flatClothing + "\",";
                }
                if (this.poiItemList[i].refrigerator != null && this.poiItemList[i].refrigerator != '' && this.poiItemList[i].refrigerator != undefined) {
                    jsonStr += "\"refrigerator\":\"" + this.poiItemList[i].refrigerator + "\",";
                }
                if (this.poiItemList[i].elastic != null && this.poiItemList[i].elastic != '' && this.poiItemList[i].elastic != undefined) {
                    jsonStr += "\"elastic\":\"" + this.poiItemList[i].elastic + "\",";
                }
                if (this.poiItemList[i].cardboard != null && this.poiItemList[i].cardboard != '' && this.poiItemList[i].cardboard != undefined) {
                    jsonStr += "\"cardboard\":\"" + this.poiItemList[i].cardboard + "\",";
                }
                if (this.poiItemList[i].stiff != null && this.poiItemList[i].stiff != '' && this.poiItemList[i].stiff != undefined) {
                    jsonStr += "\"stiff\":\"" + this.poiItemList[i].stiff + "\",";
                }
                if (this.poiItemList[i].bulktank != null && this.poiItemList[i].bulktank != '' && this.poiItemList[i].bulktank != undefined) {
                    jsonStr += "\"bulktank\":\"" + this.poiItemList[i].bulktank + "\",";
                }
                if (this.poiItemList[i].paperCardBoard != null && this.poiItemList[i].paperCardBoard != '' && this.poiItemList[i].paperCardBoard != undefined) {
                    jsonStr += "\"paperCardBoard\":\"" + this.poiItemList[i].paperCardBoard + "\",";
                }
                if (this.poiItemList[i].threeSeats != null && this.poiItemList[i].threeSeats != '' && this.poiItemList[i].threeSeats != undefined) {
                    jsonStr += "\"threeSeats\":\"" + this.poiItemList[i].threeSeats + "\",";
                }
                if (this.poiItemList[i].twoSeats != null && this.poiItemList[i].twoSeats != '' && this.poiItemList[i].twoSeats != undefined) {
                    jsonStr += "\"twoSeats\":\"" + this.poiItemList[i].twoSeats + "\",";
                }
                if (this.poiItemList[i].oneSeats != null && this.poiItemList[i].oneSeats != '' && this.poiItemList[i].oneSeats != undefined) {
                    jsonStr += "\"oneSeats\":\"" + this.poiItemList[i].oneSeats + "\",";
                }
                if (this.poiItemList[i].sixRuler != null && this.poiItemList[i].sixRuler != '' && this.poiItemList[i].sixRuler != undefined) {
                    jsonStr += "\"sixRuler\":\"" + this.poiItemList[i].sixRuler + "\",";
                }
                if (this.poiItemList[i].fiveRuler != null && this.poiItemList[i].fiveRuler != '' && this.poiItemList[i].fiveRuler != undefined) {
                    jsonStr += "\"fiveRuler\":\"" + this.poiItemList[i].fiveRuler + "\",";
                }
                if (this.poiItemList[i].fourRuler != null && this.poiItemList[i].fourRuler != '' && this.poiItemList[i].fourRuler != undefined) {
                    jsonStr += "\"fourRuler\":\"" + this.poiItemList[i].fourRuler + "\",";
                }
                if (this.poiItemList[i].threeRuler != null && this.poiItemList[i].threeRuler != '' && this.poiItemList[i].threeRuler != undefined) {
                    jsonStr += "\"threeRuler\":\"" + this.poiItemList[i].threeRuler + "\",";
                }
                if (this.poiItemList[i].oneSmall != null && this.poiItemList[i].oneSmall != '' && this.poiItemList[i].oneSmall != undefined) {
                    jsonStr += "\"oneSmall\":\"" + this.poiItemList[i].oneSmall + "\",";
                }
                if (this.poiItemList[i].small != null && this.poiItemList[i].small != '' && this.poiItemList[i].small != undefined) {
                    jsonStr += "\"small\":\"" + this.poiItemList[i].small + "\",";
                }
                if (this.poiItemList[i].tool != null && this.poiItemList[i].tool != '' && this.poiItemList[i].tool != undefined) {
                    jsonStr += "\"tool\":\"" + this.poiItemList[i].tool + "\",";
                }
                if (this.poiItemList[i].glue != null && this.poiItemList[i].glue != '' && this.poiItemList[i].glue != undefined) {
                    jsonStr += "\"glue\":\"" + this.poiItemList[i].glue + "\",";
                }
                if (this.poiItemList[i].cage != null && this.poiItemList[i].cage != '' && this.poiItemList[i].cage != undefined) {
                    jsonStr += "\"cage\":\"" + this.poiItemList[i].cage + "\",";
                }
                if (this.poiItemList[i].theWire != null && this.poiItemList[i].theWire != '' && this.poiItemList[i].theWire != undefined) {
                    jsonStr += "\"theWire\":\"" + this.poiItemList[i].theWire + "\",";
                }
                if (this.poiItemList[i].plywood != null && this.poiItemList[i].plywood != '' && this.poiItemList[i].plywood != undefined) {
                    jsonStr += "\"plywood\":\"" + this.poiItemList[i].plywood + "\",";
                }
                if (this.poiItemList[i].oneGlue != null && this.poiItemList[i].oneGlue != '' && this.poiItemList[i].oneGlue != undefined) {
                    jsonStr += "\"oneGlue\":\"" + this.poiItemList[i].oneGlue + "\",";
                }
                if (this.poiItemList[i].wireMesh != null && this.poiItemList[i].wireMesh != '' && this.poiItemList[i].wireMesh != undefined) {
                    jsonStr += "\"wireMesh\":\"" + this.poiItemList[i].wireMesh + "\",";
                }
                if (this.poiItemList[i].productCar != null && this.poiItemList[i].productCar != '' && this.poiItemList[i].productCar != undefined) {
                    jsonStr += "\"productCar\":\"" + this.poiItemList[i].productCar + "\",";
                }
                if (this.poiItemList[i].tape != null && this.poiItemList[i].tape != '' && this.poiItemList[i].tape != undefined) {
                    jsonStr += "\"tape\":\"" + this.poiItemList[i].tape + "\",";
                }
                if (this.poiItemList[i].other != null && this.poiItemList[i].other != '' && this.poiItemList[i].other != undefined) {
                    jsonStr += "\"other\":\"" + this.poiItemList[i].other + "\",";
                }
                if (this.poiItemList[i].fork != null && this.poiItemList[i].fork != '' && this.poiItemList[i].fork != undefined) {
                    jsonStr += "\"fork\":\"" + this.poiItemList[i].fork + "\",";
                }
                if (this.poiItemList[i].shortFloor != null && this.poiItemList[i].shortFloor != '' && this.poiItemList[i].shortFloor != undefined) {
                    jsonStr += "\"shortFloor\":\"" + this.poiItemList[i].shortFloor + "\",";
                }
                if (this.poiItemList[i].chelsea != null && this.poiItemList[i].chelsea != '' && this.poiItemList[i].chelsea != undefined) {
                    jsonStr += "\"chelsea\":\"" + this.poiItemList[i].chelsea + "\",";
                }
                if (this.poiItemList[i].smooth != null && this.poiItemList[i].smooth != '' && this.poiItemList[i].smooth != undefined) {
                    jsonStr += "\"smooth\":\"" + this.poiItemList[i].smooth + "\",";
                }
                if (this.poiItemList[i].lengthFloor != null && this.poiItemList[i].lengthFloor != '' && this.poiItemList[i].lengthFloor != undefined) {
                    jsonStr += "\"lengthFloor\":\"" + this.poiItemList[i].lengthFloor + "\"";
                } else {
                    jsonStr += "\"lengthFloor\":\"" + "" + "\"";
                }
                jsonStr += '}';
                jsonStr += ',';
            }
            jsonStr = jsonStr.substring(0, jsonStr.length - 1);
            jsonStr += ']';
            if (jsonStr.length == 1) {
                return null;
            }
            return jsonStr;
        },
        getItemOption: function getItemOption() {
            var _this60 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["L" /* getItemAllList */])().then(function (data) {
                _this60.itemOptions = data.data.data;
            });
        },
        getFeedParams: function getFeedParams() {
            this.acctId = '';
            this.initalRolling();
            if (this.acctId == '') {
                this.acctId = this.$route.params.outId;
                if (this.acctId != '' || this.acctId != undefined) {
                    this.queryOneAcctRec(this.acctId);
                    this.queryOneRollList(this.acctId);
                    this.paramsId = this.acctId;
                }
            }
            if (this.acctId != this.$route.params.outId && this.$route.params.outId != undefined) {
                this.acctId = this.$route.params.outId;
                this.paramsId = this.acctId;
                this.queryOneAcctRec(this.acctId);
                this.queryOneRollList(this.acctId);
            }
        },
        initalRolling: function initalRolling() {
            this.poiItem = { index: '', pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '', copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '', softPaper: '', lousyPaper: '', moistureproof: '', electric: '',
                gummedPaper: '', big: '', inthe: '', fine: '', oldBig: '', oldInthe: '', oldFine: '', plasma: '', crepePaper: '', flatClothing: '',
                refrigerator: '', elastic: '', cardboard: '', stiff: '', bulktank: '', paperCardBoard: '',
                threeSeats: '', twoSeats: '', oneSeats: '', threeRuler: '', fourRuler: '', fiveRuler: '',
                cage: '', theWire: '', plywood: '', oneGlue: '', wireMesh: '', productCar: '', tape: '', other: '',
                fork: '', //叉
                shortFloor: '', //短木板
                lengthFloor: '',
                chelsea: '', //車仔
                smooth: '' //滑潤
            };
            this.rollingForm = {
                id: '',
                feedDate: "",
                carNumber: '',
                oneCar: '',
                twoCar: '',
                threeCar: '',
                sendBox: '',
                oneOther: '',
                internal: ''
            };
            this.poiItemList = [];
            this.acctId = "";
            this.disabledNum = false;
            this.delRollItemList = [];
            this.index = 0;
            this.loadingSave = false;
            this.oldoneCar = 0;
            this.oldtwoCar = 0;
            this.oldthreeCar = 0;
        },
        validateChange: function validateChange(ev) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (ev != "半" && !re.test(ev)) {
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                }
            }
        },
        queryOneAcctRec: function queryOneAcctRec(acctId) {
            var _this61 = this;

            if (acctId != undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_9" /* getRollingsById */])(acctId).then(function (data) {
                    var item = data.data;
                    if (item != null) {
                        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this61.rollingForm, item.data);
                        if (item.data.status == 1) {
                            _this61.disabledNum = true;
                        }
                        if (item.data.feedDate == null || item.data.feedDate == '' || item.data.feedDate == 0) {
                            _this61.rollingForm.feedDate = "";
                        } else {
                            _this61.rollingForm.feedDate = new Date(item.data.feedDate * 1000);
                        }
                        if (item.data.oneCar != null && item.data.oneCar != '') {
                            _this61.oldoneCar = item.data.oneCar;
                        }
                        if (item.data.oldtwoCar != null && item.data.oldtwoCar != '') {
                            _this61.oldtwoCar = item.data.oldtwoCar;
                        }
                        if (item.data.oldthreeCar != null && item.data.oldthreeCar != '') {
                            _this61.oldthreeCar = item.data.oldthreeCar;
                        }
                        if (item.data.rollingItem != null) {
                            var tempList = item.data.rollingItem;
                            for (var i = 0; i < tempList.length; i++) {
                                var poiItem = tempList[i];
                                poiItem.index = _this61.index += 1;
                                poiItem.pitPaper = poiItem.pitPaper;
                                poiItem.newsPaper = poiItem.newsPaper;
                                poiItem.buBu = poiItem.buBu;
                                poiItem.copyPaper = poiItem.copyPaper;
                                _this61.poiItemList.push(poiItem);
                            }
                        }
                    }
                });
            }
        },
        queryOneRollList: function queryOneRollList(acctId) {
            var _this62 = this;

            if (acctId != undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_8" /* getRollingListById */])(acctId).then(function (data) {
                    var item = data.data;
                    if (item != null) {
                        if (item.data.rollingItem != null) {
                            var tempList = item.data.rollingItem;
                            for (var i = 0; i < tempList.length; i++) {
                                var poiItem = tempList[i];
                                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this62.feedOldForm);
                                _this62.feedOldForm.oldpitPaper = poiItem.pitPaper; //坑紙
                                _this62.feedOldForm.oldnewsPaper = poiItem.newsPaper; //报纸
                                _this62.feedOldForm.oldbuBu = poiItem.buBu;
                                _this62.feedOldForm.oldcopyPaper = poiItem.copyPaper;
                                _this62.feedOldForm.oldmat = poiItem.mat; //毡
                                _this62.feedOldForm.oldtinFoil = poiItem.tinFoil; //保鲜纸
                                _this62.feedOldForm.oldazusa = poiItem.azusa == 0;
                                _this62.feedOldForm.oldshortWood = poiItem.shortWood; //矮木
                                _this62.feedOldForm.oldironCar = poiItem.ironCar;
                                _this62.feedOldForm.oldtoGlue = poiItem.toGlue;
                                _this62.feedOldForm.oldsoftPaper = poiItem.softPaper;
                                _this62.feedOldForm.oldlousyPaper = poiItem.lousyPaper; //烂纸
                                _this62.feedOldForm.oldmoistureproof = poiItem.moistureproof;
                                _this62.feedOldForm.oldelectric = poiItem.electric;
                                _this62.feedOldForm.oldgummedPaper = poiItem.gummedPaper;
                                _this62.feedOldForm.oldbig = poiItem.big;
                                _this62.feedOldForm.oldinthe = poiItem.inthe;
                                _this62.feedOldForm.oldfine = poiItem.fine;
                                _this62.feedOldForm.oldoldBig = poiItem.oldBig == 0;
                                _this62.feedOldForm.oldoldInthe = poiItem.oldInthe == 0;
                                _this62.feedOldForm.oldoldFine = poiItem.oldFine;
                                _this62.feedOldForm.oldplasma = poiItem.plasma;
                                _this62.feedOldForm.oldcrepePaper = poiItem.crepePaper;
                                _this62.feedOldForm.oldflatClothing = poiItem.flatClothing; //平衣
                                _this62.feedOldForm.oldrefrigerator = poiItem.refrigerator;
                                _this62.feedOldForm.oldelastic = poiItem.elastic; //黑色橡筋
                                _this62.feedOldForm.oldcardboard = poiItem.cardboard;
                                _this62.feedOldForm.oldstiff = poiItem.stiff;
                                _this62.feedOldForm.oldbulktank = poiItem.bulktank;
                                _this62.feedOldForm.oldpaperCardBoard = poiItem.paperCardBoard;
                                _this62.feedOldForm.oldthreeSeats = poiItem.threeSeats;
                                _this62.feedOldForm.oldtwoSeats = poiItem.twoSeats;
                                _this62.feedOldForm.oldoneSeats = poiItem.oneSeats;
                                _this62.feedOldForm.oldthreeRuler = poiItem.threeRuler;
                                _this62.feedOldForm.oldfourRuler = poiItem.fourRuler;
                                _this62.feedOldForm.oldfiveRuler = poiItem.fiveRuler;
                                _this62.feedOldForm.oldsixRuler = poiItem.sixRuler;
                                _this62.feedOldForm.oldoneSmall = poiItem.oneSmall;
                                _this62.feedOldForm.oldsmall = poiItem.small;
                                _this62.feedOldForm.oldtool = poiItem.tool;
                                _this62.feedOldForm.oldglue = poiItem.glue;
                                _this62.feedOldForm.oldtoCounter = poiItem.toCounter;
                                _this62.feedOldForm.oldcage = poiItem.cage; //铁笼
                                _this62.feedOldForm.oldtheWire = poiItem.theWire;
                                _this62.feedOldForm.oldplywood = poiItem.plywood;
                                _this62.feedOldForm.oldoneGlue = poiItem.oneGlue;
                                _this62.feedOldForm.oldwireMesh = poiItem.wireMesh;
                                _this62.feedOldForm.oldproductCar = poiItem.productCar;
                                _this62.feedOldForm.oldtape = poiItem.tape;
                                _this62.feedOldForm.oldother = poiItem.other;
                                _this62.feedOldForm.oldstatus = poiItem.status;
                                _this62.feedOldForm.oldsmooth = poiItem.smooth;
                                _this62.feedOldForm.oldlengthFloor = poiItem.lengthFloor;
                                _this62.feedOldForm.oldshortFloor = poiItem.shortFloor;
                                _this62.feedOldForm.oldfork = poiItem.fork;
                                _this62.feedOldForm.oldchelsea = poiItem.chelsea;
                            }
                        }
                    }
                });
            }
        }
    },
    mounted: function mounted() {
        ///console.log("=====mounted")
        //this.getFeedParams();
    },

    /* watch: {
     // 利用watch方法检测路由变化：
     '$route': function (to, from) {
         //console.log(to.params.outId+"===tototototto==="+this.paramsId+"==="+this.paramsName)
         if(to.params.outId!= this.paramsId && to.name=='編輯出倉紙'){
             this.getFeedParams();
         }
     }
     },*/
    activated: function activated() {
        this.getItemOption();
        var outId = this.$route.params.outId;
        console.log(outId + "===" + this.paramsId + "==" + this.updateId);
        if (outId != '' && outId != null && outId != undefined) {
            if (outId != this.paramsId && this.updateId == 0) {
                this.getFeedParams();
            } else if (outId == this.paramsId && this.updateId == 0) {
                this.getFeedParams();
            }
        }
        this.updateId = 1;
    },

    computed: {
        canOut: function canOut() {
            return this.$store.getters.hasPermission("ROLL_OUT");
        }
    }
});

/***/ }),

/***/ "gXfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            //查詢條件
            serchGroupName: "",
            serchCustNo: "",
            selectionItems: [],
            custGroupItemList: [],
            tableloading: false,
            dialogDiscAddVisible: false,
            dialogDiscEditVisible: false,
            Addloading: false,
            Editloading: false,
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            custOptions: [],
            dialogItemVisible: false,
            dialogName: '',
            custGroupList: [],
            dialogEditName: "",
            dialogAddName: "",
            groupPager: {
                page: 0,
                size: 10,
                total: 0
            },
            custGroupForm: {
                id: "",
                groupName: ""
            },
            custForm: {
                custId: "",
                custNo: "",
                groupId: ""
            },
            custGroupRules: {
                groupName: [{ required: true, message: this.$t('m.m_groupnameinput'), trigger: 'blur' }]
            }, custRules: {
                custNo: [{ required: true, message: this.$t('m.m_nocustomer'), trigger: 'blur' }]
            }
        };
    },

    methods: {
        querySearch: function querySearch(queryString, cb) {
            var _this = this;

            if (queryString != "") {
                var params = { custNo: queryString, groupId: this.id };
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    _this.custOptions = res.data == null ? [] : res.data;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.custOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var i = _step.value;

                            i.value = i.custNo;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    ;
                    var custOptions = _this.custOptions;
                    var results = queryString ? custOptions.filter(_this.createFilter(queryString)) : searchItemOptions;
                    cb(results);
                });
            }
        },
        createFilter: function createFilter(queryString) {
            return function (custOptions) {
                return custOptions.custNo.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
            };
        },
        custGroupPageChange: function custGroupPageChange(val) {
            this.getCustGroupPageList();
        },
        handleItemChange: function handleItemChange(val) {
            this.serchCustDetails();
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        addCustGroup: function addCustGroup() {
            this.custGroupForm = {
                id: "",
                groupName: ""
            }, this.dialogAddName = this.$t('m.t_newcustomergroup');
            this.dialogDiscAddVisible = true;
            this.resetForm("custGroupForm");
            this.custOptions = [];
        },
        itemRemoteMethod: function itemRemoteMethod(query) {
            var _this2 = this;

            if (query != "") {
                var params = { custNo: query, groupId: null };
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data2 = data.data,
                        res = _data$data2 === undefined ? {} : _data$data2;

                    _this2.custOptions = res.data;
                });
            }
        },
        deleteCustGroupId: function deleteCustGroupId(index, row) {
            var _this3 = this;

            this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.b_cancel'),
                type: 'warning'
            }).then(function () {
                _this3.custForm.custId = row.id;
                _this3.custForm.custNo = row.id;
                var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this3.custForm);
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_62" /* updateCustGroupIds */])(params).then(function (data) {
                    var _data$data3 = data.data,
                        errcode = _data$data3.errcode,
                        errmsg = _data$data3.errmsg;

                    if (errcode == 200) {
                        _this3.$message.success(_this3.$t('m.m_removesuc'));
                        _this3.resetForm("custForm");
                        _this3.custOptions = [];
                        _this3.serchCustDetails();
                    } else {
                        _this3.$message.error(data.errmsg);
                    }
                });
            }); /*.catch(() => {
                  this.$message({
                      type: 'info',
                      message: this.$t('m.b_canceledDeleting')
                  });
                });*/
        },
        deleteCustEdit: function deleteCustEdit(index, row) {
            var _this4 = this;

            this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this4.custForm);
                params.id = row.id;
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["h" /* deleteGroupName */])(params).then(function (data) {
                    var _data$data4 = data.data,
                        errcode = _data$data4.errcode,
                        errmsg = _data$data4.errmsg;

                    if (errcode == 200) {
                        _this4.$message.success(_this4.$t('m.m_deletesuc'));
                        _this4.getCustGroupPageList();
                    } else {
                        _this4.$message.error(data.errmsg);
                    }
                });
            });
        },
        custGroupEdit: function custGroupEdit(index, row) {
            this.dialogAddName = this.$t('m.t_updatecustomergroup'), this.dialogDiscAddVisible = true;
            this.resetForm("custGroupForm");
            this.custGById(row.id);
        },
        getCustGroupPageList: function getCustGroupPageList() {
            var _this5 = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, groupName: this.serchGroupName.trim(), custNo: this.serchCustNo.trim() };

            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["C" /* getCustGroupMgtList */])(params).then(function (data) {
                var _data$data5 = data.data,
                    res = _data$data5 === undefined ? {} : _data$data5;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this5.custGroupList = items;
                    _this5.pager.total = total;
                    _this5.pager.page = page;
                    _this5.pager.size = size;
                    _this5.tableloading = false;
                } else {
                    _this5.$message.error(res.errmsg);
                }
            });
        },
        custGById: function custGById(id) {
            var _this6 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["A" /* getCustGroupMgtById */])(id).then(function (data) {
                var _data$data6 = data.data,
                    res = _data$data6 === undefined ? {} : _data$data6;

                var item = res.data;
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.custGroupForm, item);
            });
        },
        itemEdit: function itemEdit(index, row) {
            this.dialogName = row.groupName + " - " + this.$t('m.t_memberdata');
            this.dialogItemVisible = true;
            this.id = row.id;
            this.custForm.groupId = row.id;
            this.serchCustDetails();
        },
        AddCustEdit: function AddCustEdit() {
            this.dialogEditName = this.$t('m.b_newmembergrp');
            this.dialogDiscEditVisible = true;
            this.resetForm("custForm");
        },
        serchCustDetails: function serchCustDetails() {
            var _this7 = this;

            this.tableloading = true;

            var params = { page: this.groupPager.page, size: this.groupPager.size, id: this.id };
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["B" /* getCustGroupMgtDetailsList */])(params).then(function (data) {
                var _data$data7 = data.data,
                    res = _data$data7 === undefined ? {} : _data$data7;

                if (res.errcode == 200) {
                    var _res$data2 = res.data,
                        size = _res$data2.size,
                        page = _res$data2.page,
                        total = _res$data2.total,
                        _res$data2$data = _res$data2.data,
                        items = _res$data2$data === undefined ? [] : _res$data2$data;

                    _this7.custGroupItemList = items;
                    _this7.groupPager.total = total;
                    _this7.groupPager.page = page;
                    _this7.groupPager.size = size;
                    _this7.tableloading = false;
                } else {
                    _this7.$message.error(res.errmsg);
                }
            });
        },
        custMgtSave: function custMgtSave() {
            var _this8 = this;

            //新增客戶組成員
            this.$refs.custForm.validate(function (valid) {
                if (valid) {
                    _this8.custForm.custId = _this8.custForm.custNo;
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.custForm);

                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_63" /* updateCustNoGroupId */])(params).then(function (data) {
                        _this8.Addloading = false;
                        var _data$data8 = data.data,
                            errcode = _data$data8.errcode,
                            errmsg = _data$data8.errmsg;

                        if (errcode == 200) {
                            _this8.$message.success(_this8.$t('m.m_newmembersuc'));
                            _this8.custOptions = [];
                            _this8.resetForm("custForm");
                            _this8.serchCustDetails();
                            _this8.dialogDiscEditVisible = false;
                        } else {
                            _this8.$message.error(errmsg);
                        }
                    }, function (err) {
                        _this8.Addloading = false;
                    });
                }
            });
        },
        custGroupSave: function custGroupSave() {
            var _this9 = this;

            this.$refs.custGroupForm.validate(function (valid) {
                if (valid) {
                    if (_this9.custGroupForm.id == "") {
                        //var params = {groupName: this.custGroupForm.groupName}

                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this9.custGroupForm);
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_41" /* insertCustGroup */])(params).then(function (data) {
                            _this9.Addloading = false;
                            var _data$data9 = data.data,
                                errcode = _data$data9.errcode,
                                errmsg = _data$data9.errmsg;

                            if (errcode == 200) {
                                _this9.$message.success(_this9.$t('m.m_newsucs'));
                                _this9.getCustGroupPageList();
                                _this9.resetForm("custGroupForm");
                                _this9.dialogDiscAddVisible = false;
                            } else {
                                _this9.$message.error(errmsg);
                            }
                        }, function (err) {
                            _this9.Addloading = false;
                        });
                    } else {
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this9.custGroupForm);
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_61" /* updateCustGroup */])(params).then(function (data) {
                            _this9.Addloading = false;
                            var _data$data10 = data.data,
                                errcode = _data$data10.errcode,
                                errmsg = _data$data10.errmsg;

                            if (errcode == 200) {
                                _this9.$message.success(_this9.$t('m.m_updatesucs'));
                                _this9.getCustGroupPageList();
                                _this9.resetForm("custGroupForm");
                                _this9.dialogDiscAddVisible = false;
                            } else {
                                _this9.$message.error(errmsg);
                            }
                        }, function (err) {
                            _this9.Addloading = false;
                        });
                    }
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {
        this.getCustGroupPageList();
    },

    computed: {
        custGroupAdd: function custGroupAdd() {
            return this.$store.getters.hasPermission("CUST_GROUP_ADD");
        },
        custGroupNameEdit: function custGroupNameEdit() {
            return this.$store.getters.hasPermission("CUST_GROUP_EDIT");
        },
        custGroupDelete: function custGroupDelete() {
            return this.$store.getters.hasPermission("CUST_GROUP_DELETE");
        },
        custGroupInfromation: function custGroupInfromation() {
            return this.$store.getters.hasPermission("CUST_GROUP_INFORMATION");
        }
    }
});

/***/ }),

/***/ "gdsr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h7Tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskCalendar_vue__ = __webpack_require__("2FFv");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419e3fac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskCalendar_vue__ = __webpack_require__("lZHv");
function injectStyle (ssrContext) {
  __webpack_require__("J8pp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419e3fac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ia5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iodp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        var validateItem = function validateItem(rule, value, callback) {
            var pedId = _this.pendingForm.id != "" ? _this.pendingForm.id : 0;
            var params = { id: pedId, itemId: value };
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_37" /* getValidateAdjustmentItemCode */])(params).then(function (data) {
                var item = data.data.data;
                if (item == true) {
                    callback(new Error(_this.$t('m.m_untreated')));
                } else {
                    callback();
                }
            });
            callback();
        };
        var validateQty = function validateQty(rule, value, callback) {
            var reg = /^(-)?[1-9][0-9]*$/;
            if (value != "" && value != null) {
                if (!reg.test(value)) {
                    callback(new Error(_this.$t('m.m_numbernot0')));
                }
            }
            callback();
        };
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查詢條件
            serchCarNumber: "",
            serchStatus: '',
            getFeedDate: '',
            selectionItems: [],
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            stockAdjList: [],
            dialogName: '',
            tableloading: false,
            dialogAddsVisible: false,
            dialogCodeName: '',
            dialogAddsName: "",
            stockInList: [],
            index: 0,
            selectIndex: 0,
            addEidtloading: false,
            dialogCodeVisible: false,
            itemOptions: [],
            pendingForm: {
                id: "",
                itemId: "",
                itemName: "",
                qty: "",
                storId: "",
                shelfId: "",
                cost: "",
                status: 0,
                remark: ""
            },
            pendingRules: {
                itemId: [{ required: true, message: this.$t('m.m_producttype'), trigger: 'change' }, { validator: validateItem, trigger: 'change' }],
                qty: [{ required: true, message: this.$t('m.m_number'), trigger: 'change' }, { validator: validateQty, trigger: 'change' }],
                remark: [{ required: true, message: this.$t('m.m_remarks'), trigger: 'change' }]
            }
        };
    },

    methods: {
        importBnt: function importBnt(index, row) {
            var _this2 = this;

            this.$confirm(this.$t('m.m_Importconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.b_cancel'),
                type: 'warning'
            }).then(function () {
                var params = { id: row.id, token: _this2.$store.state.staff.token };
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_18" /* getStockAdjustmentImport */])(params).then(function (data) {
                    if (data.data.data == true) {
                        _this2.$message.success(_this2.$t('m.m_Importsucs'));
                        _this2.getStockAdjustList();
                    } else {
                        _this2.$message.error("倉存數量不足以扣除！");
                    }
                });
            });
        },
        pendingDel: function pendingDel(index, row) {
            var _this3 = this;

            this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.b_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["p" /* deleteStockAdjustment */])(row.id).then(function (data) {
                    var _data$data = data.data,
                        errcode = _data$data.errcode,
                        errmsg = _data$data.errmsg;

                    if (errcode == 200) {
                        _this3.$message.success(_this3.$t('m.m_deletesuc'));
                        _this3.getStockAdjustList();
                    } else {
                        _this3.$message.error(data.data.errmsg);
                    }
                });
            });
        },
        handleSelect: function handleSelect(val) {
            if (val != '') {
                this.pendingForm.t_prodname = this.itemOptions.find(function (v) {
                    return v.id == val;
                }).itemName;
            } else {
                this.pendingForm.t_prodname = "";
            }
        },
        pendingSave: function pendingSave(ev) {
            var _this4 = this;

            if (!this.verifItemData()) {
                return;
            }

            var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.pendingForm);
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_79" /* updateStockAdj */])(params).then(function (data) {
                _this4.addEidtloading = false;
                var _data$data2 = data.data,
                    errcode = _data$data2.errcode,
                    errmsg = _data$data2.errmsg;

                if (errcode == 200) {
                    _this4.$message.success(_this4.$t('m.m_updatesucs'));
                    _this4.getStockAdjustList();
                    _this4.resetForm("pendingForm");
                    _this4.dialogCodeVisible = false;
                } else {
                    _this4.$message.error(data.errmsg);
                }
            }, function (err) {
                _this4.addEidtloading = false;
            });
        },
        pendingEdit: function pendingEdit(index, row) {
            this.dialogCodeName = this.$t('m.t_editgoodsadjustment');
            this.dialogCodeVisible = true;
            this.pendingForm.itemName = this.stockAdjList[index].itemName;
            this.getStockAdjustmentById(row.id);
            this.resetForm("pendingForm");
        },
        getStockAdjustmentById: function getStockAdjustmentById(id) {
            var _this5 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_17" /* getStockAdjId */])(id).then(function (data) {
                var item = data.data.data;
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this5.pendingForm, item);
                //this.getItemOptions(this.pendingForm.itemName);
            });
        },
        pendingAdds: function pendingAdds(index, row) {
            this.dialogAddsName = this.$t('m.t_addgoodsadjustment');
            this.dialogAddsVisible = true;
            this.index = 0;
            this.stockInList = [];
            this.stockInItem = { index: this.index, itemId: '', itemName: '', qty: '', remark: '', isShow: true, itemOptions: [] };
            this.stockInList.push(this.stockInItem);
        },
        getItemOptions: function getItemOptions(itemCode) {
            var _this6 = this;

            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["K" /* getItemAll */])(itemCode).then(function (data) {
                _this6.itemOptions = data.data.data;
            });
        },
        pendingAdd: function pendingAdd(index, row) {
            this.pendingForm = {
                id: "",
                itemId: "",
                itemName: "",
                qty: "",
                status: 0,
                remark: ""
            };
            this.custOptions = [];
            this.dialogCodeName = "新增货品调整";
            this.dialogCodeVisible = true;
            this.isShow = true;
            this.resetForm("pendingForm");
            this.getItemOptions();
        },
        getItemAllOption: function getItemAllOption(value) {
            var _this7 = this;

            if (value != '') {
                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["K" /* getItemAll */])(value).then(function (res) {
                    if (res.data.errcode == 200) {
                        var _res$data$data$data = res.data.data.data,
                            itemOption = _res$data$data$data === undefined ? [] : _res$data$data$data;

                        _this7.itemOptions = itemOption;
                    } else {
                        _this7.$message.error(res.data.errmsg);
                    }
                }).catch(function (error) {
                    console.log("getItemAllOption Error");
                });
            }
        },
        getItemListOption: function getItemListOption(value) {
            var _this8 = this;

            if (value != '') {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["K" /* getItemAll */])(value).then(function (res) {
                    if (res.data.errcode == 200) {
                        _this8.stockInList[_this8.selectIndex].itemOptions = res.data.data;
                    } else {
                        _this8.$message.error(res.errmsg);
                    }
                }).catch(function (error) {
                    console.log("getItemAllOption Error");
                });
            }
        },
        querySearch: function querySearch(queryString, cb) {
            var _this9 = this;

            if (queryString != "") {
                Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["K" /* getItemAll */])(queryString).then(function (data) {
                    _this9.itemOptions = data.data.data == null ? [] : data.data.data;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this9.itemOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var i = _step.value;

                            i.value = i.itemName;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    ;
                    var itemOptions = _this9.itemOptions;
                    var results = queryString ? itemOptions.filter(_this9.createFilter(queryString)) : itemOptions;
                    cb(results);
                });
            }
        },
        pendingListSave: function pendingListSave() {
            var _this10 = this;

            if (!this.verifItemData()) {
                return;
            }
            this.pendingForm.itemListStr = this.getStockInListJson();
            var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.pendingForm);
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["c" /* addStockAdjustmentList */])(params).then(function (res) {
                if (res.data.errcode == 200) {
                    _this10.$message.success(_this10.$t('m.m_newgoodssuc'));
                    _this10.dialogAddsVisible = false;
                    _this10.getStockAdjustList();
                } else {
                    _this10.$message.error(res.errmsg);
                }
            }).catch(function (error) {
                console.log("pendingListSave Error");
            });
        },
        getStockInListJson: function getStockInListJson() {
            var jsonStr = '[';
            for (var i = 0; i < this.stockInList.length; i++) {
                jsonStr += '{';
                jsonStr += "\"itemId\":\"" + this.stockInList[i].itemId + "\",";
                jsonStr += "\"qty\":\"" + this.stockInList[i].qty + "\",";
                jsonStr += "\"remark\":\"" + this.stockInList[i].remark + "\"";
                jsonStr += '}';
                jsonStr += ',';
            }
            jsonStr = jsonStr.substring(0, jsonStr.length - 1);
            jsonStr += ']';
            console.log(jsonStr);
            return jsonStr;
        },
        remarkChange: function remarkChange(val) {
            if (val.length > 100) {
                this.$message.error(this.$t('m.m_lengthmin100'));
                this.stockInList[this.selectIndex].remark = "";
            }
        },
        qtyChange: function qtyChange(val) {
            var reg = /^(-)?[1-9][0-9]*$/;
            if (val != "" && val != null) {
                if (!reg.test(val)) {
                    this.$message.error(this.$t('m.m_numbernot0'));
                    this.stockInList[this.selectIndex].qty = "";
                } else {
                    if (val < 0) {
                        this.stockInList[this.selectIndex].cost = "";
                    }

                    if (val.length > 6) {
                        this.$message.error(this.$t('m.m_oversize'));
                        this.stockInList[this.selectIndex].qty = "";
                    }
                }
            }
        },
        itemHandleSelect: function itemHandleSelect(val) {
            var _this11 = this;

            this.stockInList[this.selectIndex].itemName = "";
            var pedId = 0;
            var params = { id: pedId, itemId: val };
            Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_37" /* getValidateAdjustmentItemCode */])(params).then(function (data) {
                var item = data.data;
                if (item == true) {
                    _this11.$message.warning(_this11.$t('m.m_untreated'));
                    _this11.rearrData();
                    pedId = 1;
                }
            });
            var i = 0;
            for (i = 0; i < this.stockInList.length; i++) {
                if (i != this.selectIndex && this.stockInList[i].itemId == val) {
                    pedId = 2;
                }
            }
            if (pedId == 1) {
                return;
            }
            if (pedId == 2) {
                this.$message.warning(this.$t("m.m_repeatedselection"));
                //重置数据
                this.rearrData();
                return;
            }
            if (val != '') {
                this.stockInList[this.selectIndex].itemName = this.stockInList[this.selectIndex].itemOptions.find(function (v) {
                    return v.id == val;
                }).itemName;
            } else {
                this.stockInList[this.selectIndex].itemName = "";
            }
        },
        rearrData: function rearrData() {
            this.stockInList[this.selectIndex].itemName = "";
            this.stockInList[this.selectIndex].itemId = "";
            this.stockInList[this.selectIndex].itemOptions = [];
            this.stockInList[this.selectIndex].isShow = true;
        },
        removeStockInItem: function removeStockInItem(index) {
            this.stockInList.splice(index, 1);
            var i = 0;
            for (i; i < this.stockInList.length; i++) {
                this.stockInList[0].index = i;
            }
            this.index = i - 1;
        },
        getTempIndex: function getTempIndex(index) {
            this.selectIndex = index;
        },
        verifItemData: function verifItemData() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.stockInList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.itemId == "") {
                        this.$message.error(this.$t("m.m_productchoice"));
                        return false;
                    }
                    if (item.qty == "") {
                        this.$message.error(this.$t("m.m_number"));
                        return false;
                    }
                    if (item.remark == "") {
                        this.$message.error(this.$t("m.m_remarks"));
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return true;
        },
        addStockInItem: function addStockInItem() {
            if (!this.verifItemData()) {
                return;
            }
            this.stockInItem = { index: this.index += 1, itemId: '', itemName: '', qty: '', remark: '', isShow: true, itemOptions: [] };
            this.stockInList.push(this.stockInItem);
        },
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {},
        custTaskPageChange: function custTaskPageChange(val) {
            this.getStockAdjustList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        getStockAdjustList: function getStockAdjustList() {
            var _this12 = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, carNumber: this.serchCarNumber.trim(), feedDate: this.getFeedDate, status: this.serchStatus };
            if (params.feedDate != null && params.feedDate != '') {
                params.feedDate = parseInt(new Date(params.feedDate).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_19" /* getStockList */])(params).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this12.stockAdjList = items;
                    _this12.pager.total = total;
                    _this12.pager.page = page;
                    _this12.pager.size = size;
                    _this12.tableloading = false;
                } else {
                    _this12.$message.error(res.errmsg);
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getStockAdjustList();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ADJUSTMENT_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("ADJUSTMENT__EDIT");
        },
        canDel: function canDel() {
            return this.$store.getters.hasPermission("ADJUSTMENT__DEL");
        },
        canImport: function canImport() {
            return this.$store.getters.hasPermission("ADJUSTMENT__IMPORT");
        }
    }
});

/***/ }),

/***/ "j7e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("UOlw");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbd266a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("TwiV");
function injectStyle (ssrContext) {
  __webpack_require__("y9+Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cbd266a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbd266a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jXLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1200px"}},[_c('div',{staticStyle:{"float":"left"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left","padding-top":"20px"}},[_c('div',[_vm._v("     \n\t\t\t\t\t"),_c('span',[_vm._v("工作單號："+_vm._s(_vm.jobOrderForms.jobNo))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"40px"}},[_vm._v("客戶："+_vm._s(_vm.jobOrderForms.custNo))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"40px"}},[_vm._v("姓名："+_vm._s(_vm.jobOrderForms.custName))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"40px"}},[_vm._v("日期："+_vm._s(_vm.getIssueDate(this.jobOrderForms.startDate)))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticStyle:{"padding-left":"40px"}},[_vm._v("真實箱："+_vm._s(this.jobJsonList.length))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"68px"}},[_vm._v("真實板："+_vm._s(this.jobPalletList.length))]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"60px"}},[_vm._v("目的地："+_vm._s(_vm.jobOrderForms.dest))])])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}},[_c('div',{staticStyle:{"float":"left","margin-top":"10px"}},[_c('table',{staticClass:"leftTable",staticStyle:{"clear":"both"},attrs:{"border":"1","cellspacing":"0","cellpadding":"0"}},_vm._l((_vm.jobTrcount),function(n){return _c('div',[_c('tr',_vm._l((_vm.jobJsonList2[n-1]),function(value){return _c('td',{staticStyle:{"color":"#f3f3f3","background-color":"#4B78FF"},attrs:{"valign":"middle"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(value)+"\n\t\t\t\t\t\t\t")])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.jobPalletNumList[n-1]),function(item,key){return _c('td',{attrs:{"valign":"middle"},on:{"click":function($event){return _vm.boxClick(item)}}},[_c('span',[_vm._v(_vm._s(item.pallet))])])}),0)])}),0)]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin-left":"30px","margin-top":"10px"}},[_c('table',{staticClass:"leftTable",attrs:{"border":"1","cellspacing":"0","cellpadding":"0"}},_vm._l((_vm.jobPalletList),function(value,key){return _c('div',{attrs:{"id":key}},[_vm._m(0,true),_vm._v(" "),_c('tr',[_c('td',{attrs:{"valign":"middle"}},[_vm._v(_vm._s(value.pallet))]),_vm._v(" "),_c('td',{attrs:{"valign":"middle"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.cmLong),expression:"value.cmLong"}],staticStyle:{"width":"45px"},attrs:{"type":"text"},domProps:{"value":(value.cmLong)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "cmLong", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.cmWide),expression:"value.cmWide"}],staticStyle:{"width":"45px"},attrs:{"type":"text"},domProps:{"value":(value.cmWide)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "cmWide", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.cmHigh),expression:"value.cmHigh"}],staticStyle:{"width":"45px"},attrs:{"type":"text"},domProps:{"value":(value.cmHigh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "cmHigh", $event.target.value)}}})]),_vm._v(" "),_c('td',{attrs:{"valign":"middle"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.cbm),expression:"value.cbm"}],staticStyle:{"width":"95px"},attrs:{"type":"text"},domProps:{"value":(value.cbm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "cbm", $event.target.value)}}})]),_vm._v(" "),_c('td',{attrs:{"valign":"middle"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(value.pkgS),expression:"value.pkgS"}],staticStyle:{"width":"95px"},attrs:{"type":"text"},domProps:{"value":(value.pkgS)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(value, "pkgS", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"valign":"middle"}},[_vm._v("箱號")]),_vm._v(" "),_c('td',{staticStyle:{"width":"150px","height":"30px","text-align":"left"},attrs:{"colspan":"3","valign":"middle"}},[_vm._v(_vm._s(value.boxStr))])])])}),0),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.jobPallSave()}}},[_vm._v(" 保 存 ")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返 回")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogFileName,"visible":_vm.dialogFileVisible,"width":"400px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogFileVisible=$event}}},[_c('el-form',{ref:"boxFile",attrs:{"model":_vm.boxFile,"rules":_vm.boxFileRules,"label-width":"100px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"箱號","prop":"box"}},[_vm._v("\n\t\t\t\t\t\t\t "+_vm._s(_vm.boxFile.box)+"\n\t\t\t\t\t\t")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"卡板號","prop":"pallet"}},[_c('el-input',{staticStyle:{"width":"150px","line-height":"20px"},attrs:{"clearable":""},model:{value:(_vm.boxFile.pallet),callback:function ($$v) {_vm.$set(_vm.boxFile, "pallet", $$v)},expression:"boxFile.pallet"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.boxSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.dialogFileVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"valign":"middle"}},[_vm._v("PALLET#")]),_vm._v(" "),_c('td',{staticStyle:{"width":"150px","height":"30px"},attrs:{"valign":"middle"}},[_vm._v("DIMENSION(CM)")]),_vm._v(" "),_c('td',{attrs:{"valign":"middle"}},[_vm._v("CBM")]),_vm._v(" "),_c('td',{attrs:{"valign":"middle"}},[_vm._v("PKGS.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kvkd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l+cy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"xinz"},[(_vm.canAdd)?[_c('div',{staticClass:"right"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addStaff('','添加')}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")])],1)]:_vm._e()],2),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.requestStaffList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_search')+'：'}},[_c('el-input',{attrs:{"placeholder":_vm.$t('m.s_login'),"clearable":""},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"角色"},model:{value:(_vm.searchRids),callback:function ($$v) {_vm.searchRids=$$v},expression:"searchRids"}},_vm._l((_vm.roleList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))])])}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"placeholder":"狀態","clearable":""},model:{value:(_vm.searchCanLogin),callback:function ($$v) {_vm.searchCanLogin=$$v},expression:"searchCanLogin"}},_vm._l((_vm.openStopOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.requestStaffList}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"ind_main ind_main2"},[_c('div',{staticClass:"ind_cont2"},[_c('el-table',{staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.staffs,"empty-text":"无数据","stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"loginName","label":"用戶名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","align":"left","label":"別名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rName","align":"left","label":"角色"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","align":"left","label":"郵箱"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"canLogin","align":"left","label":"狀態"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.canLogin == 1)?[_vm._v("\n\t\t\t\t\t\t\t\t\t                                    啟用\n\t\t\t\t\t\t\t\t\t                                ")]:[_vm._v("\n\t\t\t\t\t\t\t\t\t                                    停用\n\t\t\t\t\t\t\t\t\t                                ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","width":"100","align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v("操作\n\t\t\t\t\t                ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.addStaff(scope.row,'修改')}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯")]):_vm._e(),_vm._v(" "),(_vm.editPwd)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.addStaffPwd(scope.row,'修改密碼')}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 修改密碼")]):_vm._e(),_vm._v(" "),(_vm.canDel)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.delStaff(scope.row.id,scope.row.loginName)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" 刪除")]):_vm._e()],1)],1)]]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-form',{ref:"staffForm",staticStyle:{"text-align":"center"},attrs:{"model":_vm.staffForm,"label-width":"85px"}},[_c('el-form-item',{attrs:{"label":"帳  號:"}},[_c('el-input',{attrs:{"size":"small","placeholder":"請輸入帳號"},on:{"change":function($event){return _vm.selLoginName(_vm.staffForm.loginName,_vm.validatNum)}},model:{value:(_vm.staffForm.loginName),callback:function ($$v) {_vm.$set(_vm.staffForm, "loginName", $$v)},expression:"staffForm.loginName"}})],1),_vm._v(" "),(_vm.addList)?[_c('el-form-item',{attrs:{"label":"密  碼:"}},[_c('el-input',{attrs:{"type":"password","size":"medium","placeholder":"請輸入密碼"},model:{value:(_vm.staffForm.password),callback:function ($$v) {_vm.$set(_vm.staffForm, "password", $$v)},expression:"staffForm.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"確認密碼:"}},[_c('el-input',{attrs:{"type":"password","size":"medium","placeholder":"請確認密碼"},model:{value:(_vm.staffForm.password1),callback:function ($$v) {_vm.$set(_vm.staffForm, "password1", $$v)},expression:"staffForm.password1"}})],1)]:_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"狀  態:"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"請選擇狀態","size":"medium"},model:{value:(_vm.staffForm.canLogin),callback:function ($$v) {_vm.$set(_vm.staffForm, "canLogin", $$v)},expression:"staffForm.canLogin"}},_vm._l((_vm.openStopOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓  名:"}},[_c('el-input',{attrs:{"size":"medium","placeholder":"請輸入姓名"},model:{value:(_vm.staffForm.name),callback:function ($$v) {_vm.$set(_vm.staffForm, "name", $$v)},expression:"staffForm.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"角  色:"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"請選擇角色","size":"medium"},on:{"change":function($event){return _vm.roleIdName()}},model:{value:(_vm.staffForm.rName),callback:function ($$v) {_vm.$set(_vm.staffForm, "rName", $$v)},expression:"staffForm.rName"}},_vm._l((_vm.roleList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"郵  箱:"}},[_c('el-input',{attrs:{"size":"medium","placeholder":"請輸入郵箱"},model:{value:(_vm.staffForm.email),callback:function ($$v) {_vm.$set(_vm.staffForm, "email", $$v)},expression:"staffForm.email"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check"},on:{"click":function($event){return _vm.submitStaff()}}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-error"},on:{"click":function($event){return _vm.cancelAddStaff()}}},[_vm._v("取 消")])],1)],2)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"修改密碼","visible":_vm.dialogFormVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"staffForm",attrs:{"model":_vm.staffForm,"size":"small","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"輸入新密碼","prop":"password"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","widht":"160px","placeholder":"請輸入新密碼"},model:{value:(_vm.staffForm.password),callback:function ($$v) {_vm.$set(_vm.staffForm, "password", $$v)},expression:"staffForm.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"確認新密碼","label-width":"120px","prop":"confirmPassword"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","widht":"160px","placeholder":"請確認新密碼"},model:{value:(_vm.staffForm.password1),callback:function ($$v) {_vm.$set(_vm.staffForm, "password1", $$v)},expression:"staffForm.password1"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check"},on:{"click":function($event){return _vm.modifyStaffPassword(_vm.staffForm)}}},[_vm._v("確 定")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-error"},on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")])],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lZHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"pcelcalendar"},[_c('el-calendar',{attrs:{"id":"calendar"},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',[(_vm.custTaskAdd)?_c('div',{staticClass:"data.isSelected ? 'is-selected' : ''",staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.handleAddClick(data.day)}}},[_vm._v(_vm._s(data.day.split('-').slice(2).join('-'))),_c('span',{staticStyle:{"color":"black","float":"right"}},[_c('i',{staticClass:"el-icon-plus"})])]):_c('div',{staticClass:"data.isSelected ? 'is-selected' : ''",staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(data.day.split('-').slice(2).join('-'))),_c('span',{staticStyle:{"color":"black","float":"right"}},[_c('i',{staticClass:"fa el-icon-plus"})])]),_vm._v(" "),_vm._l((_vm.Calendar),function(item,i){return _c('div',[((item.calendarDate.slice(0,4)).indexOf(data.day.slice(0,4))!=-1)?_c('div',[((item.calendarDate.split('-').slice(1)[0]).indexOf(data.day.split('-').slice(1)[0])!=-1)?_c('div',[((item.calendarDate.split('-').slice(2).join('-').slice(0,2)).indexOf(data.day.split('-').slice(2).join('-'))!=-1)?_c('div',[_c('div',{staticClass:"fc-day-grid-event"},[(_vm.custTaskEdit)?_c('div',{attrs:{"id":i%2==0?'fc-eventone':'fc-eventone2'},on:{"click":function($event){return _vm.handleEventClick(item.id)}}},[_vm._v(_vm._s(item.salesName)+"："+_vm._s(item.remark.length>17?item.remark.slice(0,17) + '...':item.remark))]):_c('div',{attrs:{"id":i%2==0?'fc-eventone':'fc-eventone2'}},[_vm._v(_vm._s(item.salesName)+"："+_vm._s(item.remark.length>17?item.remark.slice(0,17) + '...':item.remark))])])]):_vm._e()]):_vm._e()]):_vm._e()])})],2)]}}],null,false,1673298092),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left","margin-top":"-1030px","margin-left":"130px"}},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/calenList'}},[(!_vm.$store.getters.ismobilePhone)?_c('el-button',{attrs:{"size":"mini"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" 搜索")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"moblieElcalendar"},[_c('el-calendar',{attrs:{"id":"calendar"},scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',[_c('div',{staticStyle:{"text-align":"center","width":"30px","height":"30px"},on:{"click":function($event){return _vm.queryTask(data.day,0)}}},[_vm._v("\n\n\t\t\t\t\t\t\t"+_vm._s(data.day.split('-').slice(2).join('-'))+"\n\t\t\t\t \t\t\t\t\t\t\t\t"),_vm._l((_vm.datalist),function(item){return _c('div',[(item==data.day)?_c('div',{staticStyle:{"background-color":"rgba(39,116,244,0.2)","color":"#4B78FF","width":"28px","height":"28px","border-radius":"13px","margin-top":"-25px"}}):_vm._e()])})],2)])]}}],null,false,3047242993),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),(_vm.addDate!=null)?_c('div',{staticStyle:{"color":"#4B78FF"},on:{"click":function($event){return _vm.handleAddClick(_vm.addDate)}}},[_vm._v("新增行程")]):_vm._e(),_vm._v(" "),_vm._l((_vm.msglist),function(item){return _c('div',{staticStyle:{"width":"100%","background-color":"white","margin-top":"20px"}},[_c('div',{staticStyle:{"width":"100%","height":"20px"}},[_c('div',{staticClass:"rightDate"},[_vm._v("\n\t\t"+_vm._s(item.taskMsg.calendarDate.split('-').slice(2).join('-').slice(0,2))+"\n\t\t"),_c('div',{on:{"click":function($event){return _vm.appFileUp(item.taskMsg.id)}}},[_c('i',{staticClass:"el-icon-plus"})])])]),_vm._v(" "),_c('div',{staticStyle:{"color":"#333333","font-size":"17px","font-weight":"bold","margin-left":"10px","margin-top":"5px","width":"100%","height":"30px"}},[_vm._v(_vm._s(item.taskMsg.calendarDate)+" "+_vm._s(item.taskMsg.startDate)+"-"+_vm._s(item.taskMsg.endDate))]),_vm._v(" "),_c('div',{staticStyle:{"color":"#666666","font-size":"17px","font-weight":"bold","margin-left":"10px","margin-top":"5px","width":"100%"}},[_vm._v("銷售員："+_vm._s(item.taskMsg.salesName))]),_vm._v(" "),_c('div',{staticStyle:{"color":"#666666","font-size":"17px","font-weight":"bold","margin-left":"10px","margin-top":"5px","width":"100%"}},[_vm._v("地址："+_vm._s(item.taskMsg.place)+" ")]),_vm._v(" "),_c('div',{staticStyle:{"color":"#666666","font-size":"17px","font-weight":"bold","margin-left":"10px","margin-top":"5px","width":"100%","padding-bottom":"20px"}},[_vm._v("內容："+_vm._s(item.taskMsg.remark))]),_vm._v(" "),_vm._l((item.imgFile),function(imglist){return _c('div',[_c('img',{staticClass:"taskImg",attrs:{"src":_vm.appGetImgeUrl(imglist.relativePath)},on:{"click":function($event){return _vm.handleChangeImg($event)}}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.deleteCustFile(null, imglist)}}},[_vm._v("\n\t\t\t 删除\n\t\t ")])],1)})],2)})],2):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.optTitle,"visible":_vm.dialogFormVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFormVisible=$event}}},[_c('el-form',{ref:"taskForm",attrs:{"model":_vm.taskForm,"rules":_vm.taskRules,"label-width":"100px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_salesName')+'：',"prop":"salesId"}},[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"filterable":"","remote":"","placeholder":""},model:{value:(_vm.taskForm.salesId),callback:function ($$v) {_vm.$set(_vm.taskForm, "salesId", $$v)},expression:"taskForm.salesId"}},_vm._l((_vm.salesOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_place')+'：',"prop":"place"}},[_c('el-input',{staticStyle:{"width":"180px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.taskForm.place),callback:function ($$v) {_vm.$set(_vm.taskForm, "place", $$v)},expression:"taskForm.place"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_calendarStartdate')+'：',"prop":"startDate"}},[_c('el-time-select',{staticStyle:{"width":"180px"},attrs:{"placeholder":"","picker-options":{
                                    start: '00:00',
                                    step: '00:15',
                                    end: '24:00'
                                  }},model:{value:(_vm.taskForm.startDate),callback:function ($$v) {_vm.$set(_vm.taskForm, "startDate", $$v)},expression:"taskForm.startDate"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_calendarEnddate')+'：',"prop":"endDate"}},[_c('el-time-select',{staticStyle:{"width":"180px"},attrs:{"placeholder":"","picker-options":{
                                    start: '00:00',
                                    step: '00:15',
                                    end: '24:00',
                                  }},model:{value:(_vm.taskForm.endDate),callback:function ($$v) {_vm.$set(_vm.taskForm, "endDate", $$v)},expression:"taskForm.endDate"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_remarks'),"prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{minRows: 8, maxRows:18},"placeholder":""},model:{value:(_vm.taskForm.remark),callback:function ($$v) {_vm.$set(_vm.taskForm, "remark", $$v)},expression:"taskForm.remark"}})],1)],1)],1),_vm._v(" "),_c('el-row',[(_vm.taskForm.id&&_vm.canFile)?_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"warning"},nativeOn:{"click":function($event){return _vm.fileListEdit(_vm.taskForm.id)}}},[_vm._v(_vm._s(_vm.$t('m.t_enclosureadmin')))]):_vm._e(),_vm._v(" "),(_vm.taskForm.id&&_vm.custTaskDelete&&_vm.custTaskEditAll)?_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"warning"},on:{"click":function($event){return _vm.delEvent(_vm.taskForm.id)}}},[_vm._v("删 除")]):(_vm.taskForm.id&&_vm.custTaskDelete&&_vm.staff.id==_vm.taskForm.salesId)?_c('el-button',{staticStyle:{"float":"left"},attrs:{"type":"warning"},on:{"click":function($event){return _vm.delEvent(_vm.taskForm.id)}}},[_vm._v("删 除")]):_vm._e(),_vm._v(" "),(_vm.custTaskEditAll)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveEvent}},[_vm._v("确 定")]):(_vm.staff.id==_vm.taskForm.salesId)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saveEvent}},[_vm._v("确 定")]):_vm._e(),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right"},on:{"click":function($event){_vm.dialogFormVisible = false}}},[_vm._v("取 消")])],1)],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogFileListName,"visible":_vm.dialogFileListVisible,"width":"80%"},on:{"update:visible":function($event){_vm.dialogFileListVisible=$event}}},[_c('div',[_c('div',{staticStyle:{"float":"right"}},[(_vm.canFileAdd&&_vm.custTaskEditAll)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.custFileAdd}},[_c('i',{staticClass:"fa fa-cloud-upload"}),_vm._v(_vm._s(_vm.$t('m.b_uploadfile')))]):(_vm.canFileAdd&&_vm.staff.id==_vm.taskForm.salesId)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.custFileAdd}},[_c('i',{staticClass:"fa fa-cloud-upload"}),_vm._v(_vm._s(_vm.$t('m.b_uploadfile')))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"}})],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.fileList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionFileChange}},[_c('el-table-column',{attrs:{"prop":"fileName","align":"left","width":"160","label":_vm.$t('m.t_filename')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.pictureImg(scope.$index, scope.row))?_c('el-popover',{attrs:{"trigger":"hover","placement":"top"}},[_c('p',[_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.getImageUrl(scope.$index, scope.row)}})]),_vm._v(" "),_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('el-tag',{attrs:{"size":"medium"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.openFile(scope.$index, scope.row)}}},[_vm._v(_vm._s(scope.row.fileName))])])],1)]):_vm._e(),_vm._v(" "),(_vm.canFileDow&&!_vm.pictureImg(scope.$index, scope.row))?_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.fileDownload(scope.$index, scope.row)}}},[_vm._v(_vm._s(scope.row.fileName))]):_vm._e(),_vm._v(" "),(!_vm.canFileDow&&!_vm.pictureImg(scope.$index, scope.row))?_c('span',[_vm._v(_vm._s(scope.row.fileName))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"comment","align":"left","label":_vm.$t('m.t_remarks')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"uploadBy","align":"left","width":"120","label":_vm.$t('m.t_uploadby')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel2","align":"left","width":"160","label":_vm.$t('m.t_uploadtime')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.uploadTime*1000,'%Y-%m-%d %T'))+"\n                        ")]}}])}),_vm._v(" "),(_vm.canFileDow||_vm.canFileDel)?_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                                    ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canFileDow)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.fileDownload(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" "+_vm._s(_vm.$t('m.t_download')))]):_vm._e(),_vm._v(" "),(_vm.canFileDel&&_vm.custTaskEditAll)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.deleteCustFile(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(_vm._s(_vm.$t('m.b_delete')))]):(_vm.canFileDel&&_vm.staff.id==_vm.taskForm.salesId)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.deleteCustFile(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(_vm._s(_vm.$t('m.b_delete')))]):_vm._e()],1)],1)]]}}],null,false,2050331620)}):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.fileListPager.page,"page-size":_vm.fileListPager.size,"total":_vm.fileListPager.total},on:{"current-change":_vm.handleFileListChange,"update:currentPage":function($event){return _vm.$set(_vm.fileListPager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.fileListPager, "page", $event)}}})],1),_vm._v(" "),_c('div',{staticStyle:{"height":"50px"}}),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFileListVisible = false}}},[_vm._v(" 關閉")])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogFileName,"visible":_vm.dialogFileVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogFileVisible=$event}}},[_c('el-form',{ref:"custFile",attrs:{"model":_vm.custFile,"rules":_vm.custFileRules,"label-width":"100px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_file'),"prop":"file"}},[_c('div',[_c('div',[_c('a',{staticClass:"blueButton",attrs:{"href":"javascript:void(0);"}},[_vm._v(_vm._s(_vm.$t('m.t_selectthefile')))]),_vm._v(" "),_c('input',{staticClass:"myFileUpload",attrs:{"type":"file","id":"file","multiple":""},on:{"change":function($event){return _vm.getFile($event)}}})]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"30px"}},_vm._l((_vm.fileName),function(item){return _c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item)+"\n\t\t\t\t\t\t\t\t\t")])}),0)])])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_remarks'),"prop":"comment"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 2, maxRows: 4},"placeholder":""},model:{value:(_vm.custFile.comment),callback:function ($$v) {_vm.$set(_vm.custFile, "comment", $$v)},expression:"custFile.comment"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogFileVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.custFileSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4871e69a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("AwDt");
function injectStyle (ssrContext) {
  __webpack_require__("GIqa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4871e69a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4871e69a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "luvH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlcl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nCAB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o18F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"}),_vm._v(" "),_c('div',[_c('div',{staticClass:"ind_main"},[(_vm.$store.getters.searchSte)?_c('div',{staticClass:"fl",staticStyle:{"margin-bottom":"10px"}},[_c('button',{staticClass:"fanhui",on:{"click":_vm.retSearch}},[_vm._v(" 返回")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.searchSte == false)?_c('div',{staticClass:"fl",staticStyle:{"margin-bottom":"10px"}},[(!_vm.$store.getters.ismobilePhone)?_c('button',{staticClass:"fanhui",on:{"click":_vm.serac}},[_vm._v(" 返回")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"banckFont",on:{"click":_vm.serac}},[_vm._v("客戶詳情")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"kehu_list kehu_list2 kehu_list3"},[_c('ul',[_c('li',[_c('table',{attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('tr',{on:{"click":_vm.isonIn}},[_c('td',{staticClass:"b_1",attrs:{"colspan":"4"}},[_c('div',{class:_vm.$store.getters.ismobilePhone==false?'search_1':'search_2'},[_vm._v(_vm._s(_vm.customer.code))]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","right":"40px","color":"#f00","top":"-6px"}},[(_vm.isShow == true)?[_c('img',{attrs:{"src":__webpack_require__("3R8H")}})]:_vm._e(),_vm._v(" "),(_vm.isShow == false)?[_c('img',{attrs:{"src":__webpack_require__("SuXA")}})]:_vm._e()],2)])]),_vm._v(" "),(_vm.isShow)?_c('tr',[_c('td',{staticClass:"w0",attrs:{"width":"20%","align":"right"}},[_vm._v("姓名：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customer.name))]),_vm._v(" "),_c('td',{staticClass:"w0",attrs:{"width":"20%","align":"right"}}),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('tr',[_c('td',{staticClass:"w0",attrs:{"width":"20%","align":"right"}},[_vm._v("電話：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.customer.phone))]),_vm._v(" "),_c('td',{staticStyle:{"font-size":"12.5px"},attrs:{"width":"150px","align":"left"}},[_vm._v("銷售員：")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_vm._v(_vm._s(_vm.customer.sales))])]):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('tr',[_c('td',{staticClass:"w0",attrs:{"width":"20%","valign":"top","align":"right"}},[_vm._v("地址：")]),_vm._v(" "),_c('td',{attrs:{"colspan":"3","valign":"top"}},[_vm._v(" "+_vm._s(_vm.customer.address))])]):_vm._e()])])])]),_vm._v(" "),(!_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"sch_btn"},[_c('div',{staticClass:"sbtn fl"},[_c('el-button',{class:{qbkc:_vm.isQbkc},on:{"click":_vm.swcListTwo}},[_vm._v(" 全部庫存")]),_vm._v(" "),_c('el-button',{class:{qbkc:_vm.isRhdcx},on:{"click":_vm.swcListThree}},[_vm._v(" 入貨單查詢")]),_vm._v(" "),_c('el-button',{class:{qbkc:_vm.isChdcx},on:{"click":_vm.swcListFour}},[_vm._v(" 出倉單查詢")])],1),_vm._v(" "),(_vm.sbtnfr)?_c('div',{staticClass:"sbtn fr"},[_c('el-button',{class:{qbkc:_vm.isQhlb},on:{"click":_vm.swcList}},[_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(" "+_vm._s(_vm.listText))])])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone)?_c('div',{attrs:{"id":"btnlist"}},[_c('ul',[_c('li',{class:_vm.selectid==0?'selectbtn':'noselectbtn',on:{"click":_vm.swcListTwo}},[_vm._v("全部庫存")]),_vm._v(" "),_c('li',{class:_vm.selectid==1?'selectbtn':'noselectbtn',on:{"click":_vm.swcListThree}},[_vm._v("入貨單查詢")]),_vm._v(" "),_c('li',{class:_vm.selectid==2?'selectbtn':'noselectbtn',on:{"click":_vm.swcListFour}},[_vm._v("出倉單查詢")])])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.ruku_list)?_c('div',{staticClass:"ruku_list",staticStyle:{"margin-top":"80px"}},[(_vm.$store.getters.ismobilePhone == false)?_c('table',{staticClass:"responsive",staticStyle:{"width":"100%"},attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.locationPageList),function(item1){return (_vm.locationPageList.length != 0)?_c('tr',[_c('td',{staticClass:"name"},[(item1.floor == 0)?[_vm._v("\n\t\t\t\t\t\t\t\t\t\tG/F\n\t\t\t\t\t\t\t\t\t")]:[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(item1.floor)+"/F\n\t\t\t\t\t\t\t\t\t")]],2),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.name)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.companyNo)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions",staticStyle:{"text-align":"left"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.stock)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.code)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.createDate)+"\n\t\t\t\t\t\t\t\t")])]):_vm._e()}),_vm._v(" "),(_vm.locationPageList.length == 0)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v("暫無數據")])]):_vm._e()],2):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.$store.getters.ismobilePhone&&_vm.ruku_list)?_c('div',{staticStyle:{"margin-top":"-90px"}},[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._m(1),_vm._v(" "),_vm._l((_vm.locationPageList),function(item1){return (_vm.locationPageList.length != 0)?_c('tr',[_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.companyNo)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"name"},[(item1.floor == 0)?[_vm._v("\n\t\t\t\t\t\t\t\t\t\tGF "+_vm._s(item1.name)+"\n\t\t\t\t\t\t\t\t\t")]:[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(item1.floor)+"F "+_vm._s(item1.name)+"\n\t\t\t\t\t\t\t\t\t")]],2),_vm._v(" "),_c('td',{staticClass:"number"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.stock)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item1.code)+"\n\t\t\t\t\t\t\t\t")])]):_vm._e()}),_vm._v(" "),(_vm.locationPageList.length == 0)?_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_vm._v("暫無數據")])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.loadingimg)?_c('div',{staticStyle:{"position":"absolute","left":"50%","top":"34%"}},[_c('img',{attrs:{"src":__webpack_require__("JV7o")}})]):_vm._e(),_vm._v(" "),(_vm.ind_main)?_c('div',{staticClass:"ind_main"},[_c('div',{staticClass:"ind_cont"},[_c('div',{staticClass:"tabs",staticStyle:{"margin-top":"1%"}},_vm._l((_vm.locationList),function(flo){return _c('div',{staticClass:"tab-item",class:{'activeone':flo.floor == _vm.num},attrs:{"id":'tab'+flo.floor}},[_c('table',{staticClass:"tab1",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((4),function(n){return _c('tr',{staticClass:"xuline",staticStyle:{"width":"25%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'searchcur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).status == 1},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td')]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status == 1)?[_c('td',{staticClass:"searchcur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id)}}},[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status != 1)?[_c('td',[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name))])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td')]:_vm._e()]})],2)}),0),_vm._v(" "),_c('table',{staticClass:"tab2",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((10),function(n){return (n>4)?_c('tr',{staticClass:"xuline",staticStyle:{"width":"16.6%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'searchcur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).status == 1},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td')]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status == 1)?[_c('td',{staticClass:"searchcur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id)}}},[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t "),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status != 1)?[_c('td',[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name))])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td')]:_vm._e()]})],2):_vm._e()}),0),_vm._v(" "),_c('table',{staticClass:"tab3",attrs:{"cellpadding":"0","cellspacing":"0"}},_vm._l((16),function(n){return (n>10)?_c('tr',{staticClass:"xuline",staticStyle:{"width":"16.6%","float":"left"}},[_vm._l((flo.maxY),function(y){return [(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta; }))?[_c('td',{class:{'searchcur':flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).status == 1},on:{"click":function($event){_vm.locationEdit(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).id)}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:(_vm.$store.getters.sta)?[_c('td')]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }))?[(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status == 1)?[_c('td',{staticClass:"searchcur",on:{"click":function($event){_vm.cusInventory(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).id)}}},[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"),_c('img',{attrs:{"src":__webpack_require__("D9yh")}})])]:_vm._e(),_vm._v(" "),(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).status != 1)?[_c('td',[_vm._v(_vm._s(flo.itemList.find(function (v){ return v.x==n&&v.y==(flo.maxY-y+1)&&v.floor==flo.floor&&_vm.$store.getters.sta==false; }).name))])]:_vm._e()]:(_vm.$store.getters.sta==false)?[_c('td')]:_vm._e()]})],2):_vm._e()}),0),_vm._v(" "),(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"tongji"},_vm._l((_vm.floSideCount),function(floside){return (flo.floor == floside.floor)?_c('div',{class:'fl_'+floside.side},[_c('span',{staticClass:"red"},[_vm._v(_vm._s(floside.usecount))]),_vm._v("/"+_vm._s(floside.flosidecount))]):_vm._e()}),0):_vm._e()])}),0),_vm._v(" "),(_vm.$store.getters.ismobilePhone == false)?_c('div',{staticClass:"table_qh",attrs:{"id":"table_qh"}},[_c('ul',[_vm._l((_vm.locationList),function(flo,index){return [(flo.floor == 0)?_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v("G/F")]):_c('li',{class:{'background cur':_vm.changeRed == index},attrs:{"id":'tabBtn'+flo.floor},on:{"click":function($event){return _vm.listCut(flo.floor)}}},[_vm._v(_vm._s(flo.floor)+"/F")])]})],2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.locationList),function(flo,index){return (_vm.$store.getters.ismobilePhone)?_c('div',{staticClass:"mob_tongji"},[_c('div',{staticClass:"fl"},[_vm._v("當前樓層共"),_c('span',{staticClass:"red"},[_vm._v(_vm._s(flo.floorcount))]),_vm._v("個位置")]),_vm._v(" "),_c('div',{staticClass:"mob_tjTxt"},[(flo.floor == 0)?_c('div',{staticClass:"fl_0"},[_vm._v("G/F")]):_c('div',{staticClass:"fl_0"},[_vm._v(_vm._s(flo.floor)+"/F")]),_vm._v(" "),_vm._l((_vm.floSideCount),function(floside){return (flo.floor == floside.floor)?_c('div',{class:'fl_'+floside.side},[_c('span',{staticClass:"red"},[_vm._v(_vm._s(floside.usecount))]),_vm._v("/"+_vm._s(floside.flosidecount))]):_vm._e()})],2)]):_vm._e()})],2)]):_vm._e(),_vm._v(" "),(_vm.ruku_listTwo)?_c('div',{staticClass:"ruku_list"},[(_vm.addWarehousingList != 0)?_c('el-form',[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._l((_vm.addWarehousingList),function(items,i){return [_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"colspan":"3"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("date")(items.createDate,'%Y-%m-%d %H:%M'))+"\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('th',[_c('span',[_vm._v("Job00"+_vm._s(i+1))])])]),_vm._v(" "),_c('tr',{staticClass:"trHead"},[_c('th',[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("數量")])])]),_vm._v(" "),_vm._l((items.storInItem),function(item1,index){return _c('tr',[_c('td',{staticClass:"number"},[_c('span',[_vm._v(_vm._s(item1.unit)+_vm._s(item1.boxNo))])]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('span',[_vm._v(_vm._s(item1.value))]),_vm._v(" "),(item1.state == 1)?[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t（已出倉）\n\t\t\t\t\t\t\t\t\t\t\t")]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[_c('span',[_vm._v(_vm._s(item1.item))])]),_vm._v(" "),_c('td',{staticClass:"actions"},[_c('span',[_vm._v(_vm._s(item1.qty))])])])})]})],2)]):_vm._e(),_vm._v(" "),(_vm.addWarehousingList == 0)?_c('el-form',[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('td',[_vm._v("暫無數據")])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.show)?_c('div',[_c('div',{staticClass:"ind_main ind_main2"},[_c('div',{staticClass:"ind_cont2"},[_c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.ismobilePhone)?[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.codeTableloading),expression:"codeTableloading"}],staticStyle:{"width":"100%","margin-top":"1%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"border":"","data":_vm.warehousingList},on:{"row-click":_vm.selSotrIn}},[(_vm.isInOn == '1')?[_c('el-table-column',{attrs:{"width":"100rpx","prop":"scode","label":"入貨單號："}})]:_vm._e(),_vm._v(" "),(_vm.isInOn == '2')?[_c('el-table-column',{attrs:{"width":"100rpx","prop":"scode","label":"出货單號："}})]:_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storInDate","width":"220rpx","label":"創建時間"}})],2)]:[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.codeTableloading),expression:"codeTableloading"}],staticStyle:{"width":"100%","margin-top":"1%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"border":"","data":_vm.warehousingList}},[(_vm.isInOn == '1')?[_c('el-table-column',{attrs:{"prop":"scode","label":"入貨單號："}})]:_vm._e(),_vm._v(" "),(_vm.isInOn == '2')?[_c('el-table-column',{attrs:{"prop":"scode","label":"出货單號："}})]:_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storInDate","width":"200","label":"創建時間"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"操作","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" 操作\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('el-dropdown-menu',{staticStyle:{"padding-left":"1%"},attrs:{"slot":"dropdown","size":"small"},slot:"dropdown"},[_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.selSotrIn(scope.row)}}},[_c('i',{staticClass:"fa fa-search-plus"}),_vm._v(" 详情")]),_vm._v(" "),_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.edtSotrIn(scope.row.id)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("編輯")])],1)],1)]}}],null,false,4232050357)})],2)]],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)])])]):_vm._e()])])]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogName,"visible":_vm.dialogDiscEditVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogDiscEditVisible=$event}}},[_c('el-form',{ref:"customerForm",attrs:{"model":_vm.customerForm,"rules":_vm.customerRules,"label-width":"130px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"客戶編號:","prop":"code"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"text"},model:{value:(_vm.customerForm.code),callback:function ($$v) {_vm.$set(_vm.customerForm, "code", $$v)},expression:"customerForm.code"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"姓名:","prop":"name"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.name),callback:function ($$v) {_vm.$set(_vm.customerForm, "name", $$v)},expression:"customerForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"電話:","prop":"phone"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.phone),callback:function ($$v) {_vm.$set(_vm.customerForm, "phone", $$v)},expression:"customerForm.phone"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"地址:","prop":"address"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.customerForm.address),callback:function ($$v) {_vm.$set(_vm.customerForm, "address", $$v)},expression:"customerForm.address"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"銷售員: ","prop":"sales"}},[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethodSales,"loading":_vm.tableloading},model:{value:(_vm.customerForm.sales),callback:function ($$v) {_vm.$set(_vm.customerForm, "sales", $$v)},expression:"customerForm.sales"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogDiscEditVisible = false}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.customerSave}},[_vm._v("確認")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.tkshow},on:{"update:visible":function($event){_vm.tkshow=$event}}},[_c('div',{staticClass:"ruku_list"},[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_c('thead',[_c('tr',{staticClass:"trHead"},[_c('th',[_vm._v("订單號")]),_vm._v(" "),_c('th',[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.custName))]),_vm._v(" "),_c('th',[_vm._v("入倉時間")])])]),_vm._v(" "),_vm._l((_vm.locationListB),function(item1,index){return (_vm.locationListB.length != 0)?_c('tr',[_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item1.sCode)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item1.unit)+"("+_vm._s(item1.boxNo)+")\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item1.item)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"actions"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm._f("date")(item1.createDate*1000,'%Y-%m-%d %T'))+"\n\t\t\t\t\t\t")])]):_vm._e()}),_vm._v(" "),(_vm.locationListB.length == 0)?_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v("暫無數據")])]):_vm._e()],2)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"trHead"},[_c('th',[_vm._v("樓層")]),_vm._v(" "),_c('th',[_vm._v("貨架")]),_vm._v(" "),_c('th',[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("單號")]),_vm._v(" "),_c('th',[_vm._v("入倉日期")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"trHead"},[_c('th',[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("位置")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',[_vm._v("單號")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oEYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedBack_vue__ = __webpack_require__("4kQt");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470cbdda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedBack_vue__ = __webpack_require__("4AcP");
function injectStyle (ssrContext) {
  __webpack_require__("55r/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FeedBack_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_470cbdda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FeedBack_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ohnS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            searchName: '',
            roles: [],
            selectionRoles: [],
            roleTableloading: false,
            roleSaveloading: false,
            pager: {
                page: 1,
                size: 10,
                total: 0
            },
            dialogName: '新增角色',
            dialogRoleFormVisible: false,
            roleForm: {
                id: '',
                name: '',
                pids: [],
                oids: [],
                mids: []
            },
            roleRules: {
                name: [{ required: true, message: this.$t('m.m_accountnumber'), trigger: 'blur' }, { min: 2, max: 20, message: this.$t('m.m_length220'), trigger: 'blur' }],
                pids: [{ required: false, message: this.$t('m.m_jurisdiction'), trigger: 'blur' }]
            },
            permissionTreeExpandedKeys: [],
            permissionTreeData: [],
            permissionTreeProps: {
                children: 'children',
                label: 'name'
            }
        };
    },

    methods: {
        requestRoleList: function requestRoleList() {
            var _this = this;

            this.roleTableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, name: this.searchName.trim() };
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_5" /* getRoleList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        roles = _res$data$data === undefined ? [] : _res$data$data;

                    _this.roles = roles;
                    _this.pager.total = total;
                    _this.pager.page = page;
                    _this.pager.size = size;
                    _this.roleTableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        requestPermissionTree: function requestPermissionTree() {
            var _this2 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_0" /* getPermissionTree */])().then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode == 200) {
                    _this2.permissionTreeData = JSON.parse(res.data);
                    var expandedKyes = [];
                    _this2.permissionTreeData.forEach(function (x, i) {
                        return expandedKyes[i] = x.id;
                    });
                    _this2.permissionTreeData.forEach(function (item, index) {
                        item.name = item.name;
                        if (item.id != 9) {
                            item.children.forEach(function (chiItem, index) {
                                chiItem.name = chiItem.name;
                            });
                        }
                    });
                    _this2.permissionTreeExpandedKeys = expandedKyes;
                    _this2.$refs.permissionTree.setCheckedKeys([]);
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        requestRoleById: function requestRoleById(id) {
            var _this3 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_4" /* getRoleById */])(id).then(function (data) {
                var _data$data3 = data.data,
                    res = _data$data3 === undefined ? {} : _data$data3;
                var _res$data2 = res.data,
                    id = _res$data2.id,
                    name = _res$data2.name,
                    _res$data2$pids = _res$data2.pids,
                    pids = _res$data2$pids === undefined ? "" : _res$data2$pids;

                _this3.roleForm.id = id;
                _this3.roleForm.name = name;
                _this3.roleForm.pids = pids;
                if (pids == null || pids == '') {
                    var logicPids = [];
                    _this3.$refs.permissionTree.setCheckedKeys(logicPids);
                    _this3.permissionTreeExpandedKeys = logicPids;
                } else {
                    var _logicPids = pids.split(",");
                    _this3.$refs.permissionTree.setCheckedKeys(_logicPids);
                    _this3.permissionTreeExpandedKeys = _logicPids;
                }
            });
        },
        requestDeleteRole: function requestDeleteRole(ids) {
            var _this4 = this;

            this.$confirm(this.$t('m.m_deleterole'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                /* deleteRole(ids).then(data=>{
                     let {errcode,errmsg}=data.data;
                     if(errcode==200){
                         this.$message.success(this.$t('m.m_deletesuc'));
                         this.requestRoleList();
                     }else{
                         this.$message.error(errmsg);
                     }
                 });*/
                return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_16" /* getStffRoles */])(ids).then(function (data) {
                    if (data.data.data == 0) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["m" /* deleteRole */])(ids).then(function (data) {
                            var _data$data4 = data.data,
                                errcode = _data$data4.errcode,
                                errmsg = _data$data4.errmsg;

                            if (errcode == 200) {
                                _this4.$message.success(_this4.$t('m.m_deletesuc'));
                                _this4.requestRoleList();
                            } else {
                                _this4.$message.error("删除失败！");
                            }
                        });
                    } else {
                        _this4.$message.warning("還有員工是該角色，不能刪除！");
                    }
                });
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.requestRoleList();
        },
        handleCheckChange: function handleCheckChange(data, checked, indeterminate) {
            var nodes = this.$refs.permissionTree.getCheckedNodes();
            var oids = [];
            var mids = [];
            var pids = [];
            nodes.forEach(function (node) {
                if (node.type == "o") {
                    oids[oids.length] = node.id;
                    pids[pids.length] = node.uid;
                } else if (node.type == "m") {
                    mids[mids.length] = node.id;
                    pids[pids.length] = node.uid;
                }
            });
            this.roleForm.oids = oids.join(",");
            this.roleForm.mids = mids.join(",");

            this.roleForm.pids = pids.join(",");
            this.$refs.roleForm.validateField('pids');
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionRoles = val;
        },
        handleAdd: function handleAdd(ev) {
            this.roleForm = { id: '', name: '', pids: [] };
            this.dialogName = this.$t('m.b_newrole'), this.dialogRoleFormVisible = true;
            this.requestPermissionTree();
            this.resetForm("roleForm");
        },
        handleEdit: function handleEdit(index, row) {
            var _this5 = this;

            this.dialogName = this.$t('m.t_updaterole'), this.dialogRoleFormVisible = true;
            this.requestPermissionTree().then(function (data) {
                _this5.requestRoleById(row.id);
            });
            this.resetForm("roleForm");
        },
        handleAddByCopy: function handleAddByCopy(index, row) {
            var _this6 = this;

            this.$confirm("確定要復制新增 '" + row.name + "' 嗎？", {
                confirmButtonClass: "Confirm",
                cancelButtonClass: "Cancel",
                closeOnClickModal: false,
                type: "warning"
            }).then(function () {
                return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["b" /* addRoleByCopy */])(row.id).then(function (data) {
                    if (data.data.errcode == 200) {
                        _this6.requestRoleList();
                    } else {
                        _this6.$message.error(data.data.errmsg);
                    }
                });
            });
        },
        handleSave: function handleSave(ev) {
            var _this7 = this;

            this.$refs.roleForm.validate(function (valid) {
                if (valid) {
                    if (_this7.roleForm.id == "") {
                        _this7.roleSaveloading = true;
                        if (_this7.roleForm.pids == null) {
                            _this7.roleForm.pids = "";
                        }
                        if (_this7.roleForm.oids == null) {
                            _this7.roleForm.oids = "";
                        }
                        if (_this7.roleForm.mids == null) {
                            _this7.roleForm.mids = "";
                        }
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this7.roleForm);
                        delete params.id;
                        Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_48" /* insertRole */])(params).then(function (data) {
                            _this7.roleSaveloading = false;
                            var _data$data5 = data.data,
                                errcode = _data$data5.errcode,
                                errmsg = _data$data5.errmsg;

                            if (errcode == 200) {
                                _this7.$message.success(_this7.$t('m.m_newsucs'));
                                _this7.requestRoleList();
                                _this7.dialogRoleFormVisible = false;
                                _this7.resetForm("roleForm");
                            } else {
                                _this7.$message.error("新增失败！");
                            }
                        });
                    } else {
                        var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this7.roleForm);
                        Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_75" /* updateRole */])(params).then(function (data) {
                            _this7.roleSaveloading = false;
                            var _data$data6 = data.data,
                                errcode = _data$data6.errcode,
                                errmsg = _data$data6.errmsg;

                            if (errcode == 200) {
                                _this7.$message.success(_this7.$t('m.m_updatesucs'));
                                _this7.requestRoleList();
                                _this7.dialogRoleFormVisible = false;
                                _this7.resetForm("roleForm");
                            } else {
                                _this7.$message.error("修改失败！");
                            }
                        });
                    }
                }
            });
        },
        handleDelete: function handleDelete(index, row) {
            this.requestDeleteRole(row.id);
        },
        handleBatchDelete: function handleBatchDelete() {
            var ids = [];
            this.selectionRoles.forEach(function (v, i) {
                return ids[i] = v.id;
            });
            this.requestDeleteRole(ids.join(","));
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ROLE_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("ROLE_EDIT");
        },
        canDelete: function canDelete() {
            return this.$store.getters.hasPermission("ROLE_DELETE");
        }
    },
    activated: function activated() {
        this.requestRoleList();
    }
});

/***/ }),

/***/ "pIGA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pM4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExcelExport_vue__ = __webpack_require__("44TC");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255cb36e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExcelExport_vue__ = __webpack_require__("9kf3");
function injectStyle (ssrContext) {
  __webpack_require__("Vb2S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-255cb36e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExcelExport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255cb36e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExcelExport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "pNT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/jobAdd'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增工作單")]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getJobOrderList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"工作單號/客戶","clearable":""},model:{value:(_vm.serchJobNO),callback:function ($$v) {_vm.serchJobNO=$$v},expression:"serchJobNO"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-date-picker',{staticStyle:{"width":"260px","color":"#4B78FF"},attrs:{"type":"daterange","align":"right","unlink-panels":"","range-separator":"~","start-placeholder":"工作日期","end-placeholder":"工作日期","value-format":"timestamp","picker-options":_vm.pickerOptions2},model:{value:(_vm.searchDate),callback:function ($$v) {_vm.searchDate=$$v},expression:"searchDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getJobOrderList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.custTaskList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"jobNo","align":"left","width":"120","label":"工作單號"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.countNum!=0)?[_vm._v("\n                        "+_vm._s(scope.row.jobNo)+" *\n                    ")]:[_vm._v("\n                        "+_vm._s(scope.row.jobNo)+"\n                    ")]]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"custNo","align":"left","label":"客戶"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                   "+_vm._s(scope.row.custNo)+"/"+_vm._s(scope.row.custName)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"service","align":"left","width":"70","label":"類型"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dest","align":"left","label":"目的地"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startDate","align":"left","width":"110","label":"工作日期"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.startDate!=0)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.startDate*1000,'%Y-%m-%d'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"jobDetail","align":"left","label":"工作內容"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.feedBackEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(_vm.canPrint)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.feedBackPrint(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("卡板箱號管理")]):_vm._e(),_vm._v(" "),(_vm.canPdf)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pdfBaseDownload(scope.row)}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("Loading Chart")]):_vm._e(),_vm._v(" "),(_vm.canWord)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pdfDownload(scope.row,1)}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("工作單下載")]):_vm._e(),_vm._v(" "),(_vm.canHouse)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pdfDownload(scope.row,2)}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("回倉纸下載")]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pdO/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查詢條件
            serchCarNumber: "",
            serchStatus: '',
            getFeedDate: '',
            selectionItems: [],
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            rollingList: [],
            dialogName: '',
            tableloading: false
        };
    },

    methods: {
        removeRollItem: function removeRollItem(index) {
            var i = 0;
            for (i; i < this.poiItemList.length; i++) {
                if (index == this.poiItemList[i].index) {
                    break;
                }
            }
            this.poiItemList.splice(i, 1);
            this.rearrIndex();
        },

        //當發票商品刪除的時候， 重新給每個index 賦值
        rearrIndex: function rearrIndex() {
            var i = 0;
            for (i = 0; i < this.poiItemList.length; i++) {
                this.poiItemList[i].index = i + 1;
            }
            this.index = i;
        },
        deleteEdit: function deleteEdit(row) {
            var _this = this;

            this.$confirm('你確定要刪除嗎?', this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["n" /* deleteRollingById */])(row.id).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode == 200) {
                        _this.$message.success('刪除成功');
                        _this.getFeedBackList();
                    } else {
                        _this.$message.error("刪除失败！");
                    }
                });
            });
        },
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {},
        custTaskPageChange: function custTaskPageChange(val) {
            this.getFeedBackList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        pdfDownload: function pdfDownload(value) {
            var url = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + "/excel/rollStock?rollId=" + value.id + "&token=" + this.$store.getters.staff.token;
            window.location.href = url;
        },
        getFeedBackList: function getFeedBackList() {
            var _this2 = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, carNumber: this.serchCarNumber.trim(), feedDate: this.getFeedDate, status: this.serchStatus };
            if (params.feedDate != null && params.feedDate != '') {
                params.feedDate = parseInt(new Date(params.feedDate).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["_10" /* getRollingsList */])(params).then(function (data) {
                var _data$data2 = data.data,
                    res = _data$data2 === undefined ? {} : _data$data2;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this2.rollingList = items;
                    _this2.pager.total = total;
                    _this2.pager.page = page;
                    _this2.pager.size = size;
                    _this2.tableloading = false;
                } else {
                    _this2.$message.error(res.errmsg);
                }
            });
        },
        rollingEdit: function rollingEdit(row) {
            this.$router.push({
                name: '編輯出倉紙',
                params: {
                    outId: row.id
                }
            });
            var path = "/rollEdit/" + row.id;
            this.$router.push(path);
        },
        feedEdit: function feedEdit(row) {
            this.$router.push({
                name: '編輯回料紙',
                params: {
                    feedId: row.feeId,
                    rollId: row.id
                }
            });
            var path = "/feedEdit/" + row.feeId + "/" + row.id;
            this.$router.push(path);
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getFeedBackList();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("ROLL_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("ROLL_EDIT");
        },
        canPdf: function canPdf() {
            return this.$store.getters.hasPermission("ROLL_PDF");
        },
        canDelete: function canDelete() {
            return this.$store.getters.hasPermission("ROLL_DELETE");
        },
        canIn: function canIn() {
            return this.$store.getters.hasPermission("ROLL_IN");
        }
    }
});

/***/ }),

/***/ "qPEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemStor_vue__ = __webpack_require__("8KJh");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1744c6c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemStor_vue__ = __webpack_require__("8PTB");
function injectStyle (ssrContext) {
  __webpack_require__("Y3O9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemStor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1744c6c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemStor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qQOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"},on:{"click":_vm.pendingAdds}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.t_addgoodsadjustment')))]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getStockAdjustList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"車號"}},[_c('el-input',{attrs:{"placeholder":"車號","clearable":""},model:{value:(_vm.serchCarNumber),callback:function ($$v) {_vm.serchCarNumber=$$v},expression:"serchCarNumber"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"date","placeholder":"選擇日期"},model:{value:(_vm.getFeedDate),callback:function ($$v) {_vm.getFeedDate=$$v},expression:"getFeedDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"狀態","clearable":""},model:{value:(_vm.serchStatus),callback:function ($$v) {_vm.serchStatus=$$v},expression:"serchStatus"}},[_c('el-option',{attrs:{"value":"0","label":"未入倉"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"1","label":"已入倉"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getStockAdjustList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.stockAdjList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"itemName","align":"left","label":"产品"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qty","align":"right","width":"90","label":_vm.$t('m.t_qtysk')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","align":"left","label":_vm.$t('m.t_remarks')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createDate","align":"left","width":"110","label":_vm.$t('m.t_date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.createDate!=0)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.createDate*1000,'%Y-%m-%d'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","align":"left","width":"90","label":"狀態"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status==0)?[_vm._v("\n                        未入倉\n                    ")]:_vm._e(),_vm._v(" "),(scope.row.status==1)?[_vm._v("\n                        已入倉\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.status==0&&(_vm.canEdit||_vm.canDel||_vm.canImport))?[[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                            ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(scope.row.status==0&&_vm.canEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.pendingEdit(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(scope.row.status==0&&_vm.canImport)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.importBnt(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" "+_vm._s(_vm.$t('m.b_import')))]):_vm._e(),_vm._v(" "),(scope.row.status==0&&_vm.canDel)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pendingDel(scope.$index, scope.row)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "+_vm._s(_vm.$t('m.b_delete')))]):_vm._e()],1)],1)]]:undefined}}],null,true)})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogAddsName,"visible":_vm.dialogAddsVisible,"width":"620px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogAddsVisible=$event}}},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticStyle:{"width":"100%"},attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.stockInList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"itemCode","width":"148px","align":"left","label":_vm.$t('m.b_prodcode')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"120px"},attrs:{"filterable":"","remote":"","clearable":"","remote-method":_vm.getItemListOption,"placeholder":"","default-first-option":"","size":"mini"},on:{"focus":function($event){return _vm.getTempIndex(scope.row.index)},"change":_vm.itemHandleSelect},model:{value:(scope.row.itemId),callback:function ($$v) {_vm.$set(scope.row, "itemId", $$v)},expression:"scope.row.itemId"}},_vm._l((scope.row.itemOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.itemName,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.itemName))])])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"itemName","width":"95px","align":"left","label":_vm.$t('m.t_qtysk')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"70px"},attrs:{"placeholder":"","auto-complete":"off","size":"mini"},on:{"focus":function($event){return _vm.getTempIndex(scope.row.index)},"change":_vm.qtyChange},model:{value:(scope.row.qty),callback:function ($$v) {_vm.$set(scope.row, "qty", $$v)},expression:"scope.row.qty"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"itemName","width":"265px","align":"left","label":_vm.$t('m.t_remarks')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"240px"},attrs:{"placeholder":"","auto-complete":"off","size":"mini"},on:{"focus":function($event){return _vm.getTempIndex(scope.row.index)}},model:{value:(scope.row.remark),callback:function ($$v) {_vm.$set(scope.row, "remark", $$v)},expression:"scope.row.remark"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"70","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.removeStockInItem(scope.row.index)}}},[_c('i',{staticClass:"fa fa-trash"})])]}}])})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary","loading":_vm.addEidtloading,"size":"small"},on:{"click":_vm.addStockInItem}},[_vm._v(_vm._s(_vm.$t('m.t_new')))]),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogAddsVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.pendingListSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogCodeName,"visible":_vm.dialogCodeVisible,"width":"450px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.dialogCodeVisible=$event}}},[_c('el-form',{ref:"pendingForm",attrs:{"model":_vm.pendingForm,"label-width":"160px","size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.b_prodcode')+'：',"prop":"itemName"}},[_vm._v("\n                        "+_vm._s(_vm.pendingForm.itemName)+"\n                    ")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_qtysk')+'：',"prop":"qty"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"placeholder":"","auto-complete":"off"},model:{value:(_vm.pendingForm.qty),callback:function ($$v) {_vm.$set(_vm.pendingForm, "qty", $$v)},expression:"pendingForm.qty"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":_vm.$t('m.t_remarks')+'：',"prop":"remark"}},[_c('el-input',{staticStyle:{"width":"200px"},attrs:{"type":"textarea","autosize":{ minRows: 2, maxRows: 4},"placeholder":""},model:{value:(_vm.pendingForm.remark),callback:function ($$v) {_vm.$set(_vm.pendingForm, "remark", $$v)},expression:"pendingForm.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogCodeVisible = false}}},[_vm._v(_vm._s(_vm.$t('m.b_cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.addEidtloading},on:{"click":_vm.pendingSave}},[_vm._v(_vm._s(_vm.$t('m.b_save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rUVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddStockIn_vue__ = __webpack_require__("a8uj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9ed6e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddStockIn_vue__ = __webpack_require__("vnfS");
function injectStyle (ssrContext) {
  __webpack_require__("nCAB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddStockIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9ed6e38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddStockIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s67A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"rollingForm",staticClass:"demo-form-inline",staticStyle:{"width":"1500px"},attrs:{"inline":true,"model":_vm.rollingForm,"rules":_vm.rollingRules,"size":"small"}},[_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"日期：","prop":"feedDate"}},[_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"type":"date","placeholder":"","disabled":_vm.disabledNum},model:{value:(_vm.rollingForm.feedDate),callback:function ($$v) {_vm.$set(_vm.rollingForm, "feedDate", $$v)},expression:"rollingForm.feedDate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"車號：","prop":"carNumber"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateCarNumber(_vm.rollingForm.carNumber)}},model:{value:(_vm.rollingForm.carNumber),callback:function ($$v) {_vm.$set(_vm.rollingForm, "carNumber", $$v)},expression:"rollingForm.carNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"扎車(坑紙)","prop":"oneCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"坑紙","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatePitPaperTitle(_vm.rollingForm.oneCar)}},model:{value:(_vm.rollingForm.oneCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "oneCar", $$v)},expression:"rollingForm.oneCar"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"扎車(地膠)","prop":"twoCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"地膠","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateTwoCarTitle(_vm.rollingForm.twoCar)}},model:{value:(_vm.rollingForm.twoCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "twoCar", $$v)},expression:"rollingForm.twoCar"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"扎車(縐紋紙)","prop":"threeCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"縐紋紙","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateThreeTitle(_vm.rollingForm.threeCar)}},model:{value:(_vm.rollingForm.threeCar),callback:function ($$v) {_vm.$set(_vm.rollingForm, "threeCar", $$v)},expression:"rollingForm.threeCar"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.poiItemList),function(poiItem){return _c('div',[(poiItem.index!=1)?_c('el-row',{attrs:{"gutter":0}},[_c('div',{staticStyle:{"margin-left":"100px","border":"1px dashed #000","width":"73%","margin-bottom":"3px"}})]):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"坑紙","prop":"pitPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatePitPaper(poiItem)}},model:{value:(poiItem.pitPaper),callback:function ($$v) {_vm.$set(poiItem, "pitPaper", $$v)},expression:"poiItem.pitPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"報紙","prop":"newsPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatenewsPaper(poiItem)}},model:{value:(poiItem.newsPaper),callback:function ($$v) {_vm.$set(poiItem, "newsPaper", $$v)},expression:"poiItem.newsPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"卜卜膠","prop":"buBu"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatebuBu(poiItem)}},model:{value:(poiItem.buBu),callback:function ($$v) {_vm.$set(poiItem, "buBu", $$v)},expression:"poiItem.buBu"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"拷貝紙","prop":"copyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatecopyPaper(poiItem)}},model:{value:(poiItem.copyPaper),callback:function ($$v) {_vm.$set(poiItem, "copyPaper", $$v)},expression:"poiItem.copyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"毡","prop":"mat"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatemat(poiItem)}},model:{value:(poiItem.mat),callback:function ($$v) {_vm.$set(poiItem, "mat", $$v)},expression:"poiItem.mat"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"保鮮紙","prop":"tinFoil"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetinFoil(poiItem)}},model:{value:(poiItem.tinFoil),callback:function ($$v) {_vm.$set(poiItem, "tinFoil", $$v)},expression:"poiItem.tinFoil"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"高木箱","prop":"azusa"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateazusa(poiItem)}},model:{value:(poiItem.azusa),callback:function ($$v) {_vm.$set(poiItem, "azusa", $$v)},expression:"poiItem.azusa"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"矮木箱","prop":"shortWood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateshortWood(poiItem)}},model:{value:(poiItem.shortWood),callback:function ($$v) {_vm.$set(poiItem, "shortWood", $$v)},expression:"poiItem.shortWood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"鐵車","prop":"ironCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateironCar(poiItem)}},model:{value:(poiItem.ironCar),callback:function ($$v) {_vm.$set(poiItem, "ironCar", $$v)},expression:"poiItem.ironCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"車仔","prop":"chelsea"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatechelsea(poiItem)}},model:{value:(poiItem.chelsea),callback:function ($$v) {_vm.$set(poiItem, "chelsea", $$v)},expression:"poiItem.chelsea"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"軟紙","prop":"softPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatesoftPaper(poiItem)}},model:{value:(poiItem.softPaper),callback:function ($$v) {_vm.$set(poiItem, "softPaper", $$v)},expression:"poiItem.softPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"爛紙","prop":"lousyPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatelousyPaper(poiItem)}},model:{value:(poiItem.lousyPaper),callback:function ($$v) {_vm.$set(poiItem, "lousyPaper", $$v)},expression:"poiItem.lousyPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("盒")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"防潮珠","prop":"moistureproof"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatemoistureproof(poiItem)}},model:{value:(poiItem.moistureproof),callback:function ($$v) {_vm.$set(poiItem, "moistureproof", $$v)},expression:"poiItem.moistureproof"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"電批","prop":"electric"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateelectric(poiItem)}},model:{value:(poiItem.electric),callback:function ($$v) {_vm.$set(poiItem, "electric", $$v)},expression:"poiItem.electric"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"叉","prop":"fork"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatefork(poiItem)}},model:{value:(poiItem.fork),callback:function ($$v) {_vm.$set(poiItem, "fork", $$v)},expression:"poiItem.fork"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"散箱","prop":"bulktank"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatebulktank(poiItem)}},model:{value:(poiItem.bulktank),callback:function ($$v) {_vm.$set(poiItem, "bulktank", $$v)},expression:"poiItem.bulktank"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地膠","prop":"toGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetoGlue(poiItem)}},model:{value:(poiItem.toGlue),callback:function ($$v) {_vm.$set(poiItem, "toGlue", $$v)},expression:"poiItem.toGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙","prop":"gummedPaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":_vm.validategummedPaper},model:{value:(poiItem.gummedPaper),callback:function ($$v) {_vm.$set(poiItem, "gummedPaper", $$v)},expression:"poiItem.gummedPaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"铁笼","prop":"cage"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatecage(poiItem)}},model:{value:(poiItem.cage),callback:function ($$v) {_vm.$set(poiItem, "cage", $$v)},expression:"poiItem.cage"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"夾板(長)","prop":"plywood"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateplywood(poiItem)}},model:{value:(poiItem.plywood),callback:function ($$v) {_vm.$set(poiItem, "plywood", $$v)},expression:"poiItem.plywood"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙卡板","prop":"paperCardBoard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatepaperCardBoard(poiItem)}},model:{value:(poiItem.paperCardBoard),callback:function ($$v) {_vm.$set(poiItem, "paperCardBoard", $$v)},expression:"poiItem.paperCardBoard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"開木箱工具","prop":"tool"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetool(poiItem)}},model:{value:(poiItem.tool),callback:function ($$v) {_vm.$set(poiItem, "tool", $$v)},expression:"poiItem.tool"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠(110cm)","prop":"glue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateglue(poiItem)}},model:{value:(poiItem.glue),callback:function ($$v) {_vm.$set(poiItem, "glue", $$v)},expression:"poiItem.glue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"Plasma","prop":"plasma"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateplasma(poiItem)}},model:{value:(poiItem.plasma),callback:function ($$v) {_vm.$set(poiItem, "plasma", $$v)},expression:"poiItem.plasma"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"縐紋紙","prop":"crepePaper"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatecrepePaper(poiItem)}},model:{value:(poiItem.crepePaper),callback:function ($$v) {_vm.$set(poiItem, "crepePaper", $$v)},expression:"poiItem.crepePaper"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("卷")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"平衣","prop":"flatClothing"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateflatClothing(poiItem)}},model:{value:(poiItem.flatClothing),callback:function ($$v) {_vm.$set(poiItem, "flatClothing", $$v)},expression:"poiItem.flatClothing"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"冰箱","prop":"refrigerator"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validaterefrigerator(poiItem)}},model:{value:(poiItem.refrigerator),callback:function ($$v) {_vm.$set(poiItem, "refrigerator", $$v)},expression:"poiItem.refrigerator"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"黑色橡筋","prop":"elastic"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateelastic(poiItem)}},model:{value:(poiItem.elastic),callback:function ($$v) {_vm.$set(poiItem, "elastic", $$v)},expression:"poiItem.elastic"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("扎")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙板","prop":"cardboard"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatecardboard(poiItem)}},model:{value:(poiItem.cardboard),callback:function ($$v) {_vm.$set(poiItem, "cardboard", $$v)},expression:"poiItem.cardboard"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("塊")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"企身","prop":"stiff"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatestiff(poiItem)}},model:{value:(poiItem.stiff),callback:function ($$v) {_vm.$set(poiItem, "stiff", $$v)},expression:"poiItem.stiff"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(長)","prop":"lengthFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatelengthFloor(poiItem)}},model:{value:(poiItem.lengthFloor),callback:function ($$v) {_vm.$set(poiItem, "lengthFloor", $$v)},expression:"poiItem.lengthFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"地台板(短)","prop":"shortFloor"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateshortFloor(poiItem)}},model:{value:(poiItem.shortFloor),callback:function ($$v) {_vm.$set(poiItem, "shortFloor", $$v)},expression:"poiItem.shortFloor"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"吊繩","prop":"theWire"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetheWire(poiItem)}},model:{value:(poiItem.theWire),callback:function ($$v) {_vm.$set(poiItem, "theWire", $$v)},expression:"poiItem.theWire"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"滑潤","prop":"smooth"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatesmooth(poiItem)}},model:{value:(poiItem.smooth),callback:function ($$v) {_vm.$set(poiItem, "smooth", $$v)},expression:"poiItem.smooth"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("套")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"膠(120cm)","prop":"oneGlue"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoneGlue(poiItem)}},model:{value:(poiItem.oneGlue),callback:function ($$v) {_vm.$set(poiItem, "oneGlue", $$v)},expression:"poiItem.oneGlue"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("件")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"積車","prop":"productCar"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateproductCar(poiItem)}},model:{value:(poiItem.productCar),callback:function ($$v) {_vm.$set(poiItem, "productCar", $$v)},expression:"poiItem.productCar"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("部")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"搬花網","prop":"wireMesh"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatewireMesh(poiItem)}},model:{value:(poiItem.wireMesh),callback:function ($$v) {_vm.$set(poiItem, "wireMesh", $$v)},expression:"poiItem.wireMesh"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"膠紙冚","prop":"tape"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetape(poiItem)}},model:{value:(poiItem.tape),callback:function ($$v) {_vm.$set(poiItem, "tape", $$v)},expression:"poiItem.tape"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(新)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"紙盒(舊)"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"梳化套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"床褥套："}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"白水松："}})],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新大","prop":"big"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatebig(poiItem)}},model:{value:(poiItem.big),callback:function ($$v) {_vm.$set(poiItem, "big", $$v)},expression:"poiItem.big"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊大","prop":"oldBig"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoldbig(poiItem)}},model:{value:(poiItem.oldBig),callback:function ($$v) {_vm.$set(poiItem, "oldBig", $$v)},expression:"poiItem.oldBig"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3座位","prop":"threeSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatethreeSeats(poiItem)}},model:{value:(poiItem.threeSeats),callback:function ($$v) {_vm.$set(poiItem, "threeSeats", $$v)},expression:"poiItem.threeSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"6呎","prop":"sixRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatesixRuler(poiItem)}},model:{value:(poiItem.sixRuler),callback:function ($$v) {_vm.$set(poiItem, "sixRuler", $$v)},expression:"poiItem.sixRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"1吋","prop":"oneSmall"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoneSmall(poiItem)}},model:{value:(poiItem.oneSmall),callback:function ($$v) {_vm.$set(poiItem, "oneSmall", $$v)},expression:"poiItem.oneSmall"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新中","prop":"inthe"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateinthe(poiItem)}},model:{value:(poiItem.inthe),callback:function ($$v) {_vm.$set(poiItem, "inthe", $$v)},expression:"poiItem.inthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊中","prop":"oldInthe"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoldinthe(poiItem)}},model:{value:(poiItem.oldInthe),callback:function ($$v) {_vm.$set(poiItem, "oldInthe", $$v)},expression:"poiItem.oldInthe"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"2座位","prop":"twoSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatetwoSeats(poiItem)}},model:{value:(poiItem.twoSeats),callback:function ($$v) {_vm.$set(poiItem, "twoSeats", $$v)},expression:"poiItem.twoSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"5呎","prop":"fiveRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatefiveRuler(poiItem)}},model:{value:(poiItem.fiveRuler),callback:function ($$v) {_vm.$set(poiItem, "fiveRuler", $$v)},expression:"poiItem.fiveRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":"半吋","prop":"small"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatesmall(poiItem)}},model:{value:(poiItem.small),callback:function ($$v) {_vm.$set(poiItem, "small", $$v)},expression:"poiItem.small"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("袋")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"新細","prop":"fine"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatefine(poiItem)}},model:{value:(poiItem.fine),callback:function ($$v) {_vm.$set(poiItem, "fine", $$v)},expression:"poiItem.fine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"舊細","prop":"oldFine"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoldfine(poiItem)}},model:{value:(poiItem.oldFine),callback:function ($$v) {_vm.$set(poiItem, "oldFine", $$v)},expression:"poiItem.oldFine"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("個")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"1座位","prop":"oneSeats"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validateoneSeats(poiItem)}},model:{value:(poiItem.oneSeats),callback:function ($$v) {_vm.$set(poiItem, "oneSeats", $$v)},expression:"poiItem.oneSeats"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"4呎","prop":"fourRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatefourRuler(poiItem)}},model:{value:(poiItem.fourRuler),callback:function ($$v) {_vm.$set(poiItem, "fourRuler", $$v)},expression:"poiItem.fourRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":""}},[_c('span',{staticStyle:{"color":"#000000"}})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"3呎","prop":"threeRuler"}},[_c('el-input',{staticStyle:{"width":"100px"},attrs:{"placeholder":"","clearable":"","disabled":_vm.disabledNum},on:{"change":function($event){return _vm.validatethreeRuler(poiItem)}},model:{value:(poiItem.threeRuler),callback:function ($$v) {_vm.$set(poiItem, "threeRuler", $$v)},expression:"poiItem.threeRuler"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("張")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label-width":"110px","label":" "}},[(_vm.rollingForm.status==0)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.removeRollItem(poiItem.index)}}},[_c('i',{staticClass:"fa fa-trash"})]):_vm._e()],1)],1)],1)],1)}),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"其他：","prop":"oneOther"}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.oneOther),callback:function ($$v) {_vm.$set(_vm.rollingForm, "oneOther", $$v)},expression:"rollingForm.oneOther"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"送盒："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.sendBox),callback:function ($$v) {_vm.$set(_vm.rollingForm, "sendBox", $$v)},expression:"rollingForm.sendBox"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"45px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label-width":"100px","label":"內部備註："}},[_c('el-input',{staticStyle:{"width":"900px"},attrs:{"placeholder":"","type":"textarea","autosize":{minRows: 4,maxRows: 4},"clearable":""},model:{value:(_vm.rollingForm.internal),callback:function ($$v) {_vm.$set(_vm.rollingForm, "internal", $$v)},expression:"rollingForm.internal"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"height":"40px"},attrs:{"gutter":0}},[_c('el-col',{attrs:{"span":23}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":0}},[(_vm.rollingForm.status==0)?_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"45px","margin-top":"10px"},attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.createPoiItem()}}},[_vm._v("添加單")]):_vm._e(),_vm._v(" "),(_vm.rollingForm.status==0&&_vm.canOut)?_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(this.loadingSave),expression:"this.loadingSave"}],staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.rollSave(1)}}},[_vm._v("確認出倉")]):_vm._e(),_vm._v(" "),(_vm.rollingForm.status==0)?_c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(this.loadingSave),expression:"this.loadingSave"}],staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.rollSave(0)}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),(_vm.rollingForm.status==1)?_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.updateRollSave()}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),_c('el-button',{staticStyle:{"float":"left","margin-bottom":"5px","margin-left":"15px","margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sMeZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',[_c('div',{staticClass:"xinz"},[[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/addStockin'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" 新增")]):_vm._e()],1)],1)]],2),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getWarehousing.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"搜索條件："}},[_c('el-input',{attrs:{"placeholder":"入庫單","clearable":""},model:{value:(_vm.searchStorIn),callback:function ($$v) {_vm.searchStorIn=$$v},expression:"searchStorIn"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"placeholder":"客戶/電話","clearable":""},model:{value:(_vm.searchName),callback:function ($$v) {_vm.searchName=$$v},expression:"searchName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"銷售員"},model:{value:(_vm.searchSalesId),callback:function ($$v) {_vm.searchSalesId=$$v},expression:"searchSalesId"}},_vm._l((_vm.custSalesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getWarehousing}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("查詢")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"ind_main ind_main2"},[_c('div',{staticClass:"ind_cont2"},[[_c('el-table',{staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.warehousingList,"empty-text":"无数据","stripe":"","border":""}},[_c('el-table-column',{attrs:{"prop":"scode","align":"left","label":"入庫單"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","align":"left","label":"客戶"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(scope.row.customer.code)+","+_vm._s(scope.row.customer.name)+"\n\t\t\t\t\t\t\t\t\t\t")]}}],null,false,1455876062)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer.phone","align":"left","label":"電話"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sales","align":"left","label":"銷售員"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"storInDate","align":"left","label":"時間"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","width":"100","align":"center","label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.canEdit)?_c('el-button',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.updateSelSotrIn(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" 編輯\n                                    ")]):_vm._e()]}}],null,false,1982887246)})],1)],_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)],2)])]):_vm._e(),_vm._v(" "),(_vm.add)?_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[_c('el-input',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow},on:{"blur":function($event){return _vm.selSCode()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[(_vm.form.codeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])]:[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.codeShow,"fetch-suggestions":_vm.querySearch,"trigger-on-focus":false},on:{"input":function($event){return _vm.addList(0,0,'cCode')},"select":_vm.handleSelect},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}})],1)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_c('el-form',[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._l((_vm.addWarehousingList),function(items,i){return [_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"colspan":"4"}},[_c('el-date-picker',{staticStyle:{"width":"40%"},attrs:{"format":"yyyy年MM月dd日 HH:mm","type":"datetime","size":"large"},model:{value:(items.createDate),callback:function ($$v) {_vm.$set(items, "createDate", $$v)},expression:"items.createDate"}})],1),_vm._v(" "),_c('th',[_c('span',[_vm._v("第"+_vm._s(items.second)+"次")]),_vm._v(" "),(items.storInItem.length === 0 || items.state === 0)?[_c('el-button',{attrs:{"icon":"el-icon-delete","type":"danger","circle":""},on:{"click":function($event){return _vm.delAddWarehousingList(items,i)}}},[_vm._v("刪除")])]:_vm._e()],2)]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"12%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"40%"}},[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("數量")]),_vm._v(" "),_c('th',[_vm._v("位置")])])]),_vm._v(" "),_vm._l((items.storInItem),function(item1,index){return _c('tr',[_c('td',{attrs:{"width":"12%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.unit))])]:[_c('el-select',{attrs:{"placeholder":"請輸入","disabled":item1.unitShow},on:{"change":function($event){return _vm.addList(i,index,'unit')}},model:{value:(item1.unit),callback:function ($$v) {_vm.$set(item1, "unit", $$v)},expression:"item1.unit"}},_vm._l((_vm.company),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2),_vm._v(" "),_c('td',{staticClass:"number",attrs:{"width":"10%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.boxNo))])]:[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":item1.boxNoShow,"size":"medium","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"change":function($event){return _vm.addList(i,index,'boxNo')}},model:{value:(item1.boxNo),callback:function ($$v) {_vm.$set(item1, "boxNo", $$v)},expression:"item1.boxNo"}})]],2),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"width":"40%","text-align":"left"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.item))])]:[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"85%"},attrs:{"disabled":item1.itemShows,"size":"medium","fetch-suggestions":_vm.querySearchRemark,"placeholder":"請輸入內容"},on:{"input":function($event){return _vm.addList(i,index,'item')},"select":function($event){return _vm.addList(i,index,'item')}},model:{value:(item1.item),callback:function ($$v) {_vm.$set(item1, "item", $$v)},expression:"item1.item"}})]],2),_vm._v(" "),_c('td',{staticClass:"actions",attrs:{"width":"10%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.qty))])]:[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":item1.qtyShow,"size":"medium","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"focus":function($event){return _vm.addList(i,index,'qty')}},model:{value:(item1.qty),callback:function ($$v) {_vm.$set(item1, "qty", $$v)},expression:"item1.qty"}})]],2),_vm._v(" "),_c('td',{staticClass:"actions"},[(item1.state === 1)?[_c('el-col',{attrs:{"span":16}},[_c('span',[_vm._v(_vm._s(item1.value))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('span',[_vm._v("已出倉")])])]:[_c('el-col',{attrs:{"span":16}},[_c('el-select',{style:(items.addStorIn==false?'float: left;':''),attrs:{"size":"medium","disabled":item1.locationIdShows,"default-first-option":"","clearable":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethod,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelectState($event,i,index)},"focus":function($event){return _vm.isNullOptions4()}},model:{value:(item1.value),callback:function ($$v) {_vm.$set(item1, "value", $$v)},expression:"item1.value"}},_vm._l((_vm.options4),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(item1.state === 0)?[_c('el-button',{attrs:{"type":"danger","size":"small","circle":""},on:{"click":function($event){return _vm.delStorInItem(i,index)}}},[_vm._v("刪除")])]:(item1.state === 1)?[_c('span',[_vm._v("已出倉")])]:_vm._e()],2)]],2)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"5"}},[_c('br')])])]})],2),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[(_vm.canEdit)?[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.submitInfo,"icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v(" 保存")])]:_vm._e(),_vm._v(" "),(_vm.$store.getters.customerInSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.cancelAdd}},[_vm._v(" 取消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerInSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],2)])],1)])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sYFo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/RC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "to2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3G3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateRolling_vue__ = __webpack_require__("fqUe");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99153c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateRolling_vue__ = __webpack_require__("s67A");
function injectStyle (ssrContext) {
  __webpack_require__("to2b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateRolling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99153c58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateRolling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vaGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        var validateFile = function validateFile(rule, value, callback) {
            if (value == "") {
                document.getElementById("file_name").innerHTML = _this.$t('m.t_selectthefile');
                callback(new Error(' '));
            }
            callback();
        };
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            //查詢條件
            serchSalesId: "",
            serchCustNo: "",
            serchBooking: "",
            serchSite: '',
            getTaskDate: '',
            selectionItems: [],
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            custTaskList: [],
            dialogName: '',
            tableloading: false,
            dialogDiscEditVisible: false,
            taskForm: {
                id: "",
                custId: '',
                custNo: '',
                salesId: "",
                taskDate: "",
                booking: '',
                site: ''
            },
            salesList: [],
            custOptions: [],

            returnId: 0,
            fileList: [],
            addEidtloading: false,
            dialogFileListVisible: false,
            dialogFileVisible: false,
            dialogFileListName: '',
            dialogFileName: '',
            fileListPager: {
                page: 0,
                size: 10,
                total: 0
            },
            fileId: [],
            oldFileId: [],
            custFile: {
                file: "",
                comment: ""
            },
            custFileRules: {
                file: [{ required: true, validator: validateFile, trigger: 'change' }],
                comment: [{ required: false, message: this.$t('m.m_remarks'), trigger: 'change' }]
            }
        };
    },

    methods: {
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {
            this.getCustFileList();
        },
        getImageUrl: function getImageUrl(index, row) {
            var fileUrl = row.relativePath;
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_40" /* imageUrl */])(fileUrl);
        },
        openFile: function openFile(index, row) {
            var fileUrl = row.relativePath;
            window.open(Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_40" /* imageUrl */])(fileUrl));
        },
        pictureImg: function pictureImg(index, row) {
            var url = row.fileUrl;
            var suffixName = url.substr(url.lastIndexOf(".")).toLowerCase(); //获得文件后缀名
            var strFilter = ".jpeg|.gif|.jpg|.png|.bmp|.pic|";
            if (strFilter.indexOf(suffixName) > -1) {
                return true;
            } else {
                return false;
            }
        },
        fileListEdit: function fileListEdit(value) {
            this.dialogFileListName = this.$t('m.t_enclosureadmin');
            this.dialogFileListVisible = true;
            this.returnId = value.id;
            this.getCustFileList();
        },
        getCustFileList: function getCustFileList() {
            var _this2 = this;

            if (this.returnId != "" || this.returnId != undefined) {
                var params = {
                    page: this.fileListPager.page,
                    size: this.fileListPager.size,
                    taskId: this.returnId,
                    typeId: 1
                };
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["z" /* getCustFileList */])(params).then(function (data) {
                    var _data$data = data.data,
                        res = _data$data === undefined ? {} : _data$data;

                    if (res.errcode == 200) {
                        var _res$data = res.data,
                            size = _res$data.size,
                            page = _res$data.page,
                            total = _res$data.total,
                            _res$data$data = _res$data.data,
                            items = _res$data$data === undefined ? [] : _res$data$data;

                        _this2.fileList = items;
                        _this2.fileListPager.total = total;
                        _this2.fileListPager.page = page;
                        _this2.fileListPager.size = size;
                        _this2.tableloading = false;
                    } else {
                        _this2.$message.error(res.errmsg);
                    }
                });
            }
        },
        custFileAdd: function custFileAdd() {
            this.dialogFileName = this.$t('m.b_uploadfile');
            this.dialogFileVisible = true;
            //重置file
            var file = document.getElementById('file');
            if (file != null || file != undefined) {
                file.value = "";
            }
            var fileValue = document.getElementById("file_name");
            if (fileValue != null || fileValue != undefined) {
                fileValue.innerHTML = "";
            }
            this.resetForm("custFile");
        },
        getFile: function getFile(event) {
            if (event.target.files[0] != undefined && event.target.files[0] != null) {
                this.custFile.file = event.target.files[0];
                document.getElementById("file_name").innerHTML = this.custFile.file.name;
            }
        },
        custFileSave: function custFileSave() {
            var _this3 = this;

            this.$refs.custFile.validate(function (valid) {
                if (valid) {
                    var fileSize = _this3.custFile.file.size / 1024;
                    if (fileSize > 50000) {
                        _this3.$message.warning(_this3.$t('m.b_uploadfileMaxFiftyMb'));
                        return;
                    }

                    //阻止元素发生默认的行为
                    event.preventDefault();
                    var token = JSON.parse(window.sessionStorage.getItem("staff")).token;
                    var paramData = new FormData(); //创建form对象
                    paramData.append("file", _this3.custFile.file); //通过append向form对象添加数据
                    paramData.append("comment", _this3.custFile.comment); //通过append向form对象添加数据
                    paramData.append("typeId", 1); //通过append向form对象添加数据
                    paramData.append("taskId", _this3.returnId); //通过append向form对象添加数据*/
                    var config = {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': token
                        }
                    };
                    _this3.$http.post(__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL + '/fileUpload/upload', paramData, config).then(function (res) {
                        var item = res.data;
                        if (item.errcode === 200) {
                            this.$message.success(this.$t('m.m_uploadsuccess'));
                            this.getCustFileList();
                            this.resetForm("custFile");
                            this.dialogFileVisible = false;

                            //重置file
                            var file = document.getElementById('file');
                            file.value = '';
                            document.getElementById("file_name").innerHTML = "";
                        }
                    });
                }
            });
        },
        deleteCustFile: function deleteCustFile(index, row) {
            var _this4 = this;

            this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.b_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["f" /* deleteCustFile */])(row.id).then(function (data) {
                    var _data$data2 = data.data,
                        errcode = _data$data2.errcode,
                        errmsg = _data$data2.errmsg;

                    if (errcode == 200) {
                        _this4.$message.success(_this4.$t('m.m_deletesuc'));
                        _this4.getCustFileList();
                    } else {
                        _this4.$message.error(errmsg);
                    }
                });
            });
        },
        fileDownload: function fileDownload(index, row) {
            window.location.href = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL + '/fileDownload?id=' + row.id;
        },
        deleteTask: function deleteTask(index, row) {
            var _this5 = this;

            this.$confirm('你確定要删除任务嗎?', this.$t('m.m_info'), {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('m.t_confirm'),
                cancelButtonText: this.$t('m.t_cancel'),
                type: 'warning'
            }).then(function () {
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["q" /* deleteTaskById */])(row.id).then(function (data) {
                    var _data$data3 = data.data,
                        res = _data$data3 === undefined ? {} : _data$data3;

                    if (res.errcode == 200) {
                        _this5.$message.success('刪除成功');
                        _this5.getTaskList();
                    } else {
                        _this5.$message.error(res.errmsg);
                    }
                });
            });
        },
        custChange: function custChange(ev) {
            if (ev != "") {
                this.taskForm.custId = ev.id;
                this.taskForm.custNo = ev.code;
            }
        },
        isNull: function isNull() {
            /*是否为空*/
            if (this.taskForm.custId === "" || this.taskForm.custId === null) {
                return "客戶編號不能為空";
            }if (this.taskForm.salesId === "" || this.taskForm.salesId === null) {
                return "銷售員不能為空";
            }
            if (this.taskForm.taskDate === "" || this.taskForm.taskDate === null) {
                return "任务時間不能為空";
            }
            if (this.taskForm.booking === "" || this.taskForm.booking === null) {
                return "搬迁预订不能為空";
            }
            if (this.taskForm.site === "" || this.taskForm.site === null) {
                return "现场调查不能為空";
            }
            return "";
        },
        taskEdit: function taskEdit(index, row) {
            this.dialogName = "編輯客戶資訊", this.dialogDiscEditVisible = true;
            this.resetForm("taskForm");
            this.getTaskById(row.id);
        },
        getTaskById: function getTaskById(id) {
            var _this6 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_31" /* getTaskById */])(id).then(function (data) {
                var item = data.data;
                if (item != null) {
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this6.taskForm, item.data);
                    if (item.data.taskDate == 0) {
                        _this6.taskForm.taskDate = "";
                    } else {
                        _this6.taskForm.taskDate = new Date(item.data.taskDate * 1000);
                    }
                } else {
                    _this6.$message.error(item.errmsg);
                }
            });
        },
        itemRemoteMethod: function itemRemoteMethod(query) {
            var _this7 = this;

            if (query != "") {
                var params = { custNo: query, groupId: this.id };
                Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["y" /* getCustAllCustMgtList */])(params).then(function (data) {
                    var _data$data4 = data.data,
                        res = _data$data4 === undefined ? {} : _data$data4;

                    _this7.custOptions = res.data;
                });
            }
        },
        taskManagementSave: function taskManagementSave() {
            var _this8 = this;

            this.$refs.taskForm.validate(function (valid) {
                var str = _this8.isNull();
                if (str !== "") {
                    _this8.dialogVisible = true;
                    _this8.$alert(str, '提示', {
                        confirmButtonText: '確定',
                        type: 'error'
                    });
                } else {
                    if (valid) {
                        if (_this8.taskForm.taskDate == null || _this8.taskForm.taskDate == '') {
                            _this8.taskForm.taskDate = 0;
                        }
                        if (_this8.taskForm.id == "") {
                            //新增
                            _this8.addEidtloading = true;
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.taskForm);
                            params.taskDate = Math.round(new Date(params.taskDate).getTime() / 1000);
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_53" /* insertTask */])(params).then(function (data) {
                                _this8.addEidtloading = false;
                                var _data$data5 = data.data,
                                    res = _data$data5 === undefined ? {} : _data$data5;

                                if (res.errcode == 200) {
                                    _this8.$message.success("新增成功！！");
                                    _this8.getTaskList();
                                    _this8.resetForm("taskForm");
                                    _this8.dialogDiscEditVisible = false;
                                } else {
                                    _this8.$message.error(res.errmsg);
                                }
                            }, function (err) {
                                _this8.addEidtloading = false;
                            });
                        } else {
                            var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.taskForm);
                            params.taskDate = Math.round(new Date(params.taskDate).getTime() / 1000);
                            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_81" /* updateTask */])(params).then(function (data) {
                                _this8.addEidtloading = false;
                                var _data$data6 = data.data,
                                    res = _data$data6 === undefined ? {} : _data$data6;

                                if (res.errcode == 200) {
                                    _this8.$message.success("修改成功");
                                    _this8.getTaskList();
                                    _this8.resetForm("taskForm");
                                    _this8.dialogDiscEditVisible = false;
                                } else {
                                    _this8.$message.error(res.errmsg);
                                }
                            }, function (err) {
                                _this8.addEidtloading = false;
                            });
                        }
                    }
                }
            });
        },
        addCustTask: function addCustTask() {
            this.dialogDiscEditVisible = true;
            this.dialogName = this.$t('m.t_newTask'), this.resetForm("taskForm");
        },
        custTaskPageChange: function custTaskPageChange(val) {
            this.getTaskList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        getTaskList: function getTaskList() {
            var _this9 = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, custNo: this.serchCustNo, salesId: this.serchSalesId, booking: this.serchBooking, site: this.serchSite, taskDate: this.getTaskDate };
            if (params.taskDate != null && params.taskDate != '') {
                params.taskDate = parseInt(new Date(params.taskDate).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_34" /* getTaskList */])(params).then(function (data) {
                var _data$data7 = data.data,
                    res = _data$data7 === undefined ? {} : _data$data7;

                if (res.errcode == 200) {
                    var _res$data2 = res.data,
                        size = _res$data2.size,
                        page = _res$data2.page,
                        total = _res$data2.total,
                        _res$data2$data = _res$data2.data,
                        items = _res$data2$data === undefined ? [] : _res$data2$data;

                    _this9.custTaskList = items;
                    _this9.pager.total = total;
                    _this9.pager.page = page;
                    _this9.pager.size = size;
                    _this9.tableloading = false;
                } else {
                    _this9.$message.error(res.errmsg);
                }
            });
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        var _this10 = this;

        this.getTaskList();
        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_13" /* getStaffAllList */])().then(function (data) {
            var _data$data8 = data.data,
                res = _data$data8 === undefined ? {} : _data$data8;

            _this10.salesList = res.data;
        });
    },

    computed: {
        custTaskAdd: function custTaskAdd() {
            return this.$store.getters.hasPermission("TASK_ADD");
        },
        custTaskEdit: function custTaskEdit() {
            return this.$store.getters.hasPermission("TASK_EDIT");
        },
        custTaskDelete: function custTaskDelete() {
            return this.$store.getters.hasPermission("TASK_DELETE");
        },
        canFile: function canFile() {
            return this.$store.getters.hasPermission("TASK_FILE");
        },
        canFileAdd: function canFileAdd() {
            return this.$store.getters.hasPermission("TASK_FILE_ADD");
        },
        canFileDow: function canFileDow() {
            return this.$store.getters.hasPermission("TASK_FILE_DOW");
        },
        canFileDel: function canFileDel() {
            return this.$store.getters.hasPermission("TASK_FILE_DEL");
        }
    }
});

/***/ }),

/***/ "vd4L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            rollingForm: {
                feedDate: new Date(),
                carNumber: '',
                oneCar: '0.5',
                twoCar: '1',
                threeCar: '2',
                sendBox: '',
                oneOther: '',
                internal: ''
            },
            itemOptions: [],
            rollingRules: {
                feedDate: [{ required: true, message: '日期不能為空', trigger: 'change' }],
                carNumber: [{ required: true, message: '車號不能為空', trigger: 'change' }],
                oneCar: [{ required: true, message: '扎車坑紙不能為空', trigger: 'change' }],
                twoCar: [{ required: true, message: '扎車地膠不能為空', trigger: 'change' }],
                threeCar: [{ required: true, message: '扎車縐紋紙不能為空', trigger: 'change' }]
            },
            acctId: '',
            poiItemList: [],
            poiItem: {},
            index: 0,
            createIndex: 0,
            delRollItemList: [],
            loadingSave: false,
            paramsNum: 0
        };
    },

    methods: {
        removeRollItem: function removeRollItem(index) {
            var i = 0;
            for (i; i < this.poiItemList.length; i++) {
                if (index == this.poiItemList[i].index) {
                    break;
                }
            }
            this.poiItemList.splice(i, 1);
            this.rearrIndex();
        },

        //當發票商品刪除的時候， 重新給每個index 賦值
        rearrIndex: function rearrIndex() {
            var i = 0;
            for (i = 0; i < this.poiItemList.length; i++) {
                this.poiItemList[i].index = i + 1;
            }
            this.index = i;
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        validateCarNumber: function validateCarNumber(Number) {
            if (Number != '' && Number != null) {
                if (Number.length > 6) {
                    return this.$message.error("車號最多是6個位");
                }
            }
        },
        validatePitPaperTitle: function validatePitPaperTitle(oneCar) {
            var _this = this;

            if (oneCar != '' && oneCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(oneCar)) {
                    this.rollingForm.oneCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (oneCar == 0) {
                        return this.$message.error("輸入的數字大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].pitPaper == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '') {
                                    num = num + parseFloat(this.poiItemList[i].pitPaper);
                                }
                            }
                        }
                        var params = { itemName: "坑紙" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (num + parseFloat(oneCar) > number) {
                                    _this.rollingForm.oneCar = "";
                                    return _this.$message.error("坑紙出倉數量大於倉存數！");
                                }
                            }
                        });
                    }
                }
            };
        },
        validateTwoCarTitle: function validateTwoCarTitle(twoCar) {
            var _this2 = this;

            if (twoCar != '' && twoCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(twoCar)) {
                    this.rollingForm.twoCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (twoCar == 0) {
                        return this.$message.error("輸入的數字大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].toGlue == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '') {
                                    num = num + parseFloat(this.poiItemList[i].toGlue);
                                }
                            }
                        }
                        var params = { itemName: "地膠" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (num + parseFloat(twoCar) > number) {
                                    _this2.rollingForm.twoCar = "";
                                    return _this2.$message.error("地膠出倉數量大於倉存數！");
                                }
                            }
                        });
                    }
                }
            };
        },
        validateThreeTitle: function validateThreeTitle(threeCar) {
            var _this3 = this;

            if (threeCar != '' && threeCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(threeCar)) {
                    this.rollingForm.threeCar = "";
                    return this.$message.error("請輸入正確的格式，數字只有2位小數");
                } else {
                    if (threeCar == 0) {
                        return this.$message.error("輸入的數字大於0");
                    } else {
                        var num = 0;
                        for (var i = 0; i < this.poiItemList.length; i++) {
                            if (this.poiItemList[i].crepePaper == "半") {
                                num = num + 0.5;
                            } else {
                                if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '') {
                                    num = num + parseFloat(this.poiItemList[i].crepePaper);
                                }
                            }
                        }

                        var params = { itemName: "縐紋紙" };
                        Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                            if (res.data.errcode == 200) {
                                var number = res.data.data;
                                if (num + parseFloat(threeCar) > number) {
                                    _this3.rollingForm.threeCar = "";
                                    return _this3.$message.error("縐紋紙出倉數量大於倉存數！");
                                }
                            }
                        });
                    }
                }
            };
        },
        validatePitPaper: function validatePitPaper(poiItem) {
            var _this4 = this;

            if (poiItem.pitPaper != '' && poiItem.pitPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.pitPaper)) {
                    poiItem.pitPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].pitPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].pitPaper);
                        }
                    }

                    var params = { itemName: "坑紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (_this4.rollingForm.oneCar != '' && _this4.rollingForm.oneCar != null) {
                                if (num + parseFloat(_this4.rollingForm.oneCar) > number) {
                                    poiItem.pitPaper = "";
                                    return _this4.$message.error("坑紙出倉數量大於倉存數！");
                                }
                            } else {
                                if (num > number) {
                                    poiItem.pitPaper = "";
                                    return _this4.$message.error("坑紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatenewsPaper: function validatenewsPaper(poiItem) {
            var _this5 = this;

            if (poiItem.newsPaper != '' && poiItem.newsPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.newsPaper)) {
                    poiItem.newsPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].newsPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].newsPaper);
                        }
                    }
                    var params = { itemName: "報紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.newsPaper = "";
                                return _this5.$message.error("報紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatebuBu: function validatebuBu(poiItem) {
            var _this6 = this;

            if (poiItem.buBu != '' && poiItem.buBu != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.buBu)) {
                    poiItem.buBu = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].buBu == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].buBu);
                        }
                    }
                    var params = { itemName: "卜卜膠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.buBu = "";
                                return _this6.$message.error("卜卜膠出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatecopyPaper: function validatecopyPaper(poiItem) {
            var _this7 = this;

            if (poiItem.copyPaper != '' && poiItem.copyPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.copyPaper)) {
                    poiItem.copyPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].copyPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].copyPaper);
                        }
                    }
                    var params = { itemName: "拷貝紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.copyPaper = "";
                                return _this7.$message.error("拷貝紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatemat: function validatemat(poiItem) {
            var _this8 = this;

            if (poiItem.mat != '' && poiItem.mat != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.mat)) {
                    poiItem.mat = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].mat == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].mat);
                        }
                    }
                    var params = { itemName: "毡" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.mat = "";
                                return _this8.$message.error("毡出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetinFoil: function validatetinFoil(poiItem) {
            var _this9 = this;

            if (poiItem.tinFoil != '' && poiItem.tinFoil != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tinFoil)) {
                    poiItem.tinFoil = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tinFoil == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].tinFoil);
                        }
                    }
                    var params = { itemName: "保鮮紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.tinFoil = "";
                                return _this9.$message.error("保鮮紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateazusa: function validateazusa(poiItem) {
            var _this10 = this;

            if (poiItem.azusa != '' && poiItem.azusa != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.azusa)) {
                    poiItem.azusa = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].azusa == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].azusa);
                        }
                    }
                    var params = { itemName: "高木箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.azusa = "";
                                return _this10.$message.error("高木箱出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateshortWood: function validateshortWood(poiItem) {
            var _this11 = this;

            if (poiItem.shortWood != '' && poiItem.shortWood != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.shortWood)) {
                    poiItem.shortWood = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].shortWood == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].shortWood);
                        }
                    }
                    var params = { itemName: "矮木箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.shortWood = "";
                                return _this11.$message.error("矮木箱出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateironCar: function validateironCar(poiItem) {
            var _this12 = this;

            if (poiItem.ironCar != '' && poiItem.ironCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.ironCar)) {
                    poiItem.ironCar = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].ironCar == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].ironCar);
                        }
                    }
                    var params = { itemName: "鐵車" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.ironCar = "";
                                return _this12.$message.error("鐵車出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetoGlue: function validatetoGlue(poiItem) {
            var _this13 = this;

            if (poiItem.toGlue != '' && poiItem.toGlue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.toGlue)) {
                    poiItem.toGlue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].toGlue == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].toGlue);
                        }
                    }
                    var params = { itemName: "地膠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (_this13.rollingForm.twoCar != '' && _this13.rollingForm.twoCar != null) {
                                if (num + parseFloat(_this13.rollingForm.twoCar) > number) {
                                    poiItem.toGlue = "";
                                    return _this13.$message.error("地膠出倉數量大於倉存數！");
                                }
                            } else {
                                if (num > number) {
                                    poiItem.toGlue = "";
                                    return _this13.$message.error("地膠出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validatesoftPaper: function validatesoftPaper(poiItem) {
            var _this14 = this;

            if (poiItem.softPaper != '' && poiItem.softPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.softPaper)) {
                    poiItem.softPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].softPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].softPaper);
                        }
                    }
                    var params = { itemName: "軟紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.softPaper = "";
                                return _this14.$message.error("軟紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatelousyPaper: function validatelousyPaper(poiItem) {
            var _this15 = this;

            if (poiItem.lousyPaper != '' && poiItem.lousyPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.lousyPaper)) {
                    poiItem.lousyPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].lousyPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].lousyPaper);
                        }
                    }
                    var params = { itemName: "爛紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.lousyPaper = "";
                                return _this15.$message.error("爛紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatemoistureproof: function validatemoistureproof(poiItem) {
            var _this16 = this;

            if (poiItem.moistureproof != '' && poiItem.moistureproof != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.moistureproof)) {
                    poiItem.moistureproof = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].moistureproof == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].moistureproof);
                        }
                    }
                    var params = { itemName: "防潮珠" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.moistureproof = "";
                                return _this16.$message.error("防潮珠出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateelectric: function validateelectric(poiItem) {
            var _this17 = this;

            if (poiItem.electric != '' && poiItem.electric != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.electric)) {
                    poiItem.electric = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].electric == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].electric);
                        }
                    }
                    var params = { itemName: "電批" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.electric = "";
                                return _this17.$message.error("電批出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validategummedPaper: function validategummedPaper(poiItem) {
            var _this18 = this;

            if (poiItem.gummedPaper != '' && poiItem.gummedPaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.gummedPaper)) {
                    poiItem.gummedPaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].gummedPaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].gummedPaper);
                        }
                    }
                    var params = { itemName: "膠紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.gummedPaper = "";
                                return _this18.$message.error("膠紙出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatebig: function validatebig(poiItem) {
            var _this19 = this;

            if (poiItem.big != '' && poiItem.big != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.big)) {
                    poiItem.big = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].big == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].big);
                        }
                    }
                    var params = { itemName: "紙盒(新大)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.big = "";
                                return _this19.$message.error("紙盒(新大)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoldbig: function validateoldbig(poiItem) {
            var _this20 = this;

            if (poiItem.oldBig != '' && poiItem.oldBig != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldBig)) {
                    poiItem.oldBig = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldBig == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oldBig);
                        }
                    }
                    var params = { itemName: "紙盒(舊大)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oldBig = "";
                                return _this20.$message.error("紙盒(舊大)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateinthe: function validateinthe(poiItem) {
            var _this21 = this;

            if (poiItem.inthe != '' && poiItem.inthe != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.inthe)) {
                    poiItem.inthe = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].inthe == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].inthe);
                        }
                    }
                    var params = { itemName: "紙盒(新中)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.inthe = "";
                                return _this21.$message.error("紙盒(新中)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoldinthe: function validateoldinthe(poiItem) {
            var _this22 = this;

            if (poiItem.oldInthe != '' && poiItem.oldInthe != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldInthe)) {
                    poiItem.oldInthe = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldInthe == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oldInthe);
                        }
                    }
                    var params = { itemName: "紙盒(舊中)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oldInthe = "";
                                return _this22.$message.error("紙盒(舊中)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatefine: function validatefine(poiItem) {
            var _this23 = this;

            if (poiItem.fine != '' && poiItem.fine != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fine)) {
                    poiItem.fine = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fine == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].fine);
                        }
                    }
                    var params = { itemName: "紙盒(新細)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.fine = "";
                                return _this23.$message.error("紙盒(新細)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoldfine: function validateoldfine(poiItem) {
            var _this24 = this;

            if (poiItem.oldFine != '' && poiItem.oldFine != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oldFine)) {
                    poiItem.oldFine = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oldFine == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oldFine);
                        }
                    }
                    var params = { itemName: "紙盒(舊細)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oldFine = "";
                                return _this24.$message.error("紙盒(舊細)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateplasma: function validateplasma(poiItem) {
            var _this25 = this;

            if (poiItem.plasma != '' && poiItem.plasma != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.plasma)) {
                    poiItem.plasma = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].plasma == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].plasma);
                        }
                    }
                    var params = { itemName: "Plasma" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.plasma = "";
                                return _this25.$message.error("Plasma出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatecrepePaper: function validatecrepePaper(poiItem) {
            var _this26 = this;

            if (poiItem.crepePaper != '' && poiItem.crepePaper != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.crepePaper)) {
                    poiItem.crepePaper = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].crepePaper == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].crepePaper);
                        }
                    }
                    var params = { itemName: "縐紋紙" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (_this26.rollingForm.threeCar != '' && _this26.rollingForm.threeCar != null) {
                                if (num + parseFloat(_this26.rollingForm.threeCar) > number) {
                                    poiItem.crepePaper = "";
                                    return _this26.$message.error("縐紋紙出倉數量大於倉存數！");
                                }
                            } else {
                                if (num > number) {
                                    poiItem.crepePaper = "";
                                    return _this26.$message.error("縐紋紙出倉數量大於倉存數！");
                                }
                            }
                        }
                    });
                }
            };
        },
        validateflatClothing: function validateflatClothing(poiItem) {
            var _this27 = this;

            if (poiItem.flatClothing != '' && poiItem.flatClothing != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.flatClothing)) {
                    poiItem.flatClothing = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].flatClothing == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].flatClothing);
                        }
                    }
                    var params = { itemName: "平衣" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.flatClothing = "";
                                return _this27.$message.error("平衣出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validaterefrigerator: function validaterefrigerator(poiItem) {
            var _this28 = this;

            if (poiItem.refrigerator != '' && poiItem.refrigerator != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.refrigerator)) {
                    poiItem.refrigerator = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].refrigerator == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].refrigerator);
                        }
                    }
                    var params = { itemName: "冰箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.refrigerator = "";
                                return _this28.$message.error("冰箱出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateelastic: function validateelastic(poiItem) {
            var _this29 = this;

            if (poiItem.elastic != '' && poiItem.elastic != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.elastic)) {
                    poiItem.elastic = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].elastic == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].elastic);
                        }
                    }
                    var params = { itemName: "黑色橡筋" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.elastic = "";
                                return _this29.$message.error("黑色橡筋出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatecardboard: function validatecardboard(poiItem) {
            var _this30 = this;

            if (poiItem.cardboard != '' && poiItem.cardboard != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.cardboard)) {
                    poiItem.cardboard = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].cardboard == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].cardboard);
                        }
                    }
                    var params = { itemName: "紙板" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.cardboard = "";
                                return _this30.$message.error("紙板出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatestiff: function validatestiff(poiItem) {
            var _this31 = this;

            if (poiItem.stiff != '' && poiItem.stiff != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.stiff)) {
                    poiItem.stiff = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].stiff == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].stiff);
                        }
                    }
                    var params = { itemName: "企身" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.stiff = "";
                                return _this31.$message.error("企身出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatebulktank: function validatebulktank(poiItem) {
            var _this32 = this;

            if (poiItem.bulktank != '' && poiItem.bulktank != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.bulktank)) {
                    poiItem.bulktank = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].bulktank == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].bulktank);
                        }
                    }
                    var params = { itemName: "散箱" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.bulktank = "";
                                return _this32.$message.error("散箱出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatepaperCardBoard: function validatepaperCardBoard(poiItem) {
            var _this33 = this;

            if (poiItem.paperCardBoard != '' && poiItem.paperCardBoard != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.paperCardBoard)) {
                    poiItem.paperCardBoard = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].paperCardBoard == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].paperCardBoard);
                        }
                    }
                    var params = { itemName: "紙卡板" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.paperCardBoard = "";
                                return _this33.$message.error("紙卡板出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatethreeSeats: function validatethreeSeats(poiItem) {
            var _this34 = this;

            if (poiItem.threeSeats != '' && poiItem.threeSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.threeSeats)) {
                    poiItem.threeSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].threeSeats == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].threeSeats);
                        }
                    }
                    var params = { itemName: "梳化套(3座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.threeSeats = "";
                                return _this34.$message.error("梳化套(3座位)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetwoSeats: function validatetwoSeats(poiItem) {
            var _this35 = this;

            if (poiItem.twoSeats != '' && poiItem.twoSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.twoSeats)) {
                    poiItem.twoSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].twoSeats == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].twoSeats);
                        }
                    }
                    var params = { itemName: "梳化套(2座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.twoSeats = "";
                                return _this35.$message.error("梳化套(2座位)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoneSeats: function validateoneSeats(poiItem) {
            var _this36 = this;

            if (poiItem.oneSeats != '' && poiItem.oneSeats != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneSeats)) {
                    poiItem.oneSeats = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneSeats == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oneSeats);
                        }
                    }
                    var params = { itemName: "梳化套(1座位)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oneSeats = "";
                                return _this36.$message.error("梳化套(1座位)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatesixRuler: function validatesixRuler(poiItem) {
            var _this37 = this;

            if (poiItem.sixRuler != '' && poiItem.sixRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.sixRuler)) {
                    poiItem.sixRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].sixRuler == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].sixRuler);
                        }
                    }
                    var params = { itemName: "床褥套(6呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.sixRuler = "";
                                return _this37.$message.error("床褥套(6呎)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatefiveRuler: function validatefiveRuler(poiItem) {
            var _this38 = this;

            if (poiItem.fiveRuler != '' && poiItem.fiveRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fiveRuler)) {
                    poiItem.fiveRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fiveRuler == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].fiveRuler);
                        }
                    }
                    var params = { itemName: "床褥套(5呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.fiveRuler = "";
                                return _this38.$message.error("床褥套(5呎)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatefourRuler: function validatefourRuler(poiItem) {
            var _this39 = this;

            if (poiItem.fourRuler != '' && poiItem.fourRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fourRuler)) {
                    poiItem.fourRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fourRuler == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].fourRuler);
                        }
                    }
                    var params = { itemName: "床褥套(4呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.fourRuler = "";
                                return _this39.$message.error("床褥套(4呎)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatethreeRuler: function validatethreeRuler(poiItem) {
            var _this40 = this;

            if (poiItem.threeRuler != '' && poiItem.threeRuler != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.threeRuler)) {
                    poiItem.threeRuler = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].threeRuler == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].threeRuler);
                        }
                    }
                    var params = { itemName: "床褥套(3呎)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.threeRuler = "";
                                return _this40.$message.error("床褥套(3呎)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoneSmall: function validateoneSmall(poiItem) {
            var _this41 = this;

            if (poiItem.oneSmall != '' && poiItem.oneSmall != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneSmall)) {
                    poiItem.oneSmall = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneSmall == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oneSmall);
                        }
                    }
                    var params = { itemName: "白水松(1吋)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oneSmall = "";
                                return _this41.$message.error("白水松(1吋)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatesmall: function validatesmall(poiItem) {
            var _this42 = this;

            if (poiItem.small != '' && poiItem.small != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.small)) {
                    poiItem.small = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].small == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].small);
                        }
                    }
                    var params = { itemName: "白水松(半吋)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.small = "";
                                return _this42.$message.error("白水松(半吋)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetool: function validatetool(poiItem) {
            var _this43 = this;

            if (poiItem.tool != '' && poiItem.tool != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tool)) {
                    poiItem.tool = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tool == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].tool);
                        }
                    }
                    var params = { itemName: "開木箱工具" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.tool = "";
                                return _this43.$message.error("開木箱工具出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateglue: function validateglue(poiItem) {
            var _this44 = this;

            if (poiItem.glue != '' && poiItem.glue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.glue)) {
                    poiItem.glue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].glue == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].glue);
                        }
                    }
                    var params = { itemName: "膠(110cm)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.glue = "";
                                return _this44.$message.error("膠(110cm)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatelengthFloor: function validatelengthFloor(poiItem) {
            var _this45 = this;

            if (poiItem.lengthFloor != '' && poiItem.lengthFloor != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.lengthFloor)) {
                    poiItem.lengthFloor = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].lengthFloor == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].lengthFloor);
                        }
                    }
                    var params = { itemName: "地台板(長)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.lengthFloor = "";
                                return _this45.$message.error("地台板(長)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatecage: function validatecage(poiItem) {
            var _this46 = this;

            if (poiItem.cage != '' && poiItem.cage != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.cage)) {
                    poiItem.cage = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].cage == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].cage);
                        }
                    }
                    var params = { itemName: "铁笼" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.cage = "";
                                return _this46.$message.error("铁笼出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateplywood: function validateplywood(poiItem) {
            var _this47 = this;

            if (poiItem.plywood != '' && poiItem.plywood != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.plywood)) {
                    poiItem.plywood = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].plywood == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].plywood);
                        }
                    }
                    var params = { itemName: "夾板(長)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.plywood = "";
                                return _this47.$message.error("夾板(長)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetheWire: function validatetheWire(poiItem) {
            var _this48 = this;

            if (poiItem.theWire != '' && poiItem.theWire != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.theWire)) {
                    poiItem.theWire = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].theWire == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].theWire);
                        }
                    }
                    var params = { itemName: "吊繩" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.theWire = "";
                                return _this48.$message.error("吊繩出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateoneGlue: function validateoneGlue(poiItem) {
            var _this49 = this;

            if (poiItem.oneGlue != '' && poiItem.oneGlue != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.oneGlue)) {
                    poiItem.oneGlue = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].oneGlue == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].oneGlue);
                        }
                    }
                    var params = { itemName: "膠(120cm)" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.oneGlue = "";
                                return _this49.$message.error("膠(120cm)出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatewireMesh: function validatewireMesh(poiItem) {
            var _this50 = this;

            if (poiItem.wireMesh != '' && poiItem.wireMesh != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.wireMesh)) {
                    poiItem.wireMesh = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].wireMesh == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].wireMesh);
                        }
                    }
                    var params = { itemName: "搬花網" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.wireMesh = "";
                                return _this50.$message.error("搬花網出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validateproductCar: function validateproductCar(poiItem) {
            var _this51 = this;

            if (poiItem.productCar != '' && poiItem.productCar != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.productCar)) {
                    poiItem.productCar = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].productCar == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].productCar);
                        }
                    }
                    var params = { itemName: "積車" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.productCar = "";
                                return _this51.$message.error("積車出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatetape: function validatetape(poiItem) {
            var _this52 = this;

            if (poiItem.tape != '' && poiItem.tape != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.tape)) {
                    poiItem.tape = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].tape == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].tape);
                        }
                    }
                    var params = { itemName: "膠紙冚" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.tape = "";
                                return _this52.$message.error("膠紙冚出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatefork: function validatefork(poiItem) {
            var _this53 = this;

            if (poiItem.fork != '' && poiItem.fork != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.fork)) {
                    poiItem.fork = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].fork == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].fork);
                        }
                    }
                    var params = { itemName: "叉" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.fork = "";
                                return _this53.$message.error("叉出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatechelsea: function validatechelsea(poiItem) {
            var _this54 = this;

            if (poiItem.chelsea != '' && poiItem.chelsea != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.chelsea)) {
                    poiItem.chelsea = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].chelsea == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].chelsea);
                        }
                    }
                    var params = { itemName: "車仔" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.chelsea = "";
                                return _this54.$message.error("車仔出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        validatesmooth: function validatesmooth(poiItem) {
            var _this55 = this;

            if (poiItem.smooth != '' && poiItem.smooth != null) {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(poiItem.smooth)) {
                    poiItem.smooth = "";
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                } else {
                    var num = 0;
                    for (var i = 0; i < this.poiItemList.length; i++) {
                        if (this.poiItemList[i].smooth == "半") {
                            num = num + 0.5;
                        } else {
                            num = num + parseFloat(this.poiItemList[i].smooth);
                        }
                    }
                    var params = { itemName: "滑潤" };
                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_55" /* itemRecord */])(params).then(function (res) {
                        if (res.data.errcode == 200) {
                            var number = res.data.data;
                            if (num > number) {
                                poiItem.smooth = "";
                                return _this55.$message.error("滑潤出倉數量大於倉存數！");
                            }
                        }
                    });
                }
            };
        },
        feedBackSave: function feedBackSave() {
            var _this56 = this;

            if (this.poiItemList.length == 0) {
                return this.$message.error("請新增單信息！");
            }
            var oneNum = 0;
            var twoNum = 0;
            var threeNum = 0;
            for (var i = 0; i < this.poiItemList.length; i++) {
                if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '') {
                    //坑紙
                    oneNum = oneNum + parseFloat(this.poiItemList[i].pitPaper);
                }
                if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '') {
                    //地膠
                    twoNum = twoNum + parseFloat(this.poiItemList[i].toGlue);
                }
                if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '') {
                    //縐紋紙
                    threeNum = threeNum + parseFloat(this.poiItemList[i].crepePaper);
                }
            }
            var oneNumValue = this.itemOptions.find(function (v) {
                return v.itemName == "坑紙";
            }).stockAvail - this.itemOptions.find(function (v) {
                return v.itemName == "坑紙";
            }).stockOnhold;
            if (oneNum + parseFloat(this.rollingForm.oneCar) > oneNumValue) {
                this.rollingForm.oneCar = "";
                return this.$message.error("坑紙出倉數量大於倉存數！");
            }

            var twoNumValue = this.itemOptions.find(function (v) {
                return v.itemName == "地膠";
            }).stockAvail - this.itemOptions.find(function (v) {
                return v.itemName == "地膠";
            }).stockOnhold;
            if (twoNum + parseFloat(this.rollingForm.twoCar) > twoNumValue) {
                this.rollingForm.twoCar = "";
                return this.$message.error("地膠出倉數量大於倉存數！");
            }

            var threeNumValue = this.itemOptions.find(function (v) {
                return v.itemName == "縐紋紙";
            }).stockAvail - this.itemOptions.find(function (v) {
                return v.itemName == "縐紋紙";
            }).stockOnhold;
            if (threeNum + parseFloat(this.rollingForm.threeCar) > threeNumValue) {
                this.rollingForm.threeCar = "";
                return this.$message.error("縐紋紙出倉數量大於倉存數！");
            }

            this.$refs.rollingForm.validate(function (valid) {
                if (valid) {
                    if (_this56.rollingForm.carNumber != '' && _this56.rollingForm.carNumber != null) {
                        if (_this56.rollingForm.carNumber.length > 6) {
                            return _this56.$message.error("車號最多是6個位");
                        }
                    }
                    _this56.loadingSave = true;
                    if (_this56.rollingForm.feedDate == '') {
                        _this56.rollingForm.feedDate = 0;
                    }
                    if (_this56.poiItemList.length != 0) {
                        _this56.rollingForm.poiItemsList = _this56.poiItemsJson();
                    }
                    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this56.rollingForm);
                    params.feedDate = Math.round(new Date(params.feedDate).getTime() / 1000);
                    params.status = 0;
                    params.delRollItemList = [];

                    Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_49" /* insertRolling */])(params).then(function (data) {
                        var _data$data = data.data,
                            errcode = _data$data.errcode,
                            errmsg = _data$data.errmsg;

                        if (errcode == 200) {
                            _this56.$message.success("保存成功");
                            _this56.loadingSave = true;
                            _this56.initalRolling();
                            _this56.acctId = '';
                            _this56.poiItemList = [], _this56.paramsNum = 0;
                            _this56.$router.push({
                                name: '物料出入倉',
                                params: { str: new Date().getTime() }
                            });
                            _this56.$store.commit("closeTab", 'rollAdd');
                        } else {
                            _this56.$message.error("保存失败");
                            _this56.loadingSave = false;
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                name: '物料出入倉',
                params: { str: new Date().getTime() }
            });
            this.$store.commit("closeTab", "rollAdd");
            this.initalRolling();
            this.acctId = '';
            this.poiItemList = [];
            this.paramsNum = 0;
        },
        createPoiItem: function createPoiItem() {
            this.poiItem = { index: this.index += 1, pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '',
                copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '',
                softPaper: '',
                lousyPaper: '',
                moistureproof: '',
                electric: '',
                gummedPaper: '',
                big: '',
                inthe: '',
                fine: '',
                oldBig: '',
                oldInthe: '',
                oldFine: '',
                plasma: '',
                crepePaper: '',
                flatClothing: '',
                refrigerator: '', //冰箱
                elastic: '',
                cardboard: '',
                stiff: '', //企身
                bulktank: '',
                paperCardBoard: '',
                threeSeats: '',
                twoSeats: '',
                oneSeats: '',
                threeRuler: '',
                fourRuler: '',
                fiveRuler: '',
                sixRuler: '',
                oneSmall: '',
                small: '',
                tool: '',
                glue: '',
                cage: '',
                theWire: '',
                plywood: '',
                oneGlue: '',
                wireMesh: '',
                productCar: '',
                tape: '',
                other: '',
                fork: '', //叉
                shortFloor: '', //短木板
                lengthFloor: '',
                chelsea: '', //車仔
                smooth: '' //滑潤
            };

            /* for (var i = 0; i < this.itemOptions.length; i++) {
                 if(this.itemOptions[i].itemName=="坑紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                        /!* if(this.poiItem.index!=this.poiItemList[j].index && this.poiItemList[j].id==''&& this.poiItemList[j].id==null){*!/
                         if(this.poiItemList[j].pitPaper!='' && this.poiItemList[j].pitPaper!=null){
                             number = number + parseFloat(this.poiItemList[j].pitPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         if(this.rollingForm.oneCar !='' && this.rollingForm.oneCar !=null){
                             if ( numValue-parseFloat(this.rollingForm.oneCar) > 0) {
                                 this.poiItem.pitPaper=numValue-parseFloat(this.rollingForm.oneCar);
                             }else{
                                 this.poiItem.pitPaper="";
                             }
                         }else {
                             this.poiItem.pitPaper=numValue;
                         }
                     }else{
                         this.poiItem.pitPaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="報紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].newsPaper!='' && this.poiItemList[j].newsPaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].newsPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.newsPaper=numValue;
                     }else{
                         this.poiItem.newsPaper='';
                     }
                    // this.poiItem.newsPaper=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                 }else if(this.itemOptions[i].itemName=="卜卜膠"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].buBu!='' && this.poiItemList[j].buBu!=null) {
                             number = number + parseFloat(this.poiItemList[j].buBu);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.buBu=numValue;
                     }else{
                         this.poiItem.buBu='';
                     }
                 }else if(this.itemOptions[i].itemName=="拷貝紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].copyPaper!='' && this.poiItemList[j].copyPaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].copyPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.copyPaper=numValue;
                     }else{
                         this.poiItem.copyPaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="毡"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].mat!='' && this.poiItemList[j].mat!=null) {
                             number = number + parseFloat(this.poiItemList[j].mat);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.mat=numValue;
                     }else{
                         this.poiItem.mat='';
                     }
                 }else if(this.itemOptions[i].itemName=="保鮮紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].tinFoil!='' && this.poiItemList[j].tinFoil!=null) {
                             number = number + parseFloat(this.poiItemList[j].tinFoil);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.tinFoil=numValue;
                     }else{
                         this.poiItem.tinFoil='';
                     }
                 }else if(this.itemOptions[i].itemName=="高木箱"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].azusa!='' && this.poiItemList[j].azusa!=null) {
                             number = number + parseFloat(this.poiItemList[j].azusa);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.azusa=numValue;
                     }else{
                         this.poiItem.azusa='';
                     }
                 }else if(this.itemOptions[i].itemName=="矮木箱"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].shortWood!='' && this.poiItemList[j].shortWood!=null) {
                             number = number + parseFloat(this.poiItemList[j].shortWood);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.shortWood=numValue;
                     }else{
                         this.poiItem.shortWood='';
                     }
                 }else if(this.itemOptions[i].itemName=="鐵車"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].ironCar!='' && this.poiItemList[j].ironCar!=null) {
                             number = number + parseFloat(this.poiItemList[j].ironCar);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.ironCar=numValue;
                     }else{
                         this.poiItem.ironCar='';
                     }
                 }else if(this.itemOptions[i].itemName=="車仔"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].chelsea!='' && this.poiItemList[j].chelsea!=null) {
                             number = number + parseFloat(this.poiItemList[j].chelsea);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.chelsea=numValue;
                     }else{
                         this.poiItem.chelsea='';
                     }
                 }else if(this.itemOptions[i].itemName=="軟紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].softPaper!='' && this.poiItemList[j].softPaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].softPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.softPaper=numValue;
                     }else{
                         this.poiItem.softPaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="爛紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].lousyPaper!='' && this.poiItemList[j].lousyPaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].lousyPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.lousyPaper=numValue;
                     }else{
                         this.poiItem.lousyPaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="防潮珠"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].moistureproof!='' && this.poiItemList[j].moistureproof!=null) {
                             number = number + parseFloat(this.poiItemList[j].moistureproof);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.moistureproof=numValue;
                     }else{
                         this.poiItem.moistureproof='';
                     }
                 }else if(this.itemOptions[i].itemName=="電批"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].electric!='' && this.poiItemList[j].electric!=null) {
                             number = number + parseFloat(this.poiItemList[j].electric);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.electric=numValue;
                     }else{
                         this.poiItem.electric='';
                     }
                 }else if(this.itemOptions[i].itemName=="叉"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].fork!='' && this.poiItemList[j].fork!=null) {
                             number = number + parseFloat(this.poiItemList[j].fork);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.fork=numValue;
                     }else{
                         this.poiItem.fork='';
                     }
                 }else if(this.itemOptions[i].itemName=="地膠"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].toGlue!='' && this.poiItemList[j].toGlue!=null) {
                             number = number + parseFloat(this.poiItemList[j].toGlue);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         if(this.rollingForm.twoCar !='' && this.rollingForm.twoCar !=null){
                             if ( numValue-parseFloat(this.rollingForm.twoCar) > 0) {
                                 this.poiItem.toGlue=numValue-parseFloat(this.rollingForm.twoCar);
                             }else{
                                 this.poiItem.toGlue="";
                             }
                         }else {
                             this.poiItem.toGlue=numValue;
                         }
                     }else{
                         this.poiItem.toGlue='';
                     }
                 }else if(this.itemOptions[i].itemName=="膠紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].gummedPaper!='' && this.poiItemList[j].gummedPaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].gummedPaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.gummedPaper=numValue;
                     }else{
                         this.poiItem.gummedPaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="铁笼"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].cage!='' && this.poiItemList[j].cage!=null) {
                             number = number + parseFloat(this.poiItemList[j].cage);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.cage=numValue;
                     }else{
                         this.poiItem.cage='';
                     }
                 }else if(this.itemOptions[i].itemName=="夾板(長)"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].plywood!='' && this.poiItemList[j].plywood!=null) {
                             number = number + parseFloat(this.poiItemList[j].plywood);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.plywood=numValue;
                     }else{
                         this.poiItem.plywood='';
                     }
                 }else if(this.itemOptions[i].itemName=="新大"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].big!='' && this.poiItemList[j].big!=null) {
                             number = number + parseFloat(this.poiItemList[j].big);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.big=numValue;
                     }else{
                         this.poiItem.big='';
                     }
                 }else if(this.itemOptions[i].itemName=="新中"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].inthe!='' && this.poiItemList[j].inthe!=null) {
                             number = number + parseFloat(this.poiItemList[j].inthe);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.inthe=numValue;
                     }else{
                         this.poiItem.inthe='';
                     }
                 }else if(this.itemOptions[i].itemName=="新細"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].fine!='' && this.poiItemList[j].fine!=null) {
                             number = number + parseFloat(this.poiItemList[j].fine);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.fine=numValue;
                     }else{
                         this.poiItem.fine='';
                     }
                 }else if(this.itemOptions[i].itemName=="舊大"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oldBig!='' && this.poiItemList[j].oldBig!=null) {
                             number = number + parseFloat(this.poiItemList[j].oldBig);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oldBig=numValue;
                     }else{
                         this.poiItem.oldBig='';
                     }
                 }else if(this.itemOptions[i].itemName=="舊中"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oldInthe!='' && this.poiItemList[j].oldInthe!=null) {
                             number = number + parseFloat(this.poiItemList[j].oldInthe);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oldInthe=numValue;
                     }else{
                         this.poiItem.oldInthe='';
                     }
                 }else if(this.itemOptions[i].itemName=="舊細"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oldFine!='' && this.poiItemList[j].oldFine!=null) {
                             number = number + parseFloat(this.poiItemList[j].oldFine);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oldFine=numValue;
                     }else{
                         this.poiItem.oldFine='';
                     }
                 }else if(this.itemOptions[i].itemName=="Plasma"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].plasma!='' && this.poiItemList[j].plasma!=null) {
                             number = number + parseFloat(this.poiItemList[j].plasma);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.plasma=numValue;
                     }else{
                         this.poiItem.plasma='';
                     }
                 }else if(this.itemOptions[i].itemName=="縐紋紙"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].crepePaper!='' && this.poiItemList[j].crepePaper!=null) {
                             number = number + parseFloat(this.poiItemList[j].crepePaper);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         if(this.rollingForm.threeCar !='' && this.rollingForm.threeCar !=null){
                             if ( numValue-parseFloat(this.rollingForm.threeCar) > 0) {
                                 this.poiItem.crepePaper=numValue-parseFloat(this.rollingForm.threeCar);
                             }else{
                                 this.poiItem.crepePaper="";
                             }
                         }else {
                             this.poiItem.crepePaper=numValue;
                         }
                     }else{
                         this.poiItem.crepePaper='';
                     }
                 }else if(this.itemOptions[i].itemName=="冰箱"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].refrigerator!='' && this.poiItemList[j].refrigerator!=null) {
                             number = number + parseFloat(this.poiItemList[j].refrigerator);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.refrigerator=numValue;
                     }else{
                         this.poiItem.refrigerator='';
                     }
                 }else if(this.itemOptions[i].itemName=="黑色橡筋"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].elastic!='' && this.poiItemList[j].elastic!=null) {
                             number = number + parseFloat(this.poiItemList[j].elastic);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.elastic=numValue;
                     }else{
                         this.poiItem.elastic='';
                     }
                 }else if(this.itemOptions[i].itemName=="紙板"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].cardboard!='' && this.poiItemList[j].cardboard!=null) {
                             number = number + parseFloat(this.poiItemList[j].cardboard);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.cardboard=numValue;
                     }else{
                         this.poiItem.cardboard='';
                     }
                 }else if(this.itemOptions[i].itemName=="企身"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].stiff!='' && this.poiItemList[j].stiff!=null) {
                             number = number + parseFloat(this.poiItemList[j].stiff);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.stiff=numValue;
                     }else{
                         this.poiItem.stiff='';
                     }
                 }else if(this.itemOptions[i].itemName=="散箱"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].bulktank!='' && this.poiItemList[j].bulktank!=null) {
                             number = number + parseFloat(this.poiItemList[j].bulktank);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.bulktank=numValue;
                     }else{
                         this.poiItem.bulktank='';
                     }
                 }else if(this.itemOptions[i].itemName=="紙卡板"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].paperCardBoard!='' && this.poiItemList[j].paperCardBoard!=null) {
                             number = number + parseFloat(this.poiItemList[j].paperCardBoard);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.paperCardBoard=numValue;
                     }else{
                         this.poiItem.paperCardBoard='';
                     }
                 }else if(this.itemOptions[i].itemName=="3座位"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].threeSeats!='' && this.poiItemList[j].threeSeats!=null) {
                             number = number + parseFloat(this.poiItemList[j].threeSeats);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.threeSeats=numValue;
                     }else{
                         this.poiItem.threeSeats='';
                     }
                 }else if(this.itemOptions[i].itemName=="2座位"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].twoSeats!='' && this.poiItemList[j].twoSeats!=null) {
                             number = number + parseFloat(this.poiItemList[j].twoSeats);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.twoSeats=numValue;
                     }else{
                         this.poiItem.twoSeats='';
                     }
                 }else if(this.itemOptions[i].itemName=="1座位"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oneSeats!='' && this.poiItemList[j].oneSeats!=null) {
                             number = number + parseFloat(this.poiItemList[j].oneSeats);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oneSeats=numValue;
                     }else{
                         this.poiItem.oneSeats='';
                     }
                 }else if(this.itemOptions[i].itemName=="6呎"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].sixRuler!='' && this.poiItemList[j].sixRuler!=null) {
                             number = number + parseFloat(this.poiItemList[j].sixRuler);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.sixRuler=numValue;
                     }else{
                         this.poiItem.sixRuler='';
                     }
                 }else if(this.itemOptions[i].itemName=="5呎"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].fiveRuler!='' && this.poiItemList[j].fiveRuler!=null) {
                             number = number + parseFloat(this.poiItemList[j].fiveRuler);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.fiveRuler=numValue;
                     }else{
                         this.poiItem.fiveRuler='';
                     }
                 }else if(this.itemOptions[i].itemName=="4呎"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItem.index!=this.poiItemList[j].index && this.poiItemList[j].id==''&& this.poiItemList[j].id==null){
                             if(this.poiItemList[j].fourRuler!='' && this.poiItemList[j].fourRuler!=null) {
                                 number = number + parseFloat(this.poiItemList[j].fourRuler);
                             }
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.fourRuler=numValue;
                     }else{
                         this.poiItem.fourRuler='';
                     }
                 }else if(this.itemOptions[i].itemName=="3呎"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].threeRuler!='' && this.poiItemList[j].threeRuler!=null) {
                             number = number + parseFloat(this.poiItemList[j].threeRuler);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.threeRuler=numValue;
                     }else{
                         this.poiItem.threeRuler='';
                     }
                 }else if(this.itemOptions[i].itemName=="1吋"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oneSmall!='' && this.poiItemList[j].oneSmall!=null) {
                             number = number + parseFloat(this.poiItemList[j].oneSmall);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oneSmall=numValue;
                     }else{
                         this.poiItem.oneSmall='';
                     }
                 }else if(this.itemOptions[i].itemName=="半吋"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].small!='' && this.poiItemList[j].small!=null) {
                             number = number + parseFloat(this.poiItemList[j].small);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.small=numValue;
                     }else{
                         this.poiItem.small='';
                     }
                 }else if(this.itemOptions[i].itemName=="吊繩"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].theWire!='' && this.poiItemList[j].theWire!=null) {
                             number = number + parseFloat(this.poiItemList[j].theWire);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.theWire=numValue;
                     }else{
                         this.poiItem.theWire='';
                     }
                     //this.poiItem.theWire=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                 }else if(this.itemOptions[i].itemName=="搬花網"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].wireMesh!='' && this.poiItemList[j].wireMesh!=null) {
                             number = number + parseFloat(this.poiItemList[j].wireMesh);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.wireMesh=numValue;
                     }else{
                         this.poiItem.wireMesh='';
                     }
                 }else if(this.itemOptions[i].itemName=="開木箱工具"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].tool!='' && this.poiItemList[j].tool!=null) {
                             number = number + parseFloat(this.poiItemList[j].tool);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.tool=numValue;
                     }else{
                         this.poiItem.tool='';
                     }
                 }else if(this.itemOptions[i].itemName=="地台板(長)"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].lengthFloor!='' && this.poiItemList[j].lengthFloor!=null) {
                             number = number + parseFloat(this.poiItemList[j].lengthFloor);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.lengthFloor=numValue;
                     }else{
                         this.poiItem.lengthFloor='';
                     }
                 }else if(this.itemOptions[i].itemName=="滑潤"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].smooth!='' && this.poiItemList[j].smooth!=null) {
                             number = number + parseFloat(this.poiItemList[j].smooth);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.smooth=numValue;
                     }else{
                         this.poiItem.smooth='';
                     }
                 }else if(this.itemOptions[i].itemName=="積車"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].productCar!='' && this.poiItemList[j].productCar!=null) {
                             number = number + parseFloat(this.poiItemList[j].productCar);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.productCar=numValue;
                     }else{
                         this.poiItem.productCar='';
                     }
                 }else if(this.itemOptions[i].itemName=="膠(110cm)"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].glue!='' && this.poiItemList[j].glue!=null) {
                             number = number + parseFloat(this.poiItemList[j].glue);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.glue=numValue;
                     }else{
                         this.poiItem.glue='';
                     }
                 }else if(this.itemOptions[i].itemName=="地台板(短)"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].shortFloor!='' && this.poiItemList[j].shortFloor!=null) {
                             number = number + parseFloat(this.poiItemList[j].shortFloor);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.shortFloor=numValue;
                     }else{
                         this.poiItem.shortFloor='';
                     }
                     //this.poiItem.shortFloor=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number;
                 }else if(this.itemOptions[i].itemName=="膠(120cm)"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].oneGlue!='' && this.poiItemList[j].oneGlue!=null) {
                             number = number + parseFloat(this.poiItemList[j].oneGlue);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.oneGlue=numValue;
                     }else{
                         this.poiItem.oneGlue='';
                     }
                 }else if(this.itemOptions[i].itemName=="膠紙冚"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if (this.poiItemList[j].tape != '' && this.poiItemList[j].tape != null) {
                             number = number + parseFloat(this.poiItemList[j].tape);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.tape=numValue;
                     }else{
                         this.poiItem.tape='';
                     }
                 }else if(this.itemOptions[i].itemName=="平衣"){
                     let number = 0
                     for (var j = 0; j < this.poiItemList.length; j++) {
                         if(this.poiItemList[j].flatClothing!='' && this.poiItemList[j].flatClothing!=null) {
                             number = number + parseFloat(this.poiItemList[j].flatClothing);
                         }
                     }
                     let numValue=this.itemOptions[i].stockAvail-this.itemOptions[i].stockOnhold-number
                     if(numValue!=0){
                         this.poiItem.flatClothing=numValue;
                     }else{
                         this.poiItem.flatClothing='';
                     }
                 }
             }*/
            this.poiItemList.push(this.poiItem);
        },

        // 提交時, 把所有報價單商品轉換成json Str
        poiItemsJson: function poiItemsJson() {
            var jsonStr = '[';
            for (var i = 0; i < this.poiItemList.length; i++) {
                jsonStr += '{';
                if (this.poiItemList[i].id != null) {
                    jsonStr += "\"id\":\"" + this.poiItemList[i].id + "\",";
                }
                if (this.poiItemList[i].pitPaper != null && this.poiItemList[i].pitPaper != '' && this.poiItemList[i].pitPaper != undefined) {
                    jsonStr += "\"pitPaper\":\"" + this.poiItemList[i].pitPaper + "\",";
                }
                if (this.poiItemList[i].newsPaper != null && this.poiItemList[i].newsPaper != '' && this.poiItemList[i].newsPaper != undefined) {
                    jsonStr += "\"newsPaper\":\"" + this.poiItemList[i].newsPaper + "\",";
                }
                if (this.poiItemList[i].buBu != null && this.poiItemList[i].buBu != '' && this.poiItemList[i].buBu != undefined) {
                    jsonStr += "\"buBu\":\"" + this.poiItemList[i].buBu + "\",";
                }
                if (this.poiItemList[i].copyPaper != null && this.poiItemList[i].copyPaper != '' && this.poiItemList[i].copyPaper != undefined) {
                    jsonStr += "\"copyPaper\":\"" + this.poiItemList[i].copyPaper + "\",";
                }
                if (this.poiItemList[i].mat != null && this.poiItemList[i].mat != '' && this.poiItemList[i].mat != undefined) {
                    jsonStr += "\"mat\":\"" + this.poiItemList[i].mat + "\",";
                }
                if (this.poiItemList[i].tinFoil != null && this.poiItemList[i].tinFoil != '' && this.poiItemList[i].tinFoil != undefined) {
                    jsonStr += "\"tinFoil\":\"" + this.poiItemList[i].tinFoil + "\",";
                }
                if (this.poiItemList[i].azusa != null && this.poiItemList[i].azusa != '' && this.poiItemList[i].azusa != undefined) {
                    jsonStr += "\"azusa\":\"" + this.poiItemList[i].azusa + "\",";
                }
                if (this.poiItemList[i].shortWood != null && this.poiItemList[i].shortWood != '' && this.poiItemList[i].shortWood != undefined) {
                    jsonStr += "\"shortWood\":\"" + this.poiItemList[i].shortWood + "\",";
                }
                if (this.poiItemList[i].ironCar != null && this.poiItemList[i].ironCar != '' && this.poiItemList[i].ironCar != undefined) {
                    jsonStr += "\"ironCar\":\"" + this.poiItemList[i].ironCar + "\",";
                }
                if (this.poiItemList[i].toGlue != null && this.poiItemList[i].toGlue != '' && this.poiItemList[i].toGlue != undefined) {
                    jsonStr += "\"toGlue\":\"" + this.poiItemList[i].toGlue + "\",";
                }
                if (this.poiItemList[i].softPaper != null && this.poiItemList[i].softPaper != '' && this.poiItemList[i].softPaper != undefined) {
                    jsonStr += "\"softPaper\":\"" + this.poiItemList[i].softPaper + "\",";
                }
                if (this.poiItemList[i].lousyPaper != null && this.poiItemList[i].lousyPaper != '' && this.poiItemList[i].lousyPaper != undefined) {
                    jsonStr += "\"lousyPaper\":\"" + this.poiItemList[i].lousyPaper + "\",";
                }
                if (this.poiItemList[i].moistureproof != null && this.poiItemList[i].moistureproof != '' && this.poiItemList[i].moistureproof != undefined) {
                    jsonStr += "\"moistureproof\":\"" + this.poiItemList[i].moistureproof + "\",";
                }
                if (this.poiItemList[i].electric != null && this.poiItemList[i].electric != '' && this.poiItemList[i].electric != undefined) {
                    jsonStr += "\"electric\":\"" + this.poiItemList[i].electric + "\",";
                }
                if (this.poiItemList[i].gummedPaper != null && this.poiItemList[i].gummedPaper != '' && this.poiItemList[i].gummedPaper != undefined) {
                    jsonStr += "\"gummedPaper\":\"" + this.poiItemList[i].gummedPaper + "\",";
                }
                if (this.poiItemList[i].big != null && this.poiItemList[i].big != '' && this.poiItemList[i].big != undefined) {
                    jsonStr += "\"big\":\"" + this.poiItemList[i].big + "\",";
                }
                if (this.poiItemList[i].inthe != null && this.poiItemList[i].inthe != '' && this.poiItemList[i].inthe != undefined) {
                    jsonStr += "\"inthe\":\"" + this.poiItemList[i].inthe + "\",";
                }
                if (this.poiItemList[i].fine != null && this.poiItemList[i].fine != '' && this.poiItemList[i].fine != undefined) {
                    jsonStr += "\"fine\":\"" + this.poiItemList[i].fine + "\",";
                }
                if (this.poiItemList[i].oldBig != null && this.poiItemList[i].oldBig != '' && this.poiItemList[i].oldBig != undefined) {
                    jsonStr += "\"oldBig\":\"" + this.poiItemList[i].oldBig + "\",";
                }
                if (this.poiItemList[i].oldInthe != null && this.poiItemList[i].oldInthe != '' && this.poiItemList[i].oldInthe != undefined) {
                    jsonStr += "\"oldInthe\":\"" + this.poiItemList[i].oldInthe + "\",";
                }
                if (this.poiItemList[i].oldFine != null && this.poiItemList[i].oldFine != '' && this.poiItemList[i].oldFine != undefined) {
                    jsonStr += "\"oldFine\":\"" + this.poiItemList[i].oldFine + "\",";
                }
                if (this.poiItemList[i].plasma != null && this.poiItemList[i].plasma != '' && this.poiItemList[i].plasma != undefined) {
                    jsonStr += "\"plasma\":\"" + this.poiItemList[i].plasma + "\",";
                }
                if (this.poiItemList[i].crepePaper != null && this.poiItemList[i].crepePaper != '' && this.poiItemList[i].crepePaper != undefined) {
                    jsonStr += "\"crepePaper\":\"" + this.poiItemList[i].crepePaper + "\",";
                }
                if (this.poiItemList[i].flatClothing != null && this.poiItemList[i].flatClothing != '' && this.poiItemList[i].flatClothing != undefined) {
                    jsonStr += "\"flatClothing\":\"" + this.poiItemList[i].flatClothing + "\",";
                }
                if (this.poiItemList[i].refrigerator != null && this.poiItemList[i].refrigerator != '' && this.poiItemList[i].refrigerator != undefined) {
                    jsonStr += "\"refrigerator\":\"" + this.poiItemList[i].refrigerator + "\",";
                }
                if (this.poiItemList[i].elastic != null && this.poiItemList[i].elastic != '' && this.poiItemList[i].elastic != undefined) {
                    jsonStr += "\"elastic\":\"" + this.poiItemList[i].elastic + "\",";
                }
                if (this.poiItemList[i].cardboard != null && this.poiItemList[i].cardboard != '' && this.poiItemList[i].cardboard != undefined) {
                    jsonStr += "\"cardboard\":\"" + this.poiItemList[i].cardboard + "\",";
                }
                if (this.poiItemList[i].stiff != null && this.poiItemList[i].stiff != '' && this.poiItemList[i].stiff != undefined) {
                    jsonStr += "\"stiff\":\"" + this.poiItemList[i].stiff + "\",";
                }
                if (this.poiItemList[i].bulktank != null && this.poiItemList[i].bulktank != '' && this.poiItemList[i].bulktank != undefined) {
                    jsonStr += "\"bulktank\":\"" + this.poiItemList[i].bulktank + "\",";
                }
                if (this.poiItemList[i].paperCardBoard != null && this.poiItemList[i].paperCardBoard != '' && this.poiItemList[i].paperCardBoard != undefined) {
                    jsonStr += "\"paperCardBoard\":\"" + this.poiItemList[i].paperCardBoard + "\",";
                }
                if (this.poiItemList[i].threeSeats != null && this.poiItemList[i].threeSeats != '' && this.poiItemList[i].threeSeats != undefined) {
                    jsonStr += "\"threeSeats\":\"" + this.poiItemList[i].threeSeats + "\",";
                }
                if (this.poiItemList[i].twoSeats != null && this.poiItemList[i].twoSeats != '' && this.poiItemList[i].twoSeats != undefined) {
                    jsonStr += "\"twoSeats\":\"" + this.poiItemList[i].twoSeats + "\",";
                }
                if (this.poiItemList[i].oneSeats != null && this.poiItemList[i].oneSeats != '' && this.poiItemList[i].oneSeats != undefined) {
                    jsonStr += "\"oneSeats\":\"" + this.poiItemList[i].oneSeats + "\",";
                }
                if (this.poiItemList[i].sixRuler != null && this.poiItemList[i].sixRuler != '' && this.poiItemList[i].sixRuler != undefined) {
                    jsonStr += "\"sixRuler\":\"" + this.poiItemList[i].sixRuler + "\",";
                }
                if (this.poiItemList[i].fiveRuler != null && this.poiItemList[i].fiveRuler != '' && this.poiItemList[i].fiveRuler != undefined) {
                    jsonStr += "\"fiveRuler\":\"" + this.poiItemList[i].fiveRuler + "\",";
                }
                if (this.poiItemList[i].fourRuler != null && this.poiItemList[i].fourRuler != '' && this.poiItemList[i].fourRuler != undefined) {
                    jsonStr += "\"fourRuler\":\"" + this.poiItemList[i].fourRuler + "\",";
                }
                if (this.poiItemList[i].threeRuler != null && this.poiItemList[i].threeRuler != '' && this.poiItemList[i].threeRuler != undefined) {
                    jsonStr += "\"threeRuler\":\"" + this.poiItemList[i].threeRuler + "\",";
                }
                if (this.poiItemList[i].oneSmall != null && this.poiItemList[i].oneSmall != '' && this.poiItemList[i].oneSmall != undefined) {
                    jsonStr += "\"oneSmall\":\"" + this.poiItemList[i].oneSmall + "\",";
                }
                if (this.poiItemList[i].small != null && this.poiItemList[i].small != '' && this.poiItemList[i].small != undefined) {
                    jsonStr += "\"small\":\"" + this.poiItemList[i].small + "\",";
                }
                if (this.poiItemList[i].tool != null && this.poiItemList[i].tool != '' && this.poiItemList[i].tool != undefined) {
                    jsonStr += "\"tool\":\"" + this.poiItemList[i].tool + "\",";
                }
                if (this.poiItemList[i].glue != null && this.poiItemList[i].glue != '' && this.poiItemList[i].glue != undefined) {
                    jsonStr += "\"glue\":\"" + this.poiItemList[i].glue + "\",";
                }
                if (this.poiItemList[i].cage != null && this.poiItemList[i].cage != '' && this.poiItemList[i].cage != undefined) {
                    jsonStr += "\"cage\":\"" + this.poiItemList[i].cage + "\",";
                }
                if (this.poiItemList[i].theWire != null && this.poiItemList[i].theWire != '' && this.poiItemList[i].theWire != undefined) {
                    jsonStr += "\"theWire\":\"" + this.poiItemList[i].theWire + "\",";
                }
                if (this.poiItemList[i].plywood != null && this.poiItemList[i].plywood != '' && this.poiItemList[i].plywood != undefined) {
                    jsonStr += "\"plywood\":\"" + this.poiItemList[i].plywood + "\",";
                }
                if (this.poiItemList[i].oneGlue != null && this.poiItemList[i].oneGlue != '' && this.poiItemList[i].oneGlue != undefined) {
                    jsonStr += "\"oneGlue\":\"" + this.poiItemList[i].oneGlue + "\",";
                }
                if (this.poiItemList[i].wireMesh != null && this.poiItemList[i].wireMesh != '' && this.poiItemList[i].wireMesh != undefined) {
                    jsonStr += "\"wireMesh\":\"" + this.poiItemList[i].wireMesh + "\",";
                }
                if (this.poiItemList[i].productCar != null && this.poiItemList[i].productCar != '' && this.poiItemList[i].productCar != undefined) {
                    jsonStr += "\"productCar\":\"" + this.poiItemList[i].productCar + "\",";
                }
                if (this.poiItemList[i].tape != null && this.poiItemList[i].tape != '' && this.poiItemList[i].tape != undefined) {
                    jsonStr += "\"tape\":\"" + this.poiItemList[i].tape + "\",";
                }
                if (this.poiItemList[i].other != null && this.poiItemList[i].other != '' && this.poiItemList[i].other != undefined) {
                    jsonStr += "\"other\":\"" + this.poiItemList[i].other + "\",";
                }
                if (this.poiItemList[i].fork != null && this.poiItemList[i].fork != '' && this.poiItemList[i].fork != undefined) {
                    jsonStr += "\"fork\":\"" + this.poiItemList[i].fork + "\",";
                }
                if (this.poiItemList[i].shortFloor != null && this.poiItemList[i].shortFloor != '' && this.poiItemList[i].shortFloor != undefined) {
                    jsonStr += "\"shortFloor\":\"" + this.poiItemList[i].shortFloor + "\",";
                }
                if (this.poiItemList[i].chelsea != null && this.poiItemList[i].chelsea != '' && this.poiItemList[i].chelsea != undefined) {
                    jsonStr += "\"chelsea\":\"" + this.poiItemList[i].chelsea + "\",";
                }
                if (this.poiItemList[i].smooth != null && this.poiItemList[i].smooth != '' && this.poiItemList[i].smooth != undefined) {
                    jsonStr += "\"smooth\":\"" + this.poiItemList[i].smooth + "\",";
                }
                if (this.poiItemList[i].lengthFloor != null && this.poiItemList[i].lengthFloor != '' && this.poiItemList[i].lengthFloor != undefined) {
                    jsonStr += "\"lengthFloor\":\"" + this.poiItemList[i].lengthFloor + "\"";
                } else {
                    jsonStr += "\"lengthFloor\":\"" + "" + "\"";
                }
                jsonStr += '}';
                jsonStr += ',';
            }
            jsonStr = jsonStr.substring(0, jsonStr.length - 1);
            jsonStr += ']';
            if (jsonStr.length == 1) {
                return null;
            }
            return jsonStr;
        },
        validateChange: function validateChange(ev) {
            if (ev != null && ev != '') {
                var re = /^[0-9]\d*\.{0,1}\d{0,2}$/;
                if (!re.test(ev)) {
                    this.$message.error("請輸入正確的格式，數字只有2位小數");
                    return false;
                }
            }
        },
        initalRolling: function initalRolling() {
            this.poiItem = { index: '', pitPaper: '', //坑紙
                newsPaper: '', //报纸
                buBu: '', copyPaper: '',
                mat: '', //毡
                tinFoil: '', //保鲜纸
                azusa: '',
                shortWood: '', //矮木
                ironCar: '',
                toGlue: '', softPaper: '', lousyPaper: '', moistureproof: '', electric: '',
                gummedPaper: '', big: '', inthe: '', fine: '', oldBig: '', oldInthe: '', oldFine: '', plasma: '', crepePaper: '', flatClothing: '',
                refrigerator: '', elastic: '', cardboard: '', stiff: '', bulktank: '', paperCardBoard: '',
                threeSeats: '', twoSeats: '', oneSeats: '', threeRuler: '', fourRuler: '', fiveRuler: '',
                cage: '', theWire: '', plywood: '', oneGlue: '', wireMesh: '', productCar: '', tape: '', other: '',
                fork: '', //叉
                shortFloor: '', //短木板
                lengthFloor: '',
                chelsea: '', //車仔
                smooth: '' //滑潤
            };
            this.rollingForm = {
                id: '',
                feedDate: new Date(),
                carNumber: '',
                oneCar: '0.5',
                twoCar: '1',
                threeCar: '2',
                sendBox: '',
                oneOther: '',
                internal: ''
            };
            this.poiItemList = [];
            this.acctId = "";
            this.disabledNum = false;
            this.delRollItemList = [];
            this.index = 0;
            this.paramsNum = 0;
            this.loadingSave = false;
        },
        getItemOption: function getItemOption() {
            var _this57 = this;

            Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["L" /* getItemAllList */])().then(function (data) {
                _this57.itemOptions = data.data.data;
            });
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        //this.initalRolling();
        this.getItemOption();
        if (this.paramsNum == 0) {
            this.createPoiItem();
        }
        this.paramsNum = 1;
    },

    computed: {}
});

/***/ }),

/***/ "vnfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ind_main ind_main2"},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"ind_cont rk_cont"},[_c('div',{staticClass:"ruku_top"},[_c('div',{staticClass:"ruku_from"},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',{attrs:{"label":"工作單號 :"}},[_c('el-input',{staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.sCodeShow},on:{"blur":function($event){return _vm.selSCode()}},model:{value:(_vm.form.sCode),callback:function ($$v) {_vm.$set(_vm.form, "sCode", $$v)},expression:"form.sCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓  名 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"銷售員 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.sales))])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',{attrs:{"label":"客戶編號 :"}},[(_vm.form.codeShow)?[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.code))])]:[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"65%"},attrs:{"size":"medium","disabled":_vm.form.codeShow,"fetch-suggestions":_vm.querySearch,"trigger-on-focus":false},on:{"input":function($event){return _vm.addList(0,0,'cCode')},"select":_vm.handleSelect},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})]],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"電  話 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.phone))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"地  址 :"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px","word-wrap":"break-word","word-break":"normal"}},[_vm._v(_vm._s(_vm.form.address))])])],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('el-form-item',[_c('template',{slot:"label"},[_vm._v("\n                                    總體積"),(_vm.form.unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.form.unitVolume==='1'?'箱':_vm.form.unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.form.totalVolume))])],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"單 價 :"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_c('el-input',{staticStyle:{"width":"80px"},attrs:{"size":"medium"},on:{"input":function($event){return _vm.$forceUpdate()},"blur":function($event){return _vm.handlePrice(_vm.form.price)}},model:{value:(_vm.form.price),callback:function ($$v) {_vm.$set(_vm.form, "price", $$v)},expression:"form.price"}})],1),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"color":"#000000"}},[_vm._v("體積單位 :")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"80px"},attrs:{"size":"medium","placeholder":""},on:{"change":_vm.handleChangeUnit},model:{value:(_vm.form.unitVolume),callback:function ($$v) {_vm.$set(_vm.form, "unitVolume", $$v)},expression:"form.unitVolume"}},[_c('el-option',{attrs:{"label":"箱","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"立方尺","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"立方米","value":"3"}})],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"20px","font-size":"13px !important"}},[_vm._v("上一次單價 : "+_vm._s(_vm.form.prePrice)),_c('br'),_vm._v("入庫單號 : "+_vm._s(_vm.form.storInCode)),_c('br'),_vm._v("入庫時間 : "+_vm._s(_vm.form.storInTime))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"總價格(HKD):"}},[_c('span',{staticStyle:{"color":"black","font-size":"16px"}},[_vm._v(_vm._s(_vm.formatCurrency(_vm.form.totalPrice)))])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"ruku_list"},[_c('el-form',[_c('table',{staticClass:"responsive",attrs:{"cellspacing":"0","cellpadding":"0"}},[_vm._l((_vm.addWarehousingList),function(items,i){return [_c('thead',{key:i},[_c('tr',[_c('th',{staticStyle:{"text-align":"left"},attrs:{"colspan":"4"}},[_c('el-date-picker',{staticStyle:{"width":"40%"},attrs:{"format":"yyyy年MM月dd日 HH:mm","type":"datetime","size":"large"},model:{value:(items.createDate),callback:function ($$v) {_vm.$set(items, "createDate", $$v)},expression:"items.createDate"}})],1),_vm._v(" "),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v("第"+_vm._s(items.second)+"次")]),_vm._v(" "),(items.storInItem.length === 0 || items.state === 0)?[_c('el-button',{attrs:{"icon":"el-icon-delete","type":"danger","circle":""},on:{"click":function($event){return _vm.delAddWarehousingList(items,i)}}},[_vm._v("刪除")])]:_vm._e()],2)]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"width":"8%"}},[_vm._v("編號")]),_vm._v(" "),_c('th',{attrs:{"width":"9%"}},[_vm._v("位置")]),_vm._v(" "),_c('th',{attrs:{"width":"7%"}},[_vm._v("單位")]),_vm._v(" "),_c('th',[_vm._v("物品")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("\n                                    體積"),(_vm.form.unitVolume)?_c('span',[_vm._v("("+_vm._s(_vm.form.unitVolume==='1'?'箱':_vm.form.unitVolume==='2'?'cu.ft':'m³')+")")]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("件數")])])]),_vm._v(" "),_vm._l((items.storInItem),function(item1,index){return _c('tr',{key:index},[_c('td',{staticClass:"number",attrs:{"width":"8%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.boxNo))])]:[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":item1.boxNoShow,"size":"medium","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"change":function($event){return _vm.addList(i,index,'boxNo')}},model:{value:(item1.boxNo),callback:function ($$v) {_vm.$set(item1, "boxNo", $$v)},expression:"item1.boxNo"}})]],2),_vm._v(" "),_c('td',{staticClass:"actions",attrs:{"width":"9%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.value))])]:[_c('el-select',{style:(items.addStorIn==false?'float: left;':''),attrs:{"size":"medium","disabled":item1.locationIdShows,"default-first-option":"","clearable":"","filterable":"","remote":"","reserve-keyword":"","placeholder":"","remote-method":_vm.remoteMethod,"loading":_vm.tableloading},on:{"change":function($event){return _vm.handleSelectState($event,i,index)},"focus":function($event){return _vm.isNullOptions4()}},model:{value:(item1.value),callback:function ($$v) {_vm.$set(item1, "value", $$v)},expression:"item1.value"}},_vm._l((_vm.options4),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2),_vm._v(" "),_c('td',{attrs:{"width":"7%"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.unit))])]:[_c('el-select',{attrs:{"size":"medium","placeholder":"請輸入","disabled":item1.unitShow},on:{"change":function($event){return _vm.addList(i,index,'unit')}},model:{value:(item1.unit),callback:function ($$v) {_vm.$set(item1, "unit", $$v)},expression:"item1.unit"}},_vm._l((_vm.company),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)]],2),_vm._v(" "),_c('td',{staticClass:"name",staticStyle:{"text-align":"left"}},[(item1.state === 1)?[_c('span',[_vm._v(_vm._s(item1.item))])]:[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"disabled":item1.itemShows,"size":"medium","fetch-suggestions":_vm.querySearchRemark,"placeholder":"請輸入內容"},on:{"input":function($event){return _vm.addList(i,index,'item')},"select":function($event){return _vm.addList(i,index,'item')}},model:{value:(item1.item),callback:function ($$v) {_vm.$set(item1, "item", $$v)},expression:"item1.item"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[(item1.state != 0)?[_vm._v("\n                                        "+_vm._s(item1.volume)+" \n                                    ")]:[_c('el-input',{attrs:{"disabled":item1.ckgShow},on:{"blur":function($event){return _vm.handleBlurVolume(item1, i)}},model:{value:(item1.volume),callback:function ($$v) {_vm.$set(item1, "volume", $$v)},expression:"item1.volume"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"10%"}},[(item1.state === 1)?[_vm._v("\n                                        "+_vm._s(item1.quantity)+"\n                                    ")]:[_c('el-input',{staticStyle:{"width":"60px"},attrs:{"disabled":item1.ckgShow,"maxlength":"3","onkeypress":"return (/[\\d]/.test(String.fromCharCode(event.keyCode)))"},on:{"input":function($event){return _vm.addList(i,index,'quantity')}},model:{value:(item1.quantity),callback:function ($$v) {_vm.$set(item1, "quantity", $$v)},expression:"item1.quantity"}}),_vm._v(" "),(item1.state === 0)?[_c('el-button',{attrs:{"type":"danger","size":"small","circle":""},on:{"click":function($event){return _vm.delStorInItem(i,index)}}},[_vm._v("刪除")])]:(item1.state === 1)?[_c('span',[_vm._v("已出倉")])]:_vm._e()]],2)])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('br')])])]})],2),_vm._v(" "),_c('div',{staticClass:"rk_btn"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","circle":""},on:{"click":_vm.submitStorIn}},[_vm._v(" 保存")]),_vm._v(" "),(_vm.$store.getters.customerInSte == false)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 取消")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.customerInSte)?_c('el-button',{attrs:{"type":"warning","icon":"el-icon-delete","circle":""},on:{"click":_vm.retSearch}},[_vm._v(" 返回")]):_vm._e()],1)])],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vxvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockOut_vue__ = __webpack_require__("Gdxj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8315828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockOut_vue__ = __webpack_require__("BKd4");
function injectStyle (ssrContext) {
  __webpack_require__("bTY0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StockOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8315828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StockOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "w99b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"},[_c('div',{staticClass:"right"},[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#fff"},attrs:{"tag":"a","to":'/feedAdd'}},[(_vm.canAdd)?_c('el-button',{attrs:{"type":"warning"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('m.t_newFeedBack')))]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getFeedBackList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":"車號"}},[_c('el-input',{attrs:{"placeholder":"車號","clearable":""},model:{value:(_vm.serchCarNumber),callback:function ($$v) {_vm.serchCarNumber=$$v},expression:"serchCarNumber"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"date","placeholder":"選擇日期"},model:{value:(_vm.getFeedDate),callback:function ($$v) {_vm.getFeedDate=$$v},expression:"getFeedDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"狀態","clearable":""},model:{value:(_vm.serchStatus),callback:function ($$v) {_vm.serchStatus=$$v},expression:"serchStatus"}},[_c('el-option',{attrs:{"value":"0","label":"未入倉"}}),_vm._v(" "),_c('el-option',{attrs:{"value":"1","label":"已入倉"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getFeedBackList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.custTaskList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"title","align":"left","label":"標題"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carNumber","align":"left","label":"車號"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"feedDate","align":"left","width":"110","label":_vm.$t('m.t_date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.feedDate!=0)?[_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.feedDate*1000,'%Y-%m-%d'))+"\n                        ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","align":"left","width":"90","label":"狀態"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status==0)?[_vm._v("\n                            未入倉\n                        ")]:_vm._e(),_vm._v(" "),(scope.row.status==1)?[_vm._v("\n                            已入倉\n                        ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","align":"center","width":"100","label":_vm.$t('m.b_opt')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [[_c('el-dropdown',[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_c('i',{staticClass:"fa fa-mouse-pointer"}),_vm._v(" "+_vm._s(_vm.$t('m.b_opt'))+"\n                                ")]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[(_vm.canEdit)?_c('el-dropdown-item',{attrs:{"size":"small","type":"primary"},nativeOn:{"click":function($event){return _vm.feedBackEdit(scope.row)}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(_vm._s(_vm.$t('m.b_edit')))]):_vm._e(),_vm._v(" "),(_vm.canPdf)?_c('el-dropdown-item',{nativeOn:{"click":function($event){return _vm.pdfDownload(scope.row)}}},[_c('i',{staticClass:"fa fa-file-pdf-o"}),_vm._v("PDF")]):_vm._e()],1)],1)]]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wV9u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    strict: debug,
    state: {
        staff: {},
        tabs: [],
        clickTab: '',
        sta: false,
        isLoding: false,
        keywords: '',
        warehouseSta: false, //入倉查詢狀態
        storonSta: false, //出倉查詢狀態
        searchSte: false, //首页查詢狀態
        customerInSte: false, //客戶详情入倉編輯狀態
        customerOnSte: false, //客戶详情出倉編輯狀態
        ismobilePhone: false, //是否是手机登录
        collapsed: false
    },

    mutations: {
        clearTabs: function clearTabs(state) {
            state.tabs = [];
        },
        updateStaff: function updateStaff(state, staff) {
            state.staff = staff;
        },
        addTab: function addTab(state, tab) {

            var i = state.tabs.findIndex(function (item) {
                return item.name == tab.name;
            });
            // console.log("add=="+tab.name);
            //   console.log("addiii===="+i);
            if (i == -1) {
                state.tabs.push(tab);
            } else {
                for (var _i = 0; _i < state.tabs.length; _i++) {
                    if (tab.name == state.tabs[_i].name) {
                        state.tabs.splice(_i, 1, tab);
                        break;
                    }
                }
            }
        },
        closeTab: function closeTab(state, name) {
            var i = state.tabs.findIndex(function (item) {
                return item.name == name;
            });
            console.log("jjjj===" + i);
            console.log(state.tabs);

            state.tabs.splice(i, 1);
            console.log("jjjj===");
            console.log(state.tabs);
        },
        setterClickTab: function setterClickTab(state, value) {
            state.clickTab = value;
        },
        setSta: function setSta(state, value) {
            state.sta = value;
        },
        setKeywords: function setKeywords(state, value) {
            state.keywords = value;
        },
        setWarehouseSta: function setWarehouseSta(state, value) {
            state.warehouseSta = value;
        },
        setStoronSta: function setStoronSta(state, value) {
            state.storonSta = value;
        },
        setIsLoding: function setIsLoding(state, value) {
            state.isLoding = value;
        },
        setSearchSte: function setSearchSte(state, value) {
            state.searchSte = value;
        },
        setCustomerInSte: function setCustomerInSte(state, value) {
            state.customerInSte = value;
        },
        setCustomerOnSte: function setCustomerOnSte(state, value) {
            state.customerOnSte = value;
        },
        setIsmobilePhone: function setIsmobilePhone(state, value) {
            state.ismobilePhone = value;
        },
        setCollapsed: function setCollapsed(state, value) {
            state.collapsed = value;
        }
    },
    getters: {
        tabs: function tabs(state) {
            return state.tabs;
        },
        staff: function staff(state) {
            return state.staff;
        },
        permissions: function permissions(state) {
            return state.staff.permissions;
        },
        hasPermission: function hasPermission(state) {
            return function (permission) {
                return state.staff.permissions.findIndex(function (item) {
                    return item === permission;
                }) >= 0 ? true : false;
            };
        },
        sta: function sta(state) {
            return state.sta;
        },
        isLoding: function isLoding(state) {
            return state.isLoding;
        },
        keywords: function keywords(state) {
            return state.keywords;
        },
        warehouseSta: function warehouseSta(state) {
            return state.warehouseSta;
        },
        storonSta: function storonSta(state) {
            return state.storonSta;
        },
        searchSte: function searchSte(state) {
            return state.searchSte;
        },
        customerInSte: function customerInSte(state) {
            return state.customerInSte;
        },
        customerOnSte: function customerOnSte(state) {
            return state.customerOnSte;
        },
        ismobilePhone: function ismobilePhone(state) {
            return state.ismobilePhone;
        },
        collapsed: function collapsed(state) {
            return state.collapsed;
        },
        getTabs: function getTabs(state) {
            return state.clickTab;
        }
    },
    actions: {}
}));

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    provide: function provide() {
        return {
            reload: this.reload
        };
    },
    data: function data() {
        return {
            isRouterAlive: true
        };
    },
    mounted: function mounted() {
        //获取国际化语言
        this.getLangCoikieKey();
    },

    methods: {
        reload: function reload() {
            this.isRouterAlive = false;
            this.$nextTick(function () {
                this.isRouterAlive = true;
            });
        },
        getLangCoikieKey: function getLangCoikieKey() {
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可輸出看下
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('='); //再次切割
                    //判断查找相对应的值
                    if (arr2[0] == 'langKey') {
                        this.langVal = arr2[1];
                        this.$i18n.locale = arr2[1]; //关键语句
                    }
                }
            }
        }
    }
});

/***/ }),

/***/ "xPlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {

        return {
            pickerOptions0: {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            pickerOptions2: {
                shortcuts: [{
                    text: this.$t('m.t_lastweek'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('m.t_lastmonth'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: this.$t('m.t_lastthreemonth'),
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            //查詢條件
            serchJobNO: "",
            serchCustNO: '',
            serchStatus: '',
            getFeedDate: '',
            searchDate: '',
            selectionItems: [],
            pager: {
                page: 0,
                size: 10,
                total: 0
            },
            custTaskList: [],
            dialogName: '',
            tableloading: false
        };
    },

    methods: {
        pdfBaseDownload: function pdfBaseDownload(value) {
            var url = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + "/excel/jobPdf?jobId=" + value.id + "&token=" + this.$store.getters.staff.token;
            window.location.href = url;
        },
        pdfDownload: function pdfDownload(value, type) {
            //var url=axios.defaults.baseURL+"/excel/jobOrder?rollId="+value.id+"&token="+ this.$store.getters.staff.token;
            var url = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.baseURL + "/word/job?jobId=" + value.id + "&token=" + this.$store.getters.staff.token + "&type=" + type;
            window.location.href = url;
        },
        handleSelectionFileChange: function handleSelectionFileChange() {},
        handleFileListChange: function handleFileListChange(val) {},
        custTaskPageChange: function custTaskPageChange(val) {
            this.getJobOrderList();
        },
        handleItemChange: function handleItemChange(val) {},
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectionItems = val;
        },
        getJobOrderList: function getJobOrderList() {
            var _this = this;

            this.tableloading = true;
            var params = { page: this.pager.page, size: this.pager.size, jobNo: this.serchJobNO.trim(), custNo: this.serchCustNO.trim() };
            /* if(params.feedDate!=null && params.feedDate!=''){
                 params.feedDate = parseInt(new Date(params.feedDate).getTime()/1000);
             }*/
            if (this.searchDate != null && this.searchDate != "") {
                params.startDate = Math.round(new Date(this.searchDate[0]).getTime() / 1000);
                params.endDate = Math.round(new Date(this.searchDate[1]).getTime() / 1000);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_1__api_api__["Q" /* getJobOrderList */])(params).then(function (data) {
                var _data$data = data.data,
                    res = _data$data === undefined ? {} : _data$data;

                if (res.errcode == 200) {
                    var _res$data = res.data,
                        size = _res$data.size,
                        page = _res$data.page,
                        total = _res$data.total,
                        _res$data$data = _res$data.data,
                        items = _res$data$data === undefined ? [] : _res$data$data;

                    _this.custTaskList = items;
                    _this.pager.total = total;
                    _this.pager.page = page;
                    _this.pager.size = size;
                    _this.tableloading = false;
                } else {
                    _this.$message.error(res.errmsg);
                }
            });
        },
        feedBackEdit: function feedBackEdit(row) {
            this.$router.push({
                name: '編輯工作單',
                params: {
                    jobId: row.id
                }
            });
            var path = "/jobEdit/" + row.id;
            this.$router.push(path);
        },
        feedBackPrint: function feedBackPrint(row) {
            this.$router.push({
                name: '卡板箱号管理',
                params: {
                    id: row.id,
                    jobId: row.jobId
                }
            });
            var path = "/jobPrint/" + row.id + "/" + row.jobId;
            this.$router.push(path);
        },
        resetForm: function resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    },
    mounted: function mounted() {},
    activated: function activated() {
        this.getJobOrderList();
    },

    computed: {
        canAdd: function canAdd() {
            return this.$store.getters.hasPermission("JOB_ADD");
        },
        canEdit: function canEdit() {
            return this.$store.getters.hasPermission("JOB_EDIT");
        },
        canPrint: function canPrint() {
            return this.$store.getters.hasPermission("JOB_PRINT");
        },
        canWord: function canWord() {
            return this.$store.getters.hasPermission("JOB_WORD");
        },
        canHouse: function canHouse() {
            return this.$store.getters.hasPermission("JOB_HOUSE");
        },
        canPdf: function canPdf() {
            return this.$store.getters.hasPermission("JOB_PDF");
        }
    }
});

/***/ }),

/***/ "xZXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return m; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _m;

/**
 * Created by wzf on 2018/4/23.
 */
var m = (_m = {
    b_newrole: '新增角色',
    t_deleterole: '删除角色',
    t_updaterole: '編輯角色',
    m_newsucs: '新增成功',
    m_deletesuc: '删除成功',
    m_info: '信息提示',
    m_accountnumber: '請輸入账号',
    m_length220: '长度在 2 到 20 个字符',
    m_deleterole: '此操作將永久刪除該角色, 是否繼續?',
    m_jurisdiction: '請至少選擇一种权限',
    m_updatesucs: '修改成功',
    t_confirm: '確認',
    t_cancel: '取消',
    t_search: '搜索條件',
    t_custcode: '客戶編號',
    t_groupname: '組名',
    t_customergroupname: '客戶組名',
    b_breakrelation: '解除關系',
    b_newmembergrp: '新增客戶組成員',
    m_groupnameinput: '請輸入客戶組名',
    m_customerinput: '請輸入客戶',
    m_deleteconfirmnexus: '此操作将解除与客戶组的关系, 是否继续?',
    m_removesuc: '关系解除成功',
    t_memberdata: '成員資料',
    m_newmembersuc: '添加成员成功',
    t_memebername: '成員名字',
    b_query: '查詢',
    b_opt: '操作',
    b_edit: '編輯',
    t_nodata: '暫無數據',
    t_customergroup: '客戶组管理',
    t_newcustomergroup: '新增客戶組',
    t_updatecustomergroup: '編輯客戶組',
    t_deletecustomergroup: '刪除客戶組',
    t_customergroupsee: '客戶組詳情',
    t_newproductcode: '新增客戶产品编码',
    t_updateproductcode: '編輯客戶产品编码',
    t_deletecustproductc: '删除客戶产品编码',
    b_cancel: '取消',
    b_save: '保存'
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_newsucs', '新增成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_updatesucs', '修改成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deleteconfirm', '此操作將永久刪除該資料, 是否繼續？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deletesuc', '删除成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_customer', '客戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 's_login', '用戶名/別名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_login', '用戶名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enable', '啟用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_stop', '停用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newTask', '新增任务'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_salesName', '銷售員'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_taskDate', '任务時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_booking', '搬迁预订'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_site', '现场调查'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_delete', '删除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_selectthefile', '選擇檔案'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enclosureadmin', '附件管理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_uploadfile', '上傳文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_uploadfileMaxFiftyMb', '上傳文件不能超过50MB'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_uploadsuccess', '上傳成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_filename', '文件名'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_filenameremark', '文件備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_uploadby', '上傳人'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_uploadtime', '上傳時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_remarks', '備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_file', '文件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_download', '下载'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_delete', '删除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_task', '任務資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_export', "導出"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastweek', '最近一周'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastmonth', '最近一个月'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_lastthreemonth', '最近三个月'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_accounting', '會計'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_cust', '客戶報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storIn', '入倉報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storOn', '出倉報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_storInOn', '出入倉紀錄表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_existing', '貨倉現存報表'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'menu_jobNo', '工作單號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_date', '日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_startdate', '开始日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_enddate', '结束日期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_quarterDate', '季度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_monthDate', '月份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_yearDate', '年份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_date', '請選擇季度'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_monthDate', '請選擇月份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_yearDate', '請選擇年份'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_customer', '請選擇客戶'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newFeedBack', '新增回料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_newRolling', '新增出倉'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_numbernot0', '数量不能少于0!'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_addgoodsadjustment', '新增货品调整'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_editgoodsadjustment', '修改货品调整'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_qtysk', '数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_prodcode', '产品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_nodata', '暫無數據'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_new', '新增'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_untreated', '该产品已存在，还未处理'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_repeatedselection', '重复選擇产品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_productchoice', '請選擇产品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_number', '請輸入数量'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_remarks', '請輸入備註'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_newgoodssuc', '新增货品成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_lengthmin100', '长度不超过100位'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_producttype', '請選擇产品'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_import', '导入'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'b_delete', '删除'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deleteconfirm', '此操作將永久刪除該資料, 是否繼續？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_deletesuc', '删除成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_Importconfirm', '你確定要入倉嗎？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_outconfirm', '你確定要出倉嗎？'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_Importsucs', '导入成功'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_ExportFormat', '導出格式'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_place', '地點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseSalesName', '請選擇銷售員'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleasePlace', '請選擇地點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseStartdate', '請選擇開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_pleaseEnddate', '請選擇結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_calendarStartdate', '開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_calendarEnddate', '結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_startmaxenddate', '開始時間不能大于結束時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 'm_endminstartdate', '結束時間不能小于開始時間'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_m, 't_downloadPDF', 'PDF下载'), _m);

/***/ }),

/***/ "y9+Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yH7D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yNJ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTree_vue__ = __webpack_require__("zLU5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c05e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTree_vue__ = __webpack_require__("Mx8+");
function injectStyle (ssrContext) {
  __webpack_require__("z/+e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60c05e6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60c05e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ybj/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yoRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"xinz"}),_vm._v(" "),_c('div',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"size":"small"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCalendarTaskList.apply(null, arguments)}}},[_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":this.$t('m.t_salesName')},model:{value:(_vm.serchSalesId),callback:function ($$v) {_vm.serchSalesId=$$v},expression:"serchSalesId"}},_vm._l((_vm.salesList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px","text-align":"left","margin-left":"10px"}},[_vm._v(_vm._s(item.loginName))])])}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"date","placeholder":"日期"},model:{value:(_vm.getTaskDate),callback:function ($$v) {_vm.getTaskDate=$$v},expression:"getTaskDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.getCalendarTaskList()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$t('m.b_query')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("返回")])],1)],1)],1),_vm._v(" "),_c('div',[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.tableloading),expression:"tableloading"}],staticClass:"dataListTable",attrs:{"header-cell-style":{background:'#4B78FF',color:'#FFFFFF'},"data":_vm.calenTaskList,"empty-text":_vm.$t('m.t_nodata'),"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"salesName","align":"left","width":"120","label":_vm.$t('m.t_salesName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"place","align":"left","width":"200","label":_vm.$t('m.t_place')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"startDate","align":"right","width":"80","label":_vm.$t('m.t_calendarStartdate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"endDate","align":"right","width":"80","label":_vm.$t('m.t_calendarEnddate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"taskDate","align":"right","width":"100","label":_vm.$t('m.t_taskDate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.taskDate!=0)?[_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.taskDate*1000,'%Y-%m-%d'))+"\n                    ")]:_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","align":"left","label":_vm.$t('m.t_remarks')}})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"layout":"total, prev, pager, next","current-page":_vm.pager.page,"page-size":_vm.pager.size,"total":_vm.pager.total},on:{"current-change":_vm.custTaskPageChange,"update:currentPage":function($event){return _vm.$set(_vm.pager, "page", $event)},"update:current-page":function($event){return _vm.$set(_vm.pager, "page", $event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z/+e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zLU5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['nodes'],
    name: 'MenuTree',
    data: function data() {
        return {};
    },

    methods: {
        locationAdd: function locationAdd(path) {

            this.$store.commit("setCollapsed", false);
            if (path == '/homepage') {
                //                this.$router.push('/');
                //                this.$store.commit("setSta",true);
                //                this.$store.commit("setIsLoding",false);
                this.$store.commit("setSta", false);
                this.$store.commit("setIsLoding", true);
                //                this.$router.push({
                //                    name: '倉庫'
                //                })
            }
            if (path == '/warehousing') {
                this.$store.commit("setWarehouseSta", false);
                this.$store.commit("setCustomerInSte", false);
            }
            if (path == '/storOn') {
                this.$store.commit("setStoronSta", false);
                this.$store.commit("setCustomerOnSte", false);
            }
            if (path == '/customer') {
                this.$store.commit("setSta", false);
            }
            return;
        }
    }
});

/***/ }),

/***/ "zVBY":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAABQElEQVQoU3WRsSuFYRjFz3nfK6UMEoM/QBlMt75rtUqkrAwURclgEb77XrmDwaQwEcpESnLLokw+DDabzSSSTd/7vUf3Fl1Xnu3p+T3nnDpEw/Qtf/bI5saZ+YObtebH+jPrlz7nhyQeQngF0U5q7Mblzr6ZHziK0yWSDoariUy5wLCEoFiSu11tKlcfmHdqyYVsV8AggWuBV8GYk3vHpyj2IzTcR9CFN3aCBeePBQ4CWKC0KeCd4FFSsrNVtUKsfplQIXTO/Ip6rcl2IDzTcFRSSnI7cXa+CkfFbJ1Q5IOdq2WOir5C8AHGXIY0azOW3SJmGPAm6J5ER1LKDf+Ck5JdrFkX/R7AAUCdICoQ0n/hKM6mCa2AfBVxR6leOdsgMAnopbEkgJ0AtqqutRj5KTWZrmyEAa1/YXzcGnsKR/8F+VKRA9QmtgMAAAAASUVORK5CYII="

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// js/app.d89afff580c34e25823d.js